webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paginator = __webpack_require__(748);

Object.defineProperty(exports, 'Paginator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_paginator).default;
  }
});

var _livePaginator = __webpack_require__(749);

Object.defineProperty(exports, 'LivePaginator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_livePaginator).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAnimationFrame = exports.logger = undefined;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = exports.logger = (0, _debug2.default)('redash:directives');

var requestAnimationFrame = exports.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function requestAnimationFrameFallback(callback) {
  setTimeout(callback, 10);
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderJsonView;

var _underscore = __webpack_require__(3);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPrimitive(value) {
  return value === null || value === false || value === true || (0, _underscore.isNumber)(value) && isFinite(value);
}

function combine() {
  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  functions = (0, _underscore.filter)(functions, _underscore.isFunction);
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _underscore.each)(functions, function (fn) {
      fn.apply(undefined, args);
    });
  };
}

function initToggle(toggle, toggleBlockFn) {
  if ((0, _underscore.isFunction)(toggleBlockFn)) {
    var visible = false;
    var icon = (0, _jquery2.default)('<i>').addClass('fa fa-caret-right').appendTo(toggle.empty());
    toggleBlockFn(visible);
    toggle.on('click', function () {
      visible = !visible;
      icon.toggleClass('fa-caret-right fa-caret-down');
      toggleBlockFn(visible);
    });
  } else {
    toggle.addClass('hidden');
  }
}

function createRenderNestedBlock(block, ellipsis, values, renderKeys) {
  return function (show) {
    if (show) {
      ellipsis.addClass('hidden');
      block.removeClass('hidden').empty();

      var firstItem = null;
      var lastItem = null;
      (0, _underscore.each)(values, function (val, key) {
        var nestedBlock = (0, _jquery2.default)('<span>').addClass('jvi-item').appendTo(block);
        firstItem = firstItem || nestedBlock;
        lastItem = nestedBlock;

        var toggle = (0, _jquery2.default)('<span>').addClass('jvi-toggle').appendTo(nestedBlock);

        if (renderKeys) {
          var keyWrapper = (0, _jquery2.default)('<span>').addClass('jvi-object-key').appendTo(nestedBlock);
          // eslint-disable-next-line no-use-before-define
          renderString(keyWrapper, key);
          (0, _jquery2.default)('<span>').addClass('jvi-punctuation').text(': ').appendTo(nestedBlock);
        }
        // eslint-disable-next-line no-use-before-define
        var toggleBlockFn = renderValue(nestedBlock, val, true);
        initToggle(toggle, toggleBlockFn);
      });

      if (firstItem) {
        firstItem.addClass('jvi-nested-first');
      }
      if (lastItem) {
        lastItem.addClass('jvi-nested-last');
      }
    } else {
      block.addClass('hidden').empty();
      ellipsis.removeClass('hidden');
    }
  };
}

function renderComma($element) {
  return (0, _jquery2.default)('<span>').addClass('jvi-punctuation jvi-comma').text(',').appendTo($element);
}

function renderEllipsis($element) {
  var result = (0, _jquery2.default)('<span>').addClass('jvi-punctuation jvi-ellipsis').html('&hellip;').appendTo($element).on('click', function () {
    result.parents('.jvi-item').eq(0).find('.jvi-toggle').trigger('click');
  });
  return result;
}

function renderPrimitive($element, value, comma) {
  (0, _jquery2.default)('<span>').addClass('jvi-value jvi-primitive').text('' + value).appendTo($element);
  if (comma) {
    renderComma($element);
  }
  return null;
}

function renderString($element, value, comma) {
  (0, _jquery2.default)('<span>').addClass('jvi-punctuation jvi-string').text('"').appendTo($element);
  (0, _jquery2.default)('<span>').addClass('jvi-value jvi-string').text(value).appendTo($element);
  (0, _jquery2.default)('<span>').addClass('jvi-punctuation jvi-string').text('"').appendTo($element);
  if (comma) {
    renderComma($element);
  }
  return null;
}

function renderComment($element, count) {
  var text = ' // ' + count + ' ' + (count === 1 ? 'item' : 'items');
  var comment = (0, _jquery2.default)('<span>').addClass('jvi-comment').text(text).appendTo($element);
  return function (show) {
    if (show) {
      comment.addClass('hidden');
    } else {
      comment.removeClass('hidden');
    }
  };
}

function renderBrace($element, isForArray, isOpening) {
  var openingBrace = isForArray ? '[' : '{';
  var closingBrace = isForArray ? ']' : '}';
  var brace = isOpening ? openingBrace : closingBrace;
  return (0, _jquery2.default)('<span>').addClass('jvi-punctuation jvi-braces').text(brace).appendTo($element);
}

function renderWithNested($element, values, comma, valuesIsArray) {
  var count = valuesIsArray ? values.length : (0, _underscore.keys)(values).length;
  var result = null;

  renderBrace($element, valuesIsArray, true);
  if (count > 0) {
    var ellipsis = renderEllipsis($element);
    var block = (0, _jquery2.default)('<span>').addClass('jvi-block hidden').appendTo($element);
    result = createRenderNestedBlock(block, ellipsis, values, !valuesIsArray);
  }
  renderBrace($element, valuesIsArray, false);

  if (comma) {
    renderComma($element);
  }

  if (count > 0) {
    result = combine(renderComment($element, count), result);
  }
  return result;
}

function renderArray($element, values, comma) {
  return renderWithNested($element, values, comma, true);
}

function renderObject($element, value, comma) {
  return renderWithNested($element, value, comma, false);
}

function renderValue($element, value, comma) {
  $element = (0, _jquery2.default)('<span>').appendTo($element);

  if (isPrimitive(value)) {
    return renderPrimitive($element, value, comma);
  } else if ((0, _underscore.isString)(value)) {
    return renderString($element, value, comma);
  } else if ((0, _underscore.isArray)(value)) {
    return renderArray($element, value, comma);
  } else if ((0, _underscore.isObject)(value)) {
    return renderObject($element, value, comma);
  }
}

function renderJsonView(container, value) {
  if (container instanceof _jquery2.default && !(0, _underscore.isUndefined)(value) && !(0, _underscore.isFunction)(value)) {
    var block = (0, _jquery2.default)('<span>').addClass('jvi-item').appendTo(container);
    var toggle = (0, _jquery2.default)('<span>').addClass('jvi-toggle').appendTo(block);
    var toggleBlockFn = renderValue(block, value);
    initToggle(toggle, toggleBlockFn);
  }
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
DataSource.$inject = ['$q', '$resource', '$http'];
var SCHEMA_NOT_SUPPORTED = exports.SCHEMA_NOT_SUPPORTED = 1;
var SCHEMA_LOAD_ERROR = exports.SCHEMA_LOAD_ERROR = 2;

function DataSource($q, $resource, $http) {
  function fetchSchema(dataSourceId) {
    var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var params = {};

    if (refresh) {
      params.refresh = true;
    }

    return $http.get('api/data_sources/' + dataSourceId + '/schema', { params: params });
  }

  var actions = {
    get: { method: 'GET', cache: false, isArray: false },
    query: { method: 'GET', cache: false, isArray: true },
    test: {
      method: 'POST',
      cache: false,
      isArray: false,
      url: 'api/data_sources/:id/test'
    }
  };

  var DataSourceResource = $resource('api/data_sources/:id', { id: '@id' }, actions);

  DataSourceResource.prototype.getSchema = function getSchema() {
    var _this = this;

    var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (this._schema === undefined || refresh) {
      return fetchSchema(this.id, refresh).then(function (response) {
        var data = response.data;

        _this._schema = data;

        return data;
      });
    }

    return $q.resolve(this._schema);
  };

  return DataSourceResource;
}

function init(ngModule) {
  ngModule.factory('DataSource', DataSource);
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getColumnCleanName = getColumnCleanName;
exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

QueryResultService.$inject = ['$resource', '$timeout', '$q'];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logger = (0, _debug2.default)('redash:services:QueryResult');
var filterTypes = ['filter', 'multi-filter', 'multiFilter'];

var ALL_VALUES = '*';
var NONE_VALUES = '-';

function getColumnNameWithoutType(column) {
  var typeSplit = void 0;
  if (column.indexOf('::') !== -1) {
    typeSplit = '::';
  } else if (column.indexOf('__') !== -1) {
    typeSplit = '__';
  } else {
    return column;
  }

  var parts = column.split(typeSplit);
  if (parts[0] === '' && parts.length === 2) {
    return parts[1];
  }

  if (!(0, _underscore.contains)(filterTypes, parts[1])) {
    return column;
  }

  return parts[0];
}

function getColumnCleanName(column) {
  var name = getColumnNameWithoutType(column);
  return name;
}

function getColumnFriendlyName(column) {
  return getColumnNameWithoutType(column).replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

function addPointToSeries(point, seriesCollection, seriesName) {
  if (seriesCollection[seriesName] === undefined) {
    seriesCollection[seriesName] = {
      name: seriesName,
      type: 'column',
      data: []
    };
  }

  seriesCollection[seriesName].data.push(point);
}

function QueryResultService($resource, $timeout, $q) {
  var QueryResultResource = $resource('api/query_results/:id', { id: '@id' }, { post: { method: 'POST' } });
  var Job = $resource('api/jobs/:id', { id: '@id' });
  var statuses = {
    1: 'waiting',
    2: 'processing',
    3: 'done',
    4: 'failed'
  };

  var QueryResult = function () {
    function QueryResult(props) {
      _classCallCheck(this, QueryResult);

      this.deferred = $q.defer();
      this.job = {};
      this.query_result = {};
      this.status = 'waiting';
      this.filters = undefined;
      this.filterFreeze = undefined;

      this.updatedAt = (0, _moment2.default)();

      if (props) {
        this.update(props);
      }
    }

    _createClass(QueryResult, [{
      key: 'update',
      value: function update(props) {
        _extends(this, props);

        if ('query_result' in props) {
          this.status = 'done';
          this.filters = undefined;
          this.filterFreeze = undefined;

          var columnTypes = {};

          // TODO: we should stop manipulating incoming data, and switch to relaying
          // on the column type set by the backend. This logic is prone to errors,
          // and better be removed. Kept for now, for backward compatability.
          (0, _underscore.each)(this.query_result.data.rows, function (row) {
            (0, _underscore.each)(row, function (v, k) {
              var newType = null;
              if ((0, _underscore.isNumber)(v)) {
                newType = 'float';
              } else if ((0, _underscore.isString)(v) && v.match(/^\d{4}-\d{2}-\d{2}T/)) {
                row[k] = _moment2.default.utc(v);
                newType = 'datetime';
              } else if ((0, _underscore.isString)(v) && v.match(/^\d{4}-\d{2}-\d{2}$/)) {
                row[k] = _moment2.default.utc(v);
                newType = 'date';
              } else if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null) {
                row[k] = JSON.stringify(v);
              } else {
                newType = 'string';
              }

              if (newType !== null) {
                if (columnTypes[k] !== undefined && columnTypes[k] !== newType) {
                  columnTypes[k] = 'string';
                } else {
                  columnTypes[k] = newType;
                }
              }
            });
          });

          (0, _underscore.each)(this.query_result.data.columns, function (column) {
            if (columnTypes[column.name]) {
              if (column.type == null || column.type === 'string') {
                column.type = columnTypes[column.name];
              }
            }
          });

          this.deferred.resolve(this);
        } else if (this.job.status === 3) {
          this.status = 'processing';
        } else {
          this.status = undefined;
        }
      }
    }, {
      key: 'getId',
      value: function getId() {
        var id = null;
        if ('query_result' in this) {
          id = this.query_result.id;
        }
        return id;
      }
    }, {
      key: 'cancelExecution',
      value: function cancelExecution() {
        Job.delete({ id: this.job.id });
      }
    }, {
      key: 'getStatus',
      value: function getStatus() {
        return this.status || statuses[this.job.status];
      }
    }, {
      key: 'getError',
      value: function getError() {
        // TODO: move this logic to the server...
        if (this.job.error === 'None') {
          return undefined;
        }

        return this.job.error;
      }
    }, {
      key: 'getLog',
      value: function getLog() {
        if (!this.query_result.data || !this.query_result.data.log || this.query_result.data.log.length === 0) {
          return null;
        }

        return this.query_result.data.log;
      }
    }, {
      key: 'getUpdatedAt',
      value: function getUpdatedAt() {
        return this.query_result.retrieved_at || this.job.updated_at * 1000.0 || this.updatedAt;
      }
    }, {
      key: 'getRuntime',
      value: function getRuntime() {
        return this.query_result.runtime;
      }
    }, {
      key: 'getRawData',
      value: function getRawData() {
        if (!this.query_result.data) {
          return null;
        }

        var data = this.query_result.data.rows;

        return data;
      }
    }, {
      key: 'getData',
      value: function getData() {
        if (!this.query_result.data) {
          return null;
        }

        function filterValues(filters) {
          if (!filters) {
            return null;
          }

          return filters.reduce(function (str, filter) {
            return str + filter.current;
          }, '');
        }

        var filters = this.getFilters();
        var filterFreeze = filterValues(filters);

        if (this.filterFreeze !== filterFreeze) {
          this.filterFreeze = filterFreeze;

          if (filters) {
            filters.forEach(function (filter) {
              if (filter.multiple && (0, _underscore.includes)(filter.current, ALL_VALUES)) {
                filter.current = filter.values.slice(2);
              }

              if (filter.multiple && (0, _underscore.includes)(filter.current, NONE_VALUES)) {
                filter.current = [];
              }
            });

            this.filteredData = this.query_result.data.rows.filter(function (row) {
              return filters.reduce(function (memo, filter) {
                if (!(0, _underscore.isArray)(filter.current)) {
                  filter.current = [filter.current];
                }

                return memo && (0, _underscore.some)(filter.current, function (v) {
                  var value = row[filter.name];
                  if (_moment2.default.isMoment(value)) {
                    return value.isSame(v);
                  }
                  // We compare with either the value or the String representation of the value,
                  // because Select2 casts true/false to "true"/"false".
                  return v === value || String(value) === v;
                });
              }, true);
            });
          } else {
            this.filteredData = this.query_result.data.rows;
          }
        }

        return this.filteredData;
      }
    }, {
      key: 'isEmpty',
      value: function isEmpty() {
        return this.getData() === null || this.getData().length === 0;
      }
    }, {
      key: 'getChartData',
      value: function getChartData(mapping) {
        var series = {};

        this.getData().forEach(function (row) {
          var point = {};
          var seriesName = void 0;
          var xValue = 0;
          var yValues = {};
          var eValue = null;
          var sizeValue = null;

          (0, _underscore.each)(row, function (v, definition) {
            var name = definition.split('::')[0] || definition.split('__')[0];
            var value = v;
            var type = definition.split('::')[1] || definition.split('__')[1];
            if (mapping) {
              type = mapping[definition];
            }

            if (type === 'unused') {
              return;
            }

            if (type === 'x') {
              xValue = value;
              point[type] = value;
            }
            if (type === 'y') {
              if (value == null) {
                value = 0;
              }
              yValues[name] = value;
              point[type] = value;
            }
            if (type === 'yError') {
              eValue = value;
              point[type] = value;
            }

            if (type === 'series') {
              seriesName = String(value);
            }

            if (type === 'size') {
              point[type] = value;
              sizeValue = value;
            }

            if (type === 'multiFilter' || type === 'multi-filter') {
              seriesName = String(value);
            }
          });

          if (seriesName === undefined) {
            (0, _underscore.each)(yValues, function (yValue, ySeriesName) {
              point = { x: xValue, y: yValue };
              if (eValue !== null) {
                point.yError = eValue;
              }

              if (sizeValue !== null) {
                point.size = sizeValue;
              }
              addPointToSeries(point, series, ySeriesName);
            });
          } else {
            addPointToSeries(point, series, seriesName);
          }
        });
        return (0, _underscore.sortBy)((0, _underscore.values)(series), 'name');
      }
    }, {
      key: 'getColumns',
      value: function getColumns() {
        if (this.columns === undefined && this.query_result.data) {
          this.columns = this.query_result.data.columns;
        }

        return this.columns;
      }
    }, {
      key: 'getColumnNames',
      value: function getColumnNames() {
        if (this.columnNames === undefined && this.query_result.data) {
          this.columnNames = this.query_result.data.columns.map(function (v) {
            return v.name;
          });
        }

        return this.columnNames;
      }
    }, {
      key: 'getColumnCleanNames',
      value: function getColumnCleanNames() {
        return this.getColumnNames().map(function (col) {
          return getColumnCleanName(col);
        });
      }
    }, {
      key: 'getColumnFriendlyNames',
      value: function getColumnFriendlyNames() {
        return this.getColumnNames().map(function (col) {
          return getColumnFriendlyName(col);
        });
      }
    }, {
      key: 'getFilters',
      value: function getFilters() {
        if (!this.filters) {
          this.prepareFilters();
        }

        return this.filters;
      }
    }, {
      key: 'prepareFilters',
      value: function prepareFilters() {
        if (!this.getColumns()) {
          return;
        }

        var filters = [];

        this.getColumns().forEach(function (col) {
          var name = col.name;
          var type = name.split('::')[1] || name.split('__')[1];
          if ((0, _underscore.contains)(filterTypes, type)) {
            // filter found
            var filter = {
              name: name,
              friendlyName: getColumnFriendlyName(name),
              column: col,
              values: [],
              multiple: type === 'multiFilter' || type === 'multi-filter'
            };
            filters.push(filter);
          }
        }, this);

        this.getRawData().forEach(function (row) {
          filters.forEach(function (filter) {
            filter.values.push(row[filter.name]);
            if (filter.values.length === 1) {
              if (filter.multiple) {
                filter.current = [row[filter.name]];
              } else {
                filter.current = row[filter.name];
              }
            }
          });
        });

        filters.forEach(function (filter) {
          if (filter.multiple) {
            filter.values.unshift(ALL_VALUES);
            filter.values.unshift(NONE_VALUES);
          }
        });

        filters.forEach(function (filter) {
          filter.values = (0, _underscore.uniq)(filter.values, function (v) {
            if (_moment2.default.isMoment(v)) {
              return v.unix();
            }
            return v;
          });
        });

        this.filters = filters;
      }
    }, {
      key: 'toPromise',
      value: function toPromise() {
        return this.deferred.promise;
      }
    }, {
      key: 'loadResult',
      value: function loadResult(tryCount) {
        var _this = this;

        QueryResultResource.get({ id: this.job.query_result_id }, function (response) {
          _this.update(response);
        }, function (error) {
          if (tryCount === undefined) {
            tryCount = 0;
          }

          if (tryCount > 3) {
            logger('Connection error while trying to load result', error);
            _this.update({
              job: {
                error: 'failed communicating with server. Please check your Internet connection and try again.',
                status: 4
              }
            });
          } else {
            $timeout(function () {
              _this.loadResult(tryCount + 1);
            }, 1000 * Math.pow(2, tryCount));
          }
        });
      }
    }, {
      key: 'refreshStatus',
      value: function refreshStatus(query) {
        var _this2 = this;

        Job.get({ id: this.job.id }, function (jobResponse) {
          _this2.update(jobResponse);

          if (_this2.getStatus() === 'processing' && _this2.job.query_result_id && _this2.job.query_result_id !== 'None') {
            _this2.loadResult();
          } else if (_this2.getStatus() !== 'failed') {
            $timeout(function () {
              _this2.refreshStatus(query);
            }, 3000);
          }
        }, function (error) {
          logger('Connection error', error);
          // TODO: use QueryResultError, or better yet: exception/reject of promise.
          _this2.update({ job: { error: 'failed communicating with server. Please check your Internet connection and try again.', status: 4 } });
        });
      }
    }, {
      key: 'getLink',
      value: function getLink(queryId, fileType, apiKey) {
        var link = 'api/queries/' + queryId + '/results/' + this.getId() + '.' + fileType;
        if (apiKey) {
          link = link + '?api_key=' + apiKey;
        }
        return link;
      }
    }, {
      key: 'getName',
      value: function getName(queryName, fileType) {
        return queryName.replace(' ', '_') + (0, _moment2.default)(this.getUpdatedAt()).format('_YYYY_MM_DD') + '.' + fileType;
      }
    }], [{
      key: 'getById',
      value: function getById(id) {
        var queryResult = new QueryResult();

        QueryResultResource.get({ id: id }, function (response) {
          queryResult.update(response);
        });

        return queryResult;
      }
    }, {
      key: 'get',
      value: function get(dataSourceId, query, maxAge, queryId) {
        var queryResult = new QueryResult();

        var params = { data_source_id: dataSourceId, query: query, max_age: maxAge };
        if (queryId !== undefined) {
          params.query_id = queryId;
        }

        QueryResultResource.post(params, function (response) {
          queryResult.update(response);

          if ('job' in response) {
            queryResult.refreshStatus(query);
          }
        }, function (error) {
          if (error.status === 403) {
            queryResult.update(error.data);
          } else if (error.status === 400 && 'job' in error.data) {
            queryResult.update(error.data);
          } else {
            logger('Unknown error', error);
            queryResult.update({ job: { error: 'unknown error occurred. Please try again later.', status: 4 } });
          }
        });

        return queryResult;
      }
    }]);

    return QueryResult;
  }();

  return QueryResult;
}

function init(ngModule) {
  ngModule.factory('QueryResult', QueryResultService);
}

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createFormatter;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _numeral = __webpack_require__(736);

var _numeral2 = _interopRequireDefault(_numeral);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line
var urlPattern = /(^|[\s\n]|<br\/?>)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;

function createDefaultFormatter(highlightLinks) {
  if (highlightLinks) {
    return function (value) {
      if (_underscore2.default.isString(value)) {
        value = value.replace(urlPattern, '$1<a href="$2" target="_blank">$2</a>');
      }
      return value;
    };
  }
  return function (value) {
    return value;
  };
}

function createDateTimeFormatter(format) {
  if (_underscore2.default.isString(format) && format !== '') {
    return function (value) {
      if (value && _moment2.default.isMoment(value)) {
        return value.format(format);
      }
      return value;
    };
  }
  return function (value) {
    return value;
  };
}

function createBooleanFormatter(values) {
  if (_underscore2.default.isArray(values)) {
    if (values.length >= 2) {
      // Both `true` and `false` specified
      return function (value) {
        return '' + values[value ? 1 : 0];
      };
    } else if (values.length === 1) {
      // Only `true`
      return function (value) {
        return value ? values[0] : '';
      };
    }
  }
  return function (value) {
    return value ? 'true' : 'false';
  };
}

function createNumberFormatter(format) {
  if (_underscore2.default.isString(format) && format !== '') {
    var n = (0, _numeral2.default)(0); // cache `numeral` instance
    return function (value) {
      return n.set(value).format(format);
    };
  }
  return function (value) {
    return value;
  };
}

function createFormatter(column) {
  switch (column.displayAs) {
    case 'number':
      return createNumberFormatter(column.numberFormat);
    case 'boolean':
      return createBooleanFormatter(column.booleanValues);
    case 'datetime':
      return createDateTimeFormatter(column.dateTimeFormat);
    default:
      return createDefaultFormatter(column.allowHTML && column.highlightLinks);
  }
}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <overlay ng-if=\"canCreateQuery === false && query.isNew()\">\n    You don't have permission to create new queries on any of the data sources available to you. You can either <a\n    href=\"queries\">browse existing queries</a>, or ask for additional permissions from your Redash admin.\n  </overlay>\n  <overlay ng-if=\"noDataSources && currentUser.isAdmin\">\n    Looks like no data sources were created yet (or none of them available to the group(s) you're member of). Please\n    create one first, and then start querying.\n    <br/>\n    <a href=\"data_sources/new\" class=\"btn btn-primary\">Create Data Source</a> <a href=\"groups\" class=\"btn btn-default\">Manage\n    Group Permissions</a>\n  </overlay>\n  <overlay ng-if=\"noDataSources && !currentUser.isAdmin\">\n    Looks like no data sources were created yet (or none of them available to the group(s) you're member of). Please ask\n    your Redash admin to create one first.\n  </overlay>\n\n  <alert-unsaved-changes ng-if=\"canEdit\" is-dirty=\"isDirty\"></alert-unsaved-changes>\n\n  <div class=\"row bg-white tiled p-10 p-l-15 p-r-15 m-b-10 m-l-0 m-r-0 page-header--new\">\n    <div class=\"col-sm-9 p-l-0\">\n      <h3>\n        <edit-in-place editable=\"canEdit\" done=\"saveName\" ignore-blanks=\"true\" value=\"query.name\"></edit-in-place>\n        <span class=\"label label-default\" ng-if=\"query.is_draft && !query.is_archived\">Unpublished</span>\n        <span class=\"label label-warning\" ng-if=\"query.is_archived\" uib-popover=\"This query is archived and can't be used in dashboards, and won't appear in search results.\" popover-placement=\"right\" popover-trigger=\"'mouseenter'\">Archived</span>\n      </h3>\n\n      <em>\n        <edit-in-place editable=\"canEdit\"\n                       done=\"saveDescription\"\n                       editor=\"textarea\"\n                       placeholder=\"No description\"\n                       ignore-blanks='false'\n                       value=\"query.description\"\n                       markdown=\"true\">\n        </edit-in-place>\n      </em>\n\n      <ul class=\"list-inline m-t-20\">\n        <li>\n          <span class=\"zmdi zmdi-account\"></span>\n          <span class=\"text-muted\">Created By </span>\n          <img ng-src=\"{{query.user.profile_image_url}}\" class=\"profile__image_thumb\"/>\n          <strong>{{query.user.name}}</strong>\n        </li>\n        <li ng-if=\"query.last_modified_by && query.user.id != query.last_modified_by.id\">\n          <span class=\"zmdi zmdi-account\"></span>\n          <span class=\"text-muted\">Last Modified By </span>\n          <strong>{{query.last_modified_by.name}}</strong>\n        </li>\n        <li>\n          <i class=\"zmdi zmdi-time-restore\"></i>\n          <span class=\"text-muted\">Updated at </span>\n          <strong>\n            <rd-time-ago value=\"query.updated_at\"></rd-time-ago>\n          </strong>\n        </li>\n        <li>\n          <span class=\"zmdi zmdi-time\"></span>\n          <span class=\"text-muted\">Created at </span>\n          <strong>\n            <rd-time-ago value=\"query.created_at\"></rd-time-ago>\n          </strong>\n        </li>\n      </ul>\n\n    </div>\n    <div class=\"col-sm-3 text-right p-r-0 source-control\">\n       <span ng-show=\"query.id && canViewSource\">\n          <a ng-show=\"!sourceMode\"\n             ng-href=\"{{query.getUrl(true, selectedTab)}}\" class=\"btn btn-default btn--showhide\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Show Source</i>\n          </a>\n          <a ng-show=\"sourceMode\"\n             ng-href=\"{{query.getUrl(false, selectedTab)}}\" class=\"btn btn-default btn--showhide\"><i class=\"fa fa-eye-slash\" aria-hidden=\"true\"></i> Hide Source</i>\n          </a>\n        </span>\n    </div>\n  </div>\n\n  <!-- editor -->\n  <div class=\"container\">\n      <div class=\"row bg-white tiled p-15 m-b-10\" ng-if=\"sourceMode\" resizable r-directions=\"['bottom']\" r-height=\"300\" style=\"min-height:100px;\">\n\n        <div class=\"col-md-3 p-0 hidden-sm hidden-xs editor__left\">\n\n          <select class=\"form-control m-b-10\" ng-disabled=\"!isQueryOwner\" ng-model=\"query.data_source_id\" ng-change=\"updateDataSource()\"\n                  ng-options=\"ds.id as ds.name for ds in dataSources\"></select>\n\n          <schema-browser class=\"schema-container\"\n                          schema=\"schema\"\n                          on-refresh=\"refreshSchema()\">\n          </schema-browser>\n        </div>\n\n        <div class=\"col-md-9 p-r-0\" style=\"height:100%;\">\n          <div class=\"editor__control\">\n            <div class=\"form-inline\">\n              <div class=\"text-right\">\n                <button class=\"btn btn-default\" ng-click=\"togglePublished()\" ng-if=\"query.is_draft && query.id != undefined && (isQueryOwner || currentUser.hasPermission('admin'))\">\n                  <span class=\"fa fa-paper-plane\"></span> Publish\n                </button>\n                <button class=\"btn btn-default\" ng-show=\"canEdit\" ng-click=\"saveQuery()\">\n                  <span class=\"fa fa-floppy-o\"> </span> Save<span\n                  ng-show=\"isDirty\">&#42;</span>\n                </button>\n                <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"formatQuery()\">\n                  <span class=\"zmdi zmdi-format-indent-increase\"></span> Format\n                </button>\n\n                <div ng-if=\"query.id != undefined\" class=\"btn-group\" role=\"group\" uib-dropdown>\n                  <button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle>\n                    <span class=\"zmdi zmdi-more\"></span>\n                  </button>\n                  <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu>\n                    <li><a ng-click=\"duplicateQuery()\" ng-disabled=\"query.id === undefined || !canForkQuery()\"> Fork</a></li>\n                    <li class=\"divider\"></li>\n                    <li ng-if=\"!query.is_archived && query.id != undefined && (isQueryOwner || currentUser.hasPermission('admin'))\"><a ng-click=\"archiveQuery()\">Archive</a></li>\n                    <li ng-if=\"!query.is_archived && query.id != undefined && (isQueryOwner || currentUser.hasPermission('admin')) && showPermissionsControl\"><a ng-click=\"showManagePermissionsModal()\">Manage Permissions</a></li>\n                    <li ng-if=\"!query.is_draft && query.id != undefined && (isQueryOwner || currentUser.hasPermission('admin'))\"><a ng-click=\"togglePublished()\">Unpublish</a></li>\n                    <li class=\"divider\"></li>\n                    <li ng-if=\"query.id != undefined\"><a ng-click=\"showApiKey()\">Show API Key</a></li>\n                  </ul>\n                </div>\n\n                <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"queryExecuting || !canExecuteQuery()\" ng-click=\"executeQuery()\">\n                  <span class=\"zmdi zmdi-play\"></span> Execute\n                </button>\n              </div>\n            </div>\n          </div>\n          <p style=\"height:calc(100% - 40px); margin-bottom: 0px;\">\n            <query-editor query=\"query\"\n                          schema=\"schema\"\n                          syntax=\"dataSource.syntax\"></query-editor>\n          </p>\n        </div>\n      </div>\n  </div>\n  <!-- end of editor -->\n\n  <!-- Query Details-->\n  <div class=\"container\" ng-if=\"sourceMode\">\n  </div>\n  <!-- End of Query Details-->\n\n  <div class=\"tile\">\n    <div class=\"t-header\">\n      <div class=\"pull-right\">\n        <button class=\"btn btn-sm btn-default\" ng-click=\"executeQuery()\"\n                ng-disabled=\"queryExecuting || !canExecuteQuery()\" title=\"Refresh Dataset\"\n                ng-if=\"!sourceMode\"><span\n          class=\"zmdi zmdi-refresh\"></span></button>\n        <div class=\"btn-group\" uib-dropdown>\n          <button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\"\n                  ng-disabled=\"queryExecuting || !queryResult.getData()\" aria-haspopup=\"true\"\n                  uib-dropdown-toggle aria-expanded=\"false\">\n            Download Dataset <span class=\"caret\"></span>\n          </button>\n          <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu>\n            <li>\n              <a query-result-link target=\"_self\">\n                <span class=\"fa fa-file-o\"></span> Download as CSV File\n              </a>\n            </li>\n            <li>\n              <a query-result-link file-type=\"xlsx\" target=\"_self\">\n                <span class=\"fa fa-file-excel-o\"></span> Download as Excel File\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n      <ul class=\"list-inline\">\n        <li>\n          <!-- runtime -->\n          <span class=\"zmdi zmdi-timer\"></span>\n          <span class=\"text-muted\">Runtime </span>\n          <strong ng-show=\"!queryExecuting\">{{queryResult.getRuntime() | durationHumanize}}</strong>\n          <span ng-show=\"queryExecuting\">Running&hellip;</span>\n        </li>\n        <li>\n          <!-- rows -->\n          <span class=\"zmdi zmdi-format-align-justify\"></span>\n          <span class=\"text-muted\">Rows </span><strong>{{queryResult.getData().length}}</strong>\n        </li>\n        <li>\n          <!-- refresh schedule -->\n          <span class=\"zmdi zmdi-refresh\"></span>\n          <span class=\"text-muted\">Refresh Schedule</span>\n          <a ng-click=\"openScheduleForm()\" ng-if=\"!query.isNew()\">{{query.schedule | scheduleHumanize}}</a>\n          <span ng-if=\"query.isNew()\">Never</span>\n        </li>\n        <li>\n          <!-- last update -->\n          <i class=\"zmdi zmdi-time-restore\"></i>\n          <span class=\"text-muted\">Last update </span>\n          <strong>\n            <rd-time-ago value=\"queryResult.query_result.retrieved_at\"></rd-time-ago>\n          </strong>\n        </li>\n      </ul>\n\n    </div>\n    <div class=\"t-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <parameters parameters=\"query.getParametersDefs()\" sync-values=\"!query.isNew()\" editable=\"sourceMode && canEdit\"></parameters>\n          <!-- Query Execution Status -->\n\n          <div class=\"query-alerts\">\n            <div class=\"alert alert-info\" ng-show=\"queryResult.getStatus() == 'processing'\">\n              Executing query&hellip;\n              <rd-timer timestamp=\"queryResult.getUpdatedAt()\"></rd-timer>\n              <button type=\"button\" class=\"btn btn-warning btn-xs pull-right\" ng-disabled=\"cancelling\"\n                      ng-click=\"cancelExecution()\">Cancel\n              </button>\n            </div>\n            <div class=\"alert alert-info\" ng-show=\"queryResult.getStatus() == 'waiting'\">\n              Query in queue&hellip;\n              <rd-timer timestamp=\"queryResult.getUpdatedAt()\"></rd-timer>\n              <button type=\"button\" class=\"btn btn-warning btn-xs pull-right\" ng-disabled=\"cancelling\"\n                      ng-click=\"cancelExecution()\">Cancel\n              </button>\n            </div>\n            <div class=\"alert alert-danger\" ng-show=\"queryResult.getError()\">Error running query: <strong>{{queryResult.getError()}}</strong>\n            </div>\n          </div>\n          <!-- End of Query Execution Status -->\n\n          <!-- tabs and data -->\n          <div ng-if=\"showDataset\">\n            <div class=\"row p-10\" ng-show=\"showLog\">\n              <div class=\"col-lg-12\">\n                <p>Log Information:</p>\n                <p ng-repeat=\"l in queryResult.getLog()\">{{l}}</p>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12\">\n                <ul class=\"tab-nav\">\n                  <rd-tab ng-if=\"!query.visualizations.length\" tab-id=\"table\" name=\"Table\" base-path=\"query.getUrl(sourceMode)\"></rd-tab>\n                  <rd-tab tab-id=\"{{vis.id}}\" name=\"{{vis.name}}\" base-path=\"query.getUrl(sourceMode)\" ng-repeat=\"vis in query.visualizations | orderBy:'id'\">\n                    <span class=\"remove\" ng-click=\"deleteVisualization($event, vis)\" ng-if=\"canEdit && !($first && (vis.type === 'TABLE'))\"> &times;</span>\n                  </rd-tab>\n                  <li class=\"rd-tab\"><a ng-click=\"openVisualizationEditor()\" ng-if=\"sourceMode && canEdit\">&plus; New Visualization</a></li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12\">\n                <div ng-if=\"!query.visualizations.length\">\n                  <filters filters=\"filters\"></filters>\n                  <grid-renderer query-result=\"queryResult\" items-per-page=\"50\"></grid-renderer>\n                </div>\n                <div ng-if=\"selectedTab == vis.id\" ng-repeat=\"vis in query.visualizations\" class=\"query__vis col-md-12\">\n                  <visualization-renderer visualization=\"vis\" query-result=\"queryResult\"></visualization-renderer>\n                  <div class=\"p-t-15 p-b-15\">\n                    <button class=\"btn btn-default\" ng-click=\"openVisualizationEditor(vis)\" ng-if=\"canEdit\">Edit</button>\n                    <button class=\"btn btn-default\" ng-click=\"showEmbedDialog(query, vis)\"><i class=\"zmdi zmdi-code\"></i> Embed</button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324);
module.exports = __webpack_require__(801);


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = __webpack_require__(325);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_config2.default.config(['$locationProvider', '$compileProvider', 'uiSelectConfig', 'toastrConfig', function ($locationProvider, $compileProvider, uiSelectConfig, toastrConfig) {
  $compileProvider.debugInfoEnabled(false);
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|http|data):/);
  $locationProvider.html5Mode(true);
  uiSelectConfig.theme = 'bootstrap';

  _extends(toastrConfig, {
    positionClass: 'toast-bottom-right',
    timeOut: 2000
  });
}]);

// Update ui-select's template to use Font-Awesome instead of glyphicon.
// eslint-disable-next-line no-unused-vars
_config2.default.run(['$templateCache', 'OfflineListener', function ($templateCache, OfflineListener) {
  var templateName = 'bootstrap/match.tpl.html';
  var template = $templateCache.get(templateName);
  template = template.replace('glyphicon glyphicon-remove', 'fa fa-remove');
  $templateCache.put(templateName, template);
}]);

exports.default = _config2.default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(326);

__webpack_require__(351);

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

var _angularSanitize = __webpack_require__(355);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularRoute = __webpack_require__(357);

var _angularRoute2 = _interopRequireDefault(_angularRoute);

var _angularResource = __webpack_require__(359);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularUiBootstrap = __webpack_require__(361);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _uiSelect = __webpack_require__(363);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularMessages = __webpack_require__(365);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularToastr = __webpack_require__(367);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularBase64Upload = __webpack_require__(369);

var _angularBase64Upload2 = _interopRequireDefault(_angularBase64Upload);

var _angularVsRepeat = __webpack_require__(371);

var _angularVsRepeat2 = _interopRequireDefault(_angularVsRepeat);

__webpack_require__(372);

__webpack_require__(238);

__webpack_require__(376);

__webpack_require__(377);

var _angularGridster = __webpack_require__(378);

var _angularGridster2 = _interopRequireDefault(_angularGridster);

var _underscore = __webpack_require__(3);

__webpack_require__(379);

var _filters = __webpack_require__(384);

var filters = _interopRequireWildcard(_filters);

var _directives = __webpack_require__(385);

var _directives2 = _interopRequireDefault(_directives);

var _markdown = __webpack_require__(391);

var _markdown2 = _interopRequireDefault(_markdown);

var _datetime = __webpack_require__(397);

var _datetime2 = _interopRequireDefault(_datetime);

var _dashboardGridOptions = __webpack_require__(398);

var _dashboardGridOptions2 = _interopRequireDefault(_dashboardGridOptions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _debug2.default)('redash:config'); // This polyfill is needed to support PhantomJS which we use to generate PNGs from embeds.


var requirements = [_angularRoute2.default, _angularResource2.default, _angularSanitize2.default, _angularUiBootstrap2.default, _angularMessages2.default, _uiSelect2.default, 'angularMoment', _angularToastr2.default, 'ui.ace', _angularBase64Upload2.default, 'angularResizable', _angularVsRepeat2.default, 'ui.sortable', _angularGridster2.default.name];

var ngModule = _angular2.default.module('app', requirements);

(0, _dashboardGridOptions2.default)(ngModule);

function registerAll(context) {
  var modules = context.keys().map(context).map(function (module) {
    return module.default;
  });

  return modules.map(function (f) {
    return f(ngModule);
  });
}

function registerComponents() {
  // We repeat this code in other register functions, because if we don't use a literal for the path
  // Webpack won't be able to statcily analyze our imports.
  var context = __webpack_require__(399);
  registerAll(context);
}

function registerServices() {
  var context = __webpack_require__(472);
  registerAll(context);
}

function registerVisualizations() {
  var context = __webpack_require__(538);
  registerAll(context);
}

function registerPages() {
  var context = __webpack_require__(746);
  var routesCollection = registerAll(context);
  routesCollection.forEach(function (routes) {
    ngModule.config(['$routeProvider', function ($routeProvider) {
      (0, _underscore.each)(routes, function (route, path) {
        logger('Registering route: %s', path);
        // This is a workaround, to make sure app-header and footer are loaded only
        // for the authenticated routes.
        // We should look into switching to ui-router, that has built in support for
        // such things.
        route.template = '<app-header></app-header><route-status></route-status>' + route.template + '<footer></footer>';
        route.authenticated = true;
        $routeProvider.when(path, route);
      });
    }]);
  });
}

function registerFilters() {
  (0, _underscore.each)(filters, function (filter, name) {
    ngModule.filter(name, function () {
      return filter;
    });
  });
}

(0, _directives2.default)(ngModule);
registerServices();
registerFilters();
(0, _markdown2.default)(ngModule);
(0, _datetime2.default)(ngModule);
registerComponents();
registerPages();
registerVisualizations(ngModule);

exports.default = ngModule;

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 119,
	"./af.js": 119,
	"./ar": 120,
	"./ar-dz": 121,
	"./ar-dz.js": 121,
	"./ar-kw": 122,
	"./ar-kw.js": 122,
	"./ar-ly": 123,
	"./ar-ly.js": 123,
	"./ar-ma": 124,
	"./ar-ma.js": 124,
	"./ar-sa": 125,
	"./ar-sa.js": 125,
	"./ar-tn": 126,
	"./ar-tn.js": 126,
	"./ar.js": 120,
	"./az": 127,
	"./az.js": 127,
	"./be": 128,
	"./be.js": 128,
	"./bg": 129,
	"./bg.js": 129,
	"./bm": 130,
	"./bm.js": 130,
	"./bn": 131,
	"./bn.js": 131,
	"./bo": 132,
	"./bo.js": 132,
	"./br": 133,
	"./br.js": 133,
	"./bs": 134,
	"./bs.js": 134,
	"./ca": 135,
	"./ca.js": 135,
	"./cs": 136,
	"./cs.js": 136,
	"./cv": 137,
	"./cv.js": 137,
	"./cy": 138,
	"./cy.js": 138,
	"./da": 139,
	"./da.js": 139,
	"./de": 140,
	"./de-at": 141,
	"./de-at.js": 141,
	"./de-ch": 142,
	"./de-ch.js": 142,
	"./de.js": 140,
	"./dv": 143,
	"./dv.js": 143,
	"./el": 144,
	"./el.js": 144,
	"./en-au": 145,
	"./en-au.js": 145,
	"./en-ca": 146,
	"./en-ca.js": 146,
	"./en-gb": 147,
	"./en-gb.js": 147,
	"./en-ie": 148,
	"./en-ie.js": 148,
	"./en-nz": 149,
	"./en-nz.js": 149,
	"./eo": 150,
	"./eo.js": 150,
	"./es": 151,
	"./es-do": 152,
	"./es-do.js": 152,
	"./es-us": 153,
	"./es-us.js": 153,
	"./es.js": 151,
	"./et": 154,
	"./et.js": 154,
	"./eu": 155,
	"./eu.js": 155,
	"./fa": 156,
	"./fa.js": 156,
	"./fi": 157,
	"./fi.js": 157,
	"./fo": 158,
	"./fo.js": 158,
	"./fr": 159,
	"./fr-ca": 160,
	"./fr-ca.js": 160,
	"./fr-ch": 161,
	"./fr-ch.js": 161,
	"./fr.js": 159,
	"./fy": 162,
	"./fy.js": 162,
	"./gd": 163,
	"./gd.js": 163,
	"./gl": 164,
	"./gl.js": 164,
	"./gom-latn": 165,
	"./gom-latn.js": 165,
	"./gu": 166,
	"./gu.js": 166,
	"./he": 167,
	"./he.js": 167,
	"./hi": 168,
	"./hi.js": 168,
	"./hr": 169,
	"./hr.js": 169,
	"./hu": 170,
	"./hu.js": 170,
	"./hy-am": 171,
	"./hy-am.js": 171,
	"./id": 172,
	"./id.js": 172,
	"./is": 173,
	"./is.js": 173,
	"./it": 174,
	"./it.js": 174,
	"./ja": 175,
	"./ja.js": 175,
	"./jv": 176,
	"./jv.js": 176,
	"./ka": 177,
	"./ka.js": 177,
	"./kk": 178,
	"./kk.js": 178,
	"./km": 179,
	"./km.js": 179,
	"./kn": 180,
	"./kn.js": 180,
	"./ko": 181,
	"./ko.js": 181,
	"./ky": 182,
	"./ky.js": 182,
	"./lb": 183,
	"./lb.js": 183,
	"./lo": 184,
	"./lo.js": 184,
	"./lt": 185,
	"./lt.js": 185,
	"./lv": 186,
	"./lv.js": 186,
	"./me": 187,
	"./me.js": 187,
	"./mi": 188,
	"./mi.js": 188,
	"./mk": 189,
	"./mk.js": 189,
	"./ml": 190,
	"./ml.js": 190,
	"./mr": 191,
	"./mr.js": 191,
	"./ms": 192,
	"./ms-my": 193,
	"./ms-my.js": 193,
	"./ms.js": 192,
	"./mt": 194,
	"./mt.js": 194,
	"./my": 195,
	"./my.js": 195,
	"./nb": 196,
	"./nb.js": 196,
	"./ne": 197,
	"./ne.js": 197,
	"./nl": 198,
	"./nl-be": 199,
	"./nl-be.js": 199,
	"./nl.js": 198,
	"./nn": 200,
	"./nn.js": 200,
	"./pa-in": 201,
	"./pa-in.js": 201,
	"./pl": 202,
	"./pl.js": 202,
	"./pt": 203,
	"./pt-br": 204,
	"./pt-br.js": 204,
	"./pt.js": 203,
	"./ro": 205,
	"./ro.js": 205,
	"./ru": 206,
	"./ru.js": 206,
	"./sd": 207,
	"./sd.js": 207,
	"./se": 208,
	"./se.js": 208,
	"./si": 209,
	"./si.js": 209,
	"./sk": 210,
	"./sk.js": 210,
	"./sl": 211,
	"./sl.js": 211,
	"./sq": 212,
	"./sq.js": 212,
	"./sr": 213,
	"./sr-cyrl": 214,
	"./sr-cyrl.js": 214,
	"./sr.js": 213,
	"./ss": 215,
	"./ss.js": 215,
	"./sv": 216,
	"./sv.js": 216,
	"./sw": 217,
	"./sw.js": 217,
	"./ta": 218,
	"./ta.js": 218,
	"./te": 219,
	"./te.js": 219,
	"./tet": 220,
	"./tet.js": 220,
	"./th": 221,
	"./th.js": 221,
	"./tl-ph": 222,
	"./tl-ph.js": 222,
	"./tlh": 223,
	"./tlh.js": 223,
	"./tr": 224,
	"./tr.js": 224,
	"./tzl": 225,
	"./tzl.js": 225,
	"./tzm": 226,
	"./tzm-latn": 227,
	"./tzm-latn.js": 227,
	"./tzm.js": 226,
	"./uk": 228,
	"./uk.js": 228,
	"./ur": 229,
	"./ur.js": 229,
	"./uz": 230,
	"./uz-latn": 231,
	"./uz-latn.js": 231,
	"./uz.js": 230,
	"./vi": 232,
	"./vi.js": 232,
	"./x-pseudo": 233,
	"./x-pseudo.js": 233,
	"./yo": 234,
	"./yo.js": 234,
	"./zh-cn": 235,
	"./zh-cn.js": 235,
	"./zh-hk": 236,
	"./zh-hk.js": 236,
	"./zh-tw": 237,
	"./zh-tw.js": 237
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;

/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable */
/*
TODO:
1. export module name.
2. publish into its own repo?
3. fix lint errors.
*/


var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _sortable = __webpack_require__(380);

var _sortable2 = _interopRequireDefault(_sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 jQuery UI Sortable plugin wrapper

 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */
_angular2.default.module('ui.sortable', []).value('uiSortableConfig', {
  // the default for jquery-ui sortable is "> *", we need to restrict this to
  // ng-repeat items
  // if the user uses
  items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]',
  cancel: 'input, textarea, button, select, option, .ui-sortable-bypass'
}).directive('uiSortable', ['uiSortableConfig', '$timeout', '$log', function (uiSortableConfig, $timeout, $log) {
  return {
    require: '?ngModel',
    scope: {
      ngModel: '=',
      uiSortable: '='
    },
    link: function link(scope, element, attrs, ngModel) {
      var savedNodes = void 0;
      element = (0, _jquery2.default)(element);

      function combineCallbacks(first, second) {
        var firstIsFunc = typeof first === 'function';
        var secondIsFunc = typeof second === 'function';
        if (firstIsFunc && secondIsFunc) {
          return function () {
            first.apply(this, arguments);
            second.apply(this, arguments);
          };
        } else if (secondIsFunc) {
          return second;
        }
        return first;
      }

      function getSortableWidgetInstance(element) {
        // this is a fix to support jquery-ui prior to v1.11.x
        // otherwise we should be using `element.sortable('instance')`
        var data = element.data('ui-sortable');
        if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data.widgetFullName === 'ui-sortable') {
          return data;
        }
        return null;
      }

      function patchSortableOption(key, value) {
        if (callbacks[key]) {
          if (key === 'stop') {
            // call apply after stop
            value = combineCallbacks(value, function () {
              scope.$apply();
            });

            value = combineCallbacks(value, afterStop);
          }
          // wrap the callback
          value = combineCallbacks(callbacks[key], value);
        } else if (wrappers[key]) {
          value = wrappers[key](value);
        }

        // patch the options that need to have values set
        if (!value && (key === 'items' || key === 'ui-model-items')) {
          value = uiSortableConfig.items;
        }

        return value;
      }

      function patchUISortableOptions(newVal, oldVal, sortableWidgetInstance) {
        function addDummyOptionKey(value, key) {
          if (!(key in opts)) {
            // add the key in the opts object so that
            // the patch function detects and handles it
            opts[key] = null;
          }
        }
        // for this directive to work we have to attach some callbacks
        _angular2.default.forEach(callbacks, addDummyOptionKey);

        // only initialize it in case we have to
        // update some options of the sortable
        var optsDiff = null;

        if (oldVal) {
          // reset deleted options to default
          var defaultOptions = void 0;
          _angular2.default.forEach(oldVal, function (oldValue, key) {
            if (!newVal || !(key in newVal)) {
              if (key in directiveOpts) {
                if (key === 'ui-floating') {
                  opts[key] = 'auto';
                } else {
                  opts[key] = patchSortableOption(key, undefined);
                }
                return;
              }

              if (!defaultOptions) {
                defaultOptions = (0, _sortable2.default)().options;
              }
              var defaultValue = defaultOptions[key];
              defaultValue = patchSortableOption(key, defaultValue);

              if (!optsDiff) {
                optsDiff = {};
              }
              optsDiff[key] = defaultValue;
              opts[key] = defaultValue;
            }
          });
        }

        // update changed options
        _angular2.default.forEach(newVal, function (value, key) {
          // if it's a custom option of the directive,
          // handle it approprietly
          if (key in directiveOpts) {
            if (key === 'ui-floating' && (value === false || value === true) && sortableWidgetInstance) {
              sortableWidgetInstance.floating = value;
            }

            opts[key] = patchSortableOption(key, value);
            return;
          }

          value = patchSortableOption(key, value);

          if (!optsDiff) {
            optsDiff = {};
          }
          optsDiff[key] = value;
          opts[key] = value;
        });

        return optsDiff;
      }

      function getPlaceholderElement(element) {
        var placeholder = element.sortable('option', 'placeholder');

        // placeholder.element will be a function if the placeholder, has
        // been created (placeholder will be an object).  If it hasn't
        // been created, either placeholder will be false if no
        // placeholder class was given or placeholder.element will be
        // undefined if a class was given (placeholder will be a string)
        if (placeholder && placeholder.element && typeof placeholder.element === 'function') {
          var result = placeholder.element();
          // workaround for jquery ui 1.9.x,
          // not returning jquery collection
          result = (0, _jquery2.default)(result);
          return result;
        }
        return null;
      }

      function getPlaceholderExcludesludes(element, placeholder) {
        // exact match with the placeholder's class attribute to handle
        // the case that multiple connected sortables exist and
        // the placeholder option equals the class of sortable items
        var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
        var excludes = element.find('[class="' + placeholder.attr('class') + '"]:not(' + notCssSelector + ')');
        return excludes;
      }

      function hasSortingHelper(element, ui) {
        var helperOption = element.sortable('option', 'helper');
        return helperOption === 'clone' || typeof helperOption === 'function' && ui.item.sortable.isCustomHelperUsed();
      }

      function getSortingHelper(element, ui, savedNodes) {
        var result = null;
        if (hasSortingHelper(element, ui) && element.sortable('option', 'appendTo') === 'parent') {
          // The .ui-sortable-helper element (that's the default class name)
          // is placed last.
          result = savedNodes.last();
        }
        return result;
      }

      // thanks jquery-ui
      function isFloating(item) {
        return (/left|right/.test(item.css('float')) || /inline|table-cell/.test(item.css('display'))
        );
      }

      function getElementScope(elementScopes, element) {
        var result = null;
        for (var i = 0; i < elementScopes.length; i++) {
          var x = elementScopes[i];
          if (x.element[0] === element[0]) {
            result = x.scope;
            break;
          }
        }
        return result;
      }

      function afterStop(e, ui) {
        ui.item.sortable._destroy();
      }

      // return the index of ui.item among the items
      // we can't just do ui.item.index() because there it might have siblings
      // which are not items
      function getItemIndex(item) {
        return item.parent().find(opts['ui-model-items']).index(item);
      }

      var opts = {};

      // directive specific options
      var directiveOpts = {
        'ui-floating': undefined,
        'ui-model-items': uiSortableConfig.items
      };

      var callbacks = {
        receive: null,
        remove: null,
        start: null,
        stop: null,
        update: null
      };

      var wrappers = {
        helper: null
      };

      _angular2.default.extend(opts, directiveOpts, uiSortableConfig, scope.uiSortable);

      function wireUp() {
        // When we add or remove elements, we need the sortable to 'refresh'
        // so it can find the new/removed elements.
        scope.$watchCollection('ngModel', function () {
          // Timeout to let ng-repeat modify the DOM
          $timeout(function () {
            // ensure that the jquery-ui-sortable widget instance
            // is still bound to the directive's element
            if (!!getSortableWidgetInstance(element)) {
              element.sortable('refresh');
            }
          }, 0, false);
        });

        callbacks.start = function (e, ui) {
          if (opts['ui-floating'] === 'auto') {
            // since the drag has started, the element will be
            // absolutely positioned, so we check its siblings
            var siblings = ui.item.siblings();
            var sortableWidgetInstance = getSortableWidgetInstance((0, _jquery2.default)(e.target));
            sortableWidgetInstance.floating = isFloating(siblings);
          }

          // Save the starting position of dragged item
          var index = getItemIndex(ui.item);
          ui.item.sortable = {
            model: ngModel.$modelValue[index],
            index: index,
            source: ui.item.parent(),
            sourceModel: ngModel.$modelValue,
            cancel: function cancel() {
              ui.item.sortable._isCanceled = true;
            },
            isCanceled: function isCanceled() {
              return ui.item.sortable._isCanceled;
            },
            isCustomHelperUsed: function isCustomHelperUsed() {
              return !!ui.item.sortable._isCustomHelperUsed;
            },

            _isCanceled: false,
            _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
            _destroy: function _destroy() {
              _angular2.default.forEach(ui.item.sortable, function (value, key) {
                ui.item.sortable[key] = undefined;
              });
            }
          };
        };

        callbacks.activate = function (e, ui) {
          // We need to make a copy of the current element's contents so
          // we can restore it after sortable has messed it up.
          // This is inside activate (instead of start) in order to save
          // both lists when dragging between connected lists.
          savedNodes = element.contents();

          // If this list has a placeholder (the connected lists won't),
          // don't inlcude it in saved nodes.
          var placeholder = getPlaceholderElement(element);
          if (placeholder && placeholder.length) {
            var excludes = getPlaceholderExcludesludes(element, placeholder);
            savedNodes = savedNodes.not(excludes);
          }

          // save the directive's scope so that it is accessible from ui.item.sortable
          var connectedSortables = ui.item.sortable._connectedSortables || [];

          connectedSortables.push({
            element: element,
            scope: scope
          });

          ui.item.sortable._connectedSortables = connectedSortables;
        };

        callbacks.update = function (e, ui) {
          // Save current drop position but only if this is not a second
          // update that happens when moving between lists because then
          // the value will be overwritten with the old value
          if (!ui.item.sortable.received) {
            ui.item.sortable.dropindex = getItemIndex(ui.item);
            var droptarget = ui.item.parent();
            ui.item.sortable.droptarget = droptarget;

            var droptargetScope = getElementScope(ui.item.sortable._connectedSortables, droptarget);
            ui.item.sortable.droptargetModel = droptargetScope.ngModel;

            // Cancel the sort (let ng-repeat do the sort for us)
            // Don't cancel if this is the received list because it has
            // already been canceled in the other list, and trying to cancel
            // here will mess up the DOM.
            element.sortable('cancel');
          }

          // Put the nodes back exactly the way they started (this is very
          // important because ng-repeat uses comment elements to delineate
          // the start and stop of repeat sections and sortable doesn't
          // respect their order (even if we cancel, the order of the
          // comments are still messed up).
          var sortingHelper = !ui.item.sortable.received && getSortingHelper(element, ui, savedNodes);
          if (sortingHelper && sortingHelper.length) {
            // Restore all the savedNodes except from the sorting helper element.
            // That way it will be garbage collected.
            savedNodes = savedNodes.not(sortingHelper);
          }
          savedNodes.appendTo(element);

          // If this is the target connected list then
          // it's safe to clear the restored nodes since:
          // update is currently running and
          // stop is not called for the target list.
          if (ui.item.sortable.received) {
            savedNodes = null;
          }

          // If received is true (an item was dropped in from another list)
          // then we add the new item to this list otherwise wait until the
          // stop event where we will know if it was a sort or item was
          // moved here from another list
          if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
            scope.$apply(function () {
              ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0, ui.item.sortable.moved);
            });
          }
        };

        callbacks.stop = function (e, ui) {
          // If the received flag hasn't be set on the item, this is a
          // normal sort, if dropindex is set, the item was moved, so move
          // the items in the list.
          if (!ui.item.sortable.received && 'dropindex' in ui.item.sortable && !ui.item.sortable.isCanceled()) {
            scope.$apply(function () {
              ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0, ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]);
            });
          } else {
            // if the item was not moved, then restore the elements
            // so that the ngRepeat's comment are correct.
            if ((!('dropindex' in ui.item.sortable) || ui.item.sortable.isCanceled()) && !_angular2.default.equals(element.contents(), savedNodes)) {
              var sortingHelper = getSortingHelper(element, ui, savedNodes);
              if (sortingHelper && sortingHelper.length) {
                // Restore all the savedNodes except from the sorting helper element.
                // That way it will be garbage collected.
                savedNodes = savedNodes.not(sortingHelper);
              }
              savedNodes.appendTo(element);
            }
          }

          // It's now safe to clear the savedNodes
          // since stop is the last callback.
          savedNodes = null;
        };

        callbacks.receive = function (e, ui) {
          // An item was dropped here from another list, set a flag on the
          // item.
          ui.item.sortable.received = true;
        };

        callbacks.remove = function (e, ui) {
          // Workaround for a problem observed in nested connected lists.
          // There should be an 'update' event before 'remove' when moving
          // elements. If the event did not fire, cancel sorting.
          if (!('dropindex' in ui.item.sortable)) {
            element.sortable('cancel');
            ui.item.sortable.cancel();
          }

          // Remove the item from this list's model and copy data into item,
          // so the next list can retrive it
          if (!ui.item.sortable.isCanceled()) {
            scope.$apply(function () {
              ui.item.sortable.moved = ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0];
            });
          }
        };

        wrappers.helper = function (inner) {
          if (inner && typeof inner === 'function') {
            return function (e, item) {
              var oldItemSortable = item.sortable;
              var index = getItemIndex(item);
              item.sortable = {
                model: ngModel.$modelValue[index],
                index: index,
                source: item.parent(),
                sourceModel: ngModel.$modelValue,
                _restore: function _restore() {
                  _angular2.default.forEach(item.sortable, function (value, key) {
                    item.sortable[key] = undefined;
                  });

                  item.sortable = oldItemSortable;
                }
              };

              var innerResult = inner.apply(this, arguments);
              item.sortable._restore();
              item.sortable._isCustomHelperUsed = item !== innerResult;
              return innerResult;
            };
          }
          return inner;
        };

        scope.$watchCollection('uiSortable', function (newVal, oldVal) {
          // ensure that the jquery-ui-sortable widget instance
          // is still bound to the directive's element
          var sortableWidgetInstance = getSortableWidgetInstance(element);
          if (!!sortableWidgetInstance) {
            var optsDiff = patchUISortableOptions(newVal, oldVal, sortableWidgetInstance);

            if (optsDiff) {
              element.sortable('option', optsDiff);
            }
          }
        }, true);

        patchUISortableOptions(opts);
      }

      function init() {
        if (ngModel) {
          wireUp();
        } else {
          $log.info('ui.sortable: ngModel not provided!', element);
        }

        // Create sortable
        element.sortable(opts);
      }

      function initIfEnabled() {
        if (scope.uiSortable && scope.uiSortable.disabled) {
          return false;
        }

        init();

        // Stop Watcher
        initIfEnabled.cancelWatcher();
        initIfEnabled.cancelWatcher = _angular2.default.noop;

        return true;
      }

      initIfEnabled.cancelWatcher = _angular2.default.noop;

      if (!initIfEnabled()) {
        initIfEnabled.cancelWatcher = scope.$watch('uiSortable.disabled', initIfEnabled);
      }
    }
  };
}]);

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.durationHumanize = durationHumanize;
exports.scheduleHumanize = scheduleHumanize;
exports.toHuman = toHuman;
exports.colWidth = colWidth;
exports.capitalize = capitalize;
exports.remove = remove;
exports.notEmpty = notEmpty;
exports.showError = showError;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _capitalize2 = __webpack_require__(52);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _underscore = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function durationHumanize(duration) {
  var humanized = '';

  if (duration === undefined) {
    humanized = '-';
  } else if (duration < 60) {
    var seconds = Math.round(duration);
    humanized = seconds + 's';
  } else if (duration > 3600 * 24) {
    var days = Math.round(parseFloat(duration) / 60.0 / 60.0 / 24.0);
    humanized = days + 'days';
  } else if (duration >= 3600) {
    var hours = Math.round(parseFloat(duration) / 60.0 / 60.0);
    humanized = hours + 'h';
  } else {
    var minutes = Math.round(parseFloat(duration) / 60.0);
    humanized = minutes + 'm';
  }
  return humanized;
}

function scheduleHumanize(schedule) {
  if (schedule === null) {
    return 'Never';
  } else if (schedule.match(/\d\d:\d\d/) !== null) {
    var parts = schedule.split(':');
    var localTime = _moment2.default.utc().hour(parts[0]).minute(parts[1]).local().format('HH:mm');

    return 'Every day at ' + localTime;
  }

  return 'Every ' + durationHumanize(parseInt(schedule, 10));
}

function toHuman(text) {
  return text.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

function colWidth(widgetWidth) {
  if (widgetWidth === 0) {
    return 0;
  } else if (widgetWidth === 1) {
    return 6;
  } else if (widgetWidth === 2) {
    return 12;
  }
  return widgetWidth;
}

function capitalize(text) {
  if (text) {
    return (0, _capitalize3.default)(text);
  }

  return null;
}

function remove(items, item) {
  if (items === undefined) {
    return items;
  }

  var notEquals = void 0;

  if (item instanceof Array) {
    notEquals = function notEquals(other) {
      return item.indexOf(other) === -1;
    };
  } else {
    notEquals = function notEquals(other) {
      return item !== other;
    };
  }

  var filtered = [];

  for (var i = 0; i < items.length; i += 1) {
    if (notEquals(items[i])) {
      filtered.push(items[i]);
    }
  }

  return filtered;
}

function notEmpty(collection) {
  return !(0, _underscore.isEmpty)(collection);
}

function showError(field) {
  return field.$touched && field.$invalid;
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _autofocus = __webpack_require__(386);

var _autofocus2 = _interopRequireDefault(_autofocus);

var _compareTo = __webpack_require__(387);

var _compareTo2 = _interopRequireDefault(_compareTo);

var _gridsterAutoHeight = __webpack_require__(388);

var _gridsterAutoHeight2 = _interopRequireDefault(_gridsterAutoHeight);

var _title = __webpack_require__(389);

var _title2 = _interopRequireDefault(_title);

var _resizeEvent = __webpack_require__(390);

var _resizeEvent2 = _interopRequireDefault(_resizeEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(ngModule) {
  (0, _autofocus2.default)(ngModule);
  (0, _compareTo2.default)(ngModule);
  (0, _gridsterAutoHeight2.default)(ngModule);
  (0, _title2.default)(ngModule);
  (0, _resizeEvent2.default)(ngModule);
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
autofocus.$inject = ['$timeout'];
function autofocus($timeout) {
  return {
    link: function link(scope, element) {
      $timeout(function () {
        element[0].focus();
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('autofocus', autofocus);
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function compareTo() {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link: function link(scope, element, attributes, ngModel) {
      var validate = function validate(value) {
        ngModel.$setValidity('compareTo', value === scope.otherModelValue);
      };

      scope.$watch('otherModelValue', function () {
        validate(ngModel.$modelValue);
      });

      ngModel.$parsers.push(function (value) {
        validate(value);
        return value;
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('compareTo', compareTo);
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _utils = __webpack_require__(73);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

gridsterAutoHeight.$inject = ['$timeout'];


function gridsterAutoHeight($timeout) {
  return {
    restrict: 'A',
    require: 'gridsterItem',
    link: function link($scope, $element, attr, controller) {
      var destroyed = false;

      function updateHeight() {
        var wrapper = $element[0];
        // Query element, but keep selector order
        var element = _.chain(attr.gridsterAutoHeight.split(',')).map(function (selector) {
          return wrapper.querySelector(selector);
        }).filter(_.isObject).first().value();
        if (element) {
          var childrenBounds = _.chain(element.children).map(function (child) {
            return child.getBoundingClientRect();
          }).reduce(function (result, bounds) {
            return {
              left: Math.min(result.left, bounds.left),
              top: Math.min(result.top, bounds.top),
              right: Math.min(result.right, bounds.right),
              bottom: Math.min(result.bottom, bounds.bottom)
            };
          }).value();

          var additionalHeight = 100 + _.last(controller.gridster.margins);
          var contentsHeight = childrenBounds.bottom - childrenBounds.top;
          $timeout(function () {
            controller.sizeY = Math.ceil((contentsHeight + additionalHeight) / controller.gridster.curRowHeight);
          });
        }

        if (!destroyed) {
          (0, _utils.requestAnimationFrame)(updateHeight);
        }
      }

      if (controller.sizeY < 0) {
        $element.addClass('gridster-auto-height-enabled');
        updateHeight();

        $scope.$on('$destroy', function () {
          destroyed = true;
        });
      }
    }
  };
}

function init(ngModule) {
  ngModule.directive('gridsterAutoHeight', gridsterAutoHeight);
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _utils = __webpack_require__(73);

title.$inject = ['$rootScope', 'Title'];
TitleService.$inject = ['$rootScope'];


function TitleService($rootScope) {
  var Title = {
    title: 'Redash',
    set: function set(newTitle) {
      this.title = newTitle;
      $rootScope.$broadcast('$titleChange');
    },
    get: function get() {
      return this.title;
    }
  };

  return Title;
}

function title($rootScope, Title) {
  return {
    restrict: 'E',
    link: function link(scope, element) {
      function updateTitle() {
        var newTitle = Title.get();
        (0, _utils.logger)('Updating title to: %s', newTitle);
        element.text(newTitle);
      }

      $rootScope.$on('$routeChangeSuccess', function (event, to) {
        if (to.title) {
          Title.set(to.title);
        }
      });
      $rootScope.$on('$titleChange', updateTitle);
    }
  };
}

function init(ngModule) {
  ngModule.factory('Title', TitleService).directive('title', title);
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _utils = __webpack_require__(73);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var items = new Map();

function checkItems() {
  items.forEach(function (item, node) {
    var offsetWidth = node.offsetWidth;
    var offsetHeight = node.offsetHeight;

    if (item.offsetWidth !== offsetWidth || item.offsetHeight !== offsetHeight) {
      item.offsetWidth = offsetWidth;
      item.offsetHeight = offsetHeight;
      item.callback(node);
    }
  });

  (0, _utils.requestAnimationFrame)(checkItems);
}

checkItems(); // ensure it was called only once!

function resizeEvent() {
  return {
    restrict: 'A',
    link: function link($scope, $element, attrs) {
      var node = $element[0];
      if (!items.has(node)) {
        items.set(node, {
          callback: function callback() {
            $scope.$evalAsync(attrs.resizeEvent);
          }
        });

        $scope.$on('$destroy', function () {
          var index = _.findIndex(items, function (item) {
            return item.node === node;
          });
          if (index >= 0) {
            items.splice(index, 1); // remove item
          }
        });
      }
    }
  };
}

function init(ngModule) {
  ngModule.directive('resizeEvent', resizeEvent);
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _markdown = __webpack_require__(392);

function init(ngModule) {
  ngModule.filter('markdown', ['$sce', 'clientConfig', function ($sce, clientConfig) {
    return function parseMarkdown(text) {
      if (!text) {
        return '';
      }

      var html = _markdown.markdown.toHTML(String(text));
      if (clientConfig.allowScriptsInUserInput) {
        html = $sce.trustAsHtml(html);
      }

      return html;
    };
  }]);
}

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(ngModule) {
  ngModule.filter('toMilliseconds', function () {
    return function (value) {
      return value * 1000.0;
    };
  });

  ngModule.filter('dateTime', ['clientConfig', function (clientConfig) {
    return function dateTime(value) {
      if (!value) {
        return '';
      }

      var parsed = (0, _moment2.default)(value);

      if (!parsed.isValid()) {
        return '-';
      }

      return parsed.format(clientConfig.dateTimeFormat);
    };
  }]);
}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
var dashboardGridOptions = {
  columns: 6,
  pushing: true,
  floating: true,
  swapping: true,
  width: 'auto',
  colWidth: 'auto',
  rowHeight: 50,
  margins: [15, 15],
  outerMargin: false,
  sparse: false,
  isMobile: false,
  mobileBreakPoint: 800,
  mobileModeEnabled: true,
  minColumns: 1,
  minRows: 1,
  maxRows: 100,
  defaultSizeX: 3,
  defaultSizeY: 3,
  minSizeX: 1,
  maxSizeX: null,
  minSizeY: 4,
  maxSizeY: null,
  resizable: {
    enabled: false,
    handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw']
  },
  draggable: {
    enabled: false
  }
};

function init(ngModule) {
  ngModule.constant('dashboardGridOptions', dashboardGridOptions);
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alerts/alert-subscriptions/index.js": 400,
	"./app-header/index.js": 402,
	"./cancel-query-button/index.js": 405,
	"./dashboards/add-widget-dialog.js": 406,
	"./dashboards/edit-dashboard-dialog.js": 408,
	"./dashboards/widget.js": 410,
	"./dynamic-form.js": 414,
	"./dynamic-table/default-cell/index.js": 416,
	"./dynamic-table/dynamic-table-row.js": 418,
	"./dynamic-table/index.js": 419,
	"./dynamic-table/json-cell/index.js": 422,
	"./dynamic-table/json-cell/json-view-interactive.js": 244,
	"./edit-in-place.js": 425,
	"./email-settings-warning/index.js": 426,
	"./error-messages.js": 427,
	"./filters.js": 428,
	"./footer/index.js": 430,
	"./groups/edit-group-dialog.js": 432,
	"./groups/group-name.js": 434,
	"./overlay.js": 435,
	"./page-header/index.js": 436,
	"./paginator.js": 438,
	"./parameters.js": 439,
	"./permissions-editor/index.js": 443,
	"./queries/alert-unsaved-changes.js": 445,
	"./queries/api-key-dialog.js": 446,
	"./queries/embed-code-dialog.js": 447,
	"./queries/query-editor.js": 449,
	"./queries/query-results-link.js": 455,
	"./queries/schedule-dialog.js": 456,
	"./queries/schema-browser.js": 458,
	"./queries/visualization-embed.js": 460,
	"./query-link.js": 462,
	"./rd-tab/index.js": 463,
	"./rd-time-ago.js": 464,
	"./rd-timer.js": 465,
	"./route-status.js": 466,
	"./settings-screen.js": 467,
	"./sort-icon.js": 469,
	"./tab-nav/index.js": 470,
	"./visualization-name.js": 471
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _alertSubscriptions = __webpack_require__(401);

var _alertSubscriptions2 = _interopRequireDefault(_alertSubscriptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['$scope', '$q', '$sce', 'currentUser', 'AlertSubscription', 'Destination', 'toastr'];


function controller($scope, $q, $sce, currentUser, AlertSubscription, Destination, toastr) {
  'ngInject';

  $scope.newSubscription = {};
  $scope.subscribers = [];
  $scope.destinations = [];
  $scope.currentUser = currentUser;

  $q.all([Destination.query().$promise, AlertSubscription.query({ alertId: $scope.alertId }).$promise]).then(function (responses) {
    var destinations = responses[0];
    var subscribers = responses[1];

    var mapF = function mapF(s) {
      return s.destination && s.destination.id;
    };
    var subscribedDestinations = (0, _underscore.compact)(subscribers.map(mapF));

    var subscribedUsers = (0, _underscore.compact)(subscribers.map(function (s) {
      return !s.destination && s.user.id;
    }));

    $scope.destinations = destinations.filter(function (d) {
      return !(0, _underscore.contains)(subscribedDestinations, d.id);
    });

    if (!(0, _underscore.contains)(subscribedUsers, currentUser.id)) {
      $scope.destinations.unshift({ user: { name: currentUser.name } });
    }

    $scope.newSubscription.destination = $scope.destinations[0];
    $scope.subscribers = subscribers;
  });

  $scope.destinationsDisplay = function (d) {
    if (!d) {
      return '';
    }

    var destination = d;
    if (d.destination) {
      destination = destination.destination;
    } else if (destination.user) {
      destination = {
        name: d.user.name + ' (Email)',
        icon: 'fa-envelope',
        type: 'user'
      };
    }

    return $sce.trustAsHtml('<i class="fa ' + destination.icon + '"></i>&nbsp;' + destination.name);
  };

  $scope.saveSubscriber = function () {
    var sub = new AlertSubscription({ alert_id: $scope.alertId });
    if ($scope.newSubscription.destination.id) {
      sub.destination_id = $scope.newSubscription.destination.id;
    }

    sub.$save(function () {
      toastr.success('Subscribed.');
      $scope.subscribers.push(sub);
      $scope.destinations = (0, _underscore.without)($scope.destinations, $scope.newSubscription.destination);
      if ($scope.destinations.length > 0) {
        $scope.newSubscription.destination = $scope.destinations[0];
      } else {
        $scope.newSubscription.destination = undefined;
      }
    }, function () {
      toastr.error('Failed saving subscription.');
    });
  };

  $scope.unsubscribe = function (subscriber) {
    var destination = subscriber.destination;
    var user = subscriber.user;

    subscriber.$delete(function () {
      toastr.success('Unsubscribed');
      $scope.subscribers = (0, _underscore.without)($scope.subscribers, subscriber);
      if (destination) {
        $scope.destinations.push(destination);
      } else if (user.id === currentUser.id) {
        $scope.destinations.push({ user: { name: currentUser.name } });
      }

      if ($scope.destinations.length === 1) {
        $scope.newSubscription.destination = $scope.destinations[0];
      }
    }, function () {
      toastr.error('Failed unsubscribing.');
    });
  };
}

function init(ngModule) {
  ngModule.directive('alertSubscriptions', function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        alertId: '='
      },
      template: _alertSubscriptions2.default,
      controller: controller
    };
  });
}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<div class=\"p-5\">\n  <h4>Notifications</h4>\n\n  <div>\n    <ui-select ng-model=\"newSubscription.destination\" ng-disabled=\"destinations.length == 0\">\n      <ui-select-match><span ng-bind-html=\"destinationsDisplay($select.selected)\"></span></ui-select-match>\n      <ui-select-choices repeat=\"d in destinations\">\n        <span ng-bind-html=\"destinationsDisplay(d)\"></span>\n      </ui-select-choices>\n    </ui-select>\n  </div>\n  <div class=\"m-t-5\">\n    <button class=\"btn btn-default\" ng-click=\"saveSubscriber()\" ng-disabled=\"destinations.length == 0\" style=\"width:50%;\">Add</button>\n    <span class=\"pull-right m-t-5\">\n      <a href=\"destinations/new\" ng-if=\"currentUser.isAdmin\">Create New Destination</a>\n    </span>\n  </div>\n\n  <hr/>\n\n  <div>\n    <div class=\"list-group-item\" ng-repeat=\"subscriber in subscribers\">\n      <span ng-bind-html=\"destinationsDisplay(subscriber)\"></span>\n      <button class=\"btn btn-xs btn-danger pull-right\" ng-click=\"unsubscribe(subscriber)\" ng-if=\"currentUser.isAdmin || currentUser.id == subscriber.user.id\">Remove</button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _redash_icon_small = __webpack_require__(74);

var _redash_icon_small2 = _interopRequireDefault(_redash_icon_small);

var _appHeader = __webpack_require__(403);

var _appHeader2 = _interopRequireDefault(_appHeader);

__webpack_require__(404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['$rootScope', '$location', '$uibModal', 'Auth', 'currentUser', 'clientConfig', 'Dashboard'];


var logger = (0, _debug2.default)('redash:appHeader');

function controller($rootScope, $location, $uibModal, Auth, currentUser, clientConfig, Dashboard) {
  var _this = this;

  this.logoUrl = _redash_icon_small2.default;
  this.basePath = clientConfig.basePath;
  this.currentUser = currentUser;
  this.showQueriesMenu = currentUser.hasPermission('view_query');
  this.showAlertsLink = currentUser.hasPermission('list_alerts');
  this.showNewQueryMenu = currentUser.hasPermission('create_query');
  this.showSettingsMenu = currentUser.hasPermission('list_users');
  this.showDashboardsMenu = currentUser.hasPermission('list_dashboards');

  this.reloadDashboards = function () {
    logger('Reloading dashboards.');
    _this.dashboards = Dashboard.recent();
  };

  this.reloadDashboards();

  $rootScope.$on('reloadDashboards', this.reloadDashboards);

  this.newDashboard = function () {
    $uibModal.open({
      component: 'editDashboardDialog',
      resolve: {
        dashboard: function dashboard() {
          return { name: null, layout: null };
        }
      }
    });
  };

  this.searchQueries = function () {
    $location.path('/queries/search').search({ q: _this.term });
  };

  this.logout = function () {
    Auth.logout();
  };
}

function init(ngModule) {
  ngModule.component('appHeader', {
    template: _appHeader2.default,
    controller: controller
  });
}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-default app-header\" role=\"navigation\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button type=\"button\" class=\"navbar-toggle\" ng-click=\"isNavOpen = !isNavOpen\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <!-- REDASH LOGO -->\n      <a class=\"navbar-brand\" ng-href=\"{{$ctrl.basePath}}\"><img ng-src=\"{{$ctrl.logoUrl}}\"/></a>\n    </div>\n    <div class=\"collapse navbar-collapse\" uib-collapse=\"!isNavOpen\">\n      <!-- Main Left Nav-->\n\n      <ul class=\"nav navbar-nav nav__main\">\n        <li class=\"dropdown btn-group\" ng-show=\"$ctrl.showDashboardsMenu\" uib-dropdown>\n          <a id=\"split-button\" class=\"btn\" href=\"dashboards\">Dashboards</a>\n          <a type=\"button\" class=\"btn hidden-xs\" uib-dropdown-toggle>\n            <span class=\"caret caret--nav\"></span>\n          </a>\n          <ul class=\"dropdown-menu\" uib-dropdown-menu>\n            <li><a href=\"dashboards\">All Dashboards</a></li>\n            <li class=\"divider\" ng-if=\"$ctrl.dashboards | notEmpty\"></li>\n            <li ng-repeat=\"dashboard in $ctrl.dashboards\">\n              <a href=\"dashboard/{{dashboard.slug}}\" ng-bind=\"dashboard.name\"></a>\n            </li>\n          </ul>\n        </li>\n        <li class=\"dropdown\" ng-show=\"$ctrl.showQueriesMenu\" uib-dropdown>\n          <a href=\"queries\">Queries</a>\n        </li>\n        <li ng-if=\"$ctrl.showAlertsLink\">\n          <a href=\"alerts\">Alerts</a>\n        </li>\n      </ul>\n\n      <!-- Add New Button -->\n      <div class=\"btn-group navbar-btn navbar-left btn__new hidden-xs\" uib-dropdown is-open=\"status.isopen\">\n        <button id=\"create-button\" type=\"button\" class=\"btn btn-primary btn--create\" uib-dropdown-toggle ng-disabled=\"disabled\">\n          Create <span class=\"caret caret--nav\"></span>\n        </button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"create-button\">\n          <li role=\"menuitem\" ng-show=\"$ctrl.showNewQueryMenu\"><a href=\"queries/new\">Query</a></li>\n          <li role=\"menuitem\"><a ng-show=\"$ctrl.currentUser.hasPermission('create_dashboard')\" ng-click=\"$ctrl.newDashboard()\">Dashboard</a></li>\n          <li role=\"menuitem\"><a href=\"alerts/new\">Alert</a></li>\n        </ul>\n      </div>\n\n      <!-- Profile -->\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li ng-show=\"$ctrl.currentUser.isAdmin\">\n          <a href=\"data_sources\" title=\"Settings\"><i class=\"fa fa-sliders\" aria-hidden=\"true\"></i></a>\n        </li>\n        <!--<li ng-show=\"$ctrl.showSettingsMenu\">-->\n          <!--<a href=\"users\" title=\"Settings\"><i class=\"fa fa-cog\"></i></a>-->\n        <!--</li>-->\n        <li class=\"dropdown\" uib-dropdown>\n          <a href=\"#\" class=\"dropdown-toggle dropdown--profile\" uib-dropdown-toggle>\n            <img ng-src=\"{{$ctrl.currentUser.profile_image_url}}\" class=\"profile__image--navbar\" width=\"20\"/>\n            <span class=\"dropdown--profile__username\" ng-bind=\"$ctrl.currentUser.name\"></span> <span\n            class=\"caret caret--nav\"></span></a>\n          <ul class=\"dropdown-menu dropdown-menu--profile\">\n            <li>\n              <a ng-href=\"users/{{$ctrl.currentUser.id}}\">Edit Profile</a>\n            </li>\n            <li class=\"divider\" ng-if=\"$ctrl.currentUser.hasPermission('super_admin')\">\n\n            <li ng-show=\"$ctrl.currentUser.isAdmin\">\n              <a href=\"data_sources\" title=\"Data Sources\">Data Sources</a>\n            </li>\n            <li ng-show=\"$ctrl.showSettingsMenu\">\n              <a href=\"groups\" title=\"Settings\">Groups</a>\n            </li>\n            <li ng-show=\"$ctrl.showSettingsMenu\">\n              <a href=\"users\" title=\"Settings\">Users</a>\n            </li>\n            <li>\n              <a ng-href=\"query_snippets\">Query Snippets</a>\n            </li>\n            <li ng-show=\"$ctrl.showSettingsMenu\">\n              <a href=\"destinations\" title=\"Settings\">Alert Destinations</a>\n            </li>\n\n            <li  ng-if=\"$ctrl.currentUser.hasPermission('super_admin')\" class=\"divider\"></li>\n\n            <li ng-if=\"$ctrl.currentUser.hasPermission('super_admin')\"><a href=\"admin/status\">System Status</a></li>\n\n            <li class=\"divider\"></li>\n\n            <li>\n              <a ng-click=\"$ctrl.logout()\">Log out</a>\n            </li>\n          </ul>\n        </li>\n      </ul>\n\n      <!-- Search -->\n      <form class=\"navbar-form navbar-right\" role=\"search\" ng-submit=\"$ctrl.searchQueries()\">\n        <div class=\"input-group menu-search\">\n          <input type=\"text\" ng-model=\"$ctrl.term\" class=\"form-control navbar__search__input\" placeholder=\"Search queries...\">\n          <span class=\"input-group-btn\">\n            <button type=\"submit\" class=\"btn btn-default\"><span class=\"zmdi zmdi-search\"></span></button>\n          </span>\n        </div>\n      </form>\n    </div>\n  </div>\n</nav>\n"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function cancelQueryButton() {
  return {
    restrict: 'E',
    scope: {
      queryId: '=',
      taskId: '='
    },
    transclude: true,
    template: '<button class="btn btn-default" ng-disabled="inProgress" ng-click="cancelExecution()"><i class="zmdi zmdi-spinner zmdi-hc-spin" ng-if="inProgress"></i> Cancel</button>',
    replace: true,
    controller: ['$scope', '$http', 'currentUser', 'Events', function controller($scope, $http, currentUser, Events) {
      $scope.inProgress = false;

      $scope.cancelExecution = function () {
        $http.delete('api/jobs/' + $scope.taskId).success(function () {});

        var queryId = $scope.queryId;
        if ($scope.queryId === 'adhoc') {
          queryId = null;
        }

        Events.record('cancel_execute', 'query', queryId, { admin: true });
        $scope.inProgress = true;
      };
    }]
  };
}

function init(ngModule) {
  ngModule.directive('cancelQueryButton', cancelQueryButton);
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _addWidgetDialog = __webpack_require__(407);

var _addWidgetDialog2 = _interopRequireDefault(_addWidgetDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddWidgetDialog = {
  template: _addWidgetDialog2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$sce', 'toastr', 'Query', 'Widget', function controller($sce, toastr, Query, Widget) {
    'ngInject';

    var _this = this;

    this.dashboard = this.resolve.dashboard;
    this.saveInProgress = false;
    this.selectedVis = null;
    this.query = {};
    this.selected_query = undefined;
    this.text = '';
    this.existing_text = '';
    this.new_text = '';
    this.isHidden = false;
    this.type = 'visualization';

    this.trustAsHtml = function (html) {
      return $sce.trustAsHtml(html);
    };
    this.isVisualization = function () {
      return _this.type === 'visualization';
    };
    this.isTextBox = function () {
      return _this.type === 'textbox';
    };

    this.setType = function (type) {
      _this.type = type;
    };

    this.onQuerySelect = function () {
      if (!_this.query.selected) {
        return;
      }

      Query.get({ id: _this.query.selected.id }, function (query) {
        if (query) {
          _this.selected_query = query;
          if (query.visualizations.length) {
            _this.selectedVis = query.visualizations[0];
          }
        }
      });
    };

    this.searchQueries = function (term) {
      if (!term || term.length < 3) {
        return;
      }

      Query.search({ q: term }, function (results) {
        _this.queries = results;
      });
    };

    this.saveWidget = function () {
      _this.saveInProgress = true;

      var widget = new Widget({
        visualization_id: _this.selectedVis && _this.selectedVis.id,
        dashboard_id: _this.dashboard.id,
        options: {
          isHidden: _this.isTextBox() && _this.isHidden,
          position: {}
        },
        visualization: _this.selectedVis,
        text: _this.text
      });

      var position = _this.dashboard.calculateNewWidgetPosition(widget);
      widget.options.position.col = position.col;
      widget.options.position.row = position.row;

      widget.$save().then(function (response) {
        // update dashboard layout
        _this.dashboard.version = response.version;
        _this.dashboard.widgets.push(new Widget(response.widget));
        _this.close();
      }).catch(function () {
        toastr.error('Widget can not be added');
      }).finally(function () {
        _this.saveInProgress = false;
      });
    };
  }]
};

function init(ngModule) {
  ngModule.component('addWidgetDialog', AddWidgetDialog);
}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-disabled=\"$ctrl.saveInProgress\" aria-hidden=\"true\" ng-click=\"$ctrl.dismiss()\">&times;</button>\n  <h4 class=\"modal-title\">Add Widget</h4>\n</div>\n<div class=\"modal-body\">\n  <p class=\"btn-group\">\n      <button type=\"button\" class=\"btn btn-default\" ng-class=\"{active: $ctrl.isVisualization()}\" ng-click=\"$ctrl.setType('visualization')\">Visualization</button>\n      <button type=\"button\" class=\"btn btn-default\" ng-class=\"{active: $ctrl.isTextBox()}\" ng-click=\"$ctrl.setType('textbox')\">Text Box</button>\n  </p>\n\n  <div ng-show=\"$ctrl.isTextBox()\">\n      <div class=\"form-group\">\n          <textarea class=\"form-control\" ng-model=\"$ctrl.text\" rows=\"3\"></textarea>\n      </div>\n      <div ng-show=\"$ctrl.text\">\n          <strong>Preview:</strong>\n          <p ng-bind-html=\"$ctrl.text | markdown\"></p>\n      </div>\n  </div>\n\n  <div ng-show=\"$ctrl.isVisualization()\">\n      <div class=\"form-group\">\n          <ui-select ng-model=\"$ctrl.query.selected\" theme=\"bootstrap\" reset-search-input=\"false\" on-select=\"$ctrl.onQuerySelect($item, $model)\">\n              <ui-select-match placeholder=\"Search a query by name\">{{$select.selected.name}}</ui-select-match>\n              <ui-select-choices repeat=\"q in $ctrl.queries\"\n                                 refresh=\"$ctrl.searchQueries($select.search)\"\n                                 refresh-delay=\"0\">\n                  <div ng-bind-html=\"$ctrl.trustAsHtml(q.name | highlight: $select.search)\"></div>\n              </ui-select-choices>\n          </ui-select>\n      </div>\n\n      <div ng-show=\"$ctrl.selected_query\">\n          <div class=\"form-group\">\n              <label for=\"\">Choose Visualization</label>\n              <select ng-model=\"$ctrl.selectedVis\" ng-options=\"vis as vis.name group by vis.type for vis in $ctrl.selected_query.visualizations\" class=\"form-control\"></select>\n          </div>\n      </div>\n  </div>\n\n  <div class=\"form-group\" ng-if=\"$ctrl.isTextBox()\">\n      <label><input type=\"checkbox\" ng-model=\"$ctrl.isHidden\">&nbsp;Hidden</label>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.saveInProgress\" ng-click=\"$ctrl.dismiss()\">Close</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.saveInProgress || !($ctrl.selectedVis || $ctrl.isTextBox())\" ng-click=\"$ctrl.saveWidget()\">Add to Dashboard</button>\n</div>\n"

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _editDashboardDialog = __webpack_require__(409);

var _editDashboardDialog2 = _interopRequireDefault(_editDashboardDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditDashboardDialog = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template: _editDashboardDialog2.default,
  controller: ['$rootScope', '$location', '$http', 'toastr', 'Events', 'Dashboard', function controller($rootScope, $location, $http, toastr, Events, Dashboard) {
    'ngInject';

    var _this = this;

    this.dashboard = this.resolve.dashboard;
    this.gridsterOptions = {
      margins: [5, 5],
      rowHeight: 100,
      colWidth: 260,
      columns: 2,
      mobileModeEnabled: false,
      swapping: true,
      minRows: 1,
      draggable: {
        enabled: true
      },
      resizable: {
        enabled: false
      }
    };

    this.isFormValid = function () {
      return !(0, _underscore.isEmpty)(_this.dashboard.name);
    };

    this.saveDashboard = function () {
      _this.saveInProgress = true;

      if (_this.dashboard.id) {
        var request = {
          slug: _this.dashboard.id,
          name: _this.dashboard.name,
          version: _this.dashboard.version,
          dashboard_filters_enabled: _this.dashboard.dashboard_filters_enabled
        };

        Dashboard.save(request, function (dashboard) {
          _this.dashboard = dashboard;
          _this.saveInProgress = false;
          _this.close({ $value: _this.dashboard });
          $rootScope.$broadcast('reloadDashboards');
        }, function (error) {
          _this.saveInProgress = false;
          if (error.status === 403) {
            toastr.error('Unable to save dashboard: Permission denied.');
          } else if (error.status === 409) {
            toastr.error('It seems like the dashboard has been modified by another user. ' + 'Please copy/backup your changes and reload this page.', { autoDismiss: false });
          }
        });
        Events.record('edit', 'dashboard', _this.dashboard.id);
      } else {
        $http.post('api/dashboards', {
          name: _this.dashboard.name
        }).success(function (response) {
          _this.close();
          $location.path('/dashboard/' + response.slug).replace();
        });
        Events.record('create', 'dashboard');
      }
    };
  }]
};

function init(ngModule) {
  ngModule.component('editDashboardDialog', EditDashboardDialog);
}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"$ctrl.dismiss()\" ng-disabled=\"$ctrl.saveInProgress\" aria-hidden=\"true\">&times;</button>\n  <h4 class=\"modal-title\">Dashboard name: {{$ctrl.dashboard.name}}</h4>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <input type=\"text\" class=\"form-control\" placeholder=\"Dashboard Name\" ng-model=\"$ctrl.dashboard.name\" autofocus>\n  </p>\n\n  <p ng-if=\"$ctrl.dashboard.id\">\n    <label>\n        <input name=\"input\" type=\"checkbox\" ng-model=\"$ctrl.dashboard.dashboard_filters_enabled\">\n        Use Dashboard Level Filters\n    </label>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.saveInProgress\" ng-click=\"$ctrl.dismiss()\">Close</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.saveInProgress || !$ctrl.isFormValid()\" ng-click=\"$ctrl.saveDashboard()\">Save</button>\n</div>\n"

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _widget = __webpack_require__(411);

var _widget2 = _interopRequireDefault(_widget);

var _editTextBox = __webpack_require__(412);

var _editTextBox2 = _interopRequireDefault(_editTextBox);

__webpack_require__(413);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

DashboardWidgetCtrl.$inject = ['$location', '$uibModal', '$window', 'Events', 'currentUser'];


var EditTextBoxComponent = {
  template: _editTextBox2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['toastr', function controller(toastr) {
    'ngInject';

    var _this = this;

    this.saveInProgress = false;
    this.widget = this.resolve.widget;
    this.saveWidget = function () {
      _this.saveInProgress = true;
      if (_this.widget.new_text !== _this.widget.existing_text) {
        _this.widget.text = _this.widget.new_text;
        _this.widget.$save().then(function () {
          _this.close();
        }).catch(function () {
          toastr.error('Widget can not be updated');
        }).finally(function () {
          _this.saveInProgress = false;
        });
      } else {
        _this.close();
      }
    };
  }]
};

function DashboardWidgetCtrl($location, $uibModal, $window, Events, currentUser) {
  var _this2 = this;

  this.canViewQuery = currentUser.hasPermission('view_query');

  this.editTextBox = function () {
    _this2.widget.existing_text = _this2.widget.text;
    _this2.widget.new_text = _this2.widget.text;
    $uibModal.open({
      component: 'editTextBox',
      resolve: {
        widget: _this2.widget
      }
    });
  };

  this.getWidgetStyles = function () {
    if (_.isObject(_this2.widget) && _.isObject(_this2.widget.visualization)) {
      var visualization = _this2.widget.visualization;
      if (visualization.type === 'PIVOT') {
        return { overflow: 'visible' };
      }
    }
  };

  this.localParametersDefs = function () {
    if (!_this2.localParameters) {
      _this2.localParameters = _this2.widget.getQuery().getParametersDefs().filter(function (p) {
        return !p.global;
      });
    }
    return _this2.localParameters;
  };

  this.deleteWidget = function () {
    if (!$window.confirm('Are you sure you want to remove "' + _this2.widget.getName() + '" from the dashboard?')) {
      return;
    }

    Events.record('delete', 'widget', _this2.widget.id);

    _this2.widget.$delete(function (response) {
      _this2.dashboard.widgets = _this2.dashboard.widgets.filter(function (widget) {
        return widget.id !== undefined;
      });
      _this2.dashboard.version = response.version;
      if (_this2.deleted) {
        _this2.deleted({});
      }
    });
  };

  Events.record('view', 'widget', this.widget.id);

  this.reload = function (force) {
    var maxAge = $location.search().maxAge;
    if (force) {
      maxAge = 0;
    }
    _this2.queryResult = _this2.query.getQueryResult(maxAge);
  };

  if (this.widget.visualization) {
    Events.record('view', 'query', this.widget.visualization.query.id, { dashboard: true });
    Events.record('view', 'visualization', this.widget.visualization.id, { dashboard: true });

    this.query = this.widget.getQuery();
    this.reload(false);

    this.type = 'visualization';
  } else if (this.widget.restricted) {
    this.type = 'restricted';
  } else {
    this.type = 'textbox';
  }
}

function init(ngModule) {
  ngModule.component('editTextBox', EditTextBoxComponent);
  ngModule.component('dashboardWidget', {
    template: _widget2.default,
    controller: DashboardWidgetCtrl,
    bindings: {
      widget: '<',
      public: '<',
      dashboard: '<',
      deleted: '&onDelete'
    }
  });
}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget-wrapper\">\n  <div class=\"tile body-container\" ng-if=\"$ctrl.type=='visualization'\" ng-class=\"$ctrl.type\"\n    ng-switch=\"$ctrl.queryResult.getStatus()\">\n    <div class=\"body-row\">\n      <div class=\"t-header widget clearfix\">\n        <div class=\"dropdown pull-right widget-menu-remove\"  ng-if=\"!$ctrl.public && $ctrl.dashboard.canEdit()\">\n          <div class=\"actions\">\n            <a ng-click=\"$ctrl.deleteWidget()\" title=\"Remove From Dashboard\"><i class=\"zmdi zmdi-close\"></i></a>\n          </div>\n        </div>\n        <div class=\"dropdown pull-right widget-menu-regular\" ng-if=\"!$ctrl.public\" uib-dropdown>\n          <div class=\"actions\">\n            <a data-toggle=\"dropdown\" uib-dropdown-toggle><i class=\"zmdi zmdi-more\"></i></a>\n          </div>\n\n          <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu style=\"z-index:1000000\">\n            <li ng-class=\"{'disabled': $ctrl.queryResult.isEmpty()}\"><a ng-href=\"{{$ctrl.queryResult.getLink($ctrl.query.id, 'csv')}}\" download=\"{{$ctrl.queryResult.getName($ctrl.query.name, 'csv')}}\" target=\"_self\">Download as CSV File</a></li>\n            <li ng-class=\"{'disabled': $ctrl.queryResult.isEmpty()}\"><a ng-href=\"{{$ctrl.queryResult.getLink($ctrl.query.id, 'xlsx')}}\" download=\"{{$ctrl.queryResult.getName($ctrl.query.name, 'xlsx')}}\" target=\"_self\">Download as Excel File</a></li>\n            <li><a ng-href=\"{{$ctrl.query.getUrl(true, $ctrl.widget.visualization.id)}}\" ng-show=\"$ctrl.canViewQuery\">View Query</a></li>\n            <li><a ng-show=\"$ctrl.dashboard.canEdit()\" ng-click=\"$ctrl.deleteWidget()\">Remove From Dashboard</a></li>\n          </ul>\n        </div>\n        <div class=\"th-title\">\n          <p class=\"hidden-print\">\n            <span ng-hide=\"$ctrl.canViewQuery\">{{$ctrl.query.name}}</span>\n            <query-link query=\"$ctrl.query\" visualization=\"$ctrl.widget.visualization\" ng-show=\"$ctrl.canViewQuery\"></query-link>\n            <small><visualization-name visualization=\"$ctrl.widget.visualization\"/></small>\n          </p>\n          <p class=\"visible-print\">\n            {{$ctrl.query.name}}\n            <visualization-name visualization=\"$ctrl.widget.visualization\"/>\n          </p>\n          <div class=\"text-muted query--description\" ng-bind-html=\"$ctrl.query.description | markdown\"></div>\n        </div>\n      </div>\n      <parameters parameters=\"$ctrl.localParametersDefs()\"></parameters>\n    </div>\n\n    <div ng-switch-when=\"failed\" class=\"body-row-auto scrollbox\">\n      <div class=\"alert alert-danger m-5\" ng-show=\"$ctrl.queryResult.getError()\">Error running query: <strong>{{$ctrl.queryResult.getError()}}</strong></div>\n    </div>\n    <div ng-switch-when=\"done\" class=\"body-row-auto scrollbox\" ng-style=\"$ctrl.getWidgetStyles()\">\n      <visualization-renderer visualization=\"$ctrl.widget.visualization\" query-result=\"$ctrl.queryResult\" class=\"t-body\"></visualization-renderer>\n    </div>\n    <div ng-switch-default class=\"body-row-auto spinner-container\">\n      <div class=\"spinner\">\n        <i class=\"zmdi zmdi-refresh zmdi-hc-spin zmdi-hc-5x\"></i>\n      </div>\n    </div>\n\n    <div class=\"body-row clearfix tile__bottom-control\">\n      <a class=\"small hidden-print\" ng-click=\"$ctrl.reload(true)\" ng-if=\"!$ctrl.public\">\n        <i class=\"zmdi zmdi-time-restore\"></i> <span am-time-ago=\"$ctrl.queryResult.getUpdatedAt()\"></span>\n      </a>\n      <span class=\"small hidden-print\" ng-if=\"$ctrl.public\">\n        <i class=\"zmdi zmdi-time-restore\"></i> <span am-time-ago=\"$ctrl.queryResult.getUpdatedAt()\"></span>\n      </span>\n      <span class=\"visible-print\">\n        <i class=\"zmdi zmdi-time-restore\"></i> {{$ctrl.queryResult.getUpdatedAt() | dateTime}}\n      </span>\n\n      <button class=\"btn btn-sm btn-default pull-right hidden-print btn-transparent btn__refresh\" ng-click=\"$ctrl.reload(true)\" ng-if=\"!$ctrl.public\"><i class=\"zmdi zmdi-refresh\"></i></button>\n    </div>\n  </div>\n\n  <div class=\"tile body-container\" ng-if=\"$ctrl.type=='restricted'\" ng-class=\"$ctrl.type\">\n    <div class=\"t-body body-row-auto scrollbox\">\n      <div class=\"text-center\">\n        <h1><span class=\"zmdi zmdi-lock\"></span></h1>\n        <p class=\"text-muted\">\n          This widget requires access to a data source you don't have access to.\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"tile body-container\" ng-hide=\"$ctrl.widget.width === 0\" ng-if=\"$ctrl.type=='textbox'\" ng-class=\"$ctrl.type\">\n    <div class=\"body-row clearfix t-body\">\n      <div class=\"dropdown pull-right widget-menu-remove\" ng-if=\"!$ctrl.public && $ctrl.dashboard.canEdit()\">\n        <div class=\"dropdown-header\">\n          <a class=\"actions\" ng-click=\"$ctrl.deleteWidget()\" title=\"Remove From Dashboard\"><i class=\"zmdi zmdi-close\"></i></a>\n        </div>\n      </div>\n      <div class=\"dropdown pull-right widget-menu-regular\" ng-if=\"!$ctrl.public && $ctrl.dashboard.canEdit()\" uib-dropdown>\n        <div class=\"dropdown-header\">\n          <a data-toggle=\"dropdown\" uib-dropdown-toggle class=\"actions\"><i class=\"zmdi zmdi-more\"></i></a>\n        </div>\n\n        <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu style=\"z-index:1000000\">\n          <li><a ng-show=\"$ctrl.dashboard.canEdit()\" ng-click=\"$ctrl.editTextBox()\">Edit</a></li>\n          <li><a ng-show=\"$ctrl.dashboard.canEdit()\" ng-click=\"$ctrl.deleteWidget()\">Remove From Dashboard</a></li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"body-row-auto scrollbox tiled t-body p-15\" ng-bind-html=\"$ctrl.widget.text | markdown\"></div>\n  </div>\n</div>\n"

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\">Edit TextBox</h4>\n</div>\n<div class=\"modal-body\">\n  <div class=\"form-group\">\n    <textarea class=\"form-control\" ng-model=\"$ctrl.widget.new_text\" rows=\"3\"></textarea>\n  </div>\n  <div ng-show=\"$ctrl.widget.new_text\">\n    <strong>Preview:</strong>\n    <p ng-bind-html=\"$ctrl.widget.new_text | markdown\"></p>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"$ctrl.saveInProgress\" ng-click=\"$ctrl.close()\">Close</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.saveInProgress\" ng-click=\"$ctrl.saveWidget()\">Save</button>\n</div>\n"

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _endsWith = __webpack_require__(242);

var _endsWith2 = _interopRequireDefault(_endsWith);

var _dynamicForm = __webpack_require__(415);

var _dynamicForm2 = _interopRequireDefault(_dynamicForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DynamicForm.$inject = ['$http', 'toastr', '$q'];


function DynamicForm($http, toastr, $q) {
  function orderedInputs(properties, order) {
    var inputs = new Array(order.length);
    Object.keys(properties).forEach(function (key) {
      var position = order.indexOf(key);
      var input = { name: key, property: properties[key] };
      if (position > -1) {
        inputs[position] = input;
      } else {
        inputs.push(input);
      }
    });
    return inputs;
  }

  return {
    restrict: 'E',
    replace: 'true',
    transclude: true,
    template: _dynamicForm2.default,
    scope: {
      target: '=',
      type: '@type',
      actions: '='
    },
    link: function link($scope) {
      function setType(types) {
        if ($scope.target.type === undefined) {
          $scope.target.type = types[0].type;
        }

        var type = (0, _underscore.find)(types, function (t) {
          return t.type === $scope.target.type;
        });
        var configurationSchema = type.configuration_schema;

        $scope.fields = orderedInputs(configurationSchema.properties, configurationSchema.order || []);

        return type;
      }

      $scope.inProgressActions = {};
      if ($scope.actions) {
        $scope.actions.forEach(function (action) {
          var originalCallback = action.callback;
          var name = action.name;
          action.callback = function () {
            action.name = '<i class="zmdi zmdi-spinner zmdi-hc-spin"></i> ' + name;

            $scope.inProgressActions[action.name] = true;
            function release() {
              $scope.inProgressActions[action.name] = false;
              action.name = name;
            }

            originalCallback(release);
          };
        });
      }

      $scope.files = {};

      $scope.$watchCollection('files', function () {
        (0, _underscore.each)($scope.files, function (v, k) {
          // THis is needed because angular-base64-upload sets the value to null at initialization,
          // causing the field to be marked as dirty even if it wasn't changed.
          if (!v && $scope.target.options[k]) {
            $scope.dataSourceForm.$setPristine();
          }
          if (v) {
            $scope.target.options[k] = v.base64;
          }
        });
      });

      var typesPromise = $http.get('api/' + $scope.type + '/types');

      $q.all([typesPromise, $scope.target.$promise]).then(function (responses) {
        var types = responses[0].data;
        setType(types);

        $scope.types = types;

        types.forEach(function (type) {
          (0, _underscore.each)(type.configuration_schema.properties, function (prop, name) {
            if (name === 'password' || name === 'passwd') {
              prop.type = 'password';
            }

            if ((0, _endsWith2.default)(name, 'File')) {
              prop.type = 'file';
            }

            if (prop.type === 'boolean') {
              prop.type = 'checkbox';
            }

            prop.required = (0, _underscore.contains)(type.configuration_schema.required, name);
          });
        });

        $scope.$watch('target.type', function (current, prev) {
          if (prev !== current) {
            if (prev !== undefined) {
              $scope.target.options = {};
            }

            var type = setType($scope.types);

            if (Object.keys($scope.target.options).length === 0) {
              var properties = type.configuration_schema.properties;
              Object.keys(properties).forEach(function (property) {
                if (!(0, _underscore.isUndefined)(properties[property].default)) {
                  $scope.target.options[property] = properties[property].default;
                }
              });
            }
          }
        });
      });

      $scope.saveChanges = function () {
        $scope.target.$save(function () {
          toastr.success('Saved.');
          $scope.dataSourceForm.$setPristine();
        }, function (error) {
          if (error.status === 400 && 'message' in error.data) {
            toastr.error(error.data.message);
          } else {
            toastr.error('Failed saving.');
          }
        });
      };
    }
  };
}

function init(ngModule) {
  ngModule.directive('dynamicForm', DynamicForm);
}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<form name=\"dataSourceForm\">\n    <div class=\"form-group\">\n        <label for=\"type\">Type</label>\n        <select name=\"type\" class=\"form-control\" ng-options=\"type.type as type.name for type in types\" ng-model=\"target.type\" autofocus></select>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"dataSourceName\">Name</label>\n        <input type=\"string\" class=\"form-control\" name=\"dataSourceName\" ng-model=\"target.name\" required>\n    </div>\n    <div class=\"form-group\" ng-class='{\"has-error\": !inner.input.$valid}' ng-form=\"inner\" ng-repeat=\"field in fields\">\n        <label ng-if=\"field.property.type !== 'checkbox'\">{{field.property.title || field.name | capitalize}}</label>\n        <input name=\"input\" type=\"{{field.property.type}}\" class=\"form-control\" ng-model=\"target.options[field.name]\" ng-required=\"field.property.required\"\n               ng-if=\"field.property.type !== 'file' && field.property.type !== 'checkbox'\" accesskey=\"tab\" placeholder=\"{{field.property.default}}\">\n\n        <label ng-if=\"field.property.type=='checkbox'\">\n            <input name=\"input\" type=\"{{field.property.type}}\" ng-model=\"target.options[field.name]\" ng-required=\"field.property.required\"\n                   ng-if=\"field.property.type !== 'file'\" accesskey=\"tab\" placeholder=\"{{field.property.default}}\">\n            {{field.property.title || field.name | capitalize}}\n        </label>\n\n        <input name=\"input\" type=\"file\" class=\"form-control\" ng-model=\"files[field.name]\" ng-required=\"field.property.required && !target.options[field.name]\"\n               base-sixty-four-input\n               ng-if=\"field.property.type === 'file'\">\n    </div>\n\n    <button class=\"btn btn-primary\" ng-disabled=\"!dataSourceForm.$valid\" ng-click=\"saveChanges()\">Save</button>\n    <span ng-repeat=\"action in actions\">\n        <button class=\"btn\"\n                ng-class=\"action.class\"\n                ng-if=\"target.id\"\n                ng-disabled=\"(action.disableWhenDirty && dataSourceForm.$dirty) || inProgressActions[action.name]\"\n                ng-click=\"action.callback()\" ng-bind-html=\"action.name\"></button>\n    </span>\n\n    <span ng-transclude>\n\n    </span>\n</form>\n"

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _template = __webpack_require__(417);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(ngModule) {
  ngModule.directive('dynamicTableDefaultCell', ['$sanitize', function ($sanitize) {
    return {
      template: _template2.default,
      restrict: 'E',
      replace: true,
      scope: {
        column: '=',
        value: '='
      },
      link: function link($scope) {
        $scope.sanitize = function (value) {
          return $sanitize(value);
        };
      }
    };
  }]);
}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<td ng-class=\"'content-align-' + column.alignContent\">\n  <div ng-if=\"column.allowHTML\" ng-bind-html=\"sanitize(column.formatFunction(value))\"></div>\n  <div ng-if=\"!column.allowHTML\" ng-bind=\"column.formatFunction(value)\"></div>\n</td>\n"

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

function init(ngModule) {
  ngModule.directive('dynamicTableRow', function () {
    return {
      template: '',
      // AngularJS has a strange love to table-related tags, therefore
      // we should use this directive as an attribute
      restrict: 'A',
      replace: false,
      scope: {
        columns: '=',
        row: '=',
        render: '='
      },
      link: function link($scope, $element) {
        $scope.$watch('render', function () {
          if ((0, _underscore.isFunction)($scope.render)) {
            $scope.render($scope, function (clonedElement) {
              $element.empty().append(clonedElement);
            });
          }
        });
      }
    };
  });
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _dynamicTable = __webpack_require__(420);

var _dynamicTable2 = _interopRequireDefault(_dynamicTable);

__webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DynamicTable.$inject = ['$compile'];


function filterRows(rows, searchTerm, columns) {
  if (searchTerm === '' || columns.length === 0 || rows.length === 0) {
    return rows;
  }
  searchTerm = searchTerm.toUpperCase();
  return (0, _underscore.filter)(rows, function (row) {
    for (var i = 0; i < columns.length; i += 1) {
      var columnName = columns[i].name;
      var formatFunction = columns[i].formatFunction;
      if (row[columnName] !== undefined) {
        var value = formatFunction ? formatFunction(row[columnName]) : row[columnName];
        value = ('' + value).toUpperCase();
        if (value.indexOf(searchTerm) >= 0) {
          return true;
        }
      }
    }
    return false;
  });
}

function sortRows(rows, orderBy) {
  if (orderBy.length === 0 || rows.length === 0) {
    return rows;
  }
  // Create a copy of array before sorting, because .sort() will modify original array
  return [].concat(rows).sort(function (a, b) {
    var va = void 0;
    var vb = void 0;
    for (var i = 0; i < orderBy.length; i += 1) {
      va = a[orderBy[i].name];
      vb = b[orderBy[i].name];
      if (va < vb) {
        // if a < b - we should return -1, but take in account direction
        return orderBy[i].direction * -1;
      }
      if (va > vb) {
        // if a > b - we should return 1, but take in account direction
        return orderBy[i].direction * 1;
      }
    }
    return 0;
  });
}

function validateItemsPerPage(value, defaultValue) {
  defaultValue = defaultValue || 10;
  value = parseInt(value, 10) || defaultValue;
  return value > 0 ? value : defaultValue;
}

// Optimized rendering
// Instead of using two nested `ng-repeat`s by rows and columns,
// we'll create a template for row (and update it when columns changed),
// compile it, and then use `ng-repeat` by rows and bind this template
// to each row's scope. The goal is to reduce amount of scopes and watchers
// from `count(rows) * count(cols)` to `count(rows)`. The major disadvantage
// is that cell markup should be specified here instead of template.
function createRowRenderTemplate(columns, $compile) {
  var rowTemplate = (0, _underscore.map)(columns, function (column, index) {
    switch (column.displayAs) {
      case 'json':
        return '\n            <dynamic-table-json-cell column="columns[' + index + ']" \n              value="row[columns[' + index + '].name]"></dynamic-table-json-cell>\n          ';
      default:
        return '\n            <dynamic-table-default-cell column="columns[' + index + ']" \n              value="row[columns[' + index + '].name]"></dynamic-table-default-cell>\n          ';
    }
  }).join('');
  return $compile(rowTemplate);
}

function DynamicTable($compile) {
  'ngInject';

  var _this = this;

  this.itemsPerPage = validateItemsPerPage(this.itemsPerPage);
  this.currentPage = 1;
  this.searchTerm = '';

  this.columns = [];
  this.rows = [];
  this.preparedRows = [];
  this.rowsToDisplay = [];
  this.orderBy = [];
  this.orderByColumnsIndex = {};
  this.orderByColumnsDirection = {};

  this.searchColumns = [];

  var updateOrderByColumnsInfo = function updateOrderByColumnsInfo() {
    _this.orderByColumnsIndex = {};
    _this.orderByColumnsDirection = {};
    (0, _underscore.each)(_this.orderBy, function (column, index) {
      _this.orderByColumnsIndex[column.name] = index + 1;
      _this.orderByColumnsDirection[column.name] = column.direction;
    });
  };

  var updateRowsToDisplay = function updateRowsToDisplay(performFilterAndSort) {
    if (performFilterAndSort) {
      _this.preparedRows = sortRows(filterRows(_this.rows, _this.searchTerm, _this.searchColumns), _this.orderBy);
    }
    var first = (_this.currentPage - 1) * _this.itemsPerPage;
    var last = first + _this.itemsPerPage;
    _this.rowsToDisplay = _this.preparedRows.slice(first, last);
  };

  var setColumns = function setColumns(columns) {
    // 1. reset sorting
    // 2. reset current page
    // 3. reset search
    // 4. get columns for search
    // 5. update row rendering template
    // 6. prepare rows

    _this.columns = columns;
    updateOrderByColumnsInfo();
    _this.orderBy = [];
    _this.currentPage = 1;
    _this.searchTerm = '';
    _this.searchColumns = (0, _underscore.filter)(_this.columns, 'allowSearch');
    _this.renderSingleRow = createRowRenderTemplate(_this.columns, $compile);
    updateRowsToDisplay(true);
  };

  var setRows = function setRows(rows) {
    // 1. reset current page
    // 2. prepare rows

    _this.rows = rows;
    _this.currentPage = 1;
    updateRowsToDisplay(true);
  };

  this.renderSingleRow = null;

  this.onColumnHeaderClick = function ($event, column) {
    var orderBy = (0, _underscore.find)(_this.orderBy, function (item) {
      return item.name === column.name;
    });
    if (orderBy) {
      // ASC -> DESC -> off
      if (orderBy.direction === 1) {
        orderBy.direction = -1;
        if (!$event.shiftKey) {
          _this.orderBy = [orderBy];
        }
      } else {
        if ($event.shiftKey) {
          _this.orderBy = (0, _underscore.filter)(_this.orderBy, function (item) {
            return item.name !== column.name;
          });
        } else {
          _this.orderBy = [];
        }
      }
    } else {
      if (!$event.shiftKey) {
        _this.orderBy = [];
      }
      _this.orderBy.push({
        name: column.name,
        direction: 1
      });
    }
    updateOrderByColumnsInfo();
    updateRowsToDisplay(true);

    // Remove text selection - may occur accidentally
    if ($event.shiftKey) {
      document.getSelection().removeAllRanges();
    }
  };

  this.onPageChanged = function () {
    updateRowsToDisplay(false);
  };

  this.onSearchTermChanged = function () {
    _this.preparedRows = sortRows(filterRows(_this.rows, _this.searchTerm, _this.searchColumns), _this.orderBy);
    _this.currentPage = 1;
    updateRowsToDisplay(true);
  };

  this.$onChanges = function (changes) {
    if (changes.columns) {
      if (changes.rows) {
        // if rows also changed - temporarily set if to empty array - to avoid
        // filtering and sorting
        _this.rows = [];
      }
      setColumns(changes.columns.currentValue);
    }

    if (changes.rows) {
      setRows(changes.rows.currentValue);
    }

    if (changes.itemsPerPage) {
      _this.itemsPerPage = validateItemsPerPage(_this.itemsPerPage);
      _this.currentPage = 1;
      updateRowsToDisplay(false);
    }
  };
}

function init(ngModule) {
  ngModule.component('dynamicTable', {
    template: _dynamicTable2.default,
    controller: DynamicTable,
    bindings: {
      rows: '<',
      columns: '<',
      itemsPerPage: '<'
    }
  });
}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dynamic-table-container\">\n  <table class=\"table table-condensed table-hover\">\n    <thead>\n      <tr>\n        <th ng-repeat=\"column in $ctrl.columns\" ng-click=\"$ctrl.onColumnHeaderClick($event, column)\"\n          class=\"sortable-column\" ng-class=\"'content-align-' + column.alignContent\">\n          <span ng-if=\"($ctrl.orderBy.length > 1) && ($ctrl.orderByColumnsIndex[column.name] > 0)\"\n            class=\"sort-order-indicator\">{{ $ctrl.orderByColumnsIndex[column.name] }}</span>\n          <span>{{column.title}}</span>\n          <i ng-if=\"$ctrl.orderByColumnsIndex[column.name] > 0\"\n            ng-class=\"{\n              'fa': true,\n              'fa-caret-down': $ctrl.orderByColumnsDirection[column.name] > 0,\n              'fa-caret-up': $ctrl.orderByColumnsDirection[column.name] < 0\n            }\"></i>\n        </th>\n      </tr>\n    </thead>\n    <thead ng-if=\"$ctrl.searchColumns.length > 0\">\n      <th class=\"p-t-10 p-b-10 p-l-15 p-r-15\" colspan=\"{{ $ctrl.columns.length }}\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search...\"\n          ng-model=\"$ctrl.searchTerm\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\"\n          ng-change=\"$ctrl.onSearchTermChanged()\">\n      </th>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"row in $ctrl.rowsToDisplay\"\n        dynamic-table-row columns=\"$ctrl.columns\" row=\"row\"\n        render=\"$ctrl.renderSingleRow\"\n      ></tr>\n    </tbody>\n  </table>\n</div>\n<div class=\"paginator-container\" ng-if=\"$ctrl.preparedRows.length > $ctrl.itemsPerPage\">\n  <ul uib-pagination total-items=\"$ctrl.preparedRows.length\"\n      items-per-page=\"$ctrl.itemsPerPage\"\n      ng-model=\"$ctrl.currentPage\"\n      max-size=\"6\"\n      class=\"pagination\"\n      boundary-link-numbers=\"true\"\n      rotate=\"false\"\n      next-text='&#8594;'\n      previous-text='&#8592;'\n      ng-change=\"$ctrl.onPageChanged()\"></ul>\n</div>\n"

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _jsonViewInteractive = __webpack_require__(244);

var _jsonViewInteractive2 = _interopRequireDefault(_jsonViewInteractive);

var _template = __webpack_require__(424);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_JSON_SIZE = 50000;

function parseValue(value) {
  if ((0, _underscore.isString)(value) && value.length <= MAX_JSON_SIZE) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return undefined;
    }
  }
}

function init(ngModule) {
  ngModule.directive('dynamicTableJsonCell', function () {
    return {
      template: _template2.default,
      restrict: 'E',
      replace: true,
      scope: {
        column: '=',
        value: '='
      },
      link: function link($scope, $element) {
        var container = $element.find('.json-cell-valid');

        $scope.isValid = false;
        $scope.parsedValue = null;

        $scope.$watch('value', function () {
          $scope.parsedValue = parseValue($scope.value);
          $scope.isValid = !(0, _underscore.isUndefined)($scope.parsedValue);
          container.empty();
          (0, _jsonViewInteractive2.default)(container, $scope.parsedValue);
        });
      }
    };
  });
}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<td>\n  <div ng-if=\"!isValid\" class=\"json-cell-invalid\">{{ value }}</div>\n  <div ng-show=\"isValid\" class=\"json-cell-valid\"></div>\n</td>\n"

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// From: http://jsfiddle.net/joshdmiller/NDFHg/
function EditInPlace() {
  return {
    restrict: 'E',
    scope: {
      value: '=',
      ignoreBlanks: '=',
      editable: '=',
      done: '='
    },
    template: function template(tElement, tAttrs) {
      var elType = tAttrs.editor || 'input';
      var placeholder = tAttrs.placeholder || 'Click to edit';

      var viewMode = '';

      if (tAttrs.markdown === 'true') {
        viewMode = '<span ng-click="editable && edit()" ng-bind-html="value|markdown" ng-class="{editable: editable}"></span>';
      } else {
        viewMode = '<span ng-click="editable && edit()" ng-bind="value" ng-class="{editable: editable}"></span>';
      }

      var placeholderSpan = '<span ng-click="editable && edit()"\n                                     ng-show="editable && !value"\n                                     ng-class="{editable: editable}">' + placeholder + '</span>';
      var editor = '<{elType} ng-model="value" class="rd-form-control"></{elType}>'.replace('{elType}', elType);

      return viewMode + placeholderSpan + editor;
    },
    link: function link($scope, element) {
      // Let's get a reference to the input element, as we'll want to reference it.
      var inputElement = (0, _jquery2.default)(element.children()[2]);
      var keycodeEnter = 13;
      var keycodeEscape = 27;

      // This directive should have a set class so we can style it.
      element.addClass('edit-in-place');

      // Initially, we're not editing.
      $scope.editing = false;

      // ng-click handler to activate edit-in-place
      $scope.edit = function () {
        $scope.oldValue = $scope.value;

        $scope.editing = true;

        // We control display through a class on the directive itself. See the CSS.
        element.addClass('active');

        // And we must focus the element.
        // `angular.element()` provides a chainable array, like jQuery so to access
        // a native DOM function, we have to reference the first element in the array.
        inputElement[0].focus();
      };

      function save() {
        if ($scope.editing) {
          if ($scope.ignoreBlanks && (0, _underscore.isEmpty)($scope.value)) {
            $scope.value = $scope.oldValue;
          }
          $scope.editing = false;
          element.removeClass('active');

          if ($scope.value !== $scope.oldValue) {
            if ($scope.done) {
              $scope.done();
            }
          }
        }
      }

      (0, _jquery2.default)(inputElement).keydown(function (e) {
        // 'return' or 'enter' key pressed
        // allow 'shift' to break lines
        if (e.which === keycodeEnter && !e.shiftKey) {
          e.preventDefault();
          save();
        } else if (e.which === keycodeEscape) {
          $scope.value = $scope.oldValue;
          $scope.$apply(function () {
            (0, _jquery2.default)(inputElement[0]).blur();
          });
        }
      }).blur(function () {
        save();
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('editInPlace', EditInPlace);
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
controller.$inject = ['clientConfig', 'currentUser'];
function controller(clientConfig, currentUser) {
  this.showMailWarning = clientConfig.mailSettingsMissing && currentUser.isAdmin;
}

function init(ngModule) {
  ngModule.component('emailSettingsWarning', {
    bindings: {
      function: '<'
    },
    template: '<p class="alert alert-danger" ng-if="$ctrl.showMailWarning">It looks like your mail server isn\'t configured. Make sure to configure it for the {{$ctrl.function}} to work.</p>',
    controller: controller
  });
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
var ErrorMessagesComponent = {
  template: '\n  <div class="help-block" ng-messages="$ctrl.input.$error" ng-show="$ctrl.input.$touched || $ctrl.form.$submitted">\n    <span class="error" ng-message="required">This field is required.</span>\n    <span class="error" ng-message="minlength">This field is too short.</span>\n    <span class="error" ng-message="email">This needs to be a valid email.</span>\n  </div>\n  ',
  replace: true,
  bindings: {
    input: '<',
    form: '<'
  },
  controller: function controller() {}
};

function init(ngModule) {
  ngModule.component('errorMessages', ErrorMessagesComponent);
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _filters = __webpack_require__(429);

var _filters2 = _interopRequireDefault(_filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersComponent = {
  template: _filters2.default,
  bindings: {
    onChange: '&',
    filters: '<'
  },
  controller: function controller() {
    'ngInject';

    var _this = this;

    this.filterChangeListener = function (filter, modal) {
      _this.onChange({ filter: filter, $modal: modal });
    };

    this.itemGroup = function (item) {
      if (item === '*' || item === '-') {
        return '';
      }

      return 'Values';
    };
  }
};

function init(ngModule) {
  ngModule.component('filters', FiltersComponent);
}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container bg-white p-b-15\" ng-show=\"$ctrl.filters | notEmpty\">\n  <div class=\"row\">\n    <div class=\"col-sm-6 p-l-0\" ng-repeat=\"filter in $ctrl.filters\">\n      <label>{{filter.friendlyName}}</label>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-6 p-l-0\" ng-repeat=\"filter in $ctrl.filters\">\n      <ui-select ng-model=\"filter.current\" ng-if=\"!filter.multiple\" on-select=\"$ctrl.filterChangeListener(filter, $model)\" on-remove=\"$ctrl.filterChangeListener(filter, $model)\"\n        remove-selected=\"false\">\n        <ui-select-match placeholder=\"Select value for {{filter.friendlyName}}...\">{{$select.selected | filterValue:filter}}</ui-select-match>\n        <ui-select-choices repeat=\"value in filter.values | filter: $select.search\">\n          {{value | filterValue:filter }}\n        </ui-select-choices>\n      </ui-select>\n\n      <ui-select ng-model=\"filter.current\" multiple ng-if=\"filter.multiple\" on-select=\"$ctrl.filterChangeListener(filter, $model)\"\n        on-remove=\"$ctrl.filterChangeListener(filter, $model)\" remove-selected=\"false\">\n        <ui-select-match placeholder=\"Select value for {{filter.friendlyName}}...\">{{$item | filterValue:filter}}</ui-select-match>\n        <ui-select-choices repeat=\"value in filter.values | filter: $select.search\" group-by=\"$ctrl.itemGroup\">\n          <span ng-if=\"value == '*'\">\n            Select All\n          </span>\n          <span ng-if=\"value == '-'\">\n            Clear\n          </span>\n          <span ng-if=\"value != '*' && value != '-'\">\n            {{value | filterValue:filter }}\n          </span>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _footer = __webpack_require__(431);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['clientConfig', 'currentUser'];


function controller(clientConfig, currentUser) {
  this.version = clientConfig.version;
  this.newVersionAvailable = clientConfig.newVersionAvailable && currentUser.isAdmin;
}

function init(ngModule) {
  ngModule.component('footer', {
    template: _footer2.default,
    controller: controller
  });
}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "<div id=\"footer\">\n    <a href=\"http://redash.io\">Redash</a> <span ng-bind=\"$ctrl.version\"></span> <small ng-if=\"$ctrl.newVersionAvailable\" ng-cloak class=\"ng-cloak\"><a href=\"https://version.redash.io/\">(New Redash version available)</a></small>\n    &#8226;\n    <a href=\"https://redash.io/help/\">Documentation</a>\n    &#8226;\n    <a href=\"http://github.com/getredash/redash\">Contribute</a>\n</div>\n"

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _editGroupDialog = __webpack_require__(433);

var _editGroupDialog2 = _interopRequireDefault(_editGroupDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditGroupDialogComponent = {
  template: _editGroupDialog2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$location', function controller($location) {
    'ngInject';

    var _this = this;

    this.group = this.resolve.group;
    var newGroup = this.group.id === undefined;

    if (newGroup) {
      this.saveButtonText = 'Create';
      this.title = 'Create a New Group';
    } else {
      this.saveButtonText = 'Save';
      this.title = 'Edit Group';
    }

    this.ok = function () {
      _this.group.$save(function (group) {
        if (newGroup) {
          $location.path('/groups/' + group.id).replace();
          _this.close();
        } else {
          _this.close();
        }
      });
    };
  }]
};

function init(ngModule) {
  ngModule.component('editGroupDialog', EditGroupDialogComponent);
}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{$ctrl.title}}</h3>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form\">\n        <input type=\"text\" ng-model=\"$ctrl.group.name\" placeholder=\"Group Name\" class=\"form-control\" autofocus/>\n    </form>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" ng-click=\"$ctrl.close()\">Cancel</button>\n    <button class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">{{$ctrl.saveButtonText}}</button>\n</div>\n"

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
controller.$inject = ['$window', '$location', 'toastr', 'currentUser'];
function controller($window, $location, toastr, currentUser) {
  var _this = this;

  this.canEdit = function () {
    return currentUser.isAdmin && _this.group.type !== 'builtin';
  };

  this.saveName = function () {
    _this.group.$save();
  };

  this.deleteGroup = function () {
    if ($window.confirm('Are you sure you want to delete this group?')) {
      _this.group.$delete(function () {
        $location.path('/groups').replace();
        toastr.success('Group deleted successfully.');
      });
    }
  };
}

function init(ngModule) {
  ngModule.component('groupName', {
    bindings: {
      group: '<'
    },
    transclude: true,
    template: '\n      <h2 class="p-l-5">\n        <edit-in-place editable="$ctrl.canEdit()" done="$ctrl.saveName" ignore-blanks=\'true\' value="$ctrl.group.name"></edit-in-place>&nbsp;\n        <button class="btn btn-xs btn-danger" ng-if="$ctrl.canEdit()" ng-click="$ctrl.deleteGroup()">Delete this group</button>\n      </h2>\n    ',
    replace: true,
    controller: controller
  });
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
var Overlay = {
  template: '\n  <div>\n    <div class="overlay"></div>\n    <div style="width: 100%; position:absolute; top:50px; z-index:2000">\n      <div class="well well-lg" style="width: 70%; margin: auto;" ng-transclude>\n      </div>\n    </div>\n  </div>\n  ',
  transclude: true
};

function init(ngModule) {
  ngModule.component('overlay', Overlay);
}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _pageHeader = __webpack_require__(437);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function controller() {}

function init(ngModule) {
  ngModule.component('pageHeader', {
    template: _pageHeader2.default,
    controller: controller,
    transclude: true,
    bindings: {
      title: '@'
    }
  });
}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row bg-white tiled p-10 p-l-15 p-r-15 m-b-10 m-l-0 m-r-0\">\n  <div class=\"col-sm-9 p-l-0 p-r-0\">\n    <h3>{{$ctrl.title}}</h3>\n  </div>\n  <div class=\"col-sm-3 text-right\">\n    <h3 ng-transclude>\n    </h3>\n  </div>\n</div>\n"

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = init;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorCtrl = function () {
  function PaginatorCtrl() {
    _classCallCheck(this, PaginatorCtrl);

    this.page = this.paginator.page;
  }

  _createClass(PaginatorCtrl, [{
    key: 'pageChanged',
    value: function pageChanged() {
      this.paginator.setPage(this.page);
    }
  }]);

  return PaginatorCtrl;
}();

function init(ngModule) {
  ngModule.component('paginator', {
    template: '\n<div class="paginator-container" ng-if="$ctrl.paginator.totalCount > $ctrl.paginator.itemsPerPage">\n  <ul uib-pagination total-items="$ctrl.paginator.totalCount"\n                     items-per-page="$ctrl.paginator.itemsPerPage"\n                     ng-model="$ctrl.page"\n                     max-size="6"\n                     class="pagination"\n                     boundary-link-numbers="true"\n                     rotate="false"\n                     next-text=\'&#8594;\'\n                     previous-text=\'&#8592;\'\n                     ng-change="$ctrl.pageChanged()"></ul>\n</div>\n    ',
    bindings: {
      paginator: '<'
    },
    controller: PaginatorCtrl
  });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _parameters = __webpack_require__(440);

var _parameters2 = _interopRequireDefault(_parameters);

var _queryBasedParameter = __webpack_require__(441);

var _queryBasedParameter2 = _interopRequireDefault(_queryBasedParameter);

var _parameterSettings = __webpack_require__(442);

var _parameterSettings2 = _interopRequireDefault(_parameterSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ParametersDirective.$inject = ['$location', '$uibModal'];


var ParameterSettingsComponent = {
  template: _parameterSettings2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$sce', 'Query', function controller($sce, Query) {
    'ngInject';

    var _this = this;

    this.trustAsHtml = function (html) {
      return $sce.trustAsHtml(html);
    };
    this.parameter = this.resolve.parameter;

    if (this.parameter.queryId) {
      Query.get({ id: this.parameter.queryId }, function (query) {
        _this.queries = [query];
      });
    }

    this.searchQueries = function (term) {
      if (!term || term.length < 3) {
        return;
      }

      Query.search({ q: term }, function (results) {
        _this.queries = results;
      });
    };
  }]
};

function optionsFromQueryResult(queryResult) {
  var columns = queryResult.data.columns;
  var numColumns = columns.length;
  var options = [];
  // If there are multiple columns, check if there is a column
  // named 'name' and column named 'value'. If name column is present
  // in results, use name from name column. Similar for value column.
  // Default: Use first string column for name and value.
  if (numColumns > 0) {
    var nameColumn = null;
    var valueColumn = null;
    columns.forEach(function (column) {
      var columnName = column.name.toLowerCase();
      if (columnName === 'name') {
        nameColumn = column.name;
      }
      if (columnName === 'value') {
        valueColumn = column.name;
      }
      // Assign first string column as name and value column.
      if (nameColumn === null) {
        nameColumn = column.name;
      }
      if (valueColumn === null) {
        valueColumn = column.name;
      }
    });
    if (nameColumn !== null && valueColumn !== null) {
      options = queryResult.data.rows.map(function (row) {
        var queryResultOption = {
          name: row[nameColumn],
          value: row[valueColumn]
        };
        return queryResultOption;
      });
    }
  }
  return options;
}

function updateCurrentValue(param, options) {
  var found = (0, _underscore.find)(options, function (option) {
    return option.value === param.value;
  }) !== undefined;

  if (!found) {
    param.value = options[0].value;
  }
}

var QueryBasedParameterComponent = {
  template: _queryBasedParameter2.default,
  bindings: {
    param: '<',
    queryId: '<'
  },
  controller: ['Query', function controller(Query) {
    'ngInject';

    var _this2 = this;

    this.$onChanges = function (changes) {
      if (changes.queryId) {
        Query.resultById({ id: _this2.queryId }, function (result) {
          var queryResult = result.query_result;
          _this2.queryResultOptions = optionsFromQueryResult(queryResult);
          updateCurrentValue(_this2.param, _this2.queryResultOptions);
        });
      }
    };
  }]
};

function ParametersDirective($location, $uibModal) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      parameters: '=',
      syncValues: '=?',
      editable: '=?',
      changed: '&onChange'
    },
    template: _parameters2.default,
    link: function link(scope) {
      // is this the correct location for this logic?
      if (scope.syncValues !== false) {
        scope.$watch('parameters', function () {
          if (scope.changed) {
            scope.changed({});
          }
          scope.parameters.forEach(function (param) {
            if (param.value !== null || param.value !== '') {
              $location.search('p_' + param.name, param.value);
            }
          });
        }, true);
      }

      // These are input as newline delimited values,
      // so we split them here.
      scope.extractEnumOptions = function (enumOptions) {
        if (enumOptions) {
          return enumOptions.split('\n');
        }
        return [];
      };
      scope.showParameterSettings = function (param) {
        $uibModal.open({
          component: 'parameterSettings',
          resolve: {
            parameter: param
          }
        });
      };
    }
  };
}

function init(ngModule) {
  ngModule.directive('parameters', ParametersDirective);
  ngModule.component('queryBasedParameter', QueryBasedParameterComponent);
  ngModule.component('parameterSettings', ParameterSettingsComponent);
}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-inline bg-white p-15\"\n     ng-if=\"parameters | notEmpty\"\n     ui-sortable=\"{ 'ui-floating': true, 'disabled': !editable }\"\n     ng-model=\"parameters\">\n  <div class=\"form-group m-r-10\"\n       ng-repeat=\"param in parameters\">\n    <label class=\"parameter-label\">{{param.title}}</label>\n    <button class=\"btn btn-default btn-xs\"\n            ng-click=\"showParameterSettings(param)\"\n            ng-if=\"editable\">\n        <i class=\"zmdi zmdi-settings\"></i>\n    </button>\n    <span ng-switch=\"param.type\">\n      <input ng-switch-when=\"datetime-with-seconds\" type=\"datetime-local\" step=\"1\" class=\"form-control\" ng-model=\"param.ngModel\">\n      <input ng-switch-when=\"datetime-local\" type=\"datetime-local\" class=\"form-control\" ng-model=\"param.ngModel\">\n      <input ng-switch-when=\"date\" type=\"date\" class=\"form-control\" ng-model=\"param.ngModel\">\n      <span ng-switch-when=\"enum\">\n        <select ng-model=\"param.value\" class=\"form-control\">\n          <option ng-repeat=\"option in extractEnumOptions(param.enumOptions)\" value=\"{{option}}\">{{option}}</option>\n        </select>\n      </span>\n      <span ng-switch-when=\"query\">\n        <query-based-parameter param=\"param\" query-id=\"param.queryId\"></query-based-parameter>\n      </span>\n      <input ng-switch-default type=\"{{param.type}}\" class=\"form-control\" ng-model=\"param.ngModel\">\n    </span>\n  </div>\n</div>\n"

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "<select ng-model=\"$ctrl.param.value\" class=\"form-control\" ng-options=\"option.value as option.name for option in $ctrl.queryResultOptions\">\n</select>"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span></button>\n    <h4 class=\"modal-title\">{{$ctrl.parameter.name}}</h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"form\">\n      <div class=\"form-group\">\n        <label>Title</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.parameter.title\">\n      </div>\n      <div class=\"form-group\">\n        <label>Type</label>\n        <select ng-model=\"$ctrl.parameter.type\" class=\"form-control\">\n          <option value=\"text\">Text</option>\n          <option value=\"number\">Number</option>\n          <option value=\"enum\">Dropdown List</option>\n          <option value=\"query\">Query Based Dropdown List</option>\n          <option value=\"date\">Date</option>\n          <option value=\"datetime-local\">Date and Time</option>\n          <option value=\"datetime-with-seconds\">Date and Time (with seconds)</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <input type=\"checkbox\" class=\"form-inline\" ng-model=\"$ctrl.parameter.global\">\n          Global\n        </label>\n      </div>\n      <div class=\"form-group\" ng-if=\"$ctrl.parameter.type === 'enum'\">\n        <label>Dropdown List Values (newline delimited)</label>\n        <textarea class=\"form-control\" rows=\"3\" ng-model=\"$ctrl.parameter.enumOptions\"></textarea>\n      </div>\n      <div class=\"form-group\" ng-if=\"$ctrl.parameter.type === 'query'\">\n        <label>Query to load dropdown values from:</label>\n        <ui-select ng-model=\"$ctrl.parameter.queryId\" reset-search-input=\"false\">\n            <ui-select-match placeholder=\"Search a query by name\">{{$select.selected.name}}</ui-select-match>\n            <ui-select-choices repeat=\"q.id as q in $ctrl.queries\"\n                               refresh=\"$ctrl.searchQueries($select.search)\"\n                               refresh-delay=\"0\">\n            <div class=\"form-group\" ng-bind-html=\"$ctrl.trustAsHtml(q.name | highlight: $select.search)\"></div>\n            </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n</div>\n"

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _permissionsEditor = __webpack_require__(444);

var _permissionsEditor2 = _interopRequireDefault(_permissionsEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionsEditorComponent = {
  template: _permissionsEditor2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$http', 'User', function controller($http, User) {
    'ngInject';

    var _this = this;

    this.grantees = [];
    this.newGrantees = {};
    this.aclUrl = this.resolve.aclUrl.url;

    // List users that are granted permissions
    var loadGrantees = function loadGrantees() {
      $http.get(_this.aclUrl).success(function (result) {
        _this.grantees = [];

        (0, _underscore.each)(result, function (grantees, accessType) {
          grantees.forEach(function (grantee) {
            grantee.access_type = accessType;
            _this.grantees.push(grantee);
          });
        });
      });
    };

    loadGrantees();

    // Search for user
    this.findUser = function (search) {
      if (search === '') {
        return;
      }

      if (_this.foundUsers === undefined) {
        User.query(function (users) {
          var existingIds = _this.grantees.map(function (m) {
            return m.id;
          });
          users.forEach(function (user) {
            user.alreadyGrantee = (0, _underscore.contains)(existingIds, user.id);
          });
          _this.foundUsers = users;
        });
      }
    };

    // Add new user to grantees list
    this.addGrantee = function (user) {
      _this.newGrantees.selected = undefined;
      var body = { access_type: 'modify', user_id: user.id };
      $http.post(_this.aclUrl, body).success(function () {
        user.alreadyGrantee = true;
        loadGrantees();
      });
    };

    // Remove user from grantees list
    this.removeGrantee = function (user) {
      var body = { access_type: 'modify', user_id: user.id };
      $http({
        url: _this.aclUrl,
        method: 'DELETE',
        data: body,
        headers: { 'Content-Type': 'application/json' }
      }).success(function () {
        _this.grantees = _this.grantees.filter(function (m) {
          return m !== user;
        });

        if (_this.foundUsers) {
          _this.foundUsers.forEach(function (u) {
            if (u.id === user.id) {
              u.alreadyGrantee = false;
            }
          });
        }
      });
    };
  }]
};

function init(ngModule) {
  ngModule.component('permissionsEditor', PermissionsEditorComponent);
}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span></button>\n    <h4 class=\"modal-title\">Manage Permissions</h4>\n</div>\n<div class=\"modal-body\">\n  <div style=\"overflow: auto; height: 300px\">\n    <ui-select ng-model=\"$ctrl.newGrantee.selected\" on-select=\"$ctrl.addGrantee($item)\">\n       <ui-select-match placeholder=\"Add New User\"></ui-select-match>\n       <ui-select-choices repeat=\"user in $ctrl.foundUsers | filter:$select.search\"\n                         refresh=\"$ctrl.findUser($select.search)\"\n                         refresh-delay=\"0\"\n                         ui-disable-choice=\"user.alreadyGrantee\">\n        <div>\n          <img ng-src=\"{{user.profile_image_url}}\" height=\"24px\">&nbsp;{{user.name}}\n          <small ng-if=\"user.alreadyGrantee\">(already has permission)</small>\n        </div>\n       </ui-select-choices>\n    </ui-select>\n      <br/>\n       <table class=\"table table-condensed table-hover\">\n        <thead>\n          <tr>\n            <th></th>\n            <th>User</th>\n            <th>Permission</th>\n            <th></th>\n          </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"grantee in $ctrl.grantees\">\n          <td width=\"50px\"><img ng-src=\"{{grantee.profile_image_url}}\" height=\"40px\"/></td>\n          <td>{{grantee.name}} </td>\n          <td>{{grantee.access_type}}</td>\n          <td><button class=\"pull-right btn btn-sm btn-danger\" ng-click=\"$ctrl.removeGrantee(grantee)\">Remove</button></td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
alertUnsavedChanges.$inject = ['$window'];
function alertUnsavedChanges($window) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      isDirty: '='
    },
    link: function link($scope) {
      var unloadMessage = 'You will lose your changes if you leave';
      var confirmMessage = unloadMessage + '\n\nAre you sure you want to leave this page?';
      // store original handler (if any)
      var _onbeforeunload = $window.onbeforeunload;

      $window.onbeforeunload = function onbeforeunload() {
        return $scope.isDirty ? unloadMessage : null;
      };

      $scope.$on('$locationChangeStart', function (event, next, current) {
        if (next.split('?')[0] === current.split('?')[0] || next.split('#')[0] === current.split('#')[0]) {
          return;
        }

        if ($scope.isDirty && !$window.confirm(confirmMessage)) {
          event.preventDefault();
        }
      });

      $scope.$on('$destroy', function () {
        $window.onbeforeunload = _onbeforeunload;
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('alertUnsavedChanges', alertUnsavedChanges);
}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
var ApiKeyDialog = {
  template: '<div class="modal-header">\n    <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()"><span aria-hidden="true">&times;</span></button>\n</div>\n<div class="modal-body">\n    <h5>API Key</h5>\n    <pre>{{$ctrl.apiKey}}</pre>\n\n    <h5>Example API Calls:</h5>\n\n    <div>\n        Results in CSV format:\n\n        <pre>{{$ctrl.csvUrl}}</pre>\n\n        Results in JSON format:\n\n        <pre>{{$ctrl.jsonUrl}}</pre>\n    </div>\n</div>',
  controller: ['clientConfig', function controller(clientConfig) {
    'ngInject';

    this.apiKey = this.resolve.query.api_key;
    this.csvUrl = clientConfig.basePath + 'api/queries/' + this.resolve.query.id + '/results.csv?api_key=' + this.apiKey;
    this.jsonUrl = clientConfig.basePath + 'api/queries/' + this.resolve.query.id + '/results.json?api_key=' + this.apiKey;
  }],

  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

function init(ngModule) {
  ngModule.component('apiKeyDialog', ApiKeyDialog);
}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _embedCodeDialog = __webpack_require__(448);

var _embedCodeDialog2 = _interopRequireDefault(_embedCodeDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedCodeDialog = {
  controller: ['clientConfig', function controller(clientConfig) {
    'ngInject';

    this.query = this.resolve.query;
    this.visualization = this.resolve.visualization;

    this.embedUrl = clientConfig.basePath + 'embed/query/' + this.query.id + '/visualization/' + this.visualization.id + '?api_key=' + this.query.api_key;
    if (window.snapshotUrlBuilder) {
      this.snapshotUrl = window.snapshotUrlBuilder(this.query, this.visualization);
    }
  }],

  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template: _embedCodeDialog2.default
};

function init(ngModule) {
  ngModule.component('embedCodeDialog', EmbedCodeDialog);
}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span></button>\n  <h4 class=\"modal-title\">Embed Code</h4>\n</div>\n<div class=\"modal-body\">\n  <h5>IFrame Embed</h5>\n  <div>\n    <code>&lt;iframe src=\"{{ $ctrl.embedUrl }}\" width=\"720\" height=\"391\"&gt;&lt;/iframe&gt;</code>\n  </div>\n  <span class=\"text-muted\">(height should be adjusted)</span>\n  <div ng-if=\"$ctrl.snapshotUrl\">\n    <h5>Image Embed</h5>\n    <div>\n      <code style=\"overflow-wrap:break-word;\">{{$ctrl.snapshotUrl}}</code>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

__webpack_require__(238);

__webpack_require__(450);

__webpack_require__(451);

__webpack_require__(452);

__webpack_require__(454);

var _underscore = __webpack_require__(3);

queryEditor.$inject = ['QuerySnippet'];


// By default Ace will try to load snippet files for the different modes and fail.
// We don't need them, so we use these placeholders until we define our own.
function defineDummySnippets(mode) {
  window.ace.define('ace/snippets/' + mode, ['require', 'exports', 'module'], function (require, exports) {
    exports.snippetText = '';
    exports.scope = mode;
  });
}

defineDummySnippets('python');
defineDummySnippets('sql');
defineDummySnippets('json');

function queryEditor(QuerySnippet) {
  return {
    restrict: 'E',
    scope: {
      query: '=',
      schema: '=',
      syntax: '='
    },
    template: '<div ui-ace="editorOptions" ng-model="query.query"></div>',
    link: {
      pre: function pre($scope) {
        $scope.syntax = $scope.syntax || 'sql';

        $scope.editorOptions = {
          mode: 'json',
          // require: ['ace/ext/language_tools'],
          advanced: {
            behavioursEnabled: true,
            enableSnippets: true,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            autoScrollEditorIntoView: true
          },
          onLoad: function onLoad(editor) {
            // Release Cmd/Ctrl+L to the browser
            editor.commands.bindKey('Cmd+L', null);
            editor.commands.bindKey('Ctrl+L', null);

            QuerySnippet.query(function (snippets) {
              window.ace.acequire(['ace/snippets'], function (snippetsModule) {
                var snippetManager = snippetsModule.snippetManager;
                var m = {
                  snippetText: ''
                };
                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
                snippets.forEach(function (snippet) {
                  m.snippets.push(snippet.getSnippet());
                });

                snippetManager.register(m.snippets || [], m.scope);
              });
            });

            editor.$blockScrolling = Infinity;
            editor.getSession().setUseWrapMode(true);
            editor.setShowPrintMargin(false);

            $scope.$watch('syntax', function (syntax) {
              var newMode = 'ace/mode/' + syntax;
              editor.getSession().setMode(newMode);
            });

            $scope.$watch('schema', function (newSchema, oldSchema) {
              if (newSchema !== oldSchema) {
                if (newSchema === undefined) {
                  return;
                }
                var tokensCount = newSchema.reduce(function (totalLength, table) {
                  return totalLength + table.columns.length;
                }, 0);
                // If there are too many tokens we disable live autocomplete,
                // as it makes typing slower.
                if (tokensCount > 5000) {
                  editor.setOption('enableLiveAutocompletion', false);
                } else {
                  editor.setOption('enableLiveAutocompletion', true);
                }
              }
            });

            $scope.$parent.$on('angular-resizable.resizing', function () {
              editor.resize();
            });

            editor.focus();
          }
        };

        var schemaCompleter = {
          getCompletions: function getCompletions(state, session, pos, prefix, callback) {
            if (prefix.length === 0 || !$scope.schema) {
              callback(null, []);
              return;
            }

            if (!$scope.schema.keywords) {
              var keywords = {};

              $scope.schema.forEach(function (table) {
                keywords[table.name] = 'Table';

                table.columns.forEach(function (c) {
                  keywords[c] = 'Column';
                  keywords[table.name + '.' + c] = 'Column';
                });
              });

              $scope.schema.keywords = (0, _underscore.map)(keywords, function (v, k) {
                return {
                  name: k,
                  value: k,
                  score: 0,
                  meta: v
                };
              });
            }
            callback(null, $scope.schema.keywords);
          }
        };

        window.ace.acequire(['ace/ext/language_tools'], function (langTools) {
          langTools.addCompleter(schemaCompleter);
        });
      }
    }
  };
}

function init(ngModule) {
  ngModule.directive('queryEditor', queryEditor);
}

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function queryResultLink() {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var fileType = attrs.fileType ? attrs.fileType : 'csv';
      scope.$watch('queryResult && queryResult.getData()', function (data) {
        if (!data) {
          return;
        }

        if (scope.queryResult.getId() == null) {
          element.attr('href', '');
        } else {
          var url = void 0;
          if (scope.query.id) {
            url = 'api/queries/' + scope.query.id + '/results/' + scope.queryResult.getId() + '.' + fileType + (scope.embed ? '?api_key=' + scope.apiKey : '');
          } else {
            url = 'api/query_results/' + scope.queryResult.getId() + '.' + fileType;
          }
          element.attr('href', url);
          element.attr('download', scope.query.name.replace(' ', '_') + (0, _moment2.default)(scope.queryResult.getUpdatedAt()).format('_YYYY_MM_DD') + '.' + fileType);
        }
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('queryResultLink', queryResultLink);
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(3);

var _scheduleDialog = __webpack_require__(457);

var _scheduleDialog2 = _interopRequireDefault(_scheduleDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function padWithZeros(size, v) {
  var str = String(v);
  if (str.length < size) {
    str = '0' + str;
  }
  return str;
}

function queryTimePicker() {
  return {
    restrict: 'E',
    scope: {
      refreshType: '=',
      query: '=',
      saveQuery: '='
    },
    template: '\n      <select ng-disabled="refreshType != \'daily\'" ng-model="hour" ng-change="updateSchedule()" ng-options="c as c for c in hourOptions"></select> :\n      <select ng-disabled="refreshType != \'daily\'" ng-model="minute" ng-change="updateSchedule()" ng-options="c as c for c in minuteOptions"></select>\n    ',
    link: function link($scope) {
      $scope.hourOptions = (0, _underscore.map)((0, _underscore.range)(0, 24), (0, _underscore.partial)(padWithZeros, 2));
      $scope.minuteOptions = (0, _underscore.map)((0, _underscore.range)(0, 60, 5), (0, _underscore.partial)(padWithZeros, 2));

      if ($scope.query.hasDailySchedule()) {
        var parts = $scope.query.scheduleInLocalTime().split(':');
        $scope.minute = parts[1];
        $scope.hour = parts[0];
      } else {
        $scope.minute = '15';
        $scope.hour = '00';
      }

      $scope.updateSchedule = function () {
        var newSchedule = (0, _moment2.default)().hour($scope.hour).minute($scope.minute).utc().format('HH:mm');

        if (newSchedule !== $scope.query.schedule) {
          $scope.query.schedule = newSchedule;
          $scope.saveQuery();
        }
      };

      $scope.$watch('refreshType', function () {
        if ($scope.refreshType === 'daily') {
          $scope.updateSchedule();
        }
      });
    }
  };
}

function queryRefreshSelect() {
  return {
    restrict: 'E',
    scope: {
      refreshType: '=',
      query: '=',
      saveQuery: '='
    },
    template: '<select\n                ng-disabled="refreshType != \'periodic\'"\n                ng-model="query.schedule"\n                ng-change="saveQuery()"\n                ng-options="c.value as c.name for c in refreshOptions">\n                <option value="">No Refresh</option>\n                </select>',
    link: function link($scope) {
      $scope.refreshOptions = [{
        value: '60',
        name: 'Every minute'
      }];

      [5, 10, 15, 30].forEach(function (i) {
        $scope.refreshOptions.push({
          value: String(i * 60),
          name: 'Every ' + i + ' minutes'
        });
      });

      (0, _underscore.range)(1, 13).forEach(function (i) {
        $scope.refreshOptions.push({
          value: String(i * 3600),
          name: 'Every ' + i + 'h'
        });
      });

      $scope.refreshOptions.push({
        value: String(24 * 3600),
        name: 'Every 24h'
      });
      $scope.refreshOptions.push({
        value: String(7 * 24 * 3600),
        name: 'Every 7 days'
      });
      $scope.refreshOptions.push({
        value: String(14 * 24 * 3600),
        name: 'Every 14 days'
      });
      $scope.refreshOptions.push({
        value: String(30 * 24 * 3600),
        name: 'Every 30 days'
      });

      $scope.$watch('refreshType', function () {
        if ($scope.refreshType === 'periodic') {
          if ($scope.query.hasDailySchedule()) {
            $scope.query.schedule = null;
            $scope.saveQuery();
          }
        }
      });
    }
  };
}

var ScheduleForm = {
  controller: function controller() {
    this.query = this.resolve.query;
    this.saveQuery = this.resolve.saveQuery;

    if (this.query.hasDailySchedule()) {
      this.refreshType = 'daily';
    } else {
      this.refreshType = 'periodic';
    }
  },

  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template: _scheduleDialog2.default
};

function init(ngModule) {
  ngModule.directive('queryTimePicker', queryTimePicker);
  ngModule.directive('queryRefreshSelect', queryRefreshSelect);
  ngModule.component('scheduleDialog', ScheduleForm);
}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span></button>\n    <h4 class=\"modal-title\">Refresh Schedule</h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"radio\">\n        <label>\n            <input type=\"radio\" value=\"periodic\" ng-model=\"$ctrl.refreshType\">\n            <query-refresh-select refresh-type=\"$ctrl.refreshType\" query=\"$ctrl.query\" save-query=\"$ctrl.saveQuery\"></query-refresh-select>\n        </label>\n    </div>\n    <div class=\"radio\">\n        <label>\n            <input type=\"radio\" value=\"daily\" ng-model=\"$ctrl.refreshType\">\n            <query-time-picker refresh-type=\"$ctrl.refreshType\" query=\"$ctrl.query\" save-query=\"$ctrl.saveQuery\"></query-time-picker>\n        </label>\n    </div>\n</div>\n"

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _schemaBrowser = __webpack_require__(459);

var _schemaBrowser2 = _interopRequireDefault(_schemaBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

SchemaBrowserCtrl.$inject = ['$scope'];


function SchemaBrowserCtrl($scope) {
  'ngInject';

  this.showTable = function (table) {
    table.collapsed = !table.collapsed;
    $scope.$broadcast('vsRepeatTrigger');
  };

  this.getSize = function (table) {
    var size = 18;

    if (!table.collapsed) {
      size += 18 * table.columns.length;
    }

    return size;
  };

  this.isEmpty = function isEmpty() {
    return this.schema === undefined || this.schema.length === 0;
  };
}

var SchemaBrowser = {
  bindings: {
    schema: '<',
    onRefresh: '&'
  },
  controller: SchemaBrowserCtrl,
  template: _schemaBrowser2.default
};

function init(ngModule) {
  ngModule.component('schemaBrowser', SchemaBrowser);
}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "<div class=\"schema-container\" ng-if=\"$ctrl.schema\">\n  <div class=\"schema-control\">\n    <input type=\"text\" placeholder=\"Search schema...\" class=\"form-control\" ng-model=\"$ctrl.schemaFilter\" ng-disabled=\"$ctrl.isEmpty()\">\n    <button class=\"btn btn-default\"\n            title=\"Refresh Schema\"\n            ng-click=\"$ctrl.onRefresh()\">\n      <span class=\"zmdi zmdi-refresh\"></span>\n    </button>\n  </div>\n\n  <div class=\"schema-browser\" vs-repeat vs-size=\"$ctrl.getSize(table)\">\n    <div ng-repeat=\"table in $ctrl.schema | filter:$ctrl.schemaFilter track by table.name\">\n      <div class=\"table-name\" ng-click=\"$ctrl.showTable(table)\">\n        <i class=\"fa fa-table\"></i>\n        <strong>\n          <span title=\"{{table.name}}\">{{table.name}}</span>\n          <span ng-if=\"table.size !== undefined\"> ({{table.size}})</span>\n        </strong>\n      </div>\n      <div uib-collapse=\"table.collapsed\">\n        <div ng-repeat=\"column in table.columns track by column\" class=\"table-open\">{{column}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _redash_icon_small = __webpack_require__(74);

var _redash_icon_small2 = _interopRequireDefault(_redash_icon_small);

var _visualizationEmbed = __webpack_require__(461);

var _visualizationEmbed2 = _interopRequireDefault(_visualizationEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisualizationEmbed = {
  template: _visualizationEmbed2.default,
  bindings: {
    data: '<'
  },
  controller: ['$routeParams', 'Query', 'QueryResult', function controller($routeParams, Query, QueryResult) {
    'ngInject';

    document.querySelector('body').classList.add('headless');
    var visualizationId = parseInt($routeParams.visualizationId, 10);
    this.showQueryDescription = $routeParams.showDescription;
    this.apiKey = $routeParams.api_key;
    this.logoUrl = _redash_icon_small2.default;
    this.query = new Query(this.data[0]);
    this.queryResult = new QueryResult(this.data[1]);
    this.visualization = (0, _underscore.find)(this.query.visualizations, function (visualization) {
      return visualization.id === visualizationId;
    });
  }]
};

function init(ngModule) {
  loadData.$inject = ['$http', '$route', '$q', 'Auth'];
  session.$inject = ['$http', '$route', 'Auth'];

  ngModule.component('visualizationEmbed', VisualizationEmbed);

  function session($http, $route, Auth) {
    'ngInject';

    var apiKey = $route.current.params.api_key;
    Auth.setApiKey(apiKey);
    return Auth.loadConfig();
  }

  function loadData($http, $route, $q, Auth) {
    return session($http, $route, Auth).then(function () {
      var queryId = $route.current.params.queryId;
      var query = $http.get('api/queries/' + queryId).then(function (response) {
        return response.data;
      });
      var queryResult = $http.get('api/queries/' + queryId + '/results.json' + location.search).then(function (response) {
        return response.data;
      });
      return $q.all([query, queryResult]);
    });
  }

  ngModule.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/embed/query/:queryId/visualization/:visualizationId', {
      template: '<visualization-embed data="$resolve.data"></visualization-embed>',
      resolve: {
        data: loadData
      }
    });
  }]);
}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tile m-l-10 m-r-10 embed__vis\">\n  <div class=\"embed-heading p-t-10 p-b-10 p-r-15 p-l-15\">\n    <h3>\n      <img ng-src=\"{{$ctrl.logoUrl}}\" style=\"height: 24px;\"/>\n      {{$ctrl.query.name}}\n      <small><visualization-name visualization=\"$ctrl.visualization\"/></small>\n\n      <small ng-if=\"$ctrl.showQueryDescription\">\n        <div class=\"text-muted\" ng-bind-html=\"$ctrl.query.description | markdown\"></div>\n      </small>\n    </h3>\n  </div>\n\n  <div class=\"col-md-12 query__vis\">\n    <visualization-renderer visualization=\"$ctrl.visualization\" query-result=\"$ctrl.queryResult\" class=\"t-body\">\n    </visualization-renderer>\n  </div>\n\n  <div class=\"clearfix tile__bottom-control\">\n    <div class=\"row\">\n      <div class=\"col-xs-6\">\n        <span class=\"small hidden-print\"><i class=\"zmdi zmdi-time-restore\"></i> <span am-time-ago=\"$ctrl.queryResult.getUpdatedAt()\"></span></span>\n        <span class=\"small visible-print\"><i class=\"zmdi zmdi-time-restore\"></i> {{$ctrl.queryResult.getUpdatedAt() | dateTime}}</span>\n      </div>\n      <div class=\"col-xs-6 text-right hidden-print\">\n        <a class=\"btn btn-default btn-sm\" ng-href=\"queries/{{$ctrl.query.id}}#{{$ctrl.visualization.id}}\" target=\"_blank\" tooltip=\"Open in Redash\">\n          <span class=\"zmdi zmdi-link\"></span>\n        </a>\n\n        <div class=\"btn-group\" uib-dropdown>\n          <button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" aria-haspopup=\"true\" uib-dropdown-toggle\n                  aria-expanded=\"false\">\n            Download Dataset <span class=\"caret\"></span>\n          </button>\n          <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu>\n            <li>\n              <a ng-href=\"{{$ctrl.queryResult.getLink($ctrl.query.id, 'csv', $ctrl.apiKey)}}\" download=\"{{$ctrl.queryResult.getName($ctrl.query.name, 'csv')}}\" target=\"_self\">\n                <span class=\"fa fa-file-o\"></span> Download as CSV File\n              </a>\n            </li>\n            <li>\n              <a ng-href=\"{{$ctrl.queryResult.getLink($ctrl.query.id, 'xlsx', $ctrl.apiKey)}}\" download=\"{{$ctrl.queryResult.getName($ctrl.query.name, 'xlsx')}}\"  target=\"_self\">\n                <span class=\"fa fa-file-excel-o\"></span> Download as Excel File\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

function QueryLinkController() {
  var hash = null;
  if (this.visualization) {
    if (this.visualization.type === 'TABLE') {
      // link to hard-coded table tab instead of the (hidden) visualization tab
      hash = 'table';
    } else {
      hash = this.visualization.id;
    }
  }

  this.link = this.query.getUrl(false, hash);
}

function init(ngModule) {
  ngModule.component('queryLink', {
    bindings: {
      query: '<',
      visualization: '<'
    },
    template: '<a ng-href="{{$ctrl.link}}" class="query-link">{{$ctrl.query.name}}</a>',
    controller: QueryLinkController
  });
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
rdTab.$inject = ['$location'];
function rdTab($location) {
  return {
    restrict: 'E',
    scope: {
      tabId: '@',
      name: '@',
      basePath: '=?'
    },
    transclude: true,
    template: '<li class="rd-tab" ng-class="{active: tabId==selectedTab}"><a href="{{basePath}}#{{tabId}}">{{name}}<span ng-transclude></span></a></li>',
    replace: true,
    link: function link(scope) {
      scope.basePath = scope.basePath || $location.path().substring(1);
      scope.$watch(function () {
        return scope.$parent.selectedTab;
      }, function (tab) {
        scope.selectedTab = tab;
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('rdTab', rdTab);
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
var RdTimeAgo = {
  bindings: {
    value: '='
  },
  controller: function controller() {},

  template: '<span>' + '<span ng-show="$ctrl.value" am-time-ago="$ctrl.value"></span>' + '<span ng-hide="$ctrl.value">-</span>' + '</span>'
};

function init(ngModule) {
  ngModule.component('rdTimeAgo', RdTimeAgo);
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rdTimer() {
  return {
    restrict: 'E',
    scope: { timestamp: '=' },
    template: '{{currentTime}}',
    controller: ['$scope', function controller($scope) {
      $scope.currentTime = '00:00:00';

      // We're using setInterval directly instead of $timeout, to avoid using $apply, to
      // prevent the digest loop being run every second.
      var currentTimer = setInterval(function () {
        $scope.currentTime = (0, _moment2.default)((0, _moment2.default)() - (0, _moment2.default)($scope.timestamp)).utc().format('HH:mm:ss');
        $scope.$digest();
      }, 1000);

      $scope.$on('$destroy', function () {
        if (currentTimer) {
          clearInterval(currentTimer);
          currentTimer = null;
        }
      });
    }]
  };
}

function init(ngModule) {
  ngModule.directive('rdTimer', rdTimer);
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(ngModule) {
  ngModule.component('routeStatus', {
    template: '<overlay ng-if="$ctrl.permissionDenied">You do not have permission to load this page.',

    controller: ['$rootScope', function controller($rootScope) {
      var _this = this;

      this.permissionDenied = false;

      $rootScope.$on('$routeChangeSuccess', function () {
        _this.permissionDenied = false;
      });

      $rootScope.$on('$routeChangeError', function (event, current, previous, rejection) {
        if (rejection.status === 403) {
          _this.permissionDenied = true;
        }
      });
    }]
  });
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _startsWith = __webpack_require__(75);

var _startsWith2 = _interopRequireDefault(_startsWith);

var _settingsScreen = __webpack_require__(468);

var _settingsScreen2 = _interopRequireDefault(_settingsScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(ngModule) {
  ngModule.directive('settingsScreen', ['$location', function ($location) {
    return {
      restrict: 'E',
      transclude: true,
      template: _settingsScreen2.default,
      controller: ['$scope', 'currentUser', function controller($scope, currentUser) {
        $scope.usersPage = (0, _startsWith2.default)($location.path(), '/users');
        $scope.groupsPage = (0, _startsWith2.default)($location.path(), '/groups');
        $scope.dsPage = (0, _startsWith2.default)($location.path(), '/data_sources');
        $scope.destinationsPage = (0, _startsWith2.default)($location.path(), '/destinations');
        $scope.snippetsPage = (0, _startsWith2.default)($location.path(), '/query_snippets');

        $scope.showGroupsLink = currentUser.hasPermission('list_users');
        $scope.showUsersLink = currentUser.hasPermission('list_users');
        $scope.showDsLink = currentUser.hasPermission('admin');
        $scope.showDestinationsLink = currentUser.hasPermission('admin');
        $scope.showQuerySnippetsLink = currentUser.hasPermission('create_query');
      }]
    };
  }]);
}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Settings\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <ul class=\"tab-nav\">\n      <li ng-class=\"{'active': dsPage }\" ng-if=\"showDsLink\"><a href=\"data_sources\">Data Sources</a></li>\n      <li ng-class=\"{'active': groupsPage }\" ng-if=\"showGroupsLink\"><a href=\"groups\">Groups</a></li>\n      <li ng-class=\"{'active': usersPage }\" ng-if=\"showUsersLink\"><a href=\"users\">Users</a></li>\n      <li ng-class=\"{'active': snippetsPage }\" ng-if=\"showQuerySnippetsLink\"><a href=\"query_snippets\">Query Snippets</a></li>\n      <li ng-class=\"{'active': destinationsPage }\" ng-if=\"showDestinationsLink\"><a href=\"destinations\">Alert Destinations</a></li>\n    </ul>\n\n    <div class=\"p-15\">\n      <div ng-transclude>\n\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(ngModule) {
  ngModule.component('sortIcon', {
    template: '<span ng-if="$ctrl.showIcon"><i class="fa fa-sort-{{$ctrl.icon}}"></i></span>',
    bindings: {
      column: '<',
      sortColumn: '<',
      reverse: '<'
    },
    controller: function controller() {
      var _this = this;

      this.$onChanges = function (changes) {
        ['column', 'sortColumn', 'reverse'].forEach(function (v) {
          if (v in changes) {
            _this[v] = changes[v].currentValue;
          }
        });

        _this.showIcon = false;

        if (_this.column === _this.sortColumn) {
          _this.showIcon = true;
          _this.icon = _this.reverse ? 'desc' : 'asc';
        }
      };
    }
  });
}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _startsWith = __webpack_require__(75);

var _startsWith2 = _interopRequireDefault(_startsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['$location'];


function controller($location) {
  this.tabs.forEach(function (tab) {
    if (tab.isActive) {
      tab.active = tab.isActive($location.path());
    } else {
      tab.active = (0, _startsWith2.default)($location.path(), '/' + tab.path);
    }
  });
}

function init(ngModule) {
  ngModule.component('tabNav', {
    template: '<ul class="tab-nav bg-white">' + '<li ng-repeat="tab in $ctrl.tabs" ng-class="{\'active\': tab.active }"><a ng-href="{{tab.path}}">{{tab.name}}</a></li>' + '</ul>',
    controller: controller,
    bindings: {
      tabs: '<'
    }
  });
}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisualizationName;
function VisualizationName(Visualization) {
  return {
    restrict: 'E',
    scope: {
      visualization: '='
    },
    template: '{{name}}',
    replace: false,
    link: function link(scope) {
      var currentType = scope.visualization.type;
      var nameByType = Visualization.visualizations[currentType].name;
      var currentName = scope.visualization.name;
      if (nameByType !== currentName) {
        scope.name = scope.visualization.name;
      }
    }
  };
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alert-dialog.js": 473,
	"./alert-subscription.js": 474,
	"./alert.js": 475,
	"./auth.js": 476,
	"./dashboard.js": 477,
	"./data-source.js": 245,
	"./destination.js": 478,
	"./events.js": 479,
	"./group.js": 480,
	"./keyboard-shortcuts.js": 481,
	"./notifications.js": 484,
	"./offline-listener.js": 485,
	"./query-result.js": 246,
	"./query-snippet.js": 486,
	"./query.js": 487,
	"./user.js": 489,
	"./widget.js": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;
AlertDialog.$inject = ['$uibModal'];
var AlertDialogComponent = {
  template: '\n<div class="modal-header">\n    <h4 class="modal-title" ng-if="$ctrl.title">{{$ctrl.title}}</h4>\n</div>\n<div class="modal-body">\n  <p ng-bind-html="$ctrl.message"></p>\n</div>\n<div class="modal-footer">\n  <button class="btn btn-default" ng-click="$ctrl.dismiss()">Cancel</button>\n  <button class="btn" ng-class="$ctrl.confirm.class" ng-click="$ctrl.close()" ng-if="$ctrl.confirm.show">{{$ctrl.confirm.title}}</button>\n</div>\n  ',
  bindings: {
    close: '&',
    dismiss: '&',
    resolve: '<'
  },
  controller: function controller() {
    this.title = this.resolve.title;
    this.message = this.resolve.message;
    this.confirm = _extends({}, { class: 'btn-sucess', show: true, title: 'OK' }, this.resolve.confirm);
  }
};

function AlertDialog($uibModal) {
  var service = {
    open: function open(_title, _message, _confirm) {
      return $uibModal.open({
        component: 'alertDialog',
        resolve: {
          title: function title() {
            return _title;
          },
          message: function message() {
            return _message;
          },
          confirm: function confirm() {
            return _confirm;
          }
        }
      }).result;
    }
  };

  return service;
}

function init(ngModule) {
  ngModule.component('alertDialog', AlertDialogComponent);
  ngModule.factory('AlertDialog', AlertDialog);
}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
AlertSubscription.$inject = ['$resource'];
function AlertSubscription($resource) {
  var resource = $resource('api/alerts/:alertId/subscriptions/:subscriberId', { alertId: '@alert_id', subscriberId: '@id' });
  return resource;
}

function init(ngModule) {
  ngModule.factory('AlertSubscription', AlertSubscription);
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;
Alert.$inject = ['$resource', '$http'];
function Alert($resource, $http) {
  var actions = {
    save: {
      method: 'POST',
      transformRequest: [function (data) {
        var newData = _extends({}, data);
        if (newData.query_id === undefined) {
          newData.query_id = newData.query.id;
          newData.destination_id = newData.destinations;
          delete newData.query;
          delete newData.destinations;
        }

        return newData;
      }].concat($http.defaults.transformRequest)
    }
  };
  var resource = $resource('api/alerts/:id', { id: '@id' }, actions);

  return resource;
}

function init(ngModule) {
  ngModule.factory('Alert', Alert);
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

apiKeyHttpInterceptor.$inject = ['$injector'];
AuthService.$inject = ['$window', '$location', '$q', '$http'];


var logger = (0, _debug2.default)('redash:auth');
var SESSION_ITEM = 'session';
var session = { loaded: false };

function storeSession(sessionData) {
  logger('Updating session to be:', sessionData);
  _extends(session, sessionData, { loaded: true });
}

function getLocalSessionData() {
  if (session.loaded) {
    return session;
  }

  var sessionData = window.sessionStorage.getItem(SESSION_ITEM);
  if (sessionData) {
    storeSession(JSON.parse(sessionData));
  }

  return session;
}

function AuthService($window, $location, $q, $http) {
  var Auth = {
    isAuthenticated: function isAuthenticated() {
      var sessionData = getLocalSessionData();
      return sessionData.loaded && sessionData.user.id;
    },
    login: function login() {
      var next = encodeURI($location.url());
      logger('Calling login with next = %s', next);
      window.location.href = 'login?next=' + next;
    },
    logout: function logout() {
      logger('Logout.');
      window.sessionStorage.removeItem(SESSION_ITEM);
      $window.location.href = 'logout';
    },
    loadSession: function loadSession() {
      logger('Loading session');
      var sessionData = getLocalSessionData();
      if (sessionData.loaded && sessionData.user.id) {
        logger('Resolving with local value.');
        return $q.resolve(sessionData);
      }

      this.setApiKey(null);
      return $http.get('api/session').then(function (response) {
        storeSession(response.data);
        return session;
      });
    },
    loadConfig: function loadConfig() {
      logger('Loading config');
      return $http.get('/api/config').then(function (response) {
        storeSession({ client_config: response.data.client_config, user: { permissions: [] } });
        return response.data;
      });
    },
    setApiKey: function setApiKey(apiKey) {
      logger('Set API key to: %s', apiKey);
      this.apiKey = apiKey;
    },
    getApiKey: function getApiKey() {
      return this.apiKey;
    }
  };

  return Auth;
}

function CurrentUserService() {
  var _this = this;

  var sessionData = getLocalSessionData();
  _extends(this, sessionData.user);

  this.canEdit = function (object) {
    var userId = object.user_id || object.user && object.user.id;
    return _this.hasPermission('admin') || userId && userId === _this.id;
  };

  this.hasPermission = function (permission) {
    return _this.permissions.indexOf(permission) !== -1;
  };

  this.isAdmin = this.hasPermission('admin');
}

function ClientConfigService() {
  _extends(this, getLocalSessionData().client_config);
}

function apiKeyHttpInterceptor($injector) {
  return {
    request: function request(config) {
      var Auth = $injector.get('Auth');
      var apiKey = Auth.getApiKey();
      if (apiKey) {
        config.headers.Authorization = 'Key ' + apiKey;
      }

      return config;
    }
  };
}

function init(ngModule) {
  ngModule.factory('Auth', AuthService);
  ngModule.service('currentUser', CurrentUserService);
  ngModule.service('clientConfig', ClientConfigService);
  ngModule.factory('apiKeyHttpInterceptor', apiKeyHttpInterceptor);

  ngModule.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('apiKeyHttpInterceptor');
  }]);

  ngModule.run(['$location', '$window', '$rootScope', '$route', 'Auth', function ($location, $window, $rootScope, $route, Auth) {
    $rootScope.$on('$routeChangeStart', function (event, to) {
      if (to.authenticated && !Auth.isAuthenticated()) {
        logger('Requested authenticated route: ', to);
        event.preventDefault();
        // maybe we only miss the session? try to load session
        Auth.loadSession().then(function () {
          logger('Loaded session');
          $route.reload();
        }).catch(function () {
          logger('Need to login, redirecting');
          Auth.login();
        });
      }
    });
  }]);
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Dashboard.$inject = ['$resource', '$http', 'currentUser', 'Widget', 'dashboardGridOptions'];


function Dashboard($resource, $http, currentUser, Widget, dashboardGridOptions) {
  function prepareDashboardWidgets(widgets) {
    if (_.isArray(widgets) && widgets.length > 0 && _.isArray(widgets[0])) {
      // Dashboard v1 processing
      // v1 dashboard has two columns, and widget can occupy one of them or both;
      // this means, that there can be at most two widgets per row.
      // Here we will map gridster columns and rows to v1-style grid
      var dashboardV1ColumnSize = Math.round(dashboardGridOptions.columns / 2);
      widgets = _.map(widgets, function (row, rowIndex) {
        return _.map(row, function (widget, widgetIndex) {
          widget.options = widget.options || {};
          widget.options.position = _.extend({}, {
            row: rowIndex,
            col: widgetIndex * dashboardV1ColumnSize,
            sizeX: dashboardV1ColumnSize * widget.width
            // do not set sizeY - let widget to use defaults for visualization
          }, widget.options.position);
          return widget;
        });
      });
    }

    return _.map(_.flatten(widgets), function (widget) {
      return new Widget(widget);
    });
  }

  function transformSingle(dashboard) {
    dashboard.widgets = prepareDashboardWidgets(dashboard.widgets);
    dashboard.publicAccessEnabled = dashboard.public_url !== undefined;
  }

  var transform = $http.defaults.transformResponse.concat(function (data) {
    if (_.isArray(data)) {
      data.forEach(transformSingle);
    } else {
      transformSingle(data);
    }
    return data;
  });

  var resource = $resource('api/dashboards/:slug', { slug: '@slug' }, {
    get: { method: 'GET', transformResponse: transform },
    save: { method: 'POST', transformResponse: transform },
    query: { method: 'GET', isArray: true, transformResponse: transform },
    recent: {
      method: 'get',
      isArray: true,
      url: 'api/dashboards/recent',
      transformResponse: transform
    }
  });

  resource.prototype.canEdit = function canEdit() {
    return currentUser.canEdit(this) || this.can_edit;
  };

  resource.prototype.calculateNewWidgetPosition = function calculateNewWidgetPosition(widget) {
    var width = _.extend({ sizeX: dashboardGridOptions.defaultSizeX }, _.extend({}, widget.options).position).sizeX;

    // Find first free row for each column
    var bottomLine = _.chain(this.widgets).map(function (w) {
      var options = _.extend({}, w.options);
      var position = _.extend({ row: 0, sizeY: 0 }, options.position);
      return {
        left: position.col,
        top: position.row,
        right: position.col + position.sizeX,
        bottom: position.row + position.sizeY,
        width: position.sizeX,
        height: position.sizeY
      };
    }).reduce(function (result, item) {
      var from = Math.max(item.left, 0);
      var to = Math.min(item.right, result.length + 1);
      for (var i = from; i < to; i += 1) {
        result[i] = Math.max(result[i], item.bottom);
      }
      return result;
    }, _.map(new Array(dashboardGridOptions.columns), _.constant(0))).value();

    // Go through columns, pick them by count necessary to hold new block,
    // and calculate bottom-most free row per group.
    // Choose group with the top-most free row (comparing to other groups)
    return _.chain(_.range(0, dashboardGridOptions.columns - width + 1)).map(function (col) {
      return {
        col: col,
        row: _.chain(bottomLine).slice(col, col + width).max().value()
      };
    }).sortBy('row').first().value();
  };

  resource.prepareDashboardWidgets = prepareDashboardWidgets;

  return resource;
}

function init(ngModule) {
  ngModule.factory('Dashboard', Dashboard);
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
Destination.$inject = ['$resource'];
function Destination($resource) {
  var actions = {
    get: { method: 'GET', cache: false, isArray: false },
    query: { method: 'GET', cache: false, isArray: true }
  };

  var DestinationResource = $resource('api/destinations/:id', { id: '@id' }, actions);

  return DestinationResource;
}

function init(ngModule) {
  ngModule.factory('Destination', Destination);
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _underscore = __webpack_require__(3);

Events.$inject = ['$http'];


function Events($http) {
  var _this = this;

  this.events = [];

  this.post = (0, _underscore.debounce)(function () {
    var events = _this.events;
    _this.events = [];

    $http.post('api/events', events);
  }, 1000);

  this.record = function record(action, objectType, objectId, additionalProperties) {
    var event = {
      action: action,
      object_type: objectType,
      object_id: objectId,
      timestamp: Date.now() / 1000.0
    };
    _extends(event, additionalProperties);
    this.events.push(event);

    this.post();
  };
}

function init(ngModule) {
  ngModule.service('Events', Events);
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
Group.$inject = ['$resource'];
function Group($resource) {
  var actions = {
    get: { method: 'GET', cache: false, isArray: false },
    query: { method: 'GET', cache: false, isArray: true },
    members: {
      method: 'GET', cache: false, isArray: true, url: 'api/groups/:id/members'
    },
    dataSources: {
      method: 'GET', cache: false, isArray: true, url: 'api/groups/:id/data_sources'
    }
  };
  var resource = $resource('api/groups/:id', { id: '@id' }, actions);
  return resource;
}

function init(ngModule) {
  ngModule.factory('Group', Group);
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _mousetrap = __webpack_require__(482);

var _mousetrap2 = _interopRequireDefault(_mousetrap);

__webpack_require__(483);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyboardShortcuts() {
  this.bind = function bind(keymap) {
    (0, _underscore.each)(keymap, function (fn, key) {
      _mousetrap2.default.bindGlobal(key, function (e) {
        e.preventDefault();
        fn();
      });
    });
  };

  this.unbind = function unbind(keymap) {
    (0, _underscore.each)(keymap, function (fn, key) {
      _mousetrap2.default.unbind(key);
    });
  };
}

function init(ngModule) {
  ngModule.service('KeyboardShortcuts', KeyboardShortcuts);
}

/***/ }),
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Notifications.$inject = ['currentUser', 'Events'];


var logger = (0, _debug2.default)('redash:notifications');

function Notifications(currentUser, Events) {
  var notificationService = { pageVisible: true };

  notificationService.monitorVisibility = function monitorVisibility() {
    var hidden = void 0;
    var visibilityChange = void 0;

    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    }

    var documentHidden = document[hidden];

    document.addEventListener(visibilityChange, function () {
      if (documentHidden !== document[hidden]) {
        if (document[hidden]) {
          notificationService.pageVisible = false;
        } else {
          notificationService.pageVisible = true;
        }

        documentHidden = document[hidden];
      }
    });
  };

  notificationService.monitorVisibility();

  notificationService.isSupported = function () {
    if ('Notification' in window) {
      return true;
    }

    logger('HTML5 notifications are not supported.');
    return false;
  };

  notificationService.getPermissions = function getPermissions() {
    if (!this.isSupported()) {
      return;
    }

    if (Notification.permission === 'default') {
      Notification.requestPermission(function (status) {
        if (Notification.permission !== status) {
          Notification.permission = status;
        }
      });
    }
  };

  notificationService.showNotification = function showNotification(title, content) {
    if (!this.isSupported() || this.pageVisible || Notification.permission !== 'granted') {
      return;
    }

    // using the 'tag' to avoid showing duplicate notifications
    var notification = new Notification(title, { tag: title + content, body: content, icon: '/images/redash_icon_small.png' });
    setTimeout(function () {
      notification.close();
    }, 3000);
    notification.onclick = function onClick() {
      window.focus();
      this.close();
      Events.record('click', 'notification');
    };
  };

  return notificationService;
}

function init(ngModule) {
  ngModule.factory('Notifications', Notifications);
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
OfflineListener.$inject = ['toastr'];
function OfflineListener(toastr) {
  function addOnlineListener(toast) {
    function onlineStateHandler() {
      toastr.remove(toast.toastId);
      window.removeEventListener('online', onlineStateHandler);
    }
    window.addEventListener('online', onlineStateHandler);
  }

  window.addEventListener('offline', function () {
    var toast = toastr.warning('<div>Please check your Internet connection.</div>', '', {
      allowHtml: true,
      autoDismiss: false,
      timeOut: false,
      tapToDismiss: true
    });
    addOnlineListener(toast);
  });
}

function init(ngModule) {
  ngModule.service('OfflineListener', OfflineListener);
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
QuerySnippet.$inject = ['$resource'];
function QuerySnippet($resource) {
  var resource = $resource('api/query_snippets/:id', { id: '@id' });
  resource.prototype.getSnippet = function getSnippet() {
    var name = this.trigger;
    if (this.description !== '') {
      name = this.trigger + ': ' + this.description;
    }

    return {
      name: name,
      content: this.snippet,
      tabTrigger: this.trigger
    };
  };

  return resource;
}

function init(ngModule) {
  ngModule.factory('QuerySnippet', QuerySnippet);
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _mustache = __webpack_require__(488);

var _mustache2 = _interopRequireDefault(_mustache);

var _underscore = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

QueryResource.$inject = ['$resource', '$http', '$q', '$location', 'currentUser', 'QueryResult'];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logger = (0, _debug2.default)('redash:services:query');

function collectParams(parts) {
  var parameters = [];

  parts.forEach(function (part) {
    if (part[0] === 'name' || part[0] === '&') {
      parameters.push(part[1]);
    } else if (part[0] === '#') {
      parameters = (0, _underscore.union)(parameters, collectParams(part[4]));
    }
  });

  return parameters;
}

var QueryResultError = function () {
  function QueryResultError(errorMessage) {
    _classCallCheck(this, QueryResultError);

    this.errorMessage = errorMessage;
  }

  _createClass(QueryResultError, [{
    key: 'getError',
    value: function getError() {
      return this.errorMessage;
    }
  }], [{
    key: 'getStatus',
    value: function getStatus() {
      return 'failed';
    }
  }, {
    key: 'getData',
    value: function getData() {
      return null;
    }
  }, {
    key: 'getLog',
    value: function getLog() {
      return null;
    }
  }, {
    key: 'getChartData',
    value: function getChartData() {
      return null;
    }
  }]);

  return QueryResultError;
}();

var Parameter = function () {
  function Parameter(parameter) {
    _classCallCheck(this, Parameter);

    this.title = parameter.title;
    this.name = parameter.name;
    this.type = parameter.type;
    this.value = parameter.value;
    this.global = parameter.global;
    this.enumOptions = parameter.enumOptions;
    this.queryId = parameter.queryId;
  }

  _createClass(Parameter, [{
    key: 'ngModel',
    get: function get() {
      if (this.type === 'date' || this.type === 'datetime-local' || this.type === 'datetime-with-seconds') {
        this.$$value = this.$$value || (0, _moment2.default)(this.value).toDate();
        return this.$$value;
      } else if (this.type === 'number') {
        this.$$value = this.$$value || parseInt(this.value, 10);
        return this.$$value;
      }

      return this.value;
    },
    set: function set(value) {
      if (value && this.type === 'date') {
        this.value = (0, _moment2.default)(value).format('YYYY-MM-DD');
        this.$$value = (0, _moment2.default)(this.value).toDate();
      } else if (value && this.type === 'datetime-local') {
        this.value = (0, _moment2.default)(value).format('YYYY-MM-DD HH:mm');
        this.$$value = (0, _moment2.default)(this.value).toDate();
      } else if (value && this.type === 'datetime-with-seconds') {
        this.value = (0, _moment2.default)(value).format('YYYY-MM-DD HH:mm:ss');
        this.$$value = (0, _moment2.default)(this.value).toDate();
      } else {
        this.value = this.$$value = value;
      }
    }
  }]);

  return Parameter;
}();

var Parameters = function () {
  function Parameters(query, queryString) {
    _classCallCheck(this, Parameters);

    this.query = query;
    this.updateParameters();
    this.initFromQueryString(queryString);
  }

  _createClass(Parameters, [{
    key: 'parseQuery',
    value: function parseQuery() {
      var parameters = [];
      try {
        var parts = _mustache2.default.parse(this.query.query);
        parameters = (0, _underscore.uniq)(collectParams(parts));
      } catch (e) {
        logger('Failed parsing parameters: ', e);
      }
      return parameters;
    }
  }, {
    key: 'updateParameters',
    value: function updateParameters() {
      var _this = this;

      if (this.query.query === this.cachedQueryText) {
        return;
      }

      this.cachedQueryText = this.query.query;
      var parameterNames = this.parseQuery();

      this.query.options.parameters = this.query.options.parameters || [];

      var parametersMap = {};
      this.query.options.parameters.forEach(function (param) {
        parametersMap[param.name] = param;
      });

      parameterNames.forEach(function (param) {
        if (!(0, _underscore.has)(parametersMap, param)) {
          _this.query.options.parameters.push({
            title: param,
            name: param,
            type: 'text',
            value: null,
            global: false
          });
        }
      });

      var parameterExists = function parameterExists(p) {
        return (0, _underscore.contains)(parameterNames, p.name);
      };
      this.query.options.parameters = this.query.options.parameters.filter(parameterExists).map(function (p) {
        return new Parameter(p);
      });
    }
  }, {
    key: 'initFromQueryString',
    value: function initFromQueryString(queryString) {
      this.get().forEach(function (param) {
        var queryStringName = 'p_' + param.name;
        if ((0, _underscore.has)(queryString, queryStringName)) {
          param.value = queryString[queryStringName];
        }
      });
    }
  }, {
    key: 'get',
    value: function get() {
      this.updateParameters();
      return this.query.options.parameters;
    }
  }, {
    key: 'getMissing',
    value: function getMissing() {
      return (0, _underscore.pluck)((0, _underscore.filter)(this.get(), function (p) {
        return p.value === null || p.value === '';
      }), 'title');
    }
  }, {
    key: 'isRequired',
    value: function isRequired() {
      return !(0, _underscore.isEmpty)(this.get());
    }
  }, {
    key: 'getValues',
    value: function getValues() {
      var params = this.get();
      return (0, _underscore.object)((0, _underscore.pluck)(params, 'name'), (0, _underscore.pluck)(params, 'value'));
    }
  }]);

  return Parameters;
}();

function QueryResource($resource, $http, $q, $location, currentUser, QueryResult) {
  var Query = $resource('api/queries/:id', { id: '@id' }, {
    search: {
      method: 'get',
      isArray: true,
      url: 'api/queries/search'
    },
    recent: {
      method: 'get',
      isArray: true,
      url: 'api/queries/recent'
    },
    query: {
      isArray: false
    },
    myQueries: {
      method: 'get',
      isArray: false,
      url: 'api/queries/my'
    },
    fork: {
      method: 'post',
      isArray: false,
      url: 'api/queries/:id/fork',
      params: { id: '@id' }
    },
    resultById: {
      method: 'get',
      isArray: false,
      url: 'api/queries/:id/results.json'
    }
  });

  Query.newQuery = function newQuery() {
    return new Query({
      query: '',
      name: 'New Query',
      schedule: null,
      user: currentUser,
      options: {}
    });
  };

  Query.format = function formatQuery(syntax, query) {
    if (syntax === 'json') {
      try {
        var formatted = JSON.stringify(JSON.parse(query), ' ', 4);
        return $q.resolve(formatted);
      } catch (err) {
        return $q.reject(String(err));
      }
    } else if (syntax === 'sql') {
      return $http.post('api/queries/format', { query: query }).then(function (response) {
        return response.data.query;
      });
    } else {
      return $q.reject('Query formatting is not supported for your data source syntax.');
    }
  };

  Query.prototype.getSourceLink = function getSourceLink() {
    return '/queries/' + this.id + '/source';
  };

  Query.prototype.isNew = function isNew() {
    return this.id === undefined;
  };

  Query.prototype.hasDailySchedule = function hasDailySchedule() {
    return this.schedule && this.schedule.match(/\d\d:\d\d/) !== null;
  };

  Query.prototype.scheduleInLocalTime = function scheduleInLocalTime() {
    var parts = this.schedule.split(':');
    return _moment2.default.utc().hour(parts[0]).minute(parts[1]).local().format('HH:mm');
  };

  Query.prototype.hasResult = function hasResult() {
    return !!(this.latest_query_data || this.latest_query_data_id);
  };

  Query.prototype.paramsRequired = function paramsRequired() {
    return this.getParameters().isRequired();
  };

  Query.prototype.getQueryResult = function getQueryResult(maxAge) {
    if (!this.query) {
      return new QueryResultError("Can't execute empty query.");
    }
    var queryText = this.query;

    var parameters = this.getParameters();
    var missingParams = parameters.getMissing();

    if (missingParams.length > 0) {
      var paramsWord = 'parameter';
      var valuesWord = 'value';
      if (missingParams.length > 1) {
        paramsWord = 'parameters';
        valuesWord = 'values';
      }

      return new QueryResult({
        job: {
          error: 'missing ' + valuesWord + ' for ' + missingParams.join(', ') + ' ' + paramsWord + '.',
          status: 4
        }
      });
    }

    if (parameters.isRequired()) {
      queryText = _mustache2.default.render(queryText, parameters.getValues());

      // Need to clear latest results, to make sure we don't use results for different params.
      this.latest_query_data = null;
      this.latest_query_data_id = null;
    }

    if (this.latest_query_data && maxAge !== 0) {
      if (!this.queryResult) {
        this.queryResult = new QueryResult({
          query_result: this.latest_query_data
        });
      }
    } else if (this.latest_query_data_id && maxAge !== 0) {
      if (!this.queryResult) {
        this.queryResult = QueryResult.getById(this.latest_query_data_id);
      }
    } else if (this.data_source_id) {
      this.queryResult = QueryResult.get(this.data_source_id, queryText, maxAge, this.id);
    } else {
      return new QueryResultError('Please select data source to run this query.');
    }

    return this.queryResult;
  };

  Query.prototype.getUrl = function getUrl(source, hash) {
    var url = 'queries/' + this.id;

    if (source) {
      url += '/source';
    }

    var params = '';
    if (this.getParameters().isRequired()) {
      (0, _underscore.each)(this.getParameters().getValues(), function (value, name) {
        if (value === null) {
          return;
        }

        if (params !== '') {
          params += '&';
        }

        params += 'p_' + encodeURIComponent(name) + '=' + encodeURIComponent(value);
      });
    }

    if (params !== '') {
      url += '?' + params;
    }

    if (hash) {
      url += '#' + hash;
    }

    return url;
  };

  Query.prototype.getQueryResultPromise = function getQueryResultPromise() {
    return this.getQueryResult().toPromise();
  };

  Query.prototype.getParameters = function getParameters() {
    if (!this.$parameters) {
      this.$parameters = new Parameters(this, $location.search());
    }

    return this.$parameters;
  };

  Query.prototype.getParametersDefs = function getParametersDefs() {
    return this.getParameters().get();
  };

  return Query;
}

function init(ngModule) {
  ngModule.factory('Query', QueryResource);
}

/***/ }),
/* 488 */,
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

User.$inject = ['$resource', '$http'];


function transformSingle(user) {
  if (user.groups !== undefined) {
    user.admin = user.groups.indexOf('admin') !== -1;
  }
}

function transform(data) {
  if ((0, _underscore.isArray)(data)) {
    data.forEach(transformSingle);
  } else {
    transformSingle(data);
  }

  return data;
}

function User($resource, $http) {
  var transformResponse = $http.defaults.transformResponse.concat(transform);

  var actions = {
    get: { method: 'GET', transformResponse: transformResponse },
    save: { method: 'POST', transformResponse: transformResponse },
    query: { method: 'GET', isArray: true, transformResponse: transformResponse },
    delete: { method: 'DELETE', transformResponse: transformResponse }
  };

  var UserResource = $resource('api/users/:id', { id: '@id' }, actions);

  return UserResource;
}

function init(ngModule) {
  ngModule.factory('User', User);
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(491);

var _underscore2 = __webpack_require__(3);

Widget.$inject = ['$resource', '$http', 'Query', 'Visualization', 'dashboardGridOptions'];


function Widget($resource, $http, Query, Visualization, dashboardGridOptions) {
  function prepareForSave(data) {
    return (0, _underscore2.omit)(data, 'query');
  }

  var WidgetResource = $resource('api/widgets/:id', { id: '@id' }, {
    get: { method: 'GET' },
    save: {
      method: 'POST',
      transformRequest: (0, _underscore2.flatten)([prepareForSave, $http.defaults.transformRequest])
    },
    query: { method: 'GET', isArray: true },
    remove: { method: 'DELETE' },
    delete: { method: 'DELETE' }
  });

  WidgetResource.prototype.getQuery = function getQuery() {
    if (!this.query && this.visualization) {
      this.query = new Query(this.visualization.query);
    }

    return this.query;
  };

  WidgetResource.prototype.getName = function getName() {
    if (this.visualization) {
      return this.visualization.query.name + ' (' + this.visualization.name + ')';
    }
    return (0, _underscore.truncate)(this.text, 20);
  };

  function WidgetConstructor(widget) {
    widget.width = 1; // Backward compatibility, user on back-end

    var visualizationOptions = {
      sizeX: Math.round(dashboardGridOptions.columns / 2),
      sizeY: -1, // auto-height
      minSizeX: dashboardGridOptions.minSizeX,
      maxSizeX: dashboardGridOptions.maxSizeX,
      minSizeY: dashboardGridOptions.minSizeY,
      maxSizeY: dashboardGridOptions.maxSizeY
    };
    var visualization = widget.visualization ? Visualization.visualizations[widget.visualization.type] : null;
    if ((0, _underscore2.isObject)(visualization)) {
      var options = (0, _underscore2.extend)({}, visualization.defaultOptions);

      // Width constraints
      var minColumns = parseInt(options.minColumns, 10);
      if (isFinite(minColumns) && minColumns >= 0) {
        visualizationOptions.minSizeX = minColumns;
      }
      var maxColumns = parseInt(options.maxColumns, 10);
      if (isFinite(maxColumns) && maxColumns >= 0) {
        visualizationOptions.maxSizeX = Math.min(maxColumns, dashboardGridOptions.columns);
      }

      // Height constraints
      // `minRows` is preferred, but it should be kept for backward compatibility
      var height = parseInt(options.height, 10);
      if (isFinite(height)) {
        visualizationOptions.minSizeY = Math.ceil(height / dashboardGridOptions.rowHeight);
      }
      var minRows = parseInt(options.minRows, 10);
      if (isFinite(minRows)) {
        visualizationOptions.minSizeY = minRows;
      }
      var maxRows = parseInt(options.maxRows, 10);
      if (isFinite(maxRows) && maxRows >= 0) {
        visualizationOptions.maxSizeY = maxRows;
      }

      // Default dimensions
      var defaultWidth = parseInt(options.defaultColumns, 10);
      if (isFinite(defaultWidth) && defaultWidth > 0) {
        visualizationOptions.sizeX = defaultWidth;
      }
      var defaultHeight = parseInt(options.defaultRows, 10);
      if (isFinite(defaultHeight) && defaultHeight > 0) {
        visualizationOptions.sizeY = defaultHeight;
      }
    }

    widget.options = widget.options || {};
    widget.options.position = (0, _underscore2.extend)({}, visualizationOptions, (0, _underscore2.pick)(widget.options.position, ['col', 'row', 'sizeX', 'sizeY']));

    return new WidgetResource(widget);
  }

  return WidgetConstructor;
}

function init(ngModule) {
  ngModule.factory('Widget', Widget);
}

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./box-plot/index.js": 539,
	"./chart/index.js": 542,
	"./chart/plotly.js": 545,
	"./cohort/index.js": 705,
	"./counter/index.js": 709,
	"./edit-visualization-dialog.js": 712,
	"./index.js": 714,
	"./map/index.js": 715,
	"./pivot/index.js": 726,
	"./sankey/index.js": 730,
	"./sunburst/index.js": 733,
	"./table/formats.js": 320,
	"./table/index.js": 737,
	"./word-cloud/index.js": 741
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

var _d3box = __webpack_require__(540);

var _d3box2 = _interopRequireDefault(_d3box);

var _boxPlotEditor = __webpack_require__(541);

var _boxPlotEditor2 = _interopRequireDefault(_boxPlotEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function boxPlotRenderer() {
  return {
    restrict: 'E',
    template: '<div></div>',
    link: function link($scope, elm) {
      function calcIqr(k) {
        return function (d) {
          var q1 = d.quartiles[0];
          var q3 = d.quartiles[2];
          var iqr = (q3 - q1) * k;

          var i = -1;
          var j = d.length;

          // eslint-disable-next-line no-plusplus
          while (d[++i] < q1 - iqr) {}
          // eslint-disable-next-line no-plusplus
          while (d[--j] > q3 + iqr) {}
          return [i, j];
        };
      }

      $scope.$watch('[queryResult && queryResult.getData(), visualization.options]', function () {
        if ($scope.queryResult.getData() === null) {
          return;
        }

        var data = $scope.queryResult.getData();
        var parentWidth = _d2.default.select(elm[0].parentNode).node().getBoundingClientRect().width;
        var margin = {
          top: 10, right: 50, bottom: 40, left: 50, inner: 25
        };
        var width = parentWidth - margin.right - margin.left;
        var height = 500 - margin.top - margin.bottom;

        var min = Infinity;
        var max = -Infinity;
        var mydata = [];
        var value = 0;
        var d = [];
        var xAxisLabel = $scope.visualization.options.xAxisLabel;
        var yAxisLabel = $scope.visualization.options.yAxisLabel;

        var columns = $scope.queryResult.getColumnNames();
        var xscale = _d2.default.scale.ordinal().domain(columns).rangeBands([0, parentWidth - margin.left - margin.right]);

        var boxWidth = void 0;
        if (columns.length > 1) {
          boxWidth = Math.min(xscale(columns[1]), 120.0);
        } else {
          boxWidth = 120.0;
        }
        margin.inner = boxWidth / 3.0;

        columns.forEach(function (column, i) {
          d = mydata[i] = [];
          data.forEach(function (row) {
            value = row[column];
            d.push(value);
            if (value > max) max = Math.ceil(value);
            if (value < min) min = Math.floor(value);
          });
        });

        var yscale = _d2.default.scale.linear().domain([min * 0.99, max * 1.01]).range([height, 0]);

        var chart = (0, _d3box2.default)().whiskers(calcIqr(1.5)).width(boxWidth - 2 * margin.inner).height(height).domain([min * 0.99, max * 1.01]);
        var xAxis = _d2.default.svg.axis().scale(xscale).orient('bottom');

        var yAxis = _d2.default.svg.axis().scale(yscale).orient('left');

        var xLines = _d2.default.svg.axis().scale(xscale).tickSize(height).orient('bottom');

        var yLines = _d2.default.svg.axis().scale(yscale).tickSize(width).orient('right');

        function barOffset(i) {
          return xscale(columns[i]) + (xscale(columns[1]) - margin.inner) / 2.0;
        }

        _d2.default.select(elm[0]).selectAll('svg').remove();

        var plot = _d2.default.select(elm[0]).append('svg').attr('width', parentWidth).attr('height', height + margin.bottom + margin.top).append('g').attr('width', parentWidth - margin.left - margin.right).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        _d2.default.select('svg').append('text').attr('class', 'box').attr('x', parentWidth / 2.0).attr('text-anchor', 'middle').attr('y', height + margin.bottom).text(xAxisLabel);

        _d2.default.select('svg').append('text').attr('class', 'box').attr('transform', 'translate(10,' + (height + margin.top + margin.bottom) / 2.0 + ')rotate(-90)').attr('text-anchor', 'middle').text(yAxisLabel);

        plot.append('rect').attr('class', 'grid-background').attr('width', width).attr('height', height);

        plot.append('g').attr('class', 'grid').call(yLines);

        plot.append('g').attr('class', 'grid').call(xLines);

        plot.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);

        plot.append('g').attr('class', 'y axis').call(yAxis);

        plot.selectAll('.box').data(mydata).enter().append('g').attr('class', 'box').attr('width', boxWidth).attr('height', height).attr('transform', function (_, i) {
          return 'translate(' + barOffset(i) + ',' + 0 + ')';
        }).call(chart);
      }, true);
    }
  };
}

function boxPlotEditor() {
  return {
    restrict: 'E',
    template: _boxPlotEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('boxplotRenderer', boxPlotRenderer);
  ngModule.directive('boxplotEditor', boxPlotEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<boxplot-renderer ' + 'options="visualization.options" query-result="queryResult">' + '</boxplot-renderer>';

    var editTemplate = '<boxplot-editor></boxplot-editor>';

    VisualizationProvider.registerVisualization({
      type: 'BOXPLOT',
      name: 'Boxplot (Deprecated)',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate
    });
  }]);
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
// Inspired by http://informationandvisualization.de/blog/box-plot
function box() {
  var width = 1,
      height = 1,
      duration = 0,
      domain = null,
      value = Number,
      whiskers = boxWhiskers,
      quartiles = boxQuartiles,
      tickFormat = null;

  // For each small multiple…
  function box(g) {
    g.each(function (d, i) {
      d = d.map(value).sort(d3.ascending);
      var g = d3.select(this),
          n = d.length,
          min = d[0],
          max = d[n - 1];

      // Compute quartiles. Must return exactly 3 elements.
      var quartileData = d.quartiles = quartiles(d);

      // Compute whiskers. Must return exactly 2 elements, or null.
      var whiskerIndices = whiskers && whiskers.call(this, d, i),
          whiskerData = whiskerIndices && whiskerIndices.map(function (i) {
        return d[i];
      });

      // Compute outliers. If no whiskers are specified, all data are "outliers".
      // We compute the outliers as indices, so that we can join across transitions!
      var outlierIndices = whiskerIndices ? d3.range(0, whiskerIndices[0]).concat(d3.range(whiskerIndices[1] + 1, n)) : d3.range(n);

      // Compute the new x-scale.
      var x1 = d3.scale.linear().domain(domain && domain.call(this, d, i) || [min, max]).range([height, 0]);

      // Retrieve the old x-scale, if this is an update.
      var x0 = this.__chart__ || d3.scale.linear().domain([0, Infinity]).range(x1.range());

      // Stash the new scale.
      this.__chart__ = x1;

      // Note: the box, median, and box tick elements are fixed in number,
      // so we only have to handle enter and update. In contrast, the outliers
      // and other elements are variable, so we need to exit them! Variable
      // elements also fade in and out.

      // Update center line: the vertical line spanning the whiskers.
      var center = g.selectAll('line.center').data(whiskerData ? [whiskerData] : []);

      center.enter().insert('line', 'rect').attr('class', 'center').attr('x1', width / 2).attr('y1', function (d) {
        return x0(d[0]);
      }).attr('x2', width / 2).attr('y2', function (d) {
        return x0(d[1]);
      }).style('opacity', 1e-6).transition().duration(duration).style('opacity', 1).attr('y1', function (d) {
        return x1(d[0]);
      }).attr('y2', function (d) {
        return x1(d[1]);
      });

      center.transition().duration(duration).style('opacity', 1).attr('y1', function (d) {
        return x1(d[0]);
      }).attr('y2', function (d) {
        return x1(d[1]);
      });

      center.exit().transition().duration(duration).style('opacity', 1e-6).attr('y1', function (d) {
        return x1(d[0]);
      }).attr('y2', function (d) {
        return x1(d[1]);
      }).remove();

      // Update innerquartile box.
      var box = g.selectAll('rect.box').data([quartileData]);

      box.enter().append('rect').attr('class', 'box').attr('x', 0).attr('y', function (d) {
        return x0(d[2]);
      }).attr('width', width).attr('height', function (d) {
        return x0(d[0]) - x0(d[2]);
      }).transition().duration(duration).attr('y', function (d) {
        return x1(d[2]);
      }).attr('height', function (d) {
        return x1(d[0]) - x1(d[2]);
      });

      box.transition().duration(duration).attr('y', function (d) {
        return x1(d[2]);
      }).attr('height', function (d) {
        return x1(d[0]) - x1(d[2]);
      });

      box.exit().remove();

      // Update median line.
      var medianLine = g.selectAll('line.median').data([quartileData[1]]);

      medianLine.enter().append('line').attr('class', 'median').attr('x1', 0).attr('y1', x0).attr('x2', width).attr('y2', x0).transition().duration(duration).attr('y1', x1).attr('y2', x1);

      medianLine.transition().duration(duration).attr('y1', x1).attr('y2', x1);

      medianLine.exit().remove();

      // Update whiskers.
      var whisker = g.selectAll('line.whisker').data(whiskerData || []);

      whisker.enter().insert('line', 'circle, text').attr('class', 'whisker').attr('x1', 0).attr('y1', x0).attr('x2', width).attr('y2', x0).style('opacity', 1e-6).transition().duration(duration).attr('y1', x1).attr('y2', x1).style('opacity', 1);

      whisker.transition().duration(duration).attr('y1', x1).attr('y2', x1).style('opacity', 1);

      whisker.exit().transition().duration(duration).attr('y1', x1).attr('y2', x1).style('opacity', 1e-6).remove();

      // Update outliers.
      var outlier = g.selectAll('circle.outlier').data(outlierIndices, Number);

      outlier.enter().insert('circle', 'text').attr('class', 'outlier').attr('r', 5).attr('cx', width / 2).attr('cy', function (i) {
        return x0(d[i]);
      }).style('opacity', 1e-6).transition().duration(duration).attr('cy', function (i) {
        return x1(d[i]);
      }).style('opacity', 1);

      outlier.transition().duration(duration).attr('cy', function (i) {
        return x1(d[i]);
      }).style('opacity', 1);

      outlier.exit().transition().duration(duration).attr('cy', function (i) {
        return x1(d[i]);
      }).style('opacity', 1e-6).remove();

      // Compute the tick format.
      var format = tickFormat || x1.tickFormat(8);

      // Update box ticks.
      var boxTick = g.selectAll('text.box').data(quartileData);

      boxTick.enter().append('text').attr('class', 'box').attr('dy', '.3em').attr('dx', function (d, i) {
        return i & 1 ? 6 : -6;
      }).attr('x', function (d, i) {
        return i & 1 ? width : 0;
      }).attr('y', x0).attr('text-anchor', function (d, i) {
        return i & 1 ? 'start' : 'end';
      }).text(format).transition().duration(duration).attr('y', x1);

      boxTick.transition().duration(duration).text(format).attr('y', x1);

      boxTick.exit().remove();

      // Update whisker ticks. These are handled separately from the box
      // ticks because they may or may not exist, and we want don't want
      // to join box ticks pre-transition with whisker ticks post-.
      var whiskerTick = g.selectAll('text.whisker').data(whiskerData || []);

      whiskerTick.enter().append('text').attr('class', 'whisker').attr('dy', '.3em').attr('dx', 6).attr('x', width).attr('y', x0).text(format).style('opacity', 1e-6).transition().duration(duration).attr('y', x1).style('opacity', 1);

      whiskerTick.transition().duration(duration).text(format).attr('y', x1).style('opacity', 1);

      whiskerTick.exit().transition().duration(duration).attr('y', x1).style('opacity', 1e-6).remove();
    });
    d3.timer.flush();
  }

  box.width = function (x) {
    if (!arguments.length) return width;
    width = x;
    return box;
  };

  box.height = function (x) {
    if (!arguments.length) return height;
    height = x;
    return box;
  };

  box.tickFormat = function (x) {
    if (!arguments.length) return tickFormat;
    tickFormat = x;
    return box;
  };

  box.duration = function (x) {
    if (!arguments.length) return duration;
    duration = x;
    return box;
  };

  box.domain = function (x) {
    if (!arguments.length) return domain;
    domain = x == null ? x : d3.functor(x);
    return box;
  };

  box.value = function (x) {
    if (!arguments.length) return value;
    value = x;
    return box;
  };

  box.whiskers = function (x) {
    if (!arguments.length) return whiskers;
    whiskers = x;
    return box;
  };

  box.quartiles = function (x) {
    if (!arguments.length) return quartiles;
    quartiles = x;
    return box;
  };

  return box;
}

function boxWhiskers(d) {
  return [0, d.length - 1];
}

function boxQuartiles(d) {
  return [d3.quantile(d, 0.25), d3.quantile(d, 0.5), d3.quantile(d, 0.75)];
}

exports.default = box;

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">X Axis Label</label>\n    <div class=\"col-lg-6\">\n      <input type=\"text\" ng-model=\"visualization.options.xAxisLabel\" class=\"form-control\"></input>\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">Y Axis Label</label>\n    <div class=\"col-lg-6\">\n      <input type=\"text\" ng-model=\"visualization.options.yAxisLabel\" class=\"form-control\"></input>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _chart = __webpack_require__(543);

var _chart2 = _interopRequireDefault(_chart);

var _chartEditor = __webpack_require__(544);

var _chartEditor2 = _interopRequireDefault(_chartEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ChartEditor.$inject = ['ColorPalette', 'clientConfig'];


function ChartRenderer() {
  return {
    restrict: 'E',
    scope: {
      queryResult: '=',
      options: '=?'
    },
    template: _chart2.default,
    replace: false,
    controller: ['$scope', function controller($scope) {
      $scope.chartSeries = [];

      function zIndexCompare(series) {
        if ($scope.options.seriesOptions[series.name]) {
          return $scope.options.seriesOptions[series.name].zIndex;
        }
        return 0;
      }

      function reloadData() {
        if (!(0, _underscore.isUndefined)($scope.queryResult) && $scope.queryResult.getData()) {
          var data = $scope.queryResult.getChartData($scope.options.columnMapping);
          $scope.chartSeries = (0, _underscore.sortBy)(data, zIndexCompare);
        }
      }

      function reloadChart() {
        reloadData();
        $scope.plotlyOptions = $scope.options;
      }

      $scope.$watch('options', reloadChart, true);
      $scope.$watch('queryResult && queryResult.getData()', reloadData);
    }]
  };
}

function ChartEditor(ColorPalette, clientConfig) {
  return {
    restrict: 'E',
    template: _chartEditor2.default,
    scope: {
      queryResult: '=',
      options: '=?'
    },
    link: function link(scope) {
      scope.currentTab = 'general';
      scope.colors = (0, _underscore.extend)({ Automatic: null }, ColorPalette);

      scope.stackingOptions = {
        Disabled: null,
        Enabled: 'normal',
        Percent: 'percent'
      };

      scope.changeTab = function (tab) {
        scope.currentTab = tab;
      };

      scope.chartTypes = {
        line: { name: 'Line', icon: 'line-chart' },
        column: { name: 'Bar', icon: 'bar-chart' },
        area: { name: 'Area', icon: 'area-chart' },
        pie: { name: 'Pie', icon: 'pie-chart' },
        scatter: { name: 'Scatter', icon: 'circle-o' },
        bubble: { name: 'Bubble', icon: 'circle-o' },
        box: { name: 'Box', icon: 'square-o' }
      };

      if (clientConfig.allowCustomJSVisualizations) {
        scope.chartTypes.custom = { name: 'Custom', icon: 'code' };
      }

      scope.xAxisScales = ['datetime', 'linear', 'logarithmic', 'category'];
      scope.yAxisScales = ['linear', 'logarithmic', 'datetime', 'category'];

      scope.chartTypeChanged = function () {
        (0, _underscore.keys)(scope.options.seriesOptions).forEach(function (key) {
          scope.options.seriesOptions[key].type = scope.options.globalSeriesType;
        });
      };

      scope.showSizeColumnPicker = function () {
        return (0, _underscore.some)(scope.options.seriesOptions, function (options) {
          return options.type === 'bubble';
        });
      };

      if (scope.options.customCode === undefined) {
        scope.options.customCode = '// Available variables are x, ys, element, and Plotly\n// Type console.log(x, ys); for more info about x and ys\n// To plot your graph call Plotly.plot(element, ...)\n// Plotly examples and docs: https://plot.ly/javascript/';
      }

      function refreshColumns() {
        scope.columns = scope.queryResult.getColumns();
        scope.columnNames = (0, _underscore.pluck)(scope.columns, 'name');
        if (scope.columnNames.length > 0) {
          (0, _underscore.each)((0, _underscore.difference)((0, _underscore.keys)(scope.options.columnMapping), scope.columnNames), function (column) {
            delete scope.options.columnMapping[column];
          });
        }
      }

      function refreshColumnsAndForm() {
        refreshColumns();
        if (!scope.queryResult.getData() || scope.queryResult.getData().length === 0 || scope.columns.length === 0) {
          return;
        }
        scope.form.yAxisColumns = (0, _underscore.intersection)(scope.form.yAxisColumns, scope.columnNames);
        if (!(0, _underscore.contains)(scope.columnNames, scope.form.xAxisColumn)) {
          scope.form.xAxisColumn = undefined;
        }
        if (!(0, _underscore.contains)(scope.columnNames, scope.form.groupby)) {
          scope.form.groupby = undefined;
        }
      }

      function refreshSeries() {
        var seriesNames = (0, _underscore.pluck)(scope.queryResult.getChartData(scope.options.columnMapping), 'name');
        var existing = (0, _underscore.keys)(scope.options.seriesOptions);
        (0, _underscore.each)((0, _underscore.difference)(seriesNames, existing), function (name) {
          scope.options.seriesOptions[name] = {
            type: scope.options.globalSeriesType,
            yAxis: 0
          };
          scope.form.seriesList.push(name);
        });
        (0, _underscore.each)((0, _underscore.difference)(existing, seriesNames), function (name) {
          scope.form.seriesList = (0, _underscore.without)(scope.form.seriesList, name);
          delete scope.options.seriesOptions[name];
        });
      }

      function setColumnRole(role, column) {
        scope.options.columnMapping[column] = role;
      }

      function unsetColumn(column) {
        setColumnRole('unused', column);
      }

      refreshColumns();

      scope.$watch('options.columnMapping', function () {
        if (scope.queryResult.status === 'done') {
          refreshSeries();
        }
      }, true);

      scope.$watch(function () {
        return [scope.queryResult.getId(), scope.queryResult.status];
      }, function (changed) {
        if (!changed[0] || changed[1] !== 'done') {
          return;
        }

        refreshColumnsAndForm();
        refreshSeries();
      }, true);

      scope.form = {
        yAxisColumns: [],
        seriesList: (0, _underscore.sortBy)((0, _underscore.keys)(scope.options.seriesOptions), function (name) {
          return scope.options.seriesOptions[name].zIndex;
        })
      };

      scope.$watchCollection('form.seriesList', function (value) {
        (0, _underscore.each)(value, function (name, index) {
          scope.options.seriesOptions[name].zIndex = index;
          scope.options.seriesOptions[name].index = 0; // is this needed?
        });
      });

      scope.$watchCollection('form.yAxisColumns', function (value, old) {
        (0, _underscore.each)(old, unsetColumn);
        (0, _underscore.each)(value, (0, _underscore.partial)(setColumnRole, 'y'));
      });

      scope.$watch('form.xAxisColumn', function (value, old) {
        if (old !== undefined) {
          unsetColumn(old);
        }
        if (value !== undefined) {
          setColumnRole('x', value);
        }
      });

      scope.$watch('form.errorColumn', function (value, old) {
        if (old !== undefined) {
          unsetColumn(old);
        }
        if (value !== undefined) {
          setColumnRole('yError', value);
        }
      });

      scope.$watch('form.sizeColumn', function (value, old) {
        if (old !== undefined) {
          unsetColumn(old);
        }
        if (value !== undefined) {
          setColumnRole('size', value);
        }
      });

      scope.$watch('form.groupby', function (value, old) {
        if (old !== undefined) {
          unsetColumn(old);
        }
        if (value !== undefined) {
          setColumnRole('series', value);
        }
      });

      if (!(0, _underscore.has)(scope.options, 'legend')) {
        scope.options.legend = { enabled: true };
      }

      if (!(0, _underscore.has)(scope.options, 'bottomMargin')) {
        scope.options.bottomMargin = 50;
      }

      if (scope.columnNames) {
        (0, _underscore.each)(scope.options.columnMapping, function (value, key) {
          if (scope.columnNames.length > 0 && !(0, _underscore.contains)(scope.columnNames, key)) {
            return;
          }
          if (value === 'x') {
            scope.form.xAxisColumn = key;
          } else if (value === 'y') {
            scope.form.yAxisColumns.push(key);
          } else if (value === 'series') {
            scope.form.groupby = key;
          } else if (value === 'yError') {
            scope.form.errorColumn = key;
          } else if (value === 'size') {
            scope.form.sizeColumn = key;
          }
        });
      }
    }
  };
}

var ColorBox = {
  bindings: {
    color: '<'
  },
  template: "<span style='width: 12px; height: 12px; background-color: {{$ctrl.color}}; display: inline-block; margin-right: 5px;'></span>"
};

function init(ngModule) {
  ngModule.component('colorBox', ColorBox);
  ngModule.directive('chartRenderer', ChartRenderer);
  ngModule.directive('chartEditor', ChartEditor);
  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<chart-renderer options="visualization.options" query-result="queryResult"></chart-renderer>';
    var editTemplate = '<chart-editor options="visualization.options" query-result="queryResult"></chart-editor>';

    var defaultOptions = {
      globalSeriesType: 'column',
      sortX: true,
      legend: { enabled: true },
      yAxis: [{ type: 'linear' }, { type: 'linear', opposite: true }],
      xAxis: { type: 'datetime', labels: { enabled: true } },
      error_y: { type: 'data', visible: true },
      series: { stacking: null, error_y: { type: 'data', visible: true } },
      seriesOptions: {},
      columnMapping: {},
      bottomMargin: 50,
      defaultColumns: 3,
      defaultRows: 8,
      minColumns: 2,
      minRows: 5
    };

    VisualizationProvider.registerVisualization({
      type: 'CHART',
      name: 'Chart',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"plotlyOptions.globalSeriesType != 'custom'\">\n  <plotly-chart options=\"plotlyOptions\" series=\"chartSeries\"></plotly-chart>\n</div>\n<div ng-if=\"plotlyOptions.globalSeriesType == 'custom'\">\n  <custom-plotly-chart series=\"chartSeries\" options=\"plotlyOptions\"></custom-plotly-chart>\n</div>\n"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <ul class=\"tab-nav\">\n    <li ng-class=\"{active: currentTab == 'general'}\">\n      <a ng-click=\"changeTab('general')\">General</a>\n    </li>\n    <li ng-class=\"{active: currentTab == 'xAxis'}\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <a ng-click=\"changeTab('xAxis')\">X Axis</a>\n    </li>\n    <li ng-class=\"{active: currentTab == 'yAxis'}\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <a ng-click=\"changeTab('yAxis')\">Y Axis</a>\n    </li>\n    <li ng-class=\"{active: currentTab == 'series'}\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <a ng-click=\"changeTab('series')\">Series</a>\n    </li>\n  </ul>\n  <div ng-show=\"currentTab == 'general'\">\n    <div class=\"form-group\">\n      <label class=\"control-label\">Chart Type</label>\n      <div ng-if=\"chartTypes\"><!--the if is a weird workaround-->\n        <ui-select ng-model=\"options.globalSeriesType\" on-select=\"chartTypeChanged()\">\n          <ui-select-match placeholder=\"Choose chart type...\">\n            <div>\n              <i class=\"fa fa-{{$select.selected.value.icon}}\"></i>\n              {{$select.selected.value.name}}\n            </div>\n          </ui-select-match>\n          <ui-select-choices repeat=\"info.chartType as (chartType, info) in chartTypes\">\n            <div><i class=\"fa fa-{{info.value.icon}}\"></i><span> </span><span\n              ng-bind-html=\"info.value.name | highlight: $select.search\"></span></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n\n    <div class=\"form-group\" ng-class=\"{'has-error': chartEditor.xAxisColumn.$invalid}\">\n      <label class=\"control-label\">X Column</label>\n\n      <ui-select name=\"xAxisColumn\" required ng-model=\"form.xAxisColumn\">\n        <ui-select-match placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:form.yAxisColumns | remove:form.groupby\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <!-- not using regular validation (chartEditor.yAxisColumns.$invalid) due to a bug in ui-select with multiple choices-->\n    <div class=\"form-group\" ng-class=\"{'has-error': !form.yAxisColumns || form.yAxisColumns.length == 0}\">\n      <label class=\"control-label\">Y Columns</label>\n\n      <ui-select multiple name=\"yAxisColumns\" required ng-model=\"form.yAxisColumns\">\n        <ui-select-match placeholder=\"Choose columns...\">{{$item}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:form.groupby | remove:form.xAxisColumn\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n\n    </div>\n\n    <div class=\"form-group\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <label class=\"control-label\">Group by</label>\n      <ui-select name=\"groupby\" ng-model=\"form.groupby\" class=\"clearable\">\n        <ui-select-match allow-clear=\"true\" placeholder=\"Choose column...\">\n          {{$select.selected}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:form.yAxisColumns | remove:form.xAxisColumn\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"showSizeColumnPicker()\">\n      <label class=\"control-label\">Bubble size column</label>\n\n      <ui-select name=\"sizeColumn\" ng-model=\"form.sizeColumn\">\n        <ui-select-match allow-clear=\"true\" placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:form.yAxisColumns | remove:form.groupby\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <label class=\"control-label\">Errors column</label>\n\n      <ui-select name=\"errorColumn\" ng-model=\"form.errorColumn\">\n        <ui-select-match allow-clear=\"true\" placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:form.yAxisColumns | remove:form.groupby\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"checkbox\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"options.legend.enabled\">\n        <i class=\"input-helper\"></i> Show Legend\n      </label>\n    </div>\n\n    <div class=\"checkbox\" ng-if=\"options.globalSeriesType == 'box'\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"options.showpoints\">\n        <i class=\"input-helper\"></i> Show All Points\n      </label>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <label class=\"control-label\">Stacking</label>\n\n      <div ng-if=\"stackingOptions\"><!--the if is a weird workaround-->\n        <ui-select ng-model=\"options.series.stacking\"\n                   ng-disabled=\"['line', 'area', 'column'].indexOf(options.globalSeriesType) == -1\">\n          <ui-select-match placeholder=\"Choose Stacking...\">{{$select.selected.key | capitalize}}</ui-select-match>\n          <ui-select-choices repeat=\"value.value as (key, value) in stackingOptions\">\n            <div ng-bind-html=\"value.key | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"form-group\" ng-if=\"options.globalSeriesType == 'custom'\">\n    <label class=\"control-label\">Custom code</label>\n    <textarea ng-model=\"options.customCode\" class=\"form-control v-resizable\" rows=\"10\">\n    </textarea>\n  </div>\n\n  <div class=\"checkbox\" ng-if=\"options.globalSeriesType == 'custom'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"options.enableConsoleLogs\">\n      <i class=\"input-helper\"></i> Show errors in the console\n    </label>\n  </div>\n\n  <div class=\"checkbox\" ng-if=\"options.globalSeriesType == 'custom'\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"options.autoRedraw\">\n      <i class=\"input-helper\"></i> Auto update graph\n    </label>\n  </div>\n\n  <div ng-show=\"currentTab == 'xAxis'\">\n    <div class=\"form-group\">\n      <label class=\"control-label\">Scale</label>\n      <ui-select ng-model=\"options.xAxis.type\">\n        <ui-select-match placeholder=\"Choose Scale...\">{{$select.selected | capitalize}}</ui-select-match>\n        <ui-select-choices repeat=\"scaleType in xAxisScales\">\n          <div ng-bind-html=\"scaleType | capitalize | highlight: $select.search\"></div>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label\">Name</label>\n      <input ng-model=\"options.xAxis.title.text\" type=\"text\" class=\"form-control\"></input>\n    </div>\n\n    <div class=\"checkbox\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"options.sortX\">\n        <i class=\"input-helper\"></i> Sort Values\n      </label>\n    </div>\n\n    <div class=\"checkbox\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"options.xAxis.labels.enabled\">\n        <i class=\"input-helper\"></i> Show Labels\n      </label>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label\">Height</label>\n      <input name=\"x-axis-height\" type=\"number\" class=\"form-control\" ng-model=\"options.bottomMargin\">\n    </div>\n  </div>\n\n  <div ng-show=\"currentTab == 'yAxis'\">\n    <div ng-repeat=\"yAxis in options.yAxis\">\n      <h4>{{$index == 0 ? 'Left' : 'Right'}} Y Axis</h4>\n\n      <div class=\"form-group\">\n        <label class=\"control-label\">Scale</label>\n        <ui-select ng-model=\"yAxis.type\">\n          <ui-select-match placeholder=\"Choose Scale...\">{{$select.selected | capitalize}}</ui-select-match>\n          <ui-select-choices repeat=\"scaleType in yAxisScales\">\n            <div ng-bind-html=\"scaleType | capitalize | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label\">Name</label>\n        <input ng-model=\"yAxis.title.text\" type=\"text\" class=\"form-control\"></input>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label\">Min Value</label>\n        <input ng-model=\"yAxis.rangeMin\" type=\"number\" step=\"any\" placeholder=\"Auto\" class=\"form-control\"></input>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label\">Max Value</label>\n        <input ng-model=\"yAxis.rangeMax\" type=\"number\" step=\"any\" placeholder=\"Auto\" class=\"form-control\"></input>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"currentTab=='series'\">\n    <table class=\"table table-condensed col-table\">\n      <thead>\n      <th>zIndex</th>\n      <th>Left Y Axis</th>\n      <th>Right Y Axis</th>\n      <th>Label</th>\n      <th>Color</th>\n      <th>Type</th>\n      </thead>\n      <tbody ui-sortable ng-model=\"form.seriesList\">\n      <tr ng-repeat=\"name in form.seriesList\">\n        <td style=\"cursor: move;\"><i class=\"fa fa-arrows-v\"></i> <span\n          ng-bind=\"options.seriesOptions[name].zIndex + 1\"></span></td>\n        <td>\n          <input type=\"radio\" ng-value=\"0\" ng-model=\"options.seriesOptions[name].yAxis\">\n        </td>\n        <td>\n          <input type=\"radio\" ng-value=\"1\" ng-model=\"options.seriesOptions[name].yAxis\">\n        </td>\n        <td style=\"padding: 3px; width: 140px;\">\n          <input placeholder=\"{{name}}\" class=\"form-control input-sm super-small-input\" type=\"text\"\n                 ng-model=\"options.seriesOptions[name].name\">\n        </td>\n        <td style=\"padding: 3px; width: 35px;\">\n          <ui-select ng-model=\"options.seriesOptions[name].color\">\n            <ui-select-match>\n              <color-box color=\"$select.selected.value\"></color-box>\n            </ui-select-match>\n            <ui-select-choices repeat=\"color.value as (key, color) in colors\">\n              <color-box color=\"color.value\"></color-box>\n              <span ng-bind-html=\"color.key | capitalize | highlight: $select.search\"></span>\n            </ui-select-choices>\n          </ui-select>\n        </td>\n        <td style=\"padding: 3px; width: 105px;\">\n          <ui-select ng-model=\"options.seriesOptions[name].type\">\n            <ui-select-match placeholder=\"Chart Type\">\n              <div>\n                <i class=\"fa fa-{{$select.selected.value.icon}}\"></i>\n                {{$select.selected.value.name}}\n              </div>\n            </ui-select-match>\n            <ui-select-choices repeat=\"info.chartType as (chartType, info) in chartTypes\">\n              <div><i class=\"fa fa-{{info.value.icon}}\"></i><span> </span><span\n                ng-bind-html=\"info.value.name | highlight: $select.search\"></span></div>\n            </ui-select-choices>\n          </ui-select>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n"

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _underscore = __webpack_require__(3);

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

var _core = __webpack_require__(546);

var _core2 = _interopRequireDefault(_core);

var _bar = __webpack_require__(674);

var _bar2 = _interopRequireDefault(_bar);

var _pie = __webpack_require__(679);

var _pie2 = _interopRequireDefault(_pie);

var _histogram = __webpack_require__(687);

var _histogram2 = _interopRequireDefault(_histogram);

var _box = __webpack_require__(696);

var _box2 = _interopRequireDefault(_box);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_core2.default.register([_bar2.default, _pie2.default, _histogram2.default, _box2.default]);
_core2.default.setPlotConfig({
  modeBarButtonsToRemove: ['sendDataToCloud']
});

var DEFAULT_BOTTOM_MARGIN = 50;

// The following colors will be used if you pick "Automatic" color.
var BaseColors = {
  Blue: '#4572A7',
  Red: '#AA4643',
  Green: '#89A54E',
  Purple: '#80699B',
  Cyan: '#3D96AE',
  Orange: '#DB843D',
  'Light Blue': '#92A8CD',
  Lilac: '#A47D7C',
  'Light Green': '#B5CA92',
  Brown: '#A52A2A',
  Black: '#000000',
  Gray: '#808080',
  Pink: '#FFC0CB',
  'Dark Blue': '#00008b'
};

// Additional colors for the user to choose from:
var ColorPalette = _extends({}, BaseColors, {
  'Indian Red': '#F8766D',
  'Green 2': '#53B400',
  'Green 3': '#00C094',
  DarkTurquoise: '#00B6EB',
  'Dark Violet': '#A58AFF',
  'Pink 2': '#FB61D7'
});

var ColorPaletteArray = (0, _underscore.values)(BaseColors);

function fillXValues(seriesList) {
  var xValues = (0, _underscore.sortBy)(_underscore.union.apply(undefined, _toConsumableArray((0, _underscore.pluck)(seriesList, 'x'))), _underscore.identity);
  seriesList.forEach(function (series) {
    series.x = (0, _underscore.sortBy)(series.x, _underscore.identity);

    (0, _underscore.each)(xValues, function (value, index) {
      if (series.x[index] !== value) {
        series.x.splice(index, 0, value);
        series.y.splice(index, 0, null);
      }
    });
  });
}

function storeOriginalHeightForEachSeries(seriesList) {
  seriesList.forEach(function (series) {
    if (!(0, _underscore.has)(series, 'visible')) {
      series.visible = true;
      series.original_y = series.y.slice();
    }
  });
}

function getEnabledSeries(seriesList) {
  return seriesList.filter(function (series) {
    return series.visible === true;
  });
}

function initializeTextAndHover(seriesList) {
  seriesList.forEach(function (series) {
    series.text = [];
    series.hoverinfo = 'text+name';
  });
}

function normalAreaStacking(seriesList) {
  fillXValues(seriesList);
  storeOriginalHeightForEachSeries(seriesList);
  initializeTextAndHover(seriesList);

  var enabledSeriesList = getEnabledSeries(seriesList);

  (0, _underscore.each)(enabledSeriesList, function (series, seriesIndex, list) {
    (0, _underscore.each)(series.y, function (_, yIndex) {
      var cumulativeHeightOfPreviousSeries = seriesIndex > 0 ? list[seriesIndex - 1].y[yIndex] : 0;
      var cumulativeHeightWithThisSeries = cumulativeHeightOfPreviousSeries + series.original_y[yIndex];

      series.y[yIndex] = cumulativeHeightWithThisSeries;
      series.text.push('Value: ' + series.original_y[yIndex] + '<br>Sum: ' + cumulativeHeightWithThisSeries);
    });
  });
}

function lastVisibleY(seriesList, lastSeriesIndex, yIndex) {
  for (var i = lastSeriesIndex; i >= 0; i -= 1) {
    if (seriesList[i].visible === true) {
      return seriesList[i].y[yIndex];
    }
  }
  return 0;
}

function percentAreaStacking(seriesList) {
  if (seriesList.length === 0) {
    return;
  }
  fillXValues(seriesList);
  storeOriginalHeightForEachSeries(seriesList);
  initializeTextAndHover(seriesList);

  (0, _underscore.each)(seriesList[0].y, function (seriesY, yIndex) {
    var sumOfCorrespondingDataPoints = seriesList.reduce(function (total, series) {
      return total + series.original_y[yIndex];
    }, 0);

    (0, _underscore.each)(seriesList, function (series, seriesIndex) {
      var percentage = series.original_y[yIndex] / sumOfCorrespondingDataPoints * 100;
      var previousVisiblePercentage = lastVisibleY(seriesList, seriesIndex - 1, yIndex);
      series.y[yIndex] = percentage + previousVisiblePercentage;
      series.text.push('Value: ' + series.original_y[yIndex] + '<br>Relative: ' + percentage.toFixed(2) + '%');
    });
  });
}

function percentBarStacking(seriesList) {
  if (seriesList.length === 0) {
    return;
  }
  fillXValues(seriesList);
  initializeTextAndHover(seriesList);

  for (var i = 0; i < seriesList[0].y.length; i += 1) {
    var sum = 0;
    for (var j = 0; j < seriesList.length; j += 1) {
      sum += seriesList[j].y[i];
    }
    for (var _j = 0; _j < seriesList.length; _j += 1) {
      var value = seriesList[_j].y[i] / sum * 100;
      seriesList[_j].text.push('Value: ' + seriesList[_j].y[i] + '<br>Relative: ' + value.toFixed(2) + '%');
      seriesList[_j].y[i] = value;
    }
  }
}

function normalizeValue(value) {
  if (_moment2.default.isMoment(value)) {
    return value.format('YYYY-MM-DD HH:mm:ss');
  }
  return value;
}

function seriesMinValue(series) {
  return (0, _underscore.min)(series.map(function (s) {
    return (0, _underscore.min)(s.y);
  }));
}

function seriesMaxValue(series) {
  return (0, _underscore.max)(series.map(function (s) {
    return (0, _underscore.max)(s.y);
  }));
}

function leftAxisSeries(series) {
  return series.filter(function (s) {
    return s.yaxis !== 'y2';
  });
}

function rightAxisSeries(series) {
  return series.filter(function (s) {
    return s.yaxis === 'y2';
  });
}

function getScaleType(scale) {
  if (scale === 'datetime') {
    return 'date';
  }
  if (scale === 'logarithmic') {
    return 'log';
  }
  return scale;
}

function getColor(index) {
  return ColorPaletteArray[index % ColorPaletteArray.length];
}

var PlotlyChart = function PlotlyChart() {
  return {
    restrict: 'E',
    template: '<div class="plotly-chart-container" resize-event="handleResize()"></div>',
    scope: {
      options: '=',
      series: '='
    },
    link: function link(scope, element) {
      var container = element[0].querySelector('.plotly-chart-container');

      function setType(series, type) {
        if (type === 'column') {
          series.type = 'bar';
        } else if (type === 'line') {
          series.mode = 'lines';
        } else if (type === 'area') {
          series.fill = scope.options.series.stacking === null ? 'tozeroy' : 'tonexty';
          series.mode = 'lines';
        } else if (type === 'scatter') {
          series.type = 'scatter';
          series.mode = 'markers';
        } else if (type === 'bubble') {
          series.mode = 'markers';
        } else if (type === 'box') {
          series.type = 'box';
          series.mode = 'markers';
        }
      }

      function getTitle(axis) {
        if (!(0, _underscore.isUndefined)(axis) && !(0, _underscore.isUndefined)(axis.title)) {
          return axis.title.text;
        }
        return null;
      }

      function recalculateOptions() {
        scope.layout.margin.b = parseInt(scope.options.bottomMargin, 10) || DEFAULT_BOTTOM_MARGIN;

        scope.data.length = 0;
        scope.layout.showlegend = (0, _underscore.has)(scope.options, 'legend') ? scope.options.legend.enabled : true;
        delete scope.layout.barmode;
        delete scope.layout.xaxis;
        delete scope.layout.yaxis;
        delete scope.layout.yaxis2;

        if (scope.options.globalSeriesType === 'pie') {
          var hasX = (0, _underscore.contains)((0, _underscore.values)(scope.options.columnMapping), 'x');
          var rows = scope.series.length > 2 ? 2 : 1;
          var cellsInRow = Math.ceil(scope.series.length / rows);
          var cellWidth = 1 / cellsInRow;
          var cellHeight = 1 / rows;
          var xPadding = 0.02;
          var yPadding = 0.1;

          scope.layout.annotations = [];

          (0, _underscore.each)(scope.series, function (series, index) {
            var xPosition = index % cellsInRow * cellWidth;
            var yPosition = Math.floor(index / cellsInRow) * cellHeight;
            var plotlySeries = {
              values: [],
              labels: [],
              type: 'pie',
              hole: 0.4,
              marker: { colors: ColorPaletteArray },
              text: series.name,
              textposition: 'inside',
              textfont: { color: '#f5f5f5' },
              name: series.name,
              domain: {
                x: [xPosition, xPosition + cellWidth - xPadding],
                y: [yPosition, yPosition + cellHeight - yPadding]
              }
            };

            if (scope.series.length > 1) {
              scope.layout.annotations.push({
                x: xPosition + (cellWidth - xPadding) / 2,
                y: yPosition + cellHeight / 1 - 0.015,
                xanchor: 'center',
                yanchor: 'top',
                text: series.name,
                showarrow: false
              });
            }

            series.data.forEach(function (row) {
              plotlySeries.values.push(row.y);
              plotlySeries.labels.push(hasX ? row.x : 'Slice ' + index);
            });

            scope.data.push(plotlySeries);
          });
          return;
        }

        if (scope.options.globalSeriesType === 'box') {
          scope.layout.boxmode = 'group';
          scope.layout.boxgroupgap = 0.50;
        }

        var hasY2 = false;
        var sortX = scope.options.sortX === true || scope.options.sortX === undefined;
        var useUnifiedXaxis = sortX && scope.options.xAxis.type === 'category' && scope.options.globalSeriesType !== 'box';

        var unifiedX = null;
        if (useUnifiedXaxis) {
          unifiedX = (0, _underscore.sortBy)(_underscore.union.apply(undefined, _toConsumableArray(scope.series.map(function (s) {
            return (0, _underscore.pluck)(s.data, 'x');
          }))), _underscore.identity);
        }

        (0, _underscore.each)(scope.series, function (series, index) {
          var seriesOptions = scope.options.seriesOptions[series.name] || { type: scope.options.globalSeriesType };

          var seriesColor = seriesOptions.color ? seriesOptions.color : getColor(index);

          var plotlySeries = {
            x: [],
            y: [],
            error_y: {
              array: [],
              color: seriesColor
            },
            name: seriesOptions.name || series.name,
            marker: { color: seriesColor }
          };

          if (seriesOptions.yAxis === 1 && (scope.options.series.stacking === null || seriesOptions.type === 'line')) {
            hasY2 = true;
            plotlySeries.yaxis = 'y2';
          }

          setType(plotlySeries, seriesOptions.type);
          var data = series.data;
          if (sortX) {
            data = (0, _underscore.sortBy)(data, 'x');
          }

          if (useUnifiedXaxis && index === 0) {
            var yValues = {};
            var eValues = {};

            data.forEach(function (row) {
              yValues[row.x] = row.y;
              if (row.yError) {
                eValues[row.x] = row.yError;
              }
            });

            unifiedX.forEach(function (x) {
              plotlySeries.x.push(normalizeValue(x));
              plotlySeries.y.push(normalizeValue(yValues[x] || null));
              if (!(0, _underscore.isUndefined)(eValues[x])) {
                plotlySeries.error_y.array.push(normalizeValue(eValues[x] || null));
              }
            });
          } else {
            data.forEach(function (row) {
              plotlySeries.x.push(normalizeValue(row.x));
              plotlySeries.y.push(normalizeValue(row.y));
              if (row.yError !== undefined) {
                plotlySeries.error_y.array.push(normalizeValue(row.yError));
              }
            });
          }
          if (!plotlySeries.error_y.length) {
            delete plotlySeries.error_y.length;
          }

          if (seriesOptions.type === 'bubble') {
            plotlySeries.marker = {
              size: (0, _underscore.pluck)(data, 'size')
            };
          }

          if (seriesOptions.type === 'box') {
            plotlySeries.boxpoints = 'outliers';
            plotlySeries.marker = {
              color: seriesColor,
              size: 3
            };
            if (scope.options.showpoints) {
              plotlySeries.boxpoints = 'all';
              plotlySeries.jitter = 0.3;
              plotlySeries.pointpos = -1.8;
            }
          }

          scope.data.push(plotlySeries);
        });

        scope.layout.xaxis = {
          title: getTitle(scope.options.xAxis),
          type: getScaleType(scope.options.xAxis.type)
        };

        if (!(0, _underscore.isUndefined)(scope.options.xAxis.labels)) {
          scope.layout.xaxis.showticklabels = scope.options.xAxis.labels.enabled;
        }

        if ((0, _underscore.isArray)(scope.options.yAxis)) {
          scope.layout.yaxis = {
            title: getTitle(scope.options.yAxis[0]),
            type: getScaleType(scope.options.yAxis[0].type)
          };

          if ((0, _underscore.isNumber)(scope.options.yAxis[0].rangeMin) || (0, _underscore.isNumber)(scope.options.yAxis[0].rangeMax)) {
            var minY = scope.options.yAxis[0].rangeMin || Math.min(0, seriesMinValue(leftAxisSeries(scope.data)));
            var maxY = scope.options.yAxis[0].rangeMax || seriesMaxValue(leftAxisSeries(scope.data));

            scope.layout.yaxis.range = [minY, maxY];
          }
        }
        if (hasY2 && !(0, _underscore.isUndefined)(scope.options.yAxis)) {
          scope.layout.yaxis2 = {
            title: getTitle(scope.options.yAxis[1]),
            type: getScaleType(scope.options.yAxis[1].type),
            overlaying: 'y',
            side: 'right'
          };

          if ((0, _underscore.isNumber)(scope.options.yAxis[1].rangeMin) || (0, _underscore.isNumber)(scope.options.yAxis[1].rangeMax)) {
            var _minY = scope.options.yAxis[1].rangeMin || Math.min(0, seriesMinValue(rightAxisSeries(scope.data)));
            var _maxY = scope.options.yAxis[1].rangeMax || seriesMaxValue(rightAxisSeries(scope.data));

            scope.layout.yaxis2.range = [_minY, _maxY];
          }
        } else {
          delete scope.layout.yaxis2;
        }

        if (scope.options.series.stacking === 'normal') {
          scope.layout.barmode = 'stack';
          if (scope.options.globalSeriesType === 'area') {
            normalAreaStacking(scope.data);
          }
        } else if (scope.options.series.stacking === 'percent') {
          scope.layout.barmode = 'stack';
          if (scope.options.globalSeriesType === 'area') {
            percentAreaStacking(scope.data);
          } else if (scope.options.globalSeriesType === 'column') {
            percentBarStacking(scope.data);
          }
        }
      }

      scope.$watch('series', recalculateOptions);
      scope.$watch('options', recalculateOptions, true);

      scope.layout = {
        margin: {
          l: 50, r: 50, b: DEFAULT_BOTTOM_MARGIN, t: 20, pad: 4
        },
        width: container.offsetWidth,
        height: container.offsetHeight,
        autosize: true
      };
      scope.plotlyOptions = { showLink: false, displaylogo: false };
      scope.data = [];

      var plotlyElement = element[0].children[0];
      _core2.default.newPlot(plotlyElement, scope.data, scope.layout, scope.plotlyOptions);

      plotlyElement.on('plotly_afterplot', function () {
        if (scope.options.globalSeriesType === 'area' && (scope.options.series.stacking === 'normal' || scope.options.series.stacking === 'percent')) {
          document.querySelectorAll('.legendtoggle').forEach(function (rectDiv, i) {
            _d2.default.select(rectDiv).on('click', function () {
              var maxIndex = scope.data.length - 1;
              var itemClicked = scope.data[maxIndex - i];

              itemClicked.visible = itemClicked.visible === true ? 'legendonly' : true;
              if (scope.options.series.stacking === 'normal') {
                normalAreaStacking(scope.data);
              } else if (scope.options.series.stacking === 'percent') {
                percentAreaStacking(scope.data);
              }
              _core2.default.redraw(plotlyElement);
            });
          });
        }
      });
      scope.$watch('layout', function (layout, old) {
        if ((0, _underscore.isEqual)(layout, old)) {
          return;
        }
        _core2.default.relayout(plotlyElement, layout);
      }, true);

      scope.$watch('data', function (data) {
        if (!(0, _underscore.isEmpty)(data)) {
          _core2.default.redraw(plotlyElement);
        }
      }, true);

      scope.handleResize = (0, _underscore.debounce)(function () {
        scope.layout.width = container.offsetWidth;
        scope.layout.height = container.offsetHeight;
      }, 100);
      scope.handleResize();
    }
  };
};

var CustomPlotlyChart = function CustomPlotlyChart(clientConfig) {
  var customChart = {
    restrict: 'E',
    template: '<div></div>',
    scope: {
      series: '=',
      options: '='
    },
    link: function link(scope, element) {
      if (!clientConfig.allowCustomJSVisualizations) {
        return;
      }
      var refresh = function refresh() {
        // Clear existing data with blank data for succeeding codeCall adds data to existing plot.
        _core2.default.newPlot(element[0].children[0]);

        // eslint-disable-next-line no-eval
        var codeCall = eval('codeCall = function(x, ys, element, Plotly){ ' + scope.options.customCode + ' }');
        codeCall(scope.x, scope.ys, element[0].children[0], _core2.default);
      };
      var timeSeriesToPlotlySeries = function timeSeriesToPlotlySeries() {
        scope.x = [];
        scope.ys = {};
        (0, _underscore.each)(scope.series, function (series) {
          scope.ys[series.name] = [];
          (0, _underscore.each)(series.data, function (point) {
            scope.x.push(normalizeValue(point.x));
            scope.ys[series.name].push(normalizeValue(point.y));
          });
        });
      };
      scope.$watch('[options.customCode, options.autoRedraw]', function () {
        try {
          if (scope.options.autoRedraw) {
            refresh();
          }
        } catch (err) {
          if (scope.options.enableConsoleLogs) {
            // eslint-disable-next-line no-console
            console.log('Error while executing custom graph: ' + err);
          }
        }
      }, true);
      scope.$watch('series', function () {
        timeSeriesToPlotlySeries();
        refresh();
      }, true);
    }
  };
  return customChart;
};

CustomPlotlyChart.$inject = ['clientConfig'];
function init(ngModule) {
  ngModule.constant('ColorPalette', ColorPalette);
  ngModule.directive('plotlyChart', PlotlyChart);
  ngModule.directive('customPlotlyChart', CustomPlotlyChart);
}

/***/ }),
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(706);

__webpack_require__(707);

var _cohortEditor = __webpack_require__(708);

var _cohortEditor2 = _interopRequireDefault(_cohortEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Cornelius */
var momentInterval = {
  weekly: 'weeks',
  daily: 'days',
  monthly: 'months'
};

function prepareData(rawData, timeInterval) {
  var sortedData = _underscore2.default.sortBy(rawData, function (r) {
    return r.date + parseInt(r.day_number, 10);
  });
  var grouped = _underscore2.default.groupBy(sortedData, 'date');
  var initialDate = (0, _moment2.default)(sortedData[0].date).toDate();
  var lastDate = (0, _moment2.default)(sortedData[sortedData.length - 1].date);
  var zeroBased = _underscore2.default.min(_underscore2.default.pluck(rawData, 'day_number')) === 0;

  var previousDay = null;
  var data = [];

  _underscore2.default.each(grouped, function (values) {
    if (previousDay !== null) {
      var diff = Math.abs(previousDay.diff(values[0].date, momentInterval[timeInterval]));
      while (diff > 1) {
        data.push([0]);
        diff -= 1;
      }
    }

    previousDay = (0, _moment2.default)(values[0].date);

    var row = [parseInt(values[0].total, 10)];
    var maxDays = lastDate.diff((0, _moment2.default)(values[0].date), momentInterval[timeInterval]);
    if (zeroBased) {
      maxDays += 1;
    }

    _underscore2.default.each(values, function (value) {
      var index = zeroBased ? value.day_number + 1 : value.day_number;
      row[index] = parseInt(value.value, 10);
    });

    for (var i = 0; i <= maxDays; i += 1) {
      if (row[i] === undefined) {
        row[i] = 0;
      }
    }

    data.push(row);
  });

  return { data: data, initialDate: initialDate };
}

function cohortRenderer() {
  return {
    restrict: 'E',
    scope: {
      queryResult: '=',
      options: '='
    },
    template: '',
    replace: false,
    link: function link($scope, element) {
      $scope.options.timeInterval = $scope.options.timeInterval || 'daily';

      function updateCohort() {
        if ($scope.queryResult.getData() === null) {
          return;
        }

        var _prepareData = prepareData($scope.queryResult.getData(), $scope.options.timeInterval),
            data = _prepareData.data,
            initialDate = _prepareData.initialDate;

        var container = _angular2.default.element(element)[0];

        Cornelius.draw({
          initialDate: initialDate,
          container: container,
          cohort: data,
          title: null,
          timeInterval: $scope.options.timeInterval,
          labels: {
            time: 'Time',
            people: 'Users',
            weekOf: 'Week of'
          }
        });
      }

      $scope.$watch('queryResult && queryResult.getData()', updateCohort);
      $scope.$watch('options.timeInterval', updateCohort);
    }
  };
}

function cohortEditor() {
  return {
    restrict: 'E',
    template: _cohortEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('cohortRenderer', cohortRenderer);
  ngModule.directive('cohortEditor', cohortEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var editTemplate = '<cohort-editor></cohort-editor>';
    var defaultOptions = {
      timeInterval: 'daily'
    };

    VisualizationProvider.registerVisualization({
      type: 'COHORT',
      name: 'Cohort',
      renderTemplate: '<cohort-renderer options="visualization.options" query-result="queryResult"></cohort-renderer>',
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 706 */,
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\n    <label class=\"control-label\">Time Interval</label>\n    <select class=\"form-control\" ng-model=\"visualization.options.timeInterval\">\n      <option value=\"daily\">Daily</option>\n      <option value=\"weekly\">Weekly</option>\n      <option value=\"monthly\">Monthly</option>\n    </select>\n</div>\n"

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _numberFormat = __webpack_require__(259);

var _numberFormat2 = _interopRequireDefault(_numberFormat);

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _counter = __webpack_require__(710);

var _counter2 = _interopRequireDefault(_counter);

var _counterEditor = __webpack_require__(711);

var _counterEditor2 = _interopRequireDefault(_counterEditor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CounterRenderer.$inject = ['$timeout'];


function getRowNumber(index, size) {
  if (index >= 0) {
    return index - 1;
  }

  if (Math.abs(index) > size) {
    index %= size;
  }

  return size + index;
}

function CounterRenderer($timeout) {
  return {
    restrict: 'E',
    template: _counter2.default,
    link: function link($scope, $element) {
      $scope.fontSize = '1em';

      var rootNode = $element[0].querySelector('counter');
      $scope.handleResize = function () {
        var rootMeasures = {
          height: Math.floor(rootNode.offsetHeight),
          fontSize: parseFloat(window.getComputedStyle(rootNode).fontSize)
        };
        var rulers = rootNode.querySelectorAll('.ruler');
        var rulerMeasures = _.chain(rulers).map(function (ruler) {
          return {
            height: ruler.offsetHeight,
            fontSize: parseFloat(window.getComputedStyle(ruler).fontSize)
          };
        }).reduce(function (result, value) {
          return {
            height: result.height + value.height,
            fontSize: result.fontSize + value.fontSize
          };
        }).value();

        /* eslint-disable function-paren-newline */
        var fontSize = Math.floor(rootMeasures.height / rulerMeasures.height * rulerMeasures.fontSize / (rulerMeasures.fontSize / rootMeasures.fontSize));
        /* eslint-enable function-paren-newline */
        $scope.fontSize = fontSize + 'px';
      };

      var refreshData = function refreshData() {
        var queryData = $scope.queryResult.getData();
        if (queryData) {
          var rowNumber = getRowNumber($scope.visualization.options.rowNumber, queryData.length);
          var targetRowNumber = getRowNumber($scope.visualization.options.targetRowNumber, queryData.length);
          var counterColName = $scope.visualization.options.counterColName;
          var targetColName = $scope.visualization.options.targetColName;

          if ($scope.visualization.options.countRow) {
            $scope.counterValue = queryData.length;
          } else if (counterColName) {
            $scope.counterValue = queryData[rowNumber][counterColName];
          }
          if (targetColName) {
            $scope.targetValue = queryData[targetRowNumber][targetColName];

            if ($scope.targetValue) {
              $scope.delta = $scope.counterValue - $scope.targetValue;
              $scope.trendPositive = $scope.delta >= 0;
            }
          } else {
            $scope.targetValue = null;
          }

          $scope.isNumber = _.isNumber($scope.counterValue);
          if ($scope.isNumber) {
            $scope.stringPrefix = $scope.visualization.options.stringPrefix;
            $scope.stringSuffix = $scope.visualization.options.stringSuffix;

            var stringDecimal = $scope.visualization.options.stringDecimal;
            var stringDecChar = $scope.visualization.options.stringDecChar;
            var stringThouSep = $scope.visualization.options.stringThouSep;
            if (stringDecimal || stringDecChar || stringThouSep) {
              $scope.counterValue = (0, _numberFormat2.default)($scope.counterValue, stringDecimal, stringDecChar, stringThouSep);
              $scope.isNumber = false;
            }
          } else {
            $scope.stringPrefix = null;
            $scope.stringSuffix = null;
          }
        }

        $timeout(function () {
          $scope.handleResize();
        });
      };

      $scope.$watch('visualization.options', refreshData, true);
      $scope.$watch('queryResult && queryResult.getData()', refreshData);
    }
  };
}

function CounterEditor() {
  return {
    restrict: 'E',
    template: _counterEditor2.default,
    link: function link(scope) {
      scope.currentTab = 'general';
      scope.changeTab = function (tab) {
        scope.currentTab = tab;
      };
      scope.isValueNumber = function () {
        var queryData = scope.queryResult.getData();
        if (queryData) {
          var rowNumber = getRowNumber(scope.visualization.options.rowNumber, queryData.length);
          var counterColName = scope.visualization.options.counterColName;

          if (scope.visualization.options.countRow) {
            scope.counterValue = queryData.length;
          } else if (counterColName) {
            scope.counterValue = queryData[rowNumber][counterColName];
          }
        }
        return _.isNumber(scope.counterValue);
      };
    }
  };
}

function init(ngModule) {
  ngModule.directive('counterEditor', CounterEditor);
  ngModule.directive('counterRenderer', CounterRenderer);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<counter-renderer ' + 'options="visualization.options" query-result="queryResult">' + '</counter-renderer>';

    var editTemplate = '<counter-editor></counter-editor>';
    var defaultOptions = {
      counterColName: 'counter',
      rowNumber: 1,
      targetRowNumber: 1,
      stringDecimal: 0,
      stringDecChar: '.',
      stringThouSep: ',',
      defaultColumns: 2,
      defaultRows: 5
    };

    VisualizationProvider.registerVisualization({
      type: 'COUNTER',
      name: 'Counter',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<counter\n  ng-class=\"{'positive': targetValue && trendPositive, 'negative': targetValue && !trendPositive}\"\n  ng-style=\"{'font-size': fontSize}\" resize-event=\"handleResize()\">\n  <value ng-if=\"isNumber\"><span class=\"ruler\"\n    title=\"{{stringPrefix}}{{counterValue|number}}{{stringSuffix}}\"\n  >{{stringPrefix}}{{counterValue|number}}{{stringSuffix}}</span></value>\n  <value ng-if=\"!isNumber\"><span class=\"ruler\"\n    title=\"{{stringPrefix}}{{counterValue}}{{stringSuffix}}\"\n  >{{stringPrefix}}{{counterValue}}{{stringSuffix}}</span></value>\n  <counter-target ng-if=\"targetValue\"\n    title=\"({{targetValue|number}})\"\n  ><span class=\"ruler\">({{targetValue|number}})</span></counter-target>\n  <counter-name><span class=\"ruler\"\n    title=\"{{visualization.name}}\"\n  >{{visualization.name}}</span></counter-name>\n</counter>\n"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <ul class=\"tab-nav\">\n    <li ng-class=\"{active: currentTab == 'general'}\">\n      <a ng-click=\"changeTab('general')\">General</a>\n    </li>\n    <li ng-class=\"{active: currentTab == 'format'}\">\n      <a ng-click=\"changeTab('format')\">Format</a>\n    </li>\n  </ul>\n  <div ng-show=\"currentTab == 'general'\">\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Counter Value Column Name</label>\n      <div class=\"col-lg-6\">\n        <select ng-options=\"name for name in queryResult.getColumnNames()\" ng-model=\"visualization.options.counterColName\" class=\"form-control\" ng-disabled=\"visualization.options.countRow\"></select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Counter Value Row Number</label>\n      <div class=\"col-lg-6\">\n        <input type=\"number\" ng-model=\"visualization.options.rowNumber\" class=\"form-control\" ng-disabled=\"visualization.options.countRow\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Target Value Column Name</label>\n      <div class=\"col-lg-6\">\n        <select ng-options=\"name for name in queryResult.getColumnNames()\" ng-model=\"visualization.options.targetColName\" class=\"form-control\">\n          <option value=\"\">No target value</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"form-group\" ng-if=\"visualization.options.targetColName\">\n      <label class=\"col-lg-6\">Target Value Row Number</label>\n      <div class=\"col-lg-6\">\n        <input type=\"number\" ng-model=\"visualization.options.targetRowNumber\" class=\"form-control\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <div class=\"col-lg-6\">\n        <input type=\"checkbox\" ng-model=\"visualization.options.countRow\">\n        <i class=\"input-helper\"></i> Count Rows\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"currentTab == 'format'\">\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Formatting Decimal Place</label>\n      <div class=\"col-lg-6\">\n        <input type=\"number\" ng-model=\"visualization.options.stringDecimal\" class=\"form-control\" ng-disabled=\"!isValueNumber()\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Formatting Decimal Character</label>\n      <div class=\"col-lg-6\">\n        <input type=\"text\" ng-model=\"visualization.options.stringDecChar\" class=\"form-control\" ng-disabled=\"!isValueNumber()\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Formatting Thousands Separator</label>\n      <div class=\"col-lg-6\">\n        <input type=\"text\" ng-model=\"visualization.options.stringThouSep\" class=\"form-control\" ng-disabled=\"!isValueNumber()\" ng-trim=\"false\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Formatting String Prefix</label>\n      <div class=\"col-lg-6\">\n        <input type=\"text\" ng-model=\"visualization.options.stringPrefix\" class=\"form-control\" ng-disabled=\"!isValueNumber()\" ng-trim=\"false\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-lg-6\">Formatting String Suffix</label>\n      <div class=\"col-lg-6\">\n        <input type=\"text\" ng-model=\"visualization.options.stringSuffix\" class=\"form-control\" ng-disabled=\"!isValueNumber()\" ng-trim=\"false\">\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _angular = __webpack_require__(21);

var _editVisualizationDialog = __webpack_require__(713);

var _editVisualizationDialog2 = _interopRequireDefault(_editVisualizationDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditVisualizationDialog = {
  template: _editVisualizationDialog2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$window', 'currentUser', 'Events', 'Visualization', 'toastr', function controller($window, currentUser, Events, Visualization, toastr) {
    'ngInject';

    var _this = this;

    this.query = this.resolve.query;
    this.queryResult = this.resolve.queryResult;
    this.originalVisualization = this.resolve.visualization;
    this.onNewSuccess = this.resolve.onNewSuccess;
    this.visualization = (0, _angular.copy)(this.originalVisualization);
    this.visTypes = Visualization.visualizationTypes;

    this.newVisualization = function () {
      return {
        type: Visualization.defaultVisualization.type,
        name: Visualization.defaultVisualization.name,
        description: '',
        options: Visualization.defaultVisualization.defaultOptions
      };
    };
    if (!this.visualization) {
      this.visualization = this.newVisualization();
    }

    this.typeChanged = function (oldType) {
      var type = _this.visualization.type;
      // if not edited by user, set name to match type
      // todo: this is wrong, because he might have edited it before.
      if (type && oldType !== type && _this.visualization && !_this.visForm.name.$dirty) {
        _this.visualization.name = Visualization.visualizations[_this.visualization.type].name;
      }

      // Bring default options
      if (type && oldType !== type && _this.visualization) {
        _this.visualization.options = Visualization.visualizations[_this.visualization.type].defaultOptions;
      }
    };

    this.submit = function () {
      if (_this.visualization.id) {
        Events.record('update', 'visualization', _this.visualization.id, { type: _this.visualization.type });
      } else {
        Events.record('create', 'visualization', null, { type: _this.visualization.type });
      }

      _this.visualization.query_id = _this.query.id;

      Visualization.save(_this.visualization, function (result) {
        toastr.success('Visualization saved');

        var visIds = (0, _underscore.pluck)(_this.query.visualizations, 'id');
        var index = visIds.indexOf(result.id);
        if (index > -1) {
          _this.query.visualizations[index] = result;
        } else {
          // new visualization
          _this.query.visualizations.push(result);
          if (_this.onNewSuccess) {
            _this.onNewSuccess(result);
          }
        }
        _this.close();
      }, function () {
        toastr.error('Visualization could not be saved');
      });
    };

    this.closeDialog = function () {
      if (_this.visForm.$dirty) {
        if ($window.confirm('Are you sure you want to close the editor without saving?')) {
          _this.close();
        }
      } else {
        _this.close();
      }
    };
  }]
};

function init(ngModule) {
  ngModule.component('editVisualizationDialog', EditVisualizationDialog);
}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.closeDialog()\"><span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">Visualization Editor</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-5 p-r-5\">\n        <div>\n          <form name=\"$ctrl.visForm\">\n            <div class=\"form-group\">\n              <label class=\"control-label\">Visualization Type</label>\n\n              <select required ng-model=\"$ctrl.visualization.type\"\n                      ng-options=\"type.type as type.name for type in $ctrl.visTypes\" class=\"form-control\"\n                      ng-change=\"$ctrl.typeChanged('{{$ctrl.visualization.type}}')\"></select>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label\">Visualization Name</label>\n              <input name=\"name\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.visualization.name\"\n                     placeholder=\"{{$ctrl.visualization.type | capitalize}}\">\n            </div>\n\n            <visualization-options-editor visualization=\"$ctrl.visualization\"\n                                          query-result=\"$ctrl.queryResult\"\n                                          query=\"$ctrl.query\">\n            </visualization-options-editor>\n          </form>\n        </div>\n      </div>\n      <div class=\"col-md-7\" style=\"border: 1px solid #eee;\">\n        <visualization-renderer visualization=\"$ctrl.visualization\" query-result=\"$ctrl.queryResult\"></visualization-renderer>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.closeDialog()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.submit()\">Save</button>\n  </div>\n</div>\n"

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

FilterValueFilter.$inject = ['clientConfig'];
VisualizationName.$inject = ['Visualization'];
VisualizationOptionsEditor.$inject = ['Visualization'];
VisualizationRenderer.$inject = ['Visualization'];


function VisualizationProvider() {
  var _this = this;

  this.visualizations = {};
  // this.visualizationTypes = {};
  this.visualizationTypes = [];
  var defaultConfig = {
    defaultOptions: {},
    skipTypes: false,
    editorTemplate: null
  };

  this.registerVisualization = function (config) {
    var visualization = _extends({}, defaultConfig, config);

    // TODO: this is prone to errors; better refactor.
    if (_this.defaultVisualization === undefined && !visualization.name.match(/Deprecated/)) {
      _this.defaultVisualization = visualization;
    }

    _this.visualizations[config.type] = visualization;

    if (!config.skipTypes) {
      _this.visualizationTypes.push({ name: config.name, type: config.type });
    }
  };

  this.getSwitchTemplate = function (property) {
    var pattern = /(<[a-zA-Z0-9-]*?)( |>)/;

    var mergedTemplates = (0, _underscore.reduce)(_this.visualizations, function (templates, visualization) {
      if (visualization[property]) {
        var ngSwitch = '$1 ng-switch-when="' + visualization.type + '" $2';
        var template = visualization[property].replace(pattern, ngSwitch);

        return templates + '\n' + template;
      }

      return templates;
    }, '');

    mergedTemplates = '<div ng-switch on="visualization.type">' + mergedTemplates + '</div>';

    return mergedTemplates;
  };

  this.$get = ['$resource', function ($resource) {
    var Visualization = $resource('api/visualizations/:id', { id: '@id' });
    Visualization.visualizations = _this.visualizations;
    Visualization.visualizationTypes = _this.visualizationTypes;
    Visualization.renderVisualizationsTemplate = _this.getSwitchTemplate('renderTemplate');
    Visualization.editorTemplate = _this.getSwitchTemplate('editorTemplate');
    Visualization.defaultVisualization = _this.defaultVisualization;

    return Visualization;
  }];
}

function VisualizationName(Visualization) {
  return {
    restrict: 'E',
    scope: {
      visualization: '='
    },
    template: '{{name}}',
    replace: false,
    link: function link(scope) {
      if (Visualization.visualizations[scope.visualization.type]) {
        var defaultName = Visualization.visualizations[scope.visualization.type].name;
        if (defaultName !== scope.visualization.name) {
          scope.name = scope.visualization.name;
        }
      }
    }
  };
}

function VisualizationRenderer(Visualization) {
  return {
    restrict: 'E',
    scope: {
      visualization: '=',
      queryResult: '='
    },
    // TODO: using switch here (and in the options editor) might introduce errors and bad
    // performance wise. It's better to eventually show the correct template based on the
    // visualization type and not make the browser render all of them.
    template: '<filters filters="filters"></filters>\n' + Visualization.renderVisualizationsTemplate,
    replace: false,
    link: function link(scope) {
      scope.$watch('queryResult && queryResult.getFilters()', function (filters) {
        if (filters) {
          scope.filters = filters;
        }
      });
    }
  };
}

function VisualizationOptionsEditor(Visualization) {
  return {
    restrict: 'E',
    template: Visualization.editorTemplate,
    replace: false,
    scope: {
      visualization: '=',
      query: '=',
      queryResult: '='
    }
  };
}

function FilterValueFilter(clientConfig) {
  return function (value, filter) {
    var firstValue = value;
    if ((0, _underscore.isArray)(value)) {
      firstValue = value[0];
    }

    // TODO: deduplicate code with table.js:
    if (filter.column.type === 'date') {
      if (firstValue && _moment2.default.isMoment(firstValue)) {
        return firstValue.format(clientConfig.dateFormat);
      }
    } else if (filter.column.type === 'datetime') {
      if (firstValue && _moment2.default.isMoment(firstValue)) {
        return firstValue.format(clientConfig.dateTimeFormat);
      }
    }

    return firstValue;
  };
}

function init(ngModule) {
  ngModule.provider('Visualization', VisualizationProvider);
  ngModule.directive('visualizationRenderer', VisualizationRenderer);
  ngModule.directive('visualizationOptionsEditor', VisualizationOptionsEditor);
  ngModule.directive('visualizationName', VisualizationName);
  ngModule.filter('filterValue', FilterValueFilter);
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

var _leaflet = __webpack_require__(716);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(717);

__webpack_require__(718);

__webpack_require__(720);

__webpack_require__(721);

var _markerIcon = __webpack_require__(719);

var _markerIcon2 = _interopRequireDefault(_markerIcon);

var _markerIcon2x = __webpack_require__(722);

var _markerIcon2x2 = _interopRequireDefault(_markerIcon2x);

var _markerShadow = __webpack_require__(723);

var _markerShadow2 = _interopRequireDefault(_markerShadow);

var _map = __webpack_require__(724);

var _map2 = _interopRequireDefault(_map);

var _mapEditor = __webpack_require__(725);

var _mapEditor2 = _interopRequireDefault(_mapEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This is a workaround for an issue with giving Leaflet load the icon on its own.
*/
_leaflet2.default.Icon.Default.mergeOptions({
  iconUrl: _markerIcon2.default,
  iconRetinaUrl: _markerIcon2x2.default,
  shadowUrl: _markerShadow2.default
});

delete _leaflet2.default.Icon.Default.prototype._getIconUrl;

function mapRenderer() {
  return {
    restrict: 'E',
    template: _map2.default,
    link: function link($scope, elm) {
      var colorScale = _d2.default.scale.category10();
      var map = _leaflet2.default.map(elm[0].children[0].children[0], { scrollWheelZoom: false });
      var mapControls = _leaflet2.default.control.layers().addTo(map);
      var layers = {};
      var tileLayer = _leaflet2.default.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      function getBounds() {
        $scope.visualization.options.bounds = map.getBounds();
      }

      function setBounds() {
        var b = $scope.visualization.options.bounds;

        if (b) {
          map.fitBounds([[b._southWest.lat, b._southWest.lng], [b._northEast.lat, b._northEast.lng]]);
        } else if (layers) {
          var allMarkers = _underscore2.default.flatten(_underscore2.default.map(_underscore2.default.values(layers), function (l) {
            return l.getLayers();
          }));
          // eslint-disable-next-line new-cap
          var group = new _leaflet2.default.featureGroup(allMarkers);
          map.fitBounds(group.getBounds());
        }
      }

      map.on('focus', function () {
        map.on('moveend', getBounds);
      });
      map.on('blur', function () {
        map.off('moveend', getBounds);
      });

      function resize() {
        if (!map) return;
        map.invalidateSize(false);
        setBounds();
      }

      var createMarker = function createMarker(lat, lon) {
        return _leaflet2.default.marker([lat, lon]);
      };

      var heatpoint = function heatpoint(lat, lon, color) {
        var style = {
          fillColor: color,
          fillOpacity: 0.9,
          stroke: false
        };

        return _leaflet2.default.circleMarker([lat, lon], style);
      };

      function createDescription(latCol, lonCol, row) {
        var lat = row[latCol];
        var lon = row[lonCol];

        var description = '<ul style="list-style-type: none;padding-left: 0">';
        description += '<li><strong>' + lat + ', ' + lon + '</strong>';

        _underscore2.default.each(row, function (v, k) {
          if (!(k === latCol || k === lonCol)) {
            description += '<li>' + k + ': ' + v + '</li>';
          }
        });

        return description;
      }

      function removeLayer(layer) {
        if (layer) {
          mapControls.removeLayer(layer);
          map.removeLayer(layer);
        }
      }

      function addLayer(name, points) {
        var latCol = $scope.visualization.options.latColName || 'lat';
        var lonCol = $scope.visualization.options.lonColName || 'lon';
        var classify = $scope.visualization.options.classify;

        var markers = void 0;
        if ($scope.visualization.options.clusterMarkers) {
          var color = $scope.visualization.options.groups[name].color;
          var options = {};

          if (classify) {
            options.iconCreateFunction = function (cluster) {
              var childCount = cluster.getChildCount();

              var c = ' marker-cluster-';
              if (childCount < 10) {
                c += 'small';
              } else if (childCount < 100) {
                c += 'medium';
              } else {
                c += 'large';
              }

              c = '';

              var style = 'color: white; background-color: ' + color + ';';
              return _leaflet2.default.divIcon({ html: '<div style="' + style + '"><span>' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new _leaflet2.default.Point(40, 40) });
            };
          }

          markers = _leaflet2.default.markerClusterGroup(options);
        } else {
          markers = _leaflet2.default.layerGroup();
        }

        // create markers
        _underscore2.default.each(points, function (row) {
          var marker = void 0;

          var lat = row[latCol];
          var lon = row[lonCol];

          if (lat === null || lon === null) return;

          if (classify && classify !== 'none') {
            var groupColor = $scope.visualization.options.groups[name].color;
            marker = heatpoint(lat, lon, groupColor);
          } else {
            marker = createMarker(lat, lon);
          }

          marker.bindPopup(createDescription(latCol, lonCol, row));
          markers.addLayer(marker);
        });

        markers.addTo(map);

        layers[name] = markers;
        mapControls.addOverlay(markers, name);
      }

      function render() {
        var queryData = $scope.queryResult.getData();
        var classify = $scope.visualization.options.classify;

        $scope.visualization.options.mapTileUrl = $scope.visualization.options.mapTileUrl || '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

        tileLayer.setUrl($scope.visualization.options.mapTileUrl);

        if ($scope.visualization.options.clusterMarkers === undefined) {
          $scope.visualization.options.clusterMarkers = true;
        }

        if (queryData) {
          var pointGroups = void 0;
          if (classify && classify !== 'none') {
            pointGroups = _underscore2.default.groupBy(queryData, classify);
          } else {
            pointGroups = { All: queryData };
          }

          var groupNames = _underscore2.default.keys(pointGroups);
          var options = _underscore2.default.map(groupNames, function (group) {
            if ($scope.visualization.options.groups && $scope.visualization.options.groups[group]) {
              return $scope.visualization.options.groups[group];
            }
            return { color: colorScale(group) };
          });

          $scope.visualization.options.groups = _underscore2.default.object(groupNames, options);

          _underscore2.default.each(layers, function (v) {
            removeLayer(v);
          });

          _underscore2.default.each(pointGroups, function (v, k) {
            addLayer(k, v);
          });

          setBounds();
        }
      }

      $scope.handleResize = function () {
        resize();
      };

      $scope.$watch('queryResult && queryResult.getData()', render);
      $scope.$watch('visualization.options', render, true);
      $scope.$watch('visualization.options.height', resize);
    }
  };
}

function mapEditor() {
  return {
    restrict: 'E',
    template: _mapEditor2.default,
    link: function link($scope) {
      $scope.currentTab = 'general';
      $scope.columns = $scope.queryResult.getColumns();
      $scope.columnNames = _underscore2.default.pluck($scope.columns, 'name');
      $scope.classify_columns = $scope.columnNames.concat('none');
      $scope.mapTiles = [{
        name: 'OpenStreetMap',
        url: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      }, {
        name: 'OpenStreetMap BW',
        url: '//{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
      }, {
        name: 'OpenStreetMap DE',
        url: '//{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png'
      }, {
        name: 'OpenStreetMap FR',
        url: '//{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png'
      }, {
        name: 'OpenStreetMap Hot',
        url: '//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
      }, {
        name: 'Thunderforest',
        url: '//{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png'
      }, {
        name: 'Thunderforest Spinal',
        url: '//{s}.tile.thunderforest.com/spinal-map/{z}/{x}/{y}.png'
      }, {
        name: 'OpenMapSurfer',
        url: '//korona.geog.uni-heidelberg.de/tiles/roads/x={x}&y={y}&z={z}'
      }, {
        name: 'Stamen Toner',
        url: '//stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png'
      }, {
        name: 'Stamen Toner Background',
        url: '//stamen-tiles-{s}.a.ssl.fastly.net/toner-background/{z}/{x}/{y}.png'
      }, {
        name: 'Stamen Toner Lite',
        url: '//stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png'
      }, {
        name: 'OpenTopoMap',
        url: '//{s}.tile.opentopomap.org/{z}/{x}/{y}.png'
      }];
    }
  };
}

function init(ngModule) {
  ngModule.directive('mapRenderer', mapRenderer);
  ngModule.directive('mapEditor', mapEditor);
  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<map-renderer ' + 'options="visualization.options" query-result="queryResult">' + '</map-renderer>';

    var editTemplate = '<map-editor></map-editor>';
    var defaultOptions = {
      defaultColumns: 3,
      defaultRows: 8,
      minColumns: 2,
      classify: 'none',
      clusterMarkers: true
    };

    VisualizationProvider.registerVisualization({
      type: 'MAP',
      name: 'Map',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 716 */,
/* 717 */,
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "<div class=\"map-visualization-container\">\n    <div resize-event=\"handleResize()\" style=\"width:100%; height:100%;\"></div>\n</div>\n"

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <ul class=\"tab-nav\">\n    <li ng-class=\"{active: currentTab == 'general'}\"><a ng-click=\"currentTab='general'\">General</a></li>\n    <li ng-class=\"{active: currentTab == 'groups'}\"><a ng-click=\"currentTab='groups'\">Groups</a></li>\n    <li ng-class=\"{active: currentTab == 'map'}\"><a ng-click=\"currentTab='map'\">Map Settings</a></li>\n  </ul>\n\n  <div ng-show=\"currentTab == 'general'\">\n    <div class=\"form-group\">\n      <label class=\"control-label\">Latitude Column Name</label>\n      <ui-select name=\"form-control\" required ng-model=\"visualization.options.latColName\">\n        <ui-select-match placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:visualization.options.classify | remove:visualization.options.lonColName\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label\">Longitude Column Name</label>\n      <ui-select name=\"form-control\" required ng-model=\"visualization.options.lonColName\">\n        <ui-select-match placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in columnNames | remove:visualization.options.classify | remove:visualization.options.latColName\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label\">Group By</label>\n      <ui-select name=\"form-control\" required ng-model=\"visualization.options.classify\">\n        <ui-select-match placeholder=\"Choose column...\">{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"column in classify_columns | remove:visualization.options.lonColName | remove:visualization.options.latColName\">\n          <span ng-bind-html=\"column | highlight: $select.search\"></span><span> </span>\n          <small class=\"text-muted\" ng-bind=\"columns[column].type\"></small>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n\n  <div ng-show=\"currentTab == 'groups'\">\n    <table class=\"table table-condensed col-table\">\n      <thead>\n      <th>Name</th>\n      <th>Color</th>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"(name, options) in visualization.options.groups\">\n        <td>{{name}}</td>\n        <td>\n            <input class=\"form-control\" type=\"color\" ng-model=\"options.color\"/>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div ng-show=\"currentTab == 'map'\">\n    <div class=\"checkbox\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"visualization.options.clusterMarkers\">\n        <i class=\"input-helper\"></i> Cluster Markers\n      </label>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label\">Map Tiles</label>\n      <select ng-options=\"tile.url as tile.name for tile in mapTiles\" ng-model=\"visualization.options.mapTileUrl\"\n              class=\"form-control\"></select>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(727);

__webpack_require__(728);

var _pivottableEditor = __webpack_require__(729);

var _pivottableEditor2 = _interopRequireDefault(_pivottableEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pivotTableRenderer() {
  return {
    restrict: 'E',
    scope: {
      queryResult: '=',
      visualization: '='
    },
    template: '',
    replace: false,
    link: function link($scope, element) {
      function removeControls() {
        var hideControls = $scope.visualization.options.controls && $scope.visualization.options.controls.enabled;

        document.querySelectorAll('.pvtAxisContainer, .pvtRenderer, .pvtVals').forEach(function (control) {
          if (hideControls) {
            control.style.display = 'none';
          } else {
            control.style.display = '';
          }
        });
      }

      function updatePivot() {
        $scope.$watch('queryResult && queryResult.getData()', function (data) {
          if (!data) {
            return;
          }

          if ($scope.queryResult.getData() !== null) {
            // We need to give the pivot table its own copy of the data, because it changes
            // it which interferes with other visualizations.
            data = _angular2.default.copy($scope.queryResult.getData());
            var options = {
              renderers: _jquery2.default.pivotUtilities.renderers,
              onRefresh: function onRefresh(config) {
                var configCopy = _extends({}, config);
                // delete some values which are functions
                delete configCopy.aggregators;
                delete configCopy.renderers;
                delete configCopy.onRefresh;
                // delete some bulky default values
                delete configCopy.rendererOptions;
                delete configCopy.localeStrings;

                if ($scope.visualization) {
                  $scope.visualization.options = configCopy;
                }
              }
            };

            if ($scope.visualization) {
              _extends(options, $scope.visualization.options);
            }

            (0, _jquery2.default)(element).pivotUI(data, options, true);
            removeControls();
          }
        });
      }

      $scope.$watch('queryResult && queryResult.getData()', updatePivot);
      $scope.$watch('visualization.options.controls.enabled', removeControls);
    }
  };
}

function pivotTableEditor() {
  return {
    restrict: 'E',
    template: _pivottableEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('pivotTableRenderer', pivotTableRenderer);
  ngModule.directive('pivotTableEditor', pivotTableEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var editTemplate = '<pivot-table-editor></pivot-table-editor>';
    var defaultOptions = {
      defaultRows: 10,
      defaultColumns: 3,
      minColumns: 2
    };

    VisualizationProvider.registerVisualization({
      type: 'PIVOT',
      name: 'Pivot Table',
      renderTemplate: '<pivot-table-renderer visualization="visualization" query-result="queryResult"></pivot-table-renderer>',
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <div class=\"col-lg-6\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"visualization.options.controls.enabled\">\n        Hide Pivot Controls\n      </label>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

var _d3sankey = __webpack_require__(731);

var _d3sankey2 = _interopRequireDefault(_d3sankey);

var _sankeyEditor = __webpack_require__(732);

var _sankeyEditor2 = _interopRequireDefault(_sankeyEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getConnectedNodes(node) {
  // source link = this node is the source, I need the targets
  var nodes = [];
  node.sourceLinks.forEach(function (link) {
    nodes.push(link.target);
  });
  node.targetLinks.forEach(function (link) {
    nodes.push(link.source);
  });

  return nodes;
}

function graph(data) {
  var nodesDict = {};
  var links = {};
  var nodes = [];

  var validKey = function validKey(key) {
    return key !== 'value' && key.indexOf('$$') !== 0;
  };
  var keys = _underscore2.default.sortBy(_underscore2.default.filter(_underscore2.default.keys(data[0]), validKey), _underscore2.default.identity);

  function normalizeName(name) {
    if (name) {
      return name;
    }

    return 'Exit';
  }

  function getNode(name, level) {
    name = normalizeName(name);
    var key = name + ':' + String(level);
    var node = nodesDict[key];
    if (!node) {
      node = { name: name };
      var id = nodes.push(node) - 1;
      node.id = id;
      nodesDict[key] = node;
    }
    return node;
  }

  function getLink(source, target) {
    var link = links[[source, target]];
    if (!link) {
      link = { target: target, source: source, value: 0 };
      links[[source, target]] = link;
    }

    return link;
  }

  function addLink(sourceName, targetName, value, depth) {
    if ((sourceName === '' || !sourceName) && depth > 1) {
      return;
    }

    var source = getNode(sourceName, depth);
    var target = getNode(targetName, depth + 1);
    var link = getLink(source.id, target.id);
    link.value += parseInt(value, 10);
  }

  data.forEach(function (row) {
    addLink(row[keys[0]], row[keys[1]], row.value, 1);
    addLink(row[keys[1]], row[keys[2]], row.value, 2);
    addLink(row[keys[2]], row[keys[3]], row.value, 3);
    addLink(row[keys[3]], row[keys[4]], row.value, 4);
  });

  return { nodes: nodes, links: _underscore2.default.values(links) };
}

function spreadNodes(height, data) {
  var nodesByBreadth = _d2.default.nest().key(function (d) {
    return d.x;
  }).entries(data.nodes).map(function (d) {
    return d.values;
  });

  nodesByBreadth.forEach(function (nodes) {
    nodes = _underscore2.default.filter(_underscore2.default.sortBy(nodes, function (node) {
      return -node.value;
    }), function (node) {
      return node.name !== 'Exit';
    });

    var sum = _d2.default.sum(nodes, function (o) {
      return o.dy;
    });
    var padding = (height - sum) / nodes.length;

    _underscore2.default.reduce(nodes, function (y0, node) {
      node.y = y0;
      return y0 + node.dy + padding;
    }, 0);
  });
}

function createSankey(element, data) {
  var margin = {
    top: 10, right: 10, bottom: 10, left: 10
  };
  var width = element.offsetWidth - margin.left - margin.right;
  var height = element.offsetHeight - margin.top - margin.bottom;

  if (width <= 0 || height <= 0) {
    return;
  }

  var format = function format(d) {
    return _d2.default.format(',.0f')(d);
  };
  var color = _d2.default.scale.category20();

  data = graph(data);
  data.nodes = _underscore2.default.map(data.nodes, function (d) {
    return _underscore2.default.extend(d, {
      color: color(d.name.replace(/ .*/, ''))
    });
  });

  // append the svg canvas to the page
  var svg = _d2.default.select(element).append('svg').attr('class', 'sankey').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

  // Set the sankey diagram properties
  var sankey = (0, _d3sankey2.default)().nodeWidth(15).nodePadding(10).size([width, height]);

  var path = sankey.link();

  sankey.nodes(data.nodes).links(data.links).layout(0);

  spreadNodes(height, data);
  sankey.relayout();

  // add in the links
  var link = svg.append('g').selectAll('.link').data(data.links).enter().append('path').filter(function (l) {
    return l.target.name !== 'Exit';
  }).attr('class', 'link').attr('d', path).style('stroke-width', function (d) {
    return Math.max(1, d.dy);
  }).sort(function (a, b) {
    return b.dy - a.dy;
  });

  // add the link titles
  link.append('title').text(function (d) {
    return d.source.name + ' \u2192 ' + d.target.name + '\n' + format(d.value);
  });

  var node = svg.append('g').selectAll('.node').data(data.nodes).enter().append('g').filter(function (n) {
    return n.name !== 'Exit';
  }).attr('class', 'node').attr('transform', function (d) {
    return 'translate(' + d.x + ',' + d.y + ')';
  });

  function nodeMouseOver(currentNode) {
    var nodes = getConnectedNodes(currentNode);
    nodes = _underscore2.default.pluck(nodes, 'id');
    node.filter(function (d) {
      if (d === currentNode) {
        return false;
      }

      if (_underscore2.default.contains(nodes, d.id)) {
        return false;
      }

      return true;
    }).style('opacity', 0.2);
    link.filter(function (l) {
      return !(_underscore2.default.include(currentNode.sourceLinks, l) || _underscore2.default.include(currentNode.targetLinks, l));
    }).style('opacity', 0.2);
  }

  function nodeMouseOut() {
    node.style('opacity', 1);
    link.style('opacity', 1);
  }

  // add in the nodes
  node.on('mouseover', nodeMouseOver).on('mouseout', nodeMouseOut);

  // add the rectangles for the nodes
  node.append('rect').attr('height', function (d) {
    return d.dy;
  }).attr('width', sankey.nodeWidth()).style('fill', function (d) {
    return d.color;
  }).style('stroke', function (d) {
    return _d2.default.rgb(d.color).darker(2);
  }).append('title').text(function (d) {
    return d.name + '\n' + format(d.value);
  });

  // add in the title for the nodes
  node.append('text').attr('x', -6).attr('y', function (d) {
    return d.dy / 2;
  }).attr('dy', '.35em').attr('text-anchor', 'end').attr('transform', null).text(function (d) {
    return d.name;
  }).filter(function (d) {
    return d.x < width / 2;
  }).attr('x', 6 + sankey.nodeWidth()).attr('text-anchor', 'start');
}

function sankeyRenderer() {
  return {
    restrict: 'E',
    template: '<div class="sankey-visualization-container" resize-event="handleResize()"></div>',
    link: function link(scope, element) {
      var container = element[0].querySelector('.sankey-visualization-container');

      function refreshData() {
        var queryData = scope.queryResult.getData();
        if (queryData) {
          // do the render logic.
          _angular2.default.element(container).empty();
          createSankey(container, queryData);
        }
      }

      scope.handleResize = _underscore2.default.debounce(refreshData, 50);
      scope.$watch('queryResult && queryResult.getData()', refreshData);
      scope.$watch('visualization.options.height', function (oldValue, newValue) {
        if (oldValue !== newValue) {
          refreshData();
        }
      });
    }
  };
}

function sankeyEditor() {
  return {
    restrict: 'E',
    template: _sankeyEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('sankeyRenderer', sankeyRenderer);
  ngModule.directive('sankeyEditor', sankeyEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<sankey-renderer options="visualization.options" query-result="queryResult"></sankey-renderer>';

    var editTemplate = '<sankey-editor></sankey-editor>';
    var defaultOptions = {
      defaultRows: 7
    };

    VisualizationProvider.registerVisualization({
      type: 'SANKEY',
      name: 'Sankey',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function center(node) {
  return node.y + node.dy / 2;
} /* eslint-disable */

function value(link) {
  return link.value;
}

function Sankey() {
  var sankey = {};
  var nodeWidth = 24;
  var nodePadding = 8;
  var size = [1, 1];
  var nodes = [];
  var links = [];

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks() {
    nodes.forEach(function (node) {
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    links.forEach(function (link) {
      var source = link.source;
      var target = link.target;
      if (typeof source === 'number') source = link.source = nodes[link.source];
      if (typeof target === 'number') target = link.target = nodes[link.target];
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) of each node by summing the associated links.
  function computeNodeValues() {
    nodes.forEach(function (node) {
      node.value = Math.max(_d2.default.sum(node.sourceLinks, value), _d2.default.sum(node.targetLinks, value));
    });
  }

  function moveSinksRight(x) {
    nodes.forEach(function (node) {
      if (!node.sourceLinks.length) {
        node.x = x - 1;
      }
    });
  }

  function scaleNodeBreadths(kx) {
    nodes.forEach(function (node) {
      node.x *= kx;
    });
  }

  // Iteratively assign the breadth (x-position) for each node.
  // Nodes are assigned the maximum breadth of incoming neighbors plus one;
  // nodes with no incoming links are assigned breadth zero, while
  // nodes with no outgoing links are assigned the maximum breadth.
  function computeNodeBreadths() {
    var remainingNodes = nodes;
    var nextNodes = void 0;
    var x = 0;

    function assignBreadth(node) {
      node.x = x;
      node.dx = nodeWidth;
      node.sourceLinks.forEach(function (link) {
        if (nextNodes.indexOf(link.target) < 0) {
          nextNodes.push(link.target);
        }
      });
    }

    while (remainingNodes.length) {
      nextNodes = [];
      remainingNodes.forEach(assignBreadth);
      remainingNodes = nextNodes;
      x += 1;
    }

    //
    moveSinksRight(x);
    scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
  }

  function moveSourcesRight() {
    nodes.forEach(function (node) {
      if (!node.targetLinks.length) {
        node.x = _d2.default.min(node.sourceLinks, function (d) {
          return d.target.x;
        }) - 1;
      }
    });
  }

  function computeNodeDepths(iterations) {
    var nodesByBreadth = _d2.default.nest().key(function (d) {
      return d.x;
    }).sortKeys(_d2.default.ascending).entries(nodes).map(function (d) {
      return d.values;
    });

    function initializeNodeDepth() {
      var ky = _d2.default.min(nodesByBreadth, function (n) {
        return (size[1] - (n.length - 1) * nodePadding) / _d2.default.sum(n, value);
      });

      nodesByBreadth.forEach(function (n) {
        n.forEach(function (node, i) {
          node.y = i;
          node.dy = node.value * ky;
        });
      });

      links.forEach(function (link) {
        link.dy = link.value * ky;
      });
    }

    function relaxLeftToRight(alpha) {
      function weightedSource(link) {
        return center(link.source) * link.value;
      }

      nodesByBreadth.forEach(function (n) {
        n.forEach(function (node) {
          if (node.targetLinks.length) {
            var y = _d2.default.sum(node.targetLinks, weightedSource) / _d2.default.sum(node.targetLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });
    }

    function resolveCollisions() {
      nodesByBreadth.forEach(function (nodes) {
        var n = nodes.length;
        var node = void 0;
        var dy = void 0;
        var y0 = 0;
        var i = void 0;

        // Push any overlapping nodes down.
        nodes.sort(ascendingDepth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y0 - node.y;
          if (dy > 0) node.y += dy;
          y0 = node.y + node.dy + nodePadding;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y0 - nodePadding - size[1];
        if (dy > 0) {
          y0 = node.y -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y + node.dy + nodePadding - y0;
            if (dy > 0) node.y -= dy;
            y0 = node.y;
          }
        }
      });
    }

    function resolveCollisions() {
      nodesByBreadth.forEach(function (nodes) {
        var node = void 0,
            dy = void 0,
            y0 = 0,
            n = nodes.length,
            i = void 0;

        // Push any overlapping nodes down.
        nodes.sort(ascendingDepth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y0 - node.y;
          if (dy > 0) node.y += dy;
          y0 = node.y + node.dy + nodePadding;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y0 - nodePadding - size[1];
        if (dy > 0) {
          y0 = node.y -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y + node.dy + nodePadding - y0;
            if (dy > 0) node.y -= dy;
            y0 = node.y;
          }
        }
      });
    }

    initializeNodeDepth();
    resolveCollisions();

    for (var alpha = 1; iterations > 0; iterations -= 1) {
      relaxRightToLeft(alpha *= 0.99);
      resolveCollisions();
      relaxLeftToRight(alpha);
      resolveCollisions();
    }

    function relaxRightToLeft(alpha) {
      nodesByBreadth.slice().reverse().forEach(function (nodes) {
        nodes.forEach(function (node) {
          if (node.sourceLinks.length) {
            var y = _d2.default.sum(node.sourceLinks, weightedTarget) / _d2.default.sum(node.sourceLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });

      function weightedTarget(link) {
        return center(link.target) * link.value;
      }
    }

    function ascendingDepth(a, b) {
      return a.y - b.y;
    }
  }

  function computeLinkDepths() {
    nodes.forEach(function (node) {
      node.sourceLinks.sort(ascendingTargetDepth);
      node.targetLinks.sort(ascendingSourceDepth);
    });
    nodes.forEach(function (node) {
      var sy = 0,
          ty = 0;
      node.sourceLinks.forEach(function (link) {
        link.sy = sy;
        sy += link.dy;
      });
      node.targetLinks.forEach(function (link) {
        link.ty = ty;
        ty += link.dy;
      });
    });

    function ascendingSourceDepth(a, b) {
      return a.source.y - b.source.y;
    }

    function ascendingTargetDepth(a, b) {
      return a.target.y - b.target.y;
    }
  }

  sankey.nodeWidth = function (_) {
    if (!arguments.length) return nodeWidth;
    nodeWidth = +_;
    return sankey;
  };

  sankey.nodePadding = function (_) {
    if (!arguments.length) return nodePadding;
    nodePadding = +_;
    return sankey;
  };

  sankey.nodes = function (_) {
    if (!arguments.length) return nodes;
    nodes = _;
    return sankey;
  };

  sankey.links = function (_) {
    if (!arguments.length) return links;
    links = _;
    return sankey;
  };

  sankey.size = function (_) {
    if (!arguments.length) return size;
    size = _;
    return sankey;
  };

  sankey.layout = function (iterations) {
    computeNodeLinks();
    computeNodeValues();
    computeNodeBreadths();
    computeNodeDepths(iterations);
    computeLinkDepths();
    return sankey;
  };

  sankey.relayout = function () {
    computeLinkDepths();
    return sankey;
  };

  sankey.link = function () {
    var _arguments = arguments;

    var curvature = 0.5;

    function link(d) {
      var x0 = d.source.x + d.source.dx;
      var x1 = d.target.x;
      var xi = _d2.default.interpolateNumber(x0, x1);
      var x2 = xi(curvature);
      var x3 = xi(1 - curvature);
      var y0 = d.source.y + d.sy + d.dy / 2;
      var y1 = d.target.y + d.ty + d.dy / 2;

      return 'M' + x0 + ',' + y0 + 'C' + x2 + ',' + y0 + ' ' + x3 + ',' + y1 + ' ' + x1 + ',' + y1;
    }

    link.curvature = function (_) {
      if (!_arguments.length) return curvature;
      curvature = +_;
      return link;
    };

    return link;
  };

  return sankey;
}

exports.default = Sankey;

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <div>\n    This visualization expects the query result to have rows in the following format:\n\n    <ul>\n      <li><strong>stage1</strong> - stage 1 value</li>\n      <li><strong>stage2</strong> - stage 2 value (or null)</li>\n      <li><strong>stage3</strong> - stage 3 value (or null)</li>\n      <li><strong>stage4</strong> - stage 4 value (or null)</li>\n      <li><strong>stage5</strong> - stage 5 value (or null)</li>\n      <li><strong>value</strong> - number of times this sequence occurred</li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _sunburst = __webpack_require__(734);

var _sunburst2 = _interopRequireDefault(_sunburst);

var _sunburstSequenceEditor = __webpack_require__(735);

var _sunburstSequenceEditor2 = _interopRequireDefault(_sunburstSequenceEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sunburstSequenceRenderer() {
  return {
    restrict: 'E',
    template: '<div class="sunburst-visualization-container" resize-event="handleResize()"></div>',
    link: function link(scope, element) {
      var container = element[0].querySelector('.sunburst-visualization-container');
      var sunburst = new _sunburst2.default(scope, container);

      function resize() {
        sunburst.remove();
        sunburst = new _sunburst2.default(scope, container);
      }

      scope.handleResize = (0, _underscore.debounce)(resize, 50);

      scope.$watch('visualization.options.height', function (oldValue, newValue) {
        if (oldValue !== newValue) {
          resize();
        }
      });
    }
  };
}

function sunburstSequenceEditor() {
  return {
    restrict: 'E',
    template: _sunburstSequenceEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('sunburstSequenceRenderer', sunburstSequenceRenderer);
  ngModule.directive('sunburstSequenceEditor', sunburstSequenceEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var renderTemplate = '<sunburst-sequence-renderer options="visualization.options" query-result="queryResult"></sunburst-sequence-renderer>';

    var editTemplate = '<sunburst-sequence-editor></sunburst-sequence-editor>';
    var defaultOptions = {
      defaultRows: 7
    };

    VisualizationProvider.registerVisualization({
      type: 'SUNBURST_SEQUENCE',
      name: 'Sunburst Sequence',
      renderTemplate: renderTemplate,
      editorTemplate: editTemplate,
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = __webpack_require__(2);

var d3 = _interopRequireWildcard(_d);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var exitNode = '<<<Exit>>>';
var colors = d3.scale.category10();

// helper function colorMap - color gray if "end" is detected
function colorMap(d) {
  return colors(d.name);
}

// Return array of ancestors of nodes, highest first, but excluding the root.
function getAncestors(node) {
  var path = [];
  var current = node;

  while (current.parent) {
    path.unshift(current);
    current = current.parent;
  }
  return path;
}

// The following is based on @chrisrzhou's example from: http://bl.ocks.org/chrisrzhou/d5bdd8546f64ca0e4366.
function Sunburst(scope, element) {
  this.element = element;
  this.watches = [];

  // svg dimensions
  var width = element.clientWidth;
  var height = element.offsetHeight;

  // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
  var b = {
    w: width / 6,
    h: 30,
    s: 3,
    t: 10
  };

  var radius = Math.min(width - b.h, height - b.h) / 2 - 5;
  if (radius <= 0) {
    return;
  }

  // margins
  var margin = {
    top: radius,
    bottom: 50,
    left: radius,
    right: 0
  };

  /**
   * Drawing variables:
   *
   * e.g. colors, totalSize, partitions, arcs
   */
  // Mapping of nodes to colorscale.

  // Total size of all nodes, to be used later when data is loaded
  var totalSize = 0;

  // create d3.layout.partition
  var partition = d3.layout.partition().size([2 * Math.PI, radius * radius]).value(function (d) {
    return d.size;
  });

  // create arcs for drawing D3 paths
  var arc = d3.svg.arc().startAngle(function (d) {
    return d.x;
  }).endAngle(function (d) {
    return d.x + d.dx;
  }).innerRadius(function (d) {
    return Math.sqrt(d.y);
  }).outerRadius(function (d) {
    return Math.sqrt(d.y + d.dy);
  });

  /**
   * Define and initialize D3 select references and div-containers
   *
   * e.g. vis, breadcrumbs, lastCrumb, summary, sunburst, legend
   */
  var vis = d3.select(element);

  // create and position breadcrumbs container and svg
  var breadcrumbs = vis.append('div').classed('breadcrumbs-container', true).append('svg').attr('width', width).attr('height', b.h).attr('fill', 'white').attr('font-weight', 600);

  // create and position SVG
  var container = vis.append('div');

  // create and position summary container
  var summary = container.append('div').classed('summary-container', true);

  var sunburst = container.append('div').classed('sunburst-container', true).append('svg').attr('width', radius * 2).attr('height', radius * 2).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

  // create last breadcrumb element
  var lastCrumb = breadcrumbs.append('text').classed('lastCrumb', true);

  // Generate a string representation for drawing a breadcrumb polygon.
  function breadcrumbPoints(d, i) {
    var points = [];
    points.push('0,0');
    points.push(b.w + ',0');
    points.push(b.w + b.t + ',' + b.h / 2);
    points.push(b.w + ',' + b.h);
    points.push('0,' + b.h);

    if (i > 0) {
      // Leftmost breadcrumb; don't include 6th vertex.
      points.push(b.t + ',' + b.h / 2);
    }
    return points.join(' ');
  }

  // Update the breadcrumb breadcrumbs to show the current sequence and percentage.
  function updateBreadcrumbs(ancestors, percentageString) {
    // Data join, where primary key = name + depth.
    var g = breadcrumbs.selectAll('g').data(ancestors, function (d) {
      return d.name + d.depth;
    });

    // Add breadcrumb and label for entering nodes.
    var breadcrumb = g.enter().append('g');

    breadcrumb.append('polygon').classed('breadcrumbs-shape', true).attr('points', breadcrumbPoints).attr('fill', colorMap);

    breadcrumb.append('text').classed('breadcrumbs-text', true).attr('x', (b.w + b.t) / 2).attr('y', b.h / 2).attr('dy', '0.35em').attr('font-size', '10px').attr('text-anchor', 'middle').text(function (d) {
      return d.name;
    });

    // Set position for entering and updating nodes.
    g.attr('transform', function (d, i) {
      return 'translate(' + i * (b.w + b.s) + ', 0)';
    });

    // Remove exiting nodes.
    g.exit().remove();

    // Update percentage at the lastCrumb.
    lastCrumb.attr('x', (ancestors.length + 0.5) * (b.w + b.s)).attr('y', b.h / 2).attr('dy', '0.35em').attr('text-anchor', 'middle').attr('fill', 'black').attr('font-weight', 600).text(percentageString);
  }

  // helper function mouseover to handle mouseover events/animations and calculation
  // of ancestor nodes etc
  function mouseover(d) {
    // build percentage string
    var percentage = (100 * d.value / totalSize).toPrecision(3);
    var percentageString = percentage + '%';
    if (percentage < 1) {
      percentageString = '< 1.0%';
    }

    // update breadcrumbs (get all ancestors)
    var ancestors = getAncestors(d);
    updateBreadcrumbs(ancestors, percentageString);

    // update sunburst (Fade all the segments and highlight only ancestors of current segment)
    sunburst.selectAll('path').attr('opacity', 0.3);
    sunburst.selectAll('path').filter(function (node) {
      return ancestors.indexOf(node) >= 0;
    }).attr('opacity', 1);

    // update summary
    summary.html('\n      <span>Stage: ' + d.depth + '</span>\n      <span class=\'percentage\' style=\'font-size: 2em;\'>' + percentageString + '</span>\n      <span>' + d.value + ' of ' + totalSize + '</span>\n    ');

    // display summary and breadcrumbs if hidden
    summary.style('visibility', '');
    breadcrumbs.style('visibility', '');
  }

  // helper function click to handle mouseleave events/animations
  function click() {
    // Deactivate all segments then retransition each segment to full opacity.
    sunburst.selectAll('path').on('mouseover', null);
    sunburst.selectAll('path').transition().duration(1000).attr('opacity', 1).each('end', function endClick() {
      d3.select(this).on('mouseover', mouseover);
    });

    // hide summary and breadcrumbs if visible
    breadcrumbs.style('visibility', 'hidden');
    summary.style('visibility', 'hidden');
  }

  // helper function to draw the sunburst and breadcrumbs
  function drawSunburst(json) {
    // Build only nodes of a threshold "visible" sizes to improve efficiency
    // 0.005 radians = 0.29 degrees
    var nodes = partition.nodes(json).filter(function (d) {
      return d.dx > 0.005 && d.name !== exitNode;
    });

    // this section is required to update the colors.domain() every time the data updates
    var uniqueNames = function uniqueNames(a) {
      var output = [];
      a.forEach(function (d) {
        if (output.indexOf(d.name) === -1) output.push(d.name);
      });
      return output;
    }(nodes);
    colors.domain(uniqueNames); // update domain colors

    // create path based on nodes
    var path = sunburst.data([json]).selectAll('path').data(nodes).enter().append('path').classed('nodePath', true).attr('display', function (d) {
      return d.depth ? null : 'none';
    }).attr('d', arc).attr('fill', colorMap).attr('opacity', 1).attr('stroke', 'white').on('mouseover', mouseover);

    // // trigger mouse click over sunburst to reset visualization summary
    vis.on('click', click);

    // Update totalSize of the tree = value of root node from partition.
    totalSize = path.node().__data__.value;
  }

  // visualize json tree structure
  function createVisualization(json) {
    drawSunburst(json); // draw sunburst
  }

  function removeVisualization() {
    sunburst.selectAll('.nodePath').remove();
    // legend.selectAll("g").remove();
  }

  function buildNodes(raw) {
    var values = void 0;

    if (_underscore2.default.has(raw[0], 'sequence') && _underscore2.default.has(raw[0], 'stage') && _underscore2.default.has(raw[0], 'node') && _underscore2.default.has(raw[0], 'value')) {
      var grouped = _underscore2.default.groupBy(raw, 'sequence');

      values = _underscore2.default.map(grouped, function (value) {
        var sorted = _underscore2.default.sortBy(value, 'stage');
        return {
          size: value[0].value,
          sequence: value[0].sequence,
          nodes: _underscore2.default.pluck(sorted, 'node')
        };
      });
    } else {
      var validKey = function validKey(key) {
        return key !== 'value' && key.indexOf('$$') !== 0;
      };
      var keys = _underscore2.default.sortBy(_underscore2.default.filter(_underscore2.default.keys(raw[0]), validKey), _underscore2.default.identity);

      values = _underscore2.default.map(raw, function (row, sequence) {
        return {
          size: row.value,
          sequence: sequence,
          nodes: _underscore2.default.compact(_underscore2.default.map(keys, function (key) {
            return row[key];
          }))
        };
      });
    }

    return values;
  }

  function buildHierarchy(csv) {
    var data = buildNodes(csv);

    // build tree
    var root = {
      name: 'root',
      children: []
    };

    data.forEach(function (d) {
      var nodes = d.nodes;
      var size = parseInt(d.size, 10);

      // build graph, nodes, and child nodes
      var currentNode = root;

      var _loop = function _loop(j) {
        var children = currentNode.children;
        var nodeName = nodes[j];
        var isLeaf = j + 1 === nodes.length;

        if (!children) {
          currentNode.children = children = [];
          children.push({
            name: exitNode,
            size: currentNode.size
          });
        }

        var childNode = _underscore2.default.find(children, function (child) {
          return child.name === nodeName;
        });

        if (isLeaf && childNode) {
          childNode.children.push({
            name: exitNode,
            size: size
          });
        } else if (isLeaf) {
          children.push({
            name: nodeName,
            size: size
          });
        } else {
          if (!childNode) {
            childNode = {
              name: nodeName,
              children: []
            };
            children.push(childNode);
          }

          currentNode = childNode;
        }
      };

      for (var j = 0; j < nodes.length; j += 1) {
        _loop(j);
      }
    });

    return root;
  }

  function render(data) {
    var json = buildHierarchy(data); // build json tree
    removeVisualization(); // remove existing visualization if any
    createVisualization(json); // visualize json tree
  }

  function refreshData() {
    var queryData = scope.queryResult.getData();
    if (queryData) {
      render(queryData);
    }
  }

  refreshData();
  this.watches.push(scope.$watch('visualization.options', refreshData, true));
  this.watches.push(scope.$watch('queryResult && queryResult.getData()', refreshData));
}

Sunburst.prototype.remove = function remove() {
  this.watches.forEach(function (unregister) {
    unregister();
  });
  _angular2.default.element(this.element).empty('.vis-container');
};

exports.default = Sunburst;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <div>\n    This visualization expects the query result to have rows in one of the following formats:\n\n    <strong>Option 1:</strong>\n    <ul>\n      <li><strong>sequence</strong> - sequence id</li>\n      <li><strong>stage</strong> - what stage in sequence this is (1, 2, ...)</li>\n      <li><strong>node</strong> - stage name</li>\n      <li><strong>value</strong> - number of times this sequence occurred</li>\n    </ul>\n\n    <strong>Option 2:</strong>\n    <ul>\n      <li><strong>stage1</strong> - stage 1 value</li>\n      <li><strong>stage2</strong> - stage 2 value (or null)</li>\n      <li><strong>stage3</strong> - stage 3 value (or null)</li>\n      <li><strong>stage4</strong> - stage 4 value (or null)</li>\n      <li><strong>stage5</strong> - stage 5 value (or null)</li>\n      <li><strong>value</strong> - number of times this sequence occurred</li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 736 */,
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _queryResult = __webpack_require__(246);

var _formats = __webpack_require__(320);

var _formats2 = _interopRequireDefault(_formats);

var _table = __webpack_require__(738);

var _table2 = _interopRequireDefault(_table);

var _tableEditor = __webpack_require__(739);

var _tableEditor2 = _interopRequireDefault(_tableEditor);

__webpack_require__(740);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GridEditor.$inject = ['clientConfig'];
GridRenderer.$inject = ['clientConfig'];


var ALLOWED_ITEM_PER_PAGE = [5, 10, 15, 20, 25];

var DISPLAY_AS_OPTIONS = [{ name: 'Text', value: 'string' }, { name: 'Number', value: 'number' }, { name: 'Date/Time', value: 'datetime' }, { name: 'Boolean', value: 'boolean' }, { name: 'JSON', value: 'json' }];

var DEFAULT_OPTIONS = {
  itemsPerPage: 15,
  defaultRows: 14,
  defaultColumns: 4,
  minColumns: 2
};

function getColumnContentAlignment(type) {
  return ['integer', 'float', 'boolean', 'date', 'datetime'].indexOf(type) >= 0 ? 'right' : 'left';
}

function getDefaultColumnsOptions(columns) {
  var displayAs = {
    integer: 'number',
    float: 'number',
    boolean: 'boolean',
    date: 'datetime',
    datetime: 'datetime'
  };

  return _underscore2.default.map(columns, function (col, index) {
    return {
      name: col.name,
      type: col.type,
      displayAs: displayAs[col.type] || 'string',
      visible: true,
      order: 100000 + index,
      title: (0, _queryResult.getColumnCleanName)(col.name),
      allowSearch: false,
      allowHTML: false,
      highlightLinks: false,
      alignContent: getColumnContentAlignment(col.type)
    };
  });
}

function getDefaultFormatOptions(column, clientConfig) {
  var dateTimeFormat = {
    date: clientConfig.dateFormat || 'DD/MM/YY',
    datetime: clientConfig.dateTimeFormat || 'DD/MM/YY HH:mm'
  };
  var numberFormat = {
    integer: clientConfig.integerFormat || '0,0',
    float: clientConfig.floatFormat || '0,0.00'
  };
  return {
    dateTimeFormat: dateTimeFormat[column.type],
    numberFormat: numberFormat[column.type],
    booleanValues: clientConfig.booleanValues || ['false', 'true']
  };
}

function wereColumnsReordered(queryColumns, visualizationColumns) {
  queryColumns = _underscore2.default.map(queryColumns, function (col) {
    return col.name;
  });
  visualizationColumns = _underscore2.default.map(visualizationColumns, function (col) {
    return col.name;
  });

  // Some columns may be removed - so skip them (but keep original order)
  visualizationColumns = _underscore2.default.filter(visualizationColumns, function (col) {
    return _underscore2.default.includes(queryColumns, col);
  });
  // Pick query columns that were previously saved with viz (but keep order too)
  queryColumns = _underscore2.default.filter(queryColumns, function (col) {
    return _underscore2.default.includes(visualizationColumns, col);
  });

  // Both array now have the same size as they both contains only common columns
  // (in fact, it was an intersection, that kept order of items on both arrays).
  // Now check for equality item-by-item; if common columns are in the same order -
  // they were not reordered in editor
  for (var i = 0; i < queryColumns.length; i += 1) {
    if (visualizationColumns[i] !== queryColumns[i]) {
      return true;
    }
  }
  return false;
}

function getColumnsOptions(columns, visualizationColumns) {
  var options = getDefaultColumnsOptions(columns);

  if (wereColumnsReordered(columns, visualizationColumns)) {
    visualizationColumns = _underscore2.default.object(_underscore2.default.map(visualizationColumns, function (col, index) {
      return [col.name, _underscore2.default.extend({}, col, { order: index })];
    }));
  } else {
    visualizationColumns = _underscore2.default.object(_underscore2.default.map(visualizationColumns, function (col) {
      return [col.name, _underscore2.default.omit(col, 'order')];
    }));
  }

  _underscore2.default.each(options, function (col) {
    return _underscore2.default.extend(col, visualizationColumns[col.name]);
  });

  return _underscore2.default.sortBy(options, 'order');
}

function getColumnsToDisplay(columns, options, clientConfig) {
  columns = _underscore2.default.object(_underscore2.default.map(columns, function (col) {
    return [col.name, col];
  }));
  var result = _underscore2.default.map(options, function (col) {
    return _underscore2.default.extend(getDefaultFormatOptions(col, clientConfig), col, columns[col.name]);
  });

  result = _underscore2.default.map(result, function (col) {
    return _underscore2.default.extend(col, {
      formatFunction: (0, _formats2.default)(col)
    });
  });

  return _underscore2.default.sortBy(_underscore2.default.filter(result, 'visible'), 'order');
}

function GridRenderer(clientConfig) {
  return {
    restrict: 'E',
    scope: {
      queryResult: '=',
      options: '='
    },
    template: _table2.default,
    replace: false,
    controller: ['$scope', function controller($scope) {
      $scope.gridColumns = [];
      $scope.gridRows = [];

      function update() {
        if ($scope.queryResult.getData() == null) {
          $scope.gridColumns = [];
          $scope.filters = [];
        } else {
          $scope.filters = $scope.queryResult.getFilters();
          $scope.gridRows = $scope.queryResult.getData();
          var columns = $scope.queryResult.getColumns();
          var columnsOptions = getColumnsOptions(columns, _underscore2.default.extend({}, $scope.options).columns);
          $scope.gridColumns = getColumnsToDisplay(columns, columnsOptions, clientConfig);
        }
      }

      $scope.$watch('queryResult && queryResult.getData()', function (queryResult) {
        if (queryResult) {
          update();
        }
      });

      $scope.$watch('options', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          update();
        }
      }, true);
    }]
  };
}

function GridEditor(clientConfig) {
  return {
    restrict: 'E',
    template: _tableEditor2.default,
    link: function link($scope) {
      $scope.allowedItemsPerPage = ALLOWED_ITEM_PER_PAGE;
      $scope.displayAsOptions = DISPLAY_AS_OPTIONS;

      $scope.currentTab = 'columns';
      $scope.setCurrentTab = function (tab) {
        $scope.currentTab = tab;
      };

      $scope.$watch('visualization', function () {
        if ($scope.visualization) {
          // For existing visualization - set default options
          $scope.visualization.options = _underscore2.default.extend({}, DEFAULT_OPTIONS, $scope.visualization.options);
        }
      });

      $scope.$watch('queryResult && queryResult.getData()', function (queryResult) {
        if (queryResult) {
          var columns = $scope.queryResult.getData() !== null ? $scope.queryResult.getColumns() : [];
          $scope.visualization.options.columns = _underscore2.default.map(getColumnsOptions(columns, $scope.visualization.options.columns), function (col) {
            return _underscore2.default.extend(getDefaultFormatOptions(col, clientConfig), col);
          });
        }
      });
    }
  };
}

function init(ngModule) {
  ngModule.directive('gridRenderer', GridRenderer);
  ngModule.directive('gridEditor', GridEditor);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    var defaultOptions = DEFAULT_OPTIONS;

    VisualizationProvider.registerVisualization({
      type: 'TABLE',
      name: 'Table',
      renderTemplate: '<grid-renderer options="visualization.options" query-result="queryResult"></grid-renderer>',
      editorTemplate: '<grid-editor></grid-editor>',
      defaultOptions: defaultOptions
    });
  }]);
}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "<dynamic-table rows=\"gridRows\" columns=\"gridColumns\" items-per-page=\"options.itemsPerPage\"></dynamic-table>\n"

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "<div class=\"table-editor-container\">\n  <ul class=\"tab-nav\">\n    <li ng-class=\"{active: currentTab == 'columns'}\" ng-if=\"options.globalSeriesType != 'custom'\">\n      <a ng-click=\"setCurrentTab('columns')\">Columns</a>\n    </li>\n    <li ng-class=\"{active: currentTab == 'grid'}\">\n      <a ng-click=\"setCurrentTab('grid')\">Grid</a>\n    </li>\n  </ul>\n\n  <div ng-if=\"currentTab == 'grid'\" class=\"m-t-10 m-b-10\">\n    <div class=\"form-group\">\n      <label>Items per page</label>\n      <select ng-options=\"value for value in allowedItemsPerPage\"\n        ng-model=\"visualization.options.itemsPerPage\" class=\"form-control\">\n      </select>\n    </div>\n  </div>\n\n  <div ng-if=\"currentTab == 'columns'\" class=\"table-editor-query-columns m-t-10 m-b-10\"\n    ui-sortable ng-model=\"visualization.options.columns\">\n    <div ng-repeat=\"column in visualization.options.columns\">\n      <div class=\"table-editor-column-header form-group\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\"><input type=\"checkbox\" ng-model=\"column.visible\"></span>\n          <input class=\"form-control\" ng-model=\"column.title\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"btn-group btn-group-justified\">\n          <button type=\"button\" class=\"btn btn-default btn-xs\"\n            ng-click=\"column.alignContent = 'left'\"\n            ng-class=\"{active: column.alignContent == 'left'}\"><i class=\"fa fa-align-left\"></i></button>\n          <button type=\"button\" class=\"btn btn-default btn-xs\"\n            ng-click=\"column.alignContent = 'center'\"\n            ng-class=\"{active: column.alignContent == 'center'}\"><i class=\"fa fa-align-center\"></i></button>\n          <button type=\"button\" class=\"btn btn-default btn-xs\"\n            ng-click=\"column.alignContent = 'right'\"\n            ng-class=\"{active: column.alignContent == 'right'}\"><i class=\"fa fa-align-right\"></i></button>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label><input type=\"checkbox\" ng-model=\"column.allowSearch\"> Use for search</label>\n      </div>\n\n      <div class=\"form-group\">\n        <label>Display as:</label>\n        <select ng-options=\"item.value as item.name for item in displayAsOptions\"\n          ng-model=\"column.displayAs\" class=\"form-control\">\n        </select>\n      </div>\n\n      <div ng-if=\"column.displayAs == 'string'\">\n        <div class=\"form-group\">\n          <label class=\"ui-sortable-bypass\"><input type=\"checkbox\" ng-model=\"column.allowHTML\"> Allow HTML content</label>\n        </div>\n        <div ng-if=\"column.allowHTML\" class=\"form-group\">\n          <label class=\"ui-sortable-bypass\"><input type=\"checkbox\" ng-model=\"column.highlightLinks\"> Highlight links</label>\n        </div>\n      </div>\n\n      <div ng-if=\"column.displayAs == 'number'\">\n        <div class=\"form-group\">\n          <label for=\"table-editor-{{ column.name }}-number-format\">\n            Number format\n            <span class=\"m-l-5\"\n              uib-popover-html=\"'Format <a href=&quot;http://numeraljs.com/&quot; target=&quot;_blank&quot;>specs.</a>'\"\n              popover-trigger=\"'click outsideClick'\"><i class=\"fa fa-question-circle\"></i></span>\n          </label>\n          <input class=\"form-control\" ng-model=\"column.numberFormat\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\"\n            id=\"table-editor-{{ column.name }}-number-format\">\n        </div>\n      </div>\n\n      <div ng-if=\"column.displayAs == 'datetime'\">\n        <div class=\"form-group\">\n          <label for=\"table-editor-{{ column.name }}-datetime-format\">\n            Date/Time format\n            <span class=\"m-l-5\"\n              uib-popover-html=\"'Format <a href=&quot;http://momentjs.com/docs/#/displaying/format/&quot; target=&quot;_blank&quot;>specs.</a>'\"\n              popover-trigger=\"'click outsideClick'\"><i class=\"fa fa-question-circle\"></i></span>\n          </label>\n          <input class=\"form-control\" ng-model=\"column.dateTimeFormat\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\"\n            id=\"table-editor-{{ column.name }}-datetime-format\">\n        </div>\n      </div>\n\n      <div ng-if=\"column.displayAs == 'boolean'\">\n        <div class=\"form-group\">\n          <label for=\"table-editor-{{ column.name }}-boolean-false\">Value for <code>false</code></label>\n          <input class=\"form-control\" ng-model=\"column.booleanValues[0]\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\"\n            id=\"table-editor-{{ column.name }}-boolean-false\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"table-editor-{{ column.name }}-boolean-true\">Value for <code>true</code></label>\n          <input class=\"form-control\" ng-model=\"column.booleanValues[1]\" ng-model-options=\"{ allowInvalid: true, debounce: 200 }\"\n            id=\"table-editor-{{ column.name }}-boolean-true\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

var _angular = __webpack_require__(21);

var _angular2 = _interopRequireDefault(_angular);

var _d3Cloud = __webpack_require__(742);

var _d3Cloud2 = _interopRequireDefault(_d3Cloud);

var _underscore = __webpack_require__(3);

var _wordCloudEditor = __webpack_require__(745);

var _wordCloudEditor2 = _interopRequireDefault(_wordCloudEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findWordFrequencies(data, columnName) {
  var wordsHash = {};

  data.forEach(function (row) {
    var wordsList = row[columnName].toString().split(' ');
    wordsList.forEach(function (d) {
      if (d in wordsHash) {
        wordsHash[d] += 1;
      } else {
        wordsHash[d] = 1;
      }
    });
  });

  return wordsHash;
}

function wordCloudRenderer() {
  return {
    restrict: 'E',
    link: function link($scope, elem) {
      function reloadCloud() {
        if (!_angular2.default.isDefined($scope.queryResult)) return;

        var data = $scope.queryResult.getData();
        var wordsHash = {};

        if ($scope.visualization.options.column) {
          wordsHash = findWordFrequencies(data, $scope.visualization.options.column);
        }

        var wordList = [];
        (0, _underscore.each)(wordsHash, function (v, key) {
          wordList.push({ text: key, size: 10 + Math.pow(v, 2) });
        });

        var fill = _d2.default.scale.category20();
        var layout = (0, _d3Cloud2.default)().size([500, 500]).words(wordList).padding(5).rotate(function () {
          return Math.floor(Math.random() * 2) * 90;
        }).font('Impact').fontSize(function (d) {
          return d.size;
        });

        function draw(words) {
          _d2.default.select(elem[0].parentNode).select('svg').remove();

          _d2.default.select(elem[0].parentNode).append('svg').attr('width', layout.size()[0]).attr('height', layout.size()[1]).append('g').attr('transform', 'translate(' + layout.size()[0] / 2 + ',' + layout.size()[1] / 2 + ')').selectAll('text').data(words).enter().append('text').style('font-size', function (d) {
            return d.size + 'px';
          }).style('font-family', 'Impact').style('fill', function (d, i) {
            return fill(i);
          }).attr('text-anchor', 'middle').attr('transform', function (d) {
            return 'translate(' + [d.x, d.y] + ')rotate(' + d.rotate + ')';
          }).text(function (d) {
            return d.text;
          });
        }

        layout.on('end', draw);

        layout.start();
      }

      $scope.$watch('queryResult && queryResult.getData()', reloadCloud);
      $scope.$watch('visualization.options.column', reloadCloud);
    }
  };
}

function wordCloudEditor() {
  return {
    restrict: 'E',
    template: _wordCloudEditor2.default
  };
}

function init(ngModule) {
  ngModule.directive('wordCloudEditor', wordCloudEditor);
  ngModule.directive('wordCloudRenderer', wordCloudRenderer);

  ngModule.config(['VisualizationProvider', function (VisualizationProvider) {
    VisualizationProvider.registerVisualization({
      type: 'WORD_CLOUD',
      name: 'Word Cloud',
      renderTemplate: '<word-cloud-renderer options="visualization.options" query-result="queryResult"></word-cloud-renderer>',
      editorTemplate: '<word-cloud-editor></word-cloud-editor>'
    });
  }]);
}

/***/ }),
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">Word Cloud Column Name</label>\n    <div class=\"col-lg-6\">\n      <select ng-options=\"name for name in queryResult.getColumnNames()\" ng-model=\"visualization.options.column\" class=\"form-control\"></select>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/outdated-queries/index.js": 747,
	"./admin/status/index.js": 751,
	"./admin/tasks/index.js": 753,
	"./alert/index.js": 755,
	"./alerts-list/index.js": 757,
	"./dashboards/dashboard-list.js": 759,
	"./dashboards/dashboard.js": 762,
	"./dashboards/public-dashboard-page.js": 765,
	"./data-sources/list.js": 767,
	"./data-sources/show.js": 769,
	"./destinations/list.js": 771,
	"./destinations/show.js": 773,
	"./groups/data-sources.js": 775,
	"./groups/list.js": 777,
	"./groups/show.js": 779,
	"./home/index.js": 781,
	"./queries-list/index.js": 783,
	"./queries/queries-search-results-page.js": 785,
	"./queries/source-view.js": 787,
	"./queries/view.js": 788,
	"./query-snippets/edit.js": 789,
	"./query-snippets/list.js": 792,
	"./users/list.js": 794,
	"./users/new.js": 796,
	"./users/show.js": 798
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pagination = __webpack_require__(28);

var _outdatedQueries = __webpack_require__(750);

var _outdatedQueries2 = _interopRequireDefault(_outdatedQueries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

OutdatedQueriesCtrl.$inject = ['$scope', 'Events', '$http', '$timeout'];


function OutdatedQueriesCtrl($scope, Events, $http, $timeout) {
  var _this = this;

  Events.record('view', 'page', 'admin/outdated_queries');
  $scope.autoUpdate = true;

  this.queries = new _pagination.Paginator([], { itemsPerPage: 50 });

  var refresh = function refresh() {
    if ($scope.autoUpdate) {
      $scope.refresh_time = (0, _moment2.default)().add(1, 'minutes');
      $http.get('/api/admin/queries/outdated').success(function (data) {
        _this.queries.updateRows(data.queries);
        $scope.updatedAt = data.updated_at * 1000.0;
      });
    }

    var timer = $timeout(refresh, 59 * 1000);

    $scope.$on('$destroy', function () {
      if (timer) {
        $timeout.cancel(timer);
      }
    });
  };

  refresh();
}

function init(ngModule) {
  ngModule.component('outdatedQueriesPage', {
    template: _outdatedQueries2.default,
    controller: OutdatedQueriesCtrl
  });

  return {
    '/admin/queries/outdated': {
      template: '<outdated-queries-page></outdated-queries-page>',
      title: 'Outdated Queries'
    }
  };
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Paginator = function () {
  function Paginator(rows) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$itemsPerPage = _ref.itemsPerPage,
        itemsPerPage = _ref$itemsPerPage === undefined ? 20 : _ref$itemsPerPage,
        _ref$totalCount = _ref.totalCount,
        totalCount = _ref$totalCount === undefined ? undefined : _ref$totalCount;

    _classCallCheck(this, Paginator);

    this.page = page;
    this.itemsPerPage = itemsPerPage;
    this.updateRows(rows, totalCount);
    this.orderByField = undefined;
    this.orderByReverse = false;
  }

  _createClass(Paginator, [{
    key: 'setPage',
    value: function setPage(page) {
      this.page = page;
    }
  }, {
    key: 'getPageRows',
    value: function getPageRows() {
      var first = this.itemsPerPage * (this.page - 1);
      var last = this.itemsPerPage * this.page;

      return this.rows.slice(first, last);
    }
  }, {
    key: 'updateRows',
    value: function updateRows(rows) {
      var totalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      this.rows = rows;
      if (this.rows) {
        this.totalCount = totalCount || rows.length;
      } else {
        this.totalCount = 0;
      }
    }
  }, {
    key: 'orderBy',
    value: function orderBy(column) {
      if (column === this.orderByField) {
        this.orderByReverse = !this.orderByReverse;
      } else {
        this.orderByField = column;
        this.orderByReverse = false;
      }

      if (this.orderByField) {
        this.rows = (0, _underscore.sortBy)(this.rows, this.orderByField);
        if (this.orderByReverse) {
          this.rows = this.rows.reverse();
        }
      }
    }
  }]);

  return Paginator;
}();

exports.default = Paginator;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LivePaginator = function () {
  function LivePaginator(rowsFetcher) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$itemsPerPage = _ref.itemsPerPage,
        itemsPerPage = _ref$itemsPerPage === undefined ? 20 : _ref$itemsPerPage;

    _classCallCheck(this, LivePaginator);

    this.page = page;
    this.itemsPerPage = itemsPerPage;
    this.rowsFetcher = rowsFetcher;
    this.rowsFetcher(this.page, this.itemsPerPage, this);
  }

  _createClass(LivePaginator, [{
    key: "setPage",
    value: function setPage(page) {
      this.page = page;
      this.rowsFetcher(page, this.itemsPerPage, this);
    }
  }, {
    key: "getPageRows",
    value: function getPageRows() {
      return this.rows;
    }
  }, {
    key: "updateRows",
    value: function updateRows(rows) {
      var totalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      this.rows = rows;
      if (this.rows) {
        this.totalCount = totalCount || rows.length;
      } else {
        this.totalCount = 0;
      }
    }
  }]);

  return LivePaginator;
}();

exports.default = LivePaginator;

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Admin\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <ul class=\"tab-nav\">\n      <li><a href=\"admin/status\">System Status</a></li>\n      <li><a href=\"admin/queries/tasks\">Queries Queue</a></li>\n      <li class=\"active\"><a href=\"admin/queries/outdated\">Outdated Queries</a></li>\n    </ul>\n\n    <div class=\"\">\n      <table class=\"table table-condensed table-hover\">\n        <thead>\n        <tr>\n          <th>Id</th>\n          <th>Name</th>\n          <th>Created By</th>\n          <th>Runtime</th>\n          <th>Last Executed At</th>\n          <th>Created At</th>\n          <th>Update Schedule</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"row in $ctrl.queries.getPageRows()\">\n          <td>\n            {{row.data_source_id}}\n          </td>\n          <td>\n            <a ng-href=\"queries/{{row.id}}\">{{row.name}}</a>\n          </td>\n          <td>{{row.user.name}}</td>\n          <td>{{row.runtime | durationHumanize}}</td>\n          <td>{{row.retrieved_at | dateTime}}</td>\n          <td>{{row.created_at | dateTime }}</td>\n          <td>{{row.schedule | scheduleHumanize}}</td>\n        </tr>\n        </tbody>\n      </table>\n      <paginator paginator=\"$ctrl.queries\"></paginator>\n\n      <div class=\"p-15\">\n        <div class=\"badge\">\n          Last update: <span am-time-ago=\"updatedAt\"></span>\n        </div>\n        (<label><input type=\"checkbox\" ng-model=\"autoUpdate\"> Auto Update</label>)\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _status = __webpack_require__(752);

var _status2 = _interopRequireDefault(_status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AdminStatusCtrl.$inject = ['$scope', '$http', '$timeout', 'currentUser', 'Events'];


// TODO: switch to $ctrl instead of $scope.
function AdminStatusCtrl($scope, $http, $timeout, currentUser, Events) {
  Events.record('view', 'page', 'admin/status');

  var refresh = function refresh() {
    $http.get('/status.json').success(function (data) {
      $scope.workers = data.workers;
      delete data.workers;
      $scope.manager = data.manager;
      delete data.manager;
      $scope.status = data;
    });

    var timer = $timeout(refresh, 59 * 1000);

    $scope.$on('$destroy', function () {
      if (timer) {
        $timeout.cancel(timer);
      }
    });
  };

  refresh();
}

function init(ngModule) {
  ngModule.component('statusPage', {
    template: _status2.default,
    controller: AdminStatusCtrl
  });

  return {
    '/admin/status': {
      template: '<status-page></status-page>',
      title: 'System Status'
    }
  };
}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Admin\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <ul class=\"tab-nav\">\n      <li class=\"active\"><a href=\"admin/status\">System Status</a></li>\n      <li><a href=\"admin/queries/tasks\">Queries Queue</a></li>\n      <li><a href=\"admin/queries/outdated\">Outdated Queries</a></li>\n    </ul>\n\n\n    <div class=\"row p-15\">\n      <ul class=\"list-group p-l-15 col-lg-4\">\n        <li class=\"list-group-item active\">General</li>\n        <li class=\"list-group-item\" ng-repeat=\"(name, value) in status\">\n          <span class=\"badge\">{{value}}</span>\n          {{name | toHuman}}\n        </li>\n      </ul>\n\n      <ul class=\"list-group col-lg-4\">\n        <li class=\"list-group-item active\">Manager</li>\n        <li class=\"list-group-item\">\n          <span class=\"badge\" am-time-ago=\"manager.last_refresh_at*1000.0\"></span>\n          Last Refresh\n        </li>\n        <li class=\"list-group-item\">\n          <span class=\"badge\" am-time-ago=\"manager.started_at*1000.0\"></span>\n          Started\n        </li>\n        <li class=\"list-group-item\">\n          <span class=\"badge\">{{manager.outdated_queries_count}}</span>\n          Outdated Queries Count\n        </li>\n      </ul>\n\n      <ul class=\"list-group col-lg-4\">\n        <li class=\"list-group-item active\">Queues</li>\n        <li class=\"list-group-item\" ng-repeat=\"(name, value) in manager.queues\">\n          <span class=\"badge\">{{value.size}}</span>\n          {{name}} <span uib-popover=\"{{value.data_sources}}\" popover-trigger=\"'mouseenter'\"><i class=\"fa fa-question-circle\"></i></span>\n        </li>\n      </ul>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pagination = __webpack_require__(28);

var _tasks = __webpack_require__(754);

var _tasks2 = _interopRequireDefault(_tasks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

TasksCtrl.$inject = ['$scope', '$location', '$http', '$timeout', 'Events'];


function TasksCtrl($scope, $location, $http, $timeout, Events) {
  var _this = this;

  Events.record('view', 'page', 'admin/tasks');
  $scope.autoUpdate = true;

  $scope.selectedTab = 'in_progress';

  $scope.tasks = {
    waiting: [],
    in_progress: [],
    done: []
  };

  this.tasksPaginator = new _pagination.Paginator([], { itemsPerPage: 50 });

  $scope.setTab = function (tab) {
    $scope.selectedTab = tab;
    _this.tasksPaginator.updateRows($scope.tasks[tab]);
  };

  $scope.setTab($location.hash() || 'in_progress');

  var refresh = function refresh() {
    if ($scope.autoUpdate) {
      $scope.refresh_time = (0, _moment2.default)().add(1, 'minutes');
      $http.get('/api/admin/queries/tasks').success(function (data) {
        $scope.tasks = data;
        _this.tasksPaginator.updateRows($scope.tasks[$scope.selectedTab]);
      });
    }

    var timer = $timeout(refresh, 5 * 1000);

    $scope.$on('$destroy', function () {
      if (timer) {
        $timeout.cancel(timer);
      }
    });
  };

  refresh();
}

function init(ngModule) {
  ngModule.component('tasksPage', {
    template: _tasks2.default,
    controller: TasksCtrl
  });

  return {
    '/admin/queries/tasks': {
      template: '<tasks-page></tasks-page>',
      title: 'Running Queries'
    }
  };
}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Admin\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <ul class=\"tab-nav\">\n      <li><a href=\"admin/status\">System Status</a></li>\n      <li class=\"active\"><a href=\"admin/queries/tasks\">Queries Queue</a></li>\n      <li><a href=\"admin/queries/outdated\">Outdated Queries</a></li>\n    </ul>\n\n    <ul class=\"tab-nav\">\n      <rd-tab tab-id=\"in_progress\" name=\"In Progress ({{tasks.in_progress.length}})\" ng-click=\"setTab('in_progress')\"></rd-tab>\n      <rd-tab tab-id=\"waiting\" name=\"Waiting ({{tasks.waiting.length}})\" ng-click=\"setTab('waiting')\"></rd-tab>\n      <rd-tab tab-id=\"done\" name=\"Done\" ng-click=\"setTab('done')\"></rd-tab>\n    </ul>\n\n    <table class=\"table table-condensed table-hover\">\n      <thead>\n      <tr>\n        <th>Data Source ID</th>\n        <th>Username</th>\n        <th>State</th>\n        <th>Query ID</th>\n        <th>Query Hash</th>\n        <th>Runtime</th>\n        <th>Created At</th>\n        <th>Started At</th>\n        <th>Updated At</th>\n        <th ng-if=\"selectedTab === 'in_progress'\"></th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"row in $ctrl.tasksPaginator.getPageRows()\">\n        <td>{{row.data_source_id}}</td>\n        <td>{{row.username}}</td>\n        <td>{{row.state}} <span ng-if=\"row.state === 'failed'\" uib-popover=\"{{row.error}}\" popover-trigger=\"mouseenter\" class=\"zmdi zmdi-help\"></span></td>\n        <td><a href=\"queries/{{row.query_id}}\">{{row.query_id}}</a></td>\n        <td>{{row.query_hash}}</td>\n        <td>{{row.run_time | durationHumanize}}</td>\n        <td>{{row.created_at | toMilliseconds | dateTime }}</td>\n        <td>{{row.started_at | toMilliseconds | dateTime }}</td>\n        <td>{{row.updated_at | toMilliseconds | dateTime }}</td>\n        <td ng-if=\"selectedTab === 'in_progress'\">\n          <cancel-query-button query-id=\"row.query_id\" task-id=\"row.task_id\"></cancel-query-button>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n    <paginator paginator=\"$ctrl.tasksPaginator\"></paginator>\n\n    <div class=\"p-15\">\n      <label><input type=\"checkbox\" ng-model=\"autoUpdate\"> Auto Update</label>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _alert = __webpack_require__(756);

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AlertCtrl.$inject = ['$routeParams', '$location', '$sce', 'toastr', 'currentUser', 'Query', 'Events', 'Alert'];


function AlertCtrl($routeParams, $location, $sce, toastr, currentUser, Query, Events, Alert) {
  var _this = this;

  this.alertId = $routeParams.alertId;

  if (this.alertId === 'new') {
    Events.record('view', 'page', 'alerts/new');
  } else {
    Events.record('view', 'alert', this.alertId);
  }

  this.trustAsHtml = function (html) {
    return $sce.trustAsHtml(html);
  };

  this.onQuerySelected = function (item) {
    _this.selectedQuery = item;
    item.getQueryResultPromise().then(function (result) {
      _this.queryResult = result;
      _this.alert.options.column = _this.alert.options.column || result.getColumnNames()[0];
    });
  };

  if (this.alertId === 'new') {
    this.alert = new Alert({ options: {} });
    this.canEdit = true;
  } else {
    this.alert = Alert.get({ id: this.alertId }, function (alert) {
      _this.onQuerySelected(new Query(alert.query));
      _this.canEdit = currentUser.canEdit(_this.alert);
    });
  }

  this.ops = ['greater than', 'less than', 'equals'];
  this.selectedQuery = null;

  var defaultNameBuilder = (0, _underscore.template)('<%= query.name %>: <%= options.column %> <%= options.op %> <%= options.value %>');

  this.getDefaultName = function () {
    if (!_this.alert.query) {
      return undefined;
    }
    return defaultNameBuilder(_this.alert);
  };

  this.searchQueries = function (term) {
    if (!term || term.length < 3) {
      return;
    }

    Query.search({ q: term }, function (results) {
      _this.queries = results;
    });
  };

  this.saveChanges = function () {
    if (_this.alert.name === undefined || _this.alert.name === '') {
      _this.alert.name = _this.getDefaultName();
    }
    if (_this.alert.rearm === '' || _this.alert.rearm === 0) {
      _this.alert.rearm = null;
    }
    _this.alert.$save(function (alert) {
      toastr.success('Saved.');
      if (_this.alertId === 'new') {
        $location.path('/alerts/' + alert.id).replace();
      }
    }, function () {
      toastr.error('Failed saving alert.');
    });
  };

  this.delete = function () {
    _this.alert.$delete(function () {
      $location.path('/alerts');
      toastr.success('Alert deleted.');
    }, function () {
      toastr.error('Failed deleting alert.');
    });
  };
}

function init(ngModule) {
  ngModule.component('alertPage', {
    template: _alert2.default,
    controller: AlertCtrl
  });

  return {
    '/alerts/:alertId': {
      template: '<alert-page></alert-page>',
      title: 'Alerts'
    }
  };
}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n\n  <page-header title='{{$ctrl.alert.name || $ctrl.getDefaultName() || \"New Alert\" }}'>\n  </page-header>\n\n  <email-settings-warning function=\"'alert emails'\"></email-settings-warning>\n\n  <div class=\"container\">\n    <div class=\"row bg-white tiled p-10\">\n      <div class=\"col-md-8\">\n        <form name=\"alertForm\" class=\"form\">\n          <div class=\"form-group\">\n            <label>Query</label>\n            <ui-select ng-model=\"$ctrl.alert.query\" reset-search-input=\"false\" on-select=\"$ctrl.onQuerySelected($item)\" ng-disabled=\"!$ctrl.canEdit\">\n              <ui-select-match placeholder=\"Search a query by name\">{{$select.selected.name}}</ui-select-match>\n              <ui-select-choices repeat=\"q in $ctrl.queries\"\n                                 refresh=\"$ctrl.searchQueries($select.search)\"\n                                 refresh-delay=\"0\">\n                <div ng-bind-html=\"$ctrl.trustAsHtml(q.name | highlight: $select.search)\"></div>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"$ctrl.selectedQuery\">\n            <label>Name</label>\n            <input type=\"string\" placeholder=\"{{$ctrl.getDefaultName()}}\" class=\"form-control\" ng-model=\"$ctrl.alert.name\" ng-disabled=\"!$ctrl.canEdit\">\n          </div>\n\n          <div ng-show=\"$ctrl.queryResult\" class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-md-2\">Value column</label>\n              <div class=\"col-md-4\">\n                <select ng-options=\"name for name in $ctrl.queryResult.getColumnNames()\" ng-model=\"$ctrl.alert.options.column\"\n                        class=\"form-control\" ng-disabled=\"!$ctrl.canEdit\"></select>\n              </div>\n              <label class=\"control-label col-md-2\">Value</label>\n              <div class=\"col-md-4\">\n                <p class=\"form-control-static\">{{$ctrl.queryResult.getData()[0][$ctrl.alert.options.column]}}</p>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-md-2\">Op</label>\n              <div class=\"col-md-4\">\n                <select ng-options=\"name for name in $ctrl.ops\" ng-model=\"$ctrl.alert.options.op\" class=\"form-control\" ng-disabled=\"!$ctrl.canEdit\"></select>\n              </div>\n              <label class=\"control-label col-md-2\">Reference</label>\n              <div class=\"col-md-4\">\n                <input type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"$ctrl.alert.options.value\" placeholder=\"reference value\" ng-disabled=\"!$ctrl.canEdit\"\n                       required/>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-md-2\">Rearm seconds</label>\n              <div class=\"col-md-4\">\n                <input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.alert.rearm\" ng-disabled=\"!$ctrl.canEdit\"/>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"$ctrl.canEdit\">\n            <button class=\"btn btn-primary\" ng-disabled=\"!alertForm.$valid\" ng-click=\"$ctrl.saveChanges()\">Save</button>\n            <button class=\"btn btn-danger\" ng-if=\"$ctrl.alert.id\" ng-click=\"$ctrl.delete()\">Delete</button>\n          </div>\n        </form>\n      </div>\n      <div class=\"col-md-4\" ng-if=\"$ctrl.alert.id\">\n        <alert-subscriptions alert-id=\"$ctrl.alert.id\"></alert-subscriptions>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _pagination = __webpack_require__(28);

var _alertsList = __webpack_require__(758);

var _alertsList2 = _interopRequireDefault(_alertsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var stateClass = {
  ok: 'label label-success',
  triggered: 'label label-danger',
  unknown: 'label label-warning'
};

var AlertsListCtrl = function AlertsListCtrl(Events, Alert) {
  var _this = this;

  _classCallCheck(this, AlertsListCtrl);

  Events.record('view', 'page', 'alerts');

  this.alerts = new _pagination.Paginator([], { itemsPerPage: 20 });
  Alert.query(function (alerts) {
    _this.alerts.updateRows(alerts.map(function (alert) {
      return {
        id: alert.id,
        name: alert.name,
        state: alert.state,
        class: stateClass[alert.state],
        created_by: alert.user.name,
        created_at: alert.created_at,
        updated_at: alert.updated_at
      };
    }));
  });
};

AlertsListCtrl.$inject = ['Events', 'Alert'];
function init(ngModule) {
  ngModule.component('alertsListPage', {
    template: _alertsList2.default,
    controller: AlertsListCtrl
  });

  return {
    '/alerts': {
      template: '<alerts-list-page></alerts-list-page>',
      title: 'Alerts'
    }
  };
}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Alerts\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <table class=\"table table-condensed table-hover\">\n      <thead>\n      <tr>\n        <th class=\"sortable-column\" ng-click=\"$ctrl.alerts.orderBy('name')\">Name <sort-icon column=\"'name'\" sort-column=\"$ctrl.alerts.orderByField\" reverse=\"$ctrl.alerts.orderByReverse\"></sort-icon></th>\n        <th class=\"sortable-column\" ng-click=\"$ctrl.alerts.orderBy('created_by')\">Created By <sort-icon column=\"'created_by'\" sort-column=\"$ctrl.alerts.orderByField\" reverse=\"$ctrl.alerts.orderByReverse\"></sort-icon></th>\n        <th class=\"sortable-column\" ng-click=\"$ctrl.alerts.orderBy('state')\">State <sort-icon column=\"'state'\" sort-column=\"$ctrl.alerts.orderByField\" reverse=\"$ctrl.alerts.orderByReverse\"></sort-icon></th>\n        <th class=\"sortable-column\" ng-click=\"$ctrl.alerts.orderBy('created_at')\">Created By <sort-icon column=\"'created_at'\" sort-column=\"$ctrl.alerts.orderByField\" reverse=\"$ctrl.alerts.orderByReverse\"></sort-icon></th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"row in $ctrl.alerts.getPageRows()\">\n        <td><a href=\"alerts/{{row.id}}\">{{row.name}}</a></td>\n        <td>{{row.created_by}}</td>\n        <td><span ng-class=\"row.class\">{{row.state | uppercase}}</span> since <span am-time-ago=\"row.updated_at\"></span></td>\n        <td><span am-time-ago=\"row.created_at\"></span></td>\n      </tr>\n      </tbody>\n    </table>\n    <paginator paginator=\"$ctrl.alerts\"></paginator>\n  </div>\n\n</div>\n"

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _pagination = __webpack_require__(28);

var _dashboardList = __webpack_require__(760);

var _dashboardList2 = _interopRequireDefault(_dashboardList);

__webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DashboardListCtrl.$inject = ['Dashboard', '$location', 'clientConfig'];


function DashboardListCtrl(Dashboard, $location, clientConfig) {
  var _this = this;

  var TAGS_REGEX = /(^([\w\s]|[^\u0000-\u007F])+):|(#([\w-]|[^\u0000-\u007F])+)/ig;

  this.logoUrl = clientConfig.logoUrl;
  var page = parseInt($location.search().page || 1, 10);

  this.defaultOptions = {};
  this.dashboards = Dashboard.query({}); // shared promise

  this.selectedTags = []; // in scope because it needs to be accessed inside a table refresh
  this.searchText = '';

  this.tagIsSelected = function (tag) {
    return _this.selectedTags.indexOf(tag) > -1;
  };

  this.toggleTag = function ($event, tag) {
    if (_this.tagIsSelected(tag)) {
      if ($event.shiftKey) {
        _this.selectedTags = _this.selectedTags.filter(function (e) {
          return e !== tag;
        });
      } else {
        _this.selectedTags = [];
      }
    } else if ($event.shiftKey) {
      _this.selectedTags.push(tag);
    } else {
      _this.selectedTags = [tag];
    }

    _this.update();
  };

  this.allTags = [];
  this.dashboards.$promise.then(function (data) {
    var out = data.map(function (dashboard) {
      return dashboard.name.match(TAGS_REGEX);
    });
    _this.allTags = _underscore2.default.unique(_underscore2.default.flatten(out)).filter(function (e) {
      return e;
    }).map(function (tag) {
      return tag.replace(/:$/, '');
    });
    _this.allTags.sort();
  });

  this.paginator = new _pagination.Paginator([], { page: page });

  this.update = function () {
    _this.dashboards.$promise.then(function (data) {
      data = _underscore2.default.sortBy(data, 'name');
      var filteredDashboards = data.map(function (dashboard) {
        dashboard.tags = (dashboard.name.match(TAGS_REGEX) || []).map(function (tag) {
          return tag.replace(/:$/, '');
        });
        dashboard.untagged_name = dashboard.name.replace(TAGS_REGEX, '').trim();
        return dashboard;
      }).filter(function (value) {
        if (_this.selectedTags.length) {
          var valueTags = new Set(value.tags);
          var tagMatch = _this.selectedTags;
          var filteredMatch = tagMatch.filter(function (x) {
            return valueTags.has(x);
          });
          if (tagMatch.length !== filteredMatch.length) {
            return false;
          }
        }
        if (_this.searchText && _this.searchText.length) {
          if (!value.untagged_name.toLowerCase().includes(_this.searchText.toLowerCase())) {
            return false;
          }
        }
        return true;
      });

      _this.paginator.updateRows(filteredDashboards, data.count);
    });
  };

  this.update();
}

function init(ngModule) {
  ngModule.component('pageDashboardList', {
    template: _dashboardList2.default,
    controller: DashboardListCtrl
  });

  var route = {
    template: '<page-dashboard-list></page-dashboard-list>',
    reloadOnSearch: false,
    title: 'Dashboards'
  };

  return {
    '/dashboards': route
  };
}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "<div class='container'>\n  <page-header title=\"Dashboards\"></page-header>\n\n  <div class=\"row\">\n    <div class=\"col-lg-3\">\n      <input type='text' class='form-control' placeholder=\"Search Dashboards...\"\n        ng-change=\"$ctrl.update()\" ng-model=\"$ctrl.searchText\" autofocus/>\n      <div class='list-group m-t-20 tags-list tiled'>\n        <a ng-repeat='tag in $ctrl.allTags' ng-class='{\"active\": $ctrl.tagIsSelected(tag)}'\n        class='list-group-item' ng-click='$ctrl.toggleTag($event, tag)'>\n          {{ tag }}\n        </a>\n      </div>\n    </div>\n\n    <div class=\"col-lg-9\">\n      <div class=\"bg-white tiled\">\n        <table class=\"table table-condensed table-hover\">\n          <thead>\n          <tr>\n            <th>Name</th>\n            <th>Created At</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"dashboard in $ctrl.paginator.getPageRows()\">\n            <td>\n              <a href=\"dashboard/{{ dashboard.slug }}\">\n                <span class=\"label label-primary m-2\" ng-bind=\"tag\" ng-repeat=\"tag in dashboard.tags\"></span> {{ dashboard.untagged_name }}\n                <span class=\"label label-default\" ng-if=\"dashboard.is_draft\">Unpublished</span>\n              </a>\n            </td>\n            <td>{{ dashboard.created_at | dateTime }}</td>\n          </tr>\n          </tbody>\n        </table>\n        <paginator paginator=\"$ctrl.paginator\"></paginator>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _dashboard = __webpack_require__(763);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _shareDashboard = __webpack_require__(764);

var _shareDashboard2 = _interopRequireDefault(_shareDashboard);

__webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

DashboardCtrl.$inject = ['$rootScope', '$routeParams', '$location', '$timeout', '$q', '$uibModal', 'Title', 'AlertDialog', 'Dashboard', 'currentUser', 'clientConfig', 'Events', 'dashboardGridOptions', 'toastr'];


function DashboardCtrl($rootScope, $routeParams, $location, $timeout, $q, $uibModal, Title, AlertDialog, Dashboard, currentUser, clientConfig, Events, dashboardGridOptions, toastr) {
  var _this = this;

  this.saveInProgress = false;
  var saveDashboardLayout = function saveDashboardLayout() {
    if (!_this.dashboard.canEdit()) {
      return;
    }

    _this.saveInProgress = true;
    var showMessages = true; // this.layoutEditing;
    // Temporarily disable grid editing (but allow user to use UI controls)
    _this.dashboardGridOptions.draggable.enabled = false;
    _this.dashboardGridOptions.resizable.enabled = false;
    return $q.all(_.map(_this.dashboard.widgets, function (widget) {
      return widget.$save();
    })).then(function () {
      if (showMessages) {
        toastr.success('Dashboard layout saved.');
      }
    }).catch(function () {
      if (showMessages) {
        toastr.error('Cannot save dashboard layout.');
      }
    }).finally(function () {
      _this.saveInProgress = false;
      // If user didn't disable editing mode while saving - restore grid
      _this.dashboardGridOptions.draggable.enabled = _this.layoutEditing;
      _this.dashboardGridOptions.resizable.enabled = _this.layoutEditing;
    });
  };

  this.layoutEditing = false;
  this.dashboardGridOptions = _.extend({}, dashboardGridOptions, {
    resizable: {
      enabled: false,
      handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw']
      // stop: saveDashboardLayout,
    },
    draggable: {
      enabled: false
      // stop: saveDashboardLayout,
    }
  });

  this.isFullscreen = false;
  this.refreshRate = null;
  this.isGridDisabled = false;
  this.showPermissionsControl = clientConfig.showPermissionsControl;
  this.currentUser = currentUser;
  this.globalParameters = [];
  this.refreshRates = [{ name: '10 seconds', rate: 10 }, { name: '30 seconds', rate: 30 }, { name: '1 minute', rate: 60 }, { name: '5 minutes', rate: 60 * 5 }, { name: '10 minutes', rate: 60 * 10 }, { name: '30 minutes', rate: 60 * 30 }, { name: '1 hour', rate: 60 * 60 }, { name: '12 hour', rate: 12 * 60 * 60 }, { name: '24 hour', rate: 24 * 60 * 60 }];

  $rootScope.$on('gridster-mobile-changed', function ($event, gridster) {
    _this.isGridDisabled = gridster.isMobile;
  });

  this.setRefreshRate = function (rate) {
    _this.refreshRate = rate;
    if (rate !== null) {
      _this.loadDashboard(true);
      _this.autoRefresh();
    }
  };

  this.extractGlobalParameters = function () {
    var globalParams = {};
    _this.dashboard.widgets.forEach(function (widget) {
      if (widget.getQuery()) {
        widget.getQuery().getParametersDefs().filter(function (p) {
          return p.global;
        }).forEach(function (param) {
          var defaults = {};
          defaults[param.name] = _.create(Object.getPrototypeOf(param), param);
          defaults[param.name].locals = [];
          globalParams = _.defaults(globalParams, defaults);
          globalParams[param.name].locals.push(param);
        });
      }
    });
    _this.globalParameters = _.values(globalParams);
  };

  this.onGlobalParametersChange = function () {
    _this.globalParameters.forEach(function (global) {
      global.locals.forEach(function (local) {
        local.value = global.value;
      });
    });
  };

  var renderDashboard = function renderDashboard(dashboard, force) {
    Title.set(dashboard.name);
    var promises = [];

    _this.dashboard.widgets.forEach(function (widget) {
      if (widget.visualization) {
        var maxAge = force ? 0 : undefined;
        var queryResult = widget.getQuery().getQueryResult(maxAge);
        if (!_.isUndefined(queryResult)) {
          promises.push(queryResult.toPromise());
        }
      }
    });

    _this.extractGlobalParameters();

    $q.all(promises).then(function (queryResults) {
      var filters = {};
      queryResults.forEach(function (queryResult) {
        var queryFilters = queryResult.getFilters();
        queryFilters.forEach(function (queryFilter) {
          var hasQueryStringValue = _.has($location.search(), queryFilter.name);

          if (!(hasQueryStringValue || dashboard.dashboard_filters_enabled)) {
            // If dashboard filters not enabled, or no query string value given,
            // skip filters linking.
            return;
          }

          if (hasQueryStringValue) {
            queryFilter.current = $location.search()[queryFilter.name];
          }

          if (!_.has(filters, queryFilter.name)) {
            var filter = _.extend({}, queryFilter);
            filters[filter.name] = filter;
            filters[filter.name].originFilters = [];
          }

          // TODO: merge values.
          filters[queryFilter.name].originFilters.push(queryFilter);
        });
      });

      _this.filters = _.values(filters);
      _this.filtersOnChange = function (filter) {
        _.each(filter.originFilters, function (originFilter) {
          originFilter.current = filter.current;
        });
      };
    });
  };

  this.loadDashboard = _.throttle(function (force) {
    _this.dashboard = Dashboard.get({ slug: $routeParams.dashboardSlug }, function (dashboard) {
      Events.record('view', 'dashboard', dashboard.id);
      renderDashboard(dashboard, force);
    }, function () {
      // error...
      // try again. we wrap loadDashboard with throttle so it doesn't happen too often.
      // we might want to consider exponential backoff and also move this as a general
      // solution in $http/$resource for all AJAX calls.
      _this.loadDashboard();
    });
  }, 1000);

  this.loadDashboard();

  this.autoRefresh = function () {
    $timeout(function () {
      _this.loadDashboard(true);
    }, _this.refreshRate.rate * 1000).then(function () {
      return _this.autoRefresh();
    });
  };

  this.archiveDashboard = function () {
    var archive = function archive() {
      Events.record('archive', 'dashboard', _this.dashboard.id);
      _this.dashboard.$delete(function () {
        $rootScope.$broadcast('reloadDashboards');
      });
    };

    var title = 'Archive Dashboard';
    var message = 'Are you sure you want to archive the "' + _this.dashboard.name + '" dashboard?';
    var confirm = { class: 'btn-warning', title: 'Archive' };

    AlertDialog.open(title, message, confirm).then(archive);
  };

  this.showManagePermissionsModal = function () {
    $uibModal.open({
      component: 'permissionsEditor',
      resolve: {
        aclUrl: { url: 'api/dashboards/' + _this.dashboard.id + '/acl' }
      }
    });
  };

  this.editLayout = function (enableEditing, applyChanges) {
    if (!_this.isGridDisabled) {
      if (enableEditing) {
        if (!_this.layoutEditing) {
          // Save current positions of widgets
          _.each(_this.dashboard.widgets, function (widget) {
            widget.$savedPosition = _.clone(widget.options.position);
          });
        }
      } else {
        if (applyChanges) {
          // Clear saved data and save layout
          _.each(_this.dashboard.widgets, function (widget) {
            widget.$savedPosition = undefined;
          });
          saveDashboardLayout();
        } else {
          // Revert changes
          _.each(_this.dashboard.widgets, function (widget) {
            if (_.isObject(widget.$savedPosition)) {
              widget.options.position = widget.$savedPosition;
            }
            widget.$savedPosition = undefined;
          });
        }
      }

      _this.layoutEditing = enableEditing;
      _this.dashboardGridOptions.draggable.enabled = _this.layoutEditing && !_this.saveInProgress;
      _this.dashboardGridOptions.resizable.enabled = _this.layoutEditing && !_this.saveInProgress;
    }
  };

  this.editDashboard = function () {
    var previousFiltersState = _this.dashboard.dashboard_filters_enabled;
    $uibModal.open({
      component: 'editDashboardDialog',
      resolve: {
        dashboard: function dashboard() {
          return _this.dashboard;
        }
      }
    }).result.then(function (dashboard) {
      var shouldRenderDashboard = !previousFiltersState && dashboard.dashboard_filters_enabled;
      _this.dashboard = dashboard;

      if (shouldRenderDashboard) {
        renderDashboard(_this.dashboard);
      }
    });
  };

  this.addWidget = function () {
    $uibModal.open({
      component: 'addWidgetDialog',
      resolve: {
        dashboard: function dashboard() {
          return _this.dashboard;
        }
      }
    }).result.then(function () {
      _this.extractGlobalParameters();
      if (_this.layoutEditing) {
        // Save position of newly added widget (but not entire layout)
        var widget = _.last(_this.dashboard.widgets);
        if (_.isObject(widget)) {
          return widget.$save().then(function () {
            if (_this.layoutEditing) {
              widget.$savedPosition = _.clone(widget.options.position);
            }
          });
        }
      } else {
        // Update entire layout
        return saveDashboardLayout();
      }
    });
  };

  this.removeWidget = function () {
    _this.extractGlobalParameters();
    if (!_this.layoutEditing) {
      saveDashboardLayout();
    }
  };

  this.toggleFullscreen = function () {
    _this.isFullscreen = !_this.isFullscreen;
    document.querySelector('body').classList.toggle('headless');

    if (_this.isFullscreen) {
      $location.search('fullscreen', true);
    } else {
      $location.search('fullscreen', null);
    }
  };

  this.togglePublished = function () {
    Events.record('toggle_published', 'dashboard', _this.dashboard.id);
    _this.dashboard.is_draft = !_this.dashboard.is_draft;
    _this.saveInProgress = true;
    Dashboard.save({
      slug: _this.dashboard.id,
      name: _this.dashboard.name,
      is_draft: _this.dashboard.is_draft
    }, function (dashboard) {
      _this.saveInProgress = false;
      _this.dashboard.version = dashboard.version;
      $rootScope.$broadcast('reloadDashboards');
    });
  };

  if (_.has($location.search(), 'fullscreen')) {
    this.toggleFullscreen();
  }

  this.openShareForm = function () {
    $uibModal.open({
      component: 'shareDashboard',
      resolve: {
        dashboard: _this.dashboard
      }
    });
  };
}

var ShareDashboardComponent = {
  template: _shareDashboard2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ['$http', function controller($http) {
    'ngInject';

    var _this2 = this;

    this.dashboard = this.resolve.dashboard;

    this.toggleSharing = function () {
      var url = 'api/dashboards/' + _this2.dashboard.id + '/share';

      if (!_this2.dashboard.publicAccessEnabled) {
        // disable
        $http.delete(url).success(function () {
          _this2.dashboard.publicAccessEnabled = false;
          delete _this2.dashboard.public_url;
        }).error(function () {
          _this2.dashboard.publicAccessEnabled = true;
          // TODO: show message
        });
      } else {
        $http.post(url).success(function (data) {
          _this2.dashboard.publicAccessEnabled = true;
          _this2.dashboard.public_url = data.public_url;
        }).error(function () {
          _this2.dashboard.publicAccessEnabled = false;
          // TODO: show message
        });
      }
    };
  }]
};

function init(ngModule) {
  ngModule.component('shareDashboard', ShareDashboardComponent);
  ngModule.component('dashboardPage', {
    template: _dashboard2.default,
    controller: DashboardCtrl
  });

  return {
    '/dashboard/:dashboardSlug': {
      template: '<dashboard-page></dashboard-page>',
      reloadOnSearch: false
    }
  };
}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n\n  <div class=\"row bg-white tiled p-10 p-l-15 p-r-15 m-b-10 m-l-0 m-r-0\">\n    <div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-7 page-header--new p-l-0\">\n      <h3>{{$ctrl.dashboard.name}}\n        <span class=\"label label-default\" ng-if=\"$ctrl.dashboard.is_draft && !$ctrl.dashboard.is_archived\">Unpublished</span>\n        <span class=\"label label-warning\" ng-if=\"$ctrl.dashboard.is_archived\" uib-popover=\"This dashboard is archived and and won't appear in the dashboards list or search results.\" popover-placement=\"right\" popover-trigger=\"'mouseenter'\">Archived</span>\n      </h3>\n    </div>\n    <div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-5 text-right dashboard__control p-r-0\">\n      <span ng-if=\"!$ctrl.dashboard.is_archived && !public\" class=\"hidden-print\">\n\n          <div class=\"btn-group\">\n            <button type=\"button\" class=\"btn btn-default btn-sm\"\n              ng-disabled=\"$ctrl.isGridDisabled\"\n              ng-click=\"$ctrl.editLayout(false, true)\" ng-if=\"$ctrl.layoutEditing\">\n              <i class=\"zmdi zmdi-check\"></i> Apply Changes\n            </button>\n\n            <button type=\"button\" class=\"btn btn-default btn-sm\"\n              ng-disabled=\"$ctrl.isGridDisabled\"\n              ng-click=\"$ctrl.editLayout(false, false)\" ng-if=\"$ctrl.layoutEditing\">\n              Cancel\n            </button>\n          </div>\n\n          <div class=\"btn-group\" uib-dropdown>\n            <button id=\"split-button\" type=\"button\"\n                    ng-class=\"{'btn-default btn-sm': $ctrl.refreshRate === null,'btn-primary btn-sm':$ctrl.refreshRate !== null}\"\n                    class=\"btn btn-sm\" ng-click=\"$ctrl.loadDashboard(true)\">\n              <i class=\"zmdi zmdi-refresh\"></i> {{$ctrl.refreshRate === null ? 'Refresh' : $ctrl.refreshRate.name}}\n            </button>\n            <button type=\"button\" class=\"btn\" uib-dropdown-toggle\n                    ng-class=\"{'btn-default btn-sm': $ctrl.refreshRate === null,'btn-primary btn-sm':$ctrl.refreshRate !== null}\">\n              <span class=\"caret\"></span>\n              <span class=\"sr-only\">Split button!</span>\n            </button>\n            <ul class=\"dropdown-menu\" ng-model=\"$ctrl.refreshRate\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\">\n              <li role=\"menuitem\" ng-repeat=\"refreshRate in $ctrl.refreshRates\">\n                <a href=\"#\" ng-click=\"$ctrl.setRefreshRate(refreshRate)\">{{refreshRate.name}}</a>\n              </li>\n              <li role=\"menuitem\" ng-if=\"$ctrl.refreshRate !== null\">\n                <a href=\"#\" ng-click=\"$ctrl.setRefreshRate(null)\">Stop auto refresh</a>\n              </li>\n            </ul>\n          </div>\n          <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-default': !$ctrl.isFullscreen, 'btn-primary': $ctrl.isFullscreen}\" tooltip=\"Enable/Disable Fullscreen display\" ng-click=\"$ctrl.toggleFullscreen()\">\n            <span class=\"zmdi zmdi-fullscreen\"></span>\n          </button>\n          <button type=\"button\" class=\"btn btn-sm\" ng-class=\"{'btn-default': !$ctrl.dashboard.publicAccessEnabled, 'btn-primary': $ctrl.dashboard.publicAccessEnabled}\" tooltip=\"Enable/Disable Share URL\" ng-click=\"$ctrl.openShareForm()\" ng-if=\"$ctrl.dashboard.canEdit() || $ctrl.dashboard.publicAccessEnabled\">\n            <span class=\"zmdi zmdi-share\"></span>\n          </button>\n      </span>\n          <div class=\"btn-group hidden-print\" role=\"group\" ng-show=\"$ctrl.dashboard.canEdit()\" uib-dropdown ng-if=\"!$ctrl.dashboard.is_archived\">\n            <button class=\"btn btn-default btn-sm dropdown-toggle\" uib-dropdown-toggle>\n              <span class=\"zmdi zmdi-more\"></span>\n            </button>\n            <ul class=\"dropdown-menu pull-right\" uib-dropdown-menu>\n              <li ng-if=\"!$ctrl.dashboard.is_archived\"><a ng-click=\"$ctrl.editDashboard()\">Edit Dashboard</a></li>\n              <li ng-if=\"!$ctrl.dashboard.is_archived\" ng-class=\"{hidden: $ctrl.isGridDisabled}\"><a ng-click=\"$ctrl.editLayout(true)\">Edit Layout</a></li>\n              <li ng-if=\"!$ctrl.dashboard.is_archived\"><a ng-click=\"$ctrl.addWidget()\">Add Widget</a></li>\n              <li ng-if=\"$ctrl.showPermissionsControl\"><a ng-click=\"$ctrl.showManagePermissionsModal()\">Manage Permissions</a></li>\n              <li ng-if=\"!$ctrl.dashboard.is_draft\"><a ng-click=\"$ctrl.togglePublished()\">Unpublish Dashboard</a></li>\n              <li ng-if=\"$ctrl.dashboard.is_draft\"><a ng-click=\"$ctrl.togglePublished()\">Publish Dashboard</a></li>\n              <li ng-if=\"!$ctrl.dashboard.is_archived\"><a ng-click=\"$ctrl.archiveDashboard()\">Archive Dashboard</a></li>\n            </ul>\n          </div>\n    </div>\n  </div>\n\n  <div class=\"m-b-10 tiled\">\n    <parameters parameters=\"$ctrl.globalParameters\" on-change=\"$ctrl.onGlobalParametersChange()\"></parameters>\n  </div>\n\n  <div class=\"m-b-10 tiled\">\n    <filters ng-if=\"$ctrl.dashboard.dashboard_filters_enabled\" filters=\"$ctrl.filters\" on-change=\"$ctrl.filtersOnChange(filter, $modal)\"></filters>\n  </div>\n\n  <div style=\"overflow: hidden\">\n    <div gridster=\"$ctrl.dashboardGridOptions\" class=\"dashboard-wrapper\"\n      ng-class=\"{'preview-mode': !$ctrl.layoutEditing, 'editing-mode': $ctrl.layoutEditing}\">\n      <div ng-repeat=\"widget in $ctrl.dashboard.widgets\" gridster-item=\"widget.options.position\"\n        gridster-auto-height=\".scrollbox, .spinner-container\">\n        <dashboard-widget widget=\"widget\" dashboard=\"$ctrl.dashboard\" on-delete=\"$ctrl.removeWidget()\"></dashboard-widget>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">&times;</span>\n  </button>\n  <h4 class=\"modal-title\"><i class=\"fa fa-share-alt\"></i> Share</h4>\n</div>\n<div class=\"modal-body\">\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\" ng-model=\"$ctrl.dashboard.publicAccessEnabled\" ng-click=\"$ctrl.toggleSharing()\" ng-disabled=\"!$ctrl.dashboard.canEdit()\">\n      Allow public access (using a secret URL).\n    </label>\n  </div>\n\n  <div ng-if=\"$ctrl.dashboard.publicAccessEnabled\">\n    <input type=\"text\" class=\"form-control\" value=\"{{$ctrl.dashboard.public_url}}\">\n  </div>\n</div>\n"

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _ = _interopRequireWildcard(_underscore);

var _redash_icon_small = __webpack_require__(74);

var _redash_icon_small2 = _interopRequireDefault(_redash_icon_small);

var _publicDashboardPage = __webpack_require__(766);

var _publicDashboardPage2 = _interopRequireDefault(_publicDashboardPage);

__webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PublicDashboardPage = {
  template: _publicDashboardPage2.default,
  bindings: {
    dashboard: '<'
  },
  controller: ['$routeParams', 'dashboardGridOptions', 'Dashboard', function controller($routeParams, dashboardGridOptions, Dashboard) {
    'ngInject';

    this.dashboardGridOptions = _.extend({}, dashboardGridOptions, {
      resizable: { enabled: false },
      draggable: { enabled: false }
    });

    // embed in params == headless
    this.logoUrl = _redash_icon_small2.default;
    this.headless = $routeParams.embed;
    if (this.headless) {
      document.querySelector('body').classList.add('headless');
    }
    this.public = true;
    this.dashboard.widgets = Dashboard.prepareDashboardWidgets(this.dashboard.widgets);
  }]
};

function init(ngModule) {
  session.$inject = ['$http', '$route', 'Auth'];
  loadPublicDashboard.$inject = ['$http', '$route'];

  ngModule.component('publicDashboardPage', PublicDashboardPage);

  function loadPublicDashboard($http, $route) {
    'ngInject';

    var token = $route.current.params.token;
    return $http.get('api/dashboards/public/' + token).then(function (response) {
      return response.data;
    });
  }

  function session($http, $route, Auth) {
    var token = $route.current.params.token;
    Auth.setApiKey(token);
    return Auth.loadConfig();
  }

  ngModule.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/public/dashboards/:token', {
      template: '<public-dashboard-page dashboard="$resolve.dashboard"></public-dashboard-page>',
      reloadOnSearch: false,
      resolve: {
        dashboard: loadPublicDashboard,
        session: session
      }
    });
  }]);

  return [];
}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container m-t-10 m-b-20\">\n  <page-header title=\"{{$ctrl.dashboard.name}}\">\n  </page-header>\n\n  <div class=\"m-b-5\">\n    <filters ng-if=\"$ctrl.dashboard.dashboard_filters_enabled\"></filters>\n  </div>\n\n  <div style=\"overflow: hidden\">\n    <div gridster=\"$ctrl.dashboardGridOptions\" class=\"dashboard-wrapper\">\n      <div ng-repeat=\"widget in $ctrl.dashboard.widgets\" gridster-item=\"widget.options.position\"\n        gridster-auto-height=\".scrollbox, .spinner-container\">\n        <dashboard-widget widget=\"widget\" dashboard=\"$ctrl.dashboard\" public=\"true\"></dashboard-widget>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div id=\"footer\">\n  <div class=\"text-center\">\n    <a href=\"https://redash.io\"><img ng-src=\"{{$ctrl.logoUrl}}\" width=\"38\"/></a>\n  </div>\n  Powered by <a href=\"http://redash.io/?ref=public-dashboard\">Redash</a>\n</div>\n"

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _list = __webpack_require__(768);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DataSourcesCtrl.$inject = ['$scope', '$location', 'currentUser', 'Events', 'DataSource'];


function DataSourcesCtrl($scope, $location, currentUser, Events, DataSource) {
  Events.record('view', 'page', 'admin/data_sources');

  $scope.dataSources = DataSource.query();
}

function init(ngModule) {
  ngModule.controller('DataSourcesCtrl', DataSourcesCtrl);

  return {
    '/data_sources': {
      template: _list2.default,
      controller: 'DataSourcesCtrl',
      title: 'Data Sources'
    }
  };
}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-4\">\n      <p>\n        <a href=\"data_sources/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Data Source</a>\n      </p>\n      <div class=\"list-group\">\n        <a ng-href=\"data_sources/{{dataSource.id}}\" class=\"list-group-item\" ng-repeat=\"dataSource in dataSources\"><i class=\"fa fa-database\"></i> {{dataSource.name}}</a>\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _show = __webpack_require__(770);

var _show2 = _interopRequireDefault(_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DataSourceCtrl.$inject = ['$scope', '$routeParams', '$http', '$location', 'toastr', 'currentUser', 'Events', 'DataSource'];


var logger = (0, _debug2.default)('redash:http');

function DataSourceCtrl($scope, $routeParams, $http, $location, toastr, currentUser, Events, DataSource) {
  Events.record('view', 'page', 'admin/data_source');

  $scope.dataSourceId = $routeParams.dataSourceId;

  if ($scope.dataSourceId === 'new') {
    $scope.dataSource = new DataSource({ options: {} });
  } else {
    $scope.dataSource = DataSource.get({ id: $routeParams.dataSourceId });
  }

  $scope.$watch('dataSource.id', function (id) {
    if (id !== $scope.dataSourceId && id !== undefined) {
      $location.path('/data_sources/' + id).replace();
    }
  });

  function deleteDataSource() {
    Events.record('delete', 'datasource', $scope.dataSource.id);

    $scope.dataSource.$delete(function () {
      toastr.success('Data source deleted successfully.');
      $location.path('/data_sources/');
    }, function (httpResponse) {
      logger('Failed to delete data source: ', httpResponse.status, httpResponse.statusText, httpResponse.data);
      toastr.error('Failed to delete data source.');
    });
  }

  function testConnection(callback) {
    Events.record('test', 'datasource', $scope.dataSource.id);

    DataSource.test({ id: $scope.dataSource.id }, function (httpResponse) {
      if (httpResponse.ok) {
        toastr.success('Success');
      } else {
        toastr.error(httpResponse.message, 'Connection Test Failed:', { timeOut: 10000 });
      }
      callback();
    }, function (httpResponse) {
      logger('Failed to test data source: ', httpResponse.status, httpResponse.statusText, httpResponse);
      toastr.error('Unknown error occurred while performing connection test. Please try again later.', 'Connection Test Failed:', { timeOut: 10000 });
      callback();
    });
  }

  $scope.actions = [{ name: 'Delete', class: 'btn-danger', callback: deleteDataSource }, {
    name: 'Test Connection', class: 'btn-default', callback: testConnection, disableWhenDirty: true
  }];
}

function init(ngModule) {
  ngModule.controller('DataSourceCtrl', DataSourceCtrl);

  return {
    '/data_sources/:dataSourceId': {
      template: _show2.default,
      controller: 'DataSourceCtrl',
      title: 'Datasources'
    }
  };
}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <dynamic-form target=\"dataSource\" type=\"data_sources\" actions=\"actions\">\n      </dynamic-form>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _list = __webpack_require__(772);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DestinationsCtrl.$inject = ['$scope', '$location', 'toastr', 'currentUser', 'Events', 'Destination'];


function DestinationsCtrl($scope, $location, toastr, currentUser, Events, Destination) {
  Events.record('view', 'page', 'admin/destinations');

  $scope.destinations = Destination.query();
}

function init(ngModule) {
  ngModule.controller('DestinationsCtrl', DestinationsCtrl);

  return {
    '/destinations': {
      template: _list2.default,
      controller: 'DestinationsCtrl',
      title: 'Destinations'
    }
  };
}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-4\">\n      <p>\n        <a href=\"destinations/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Alert Destination</a>\n      </p>\n      <div class=\"list-group\">\n        <a ng-href=\"destinations/{{destination.id}}\" class=\"list-group-item\" ng-repeat=\"destination in destinations\"><i class=\"fa {{destination.icon}}\"></i> {{destination.name}}</a>\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _debug = __webpack_require__(25);

var _debug2 = _interopRequireDefault(_debug);

var _show = __webpack_require__(774);

var _show2 = _interopRequireDefault(_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

DestinationCtrl.$inject = ['$scope', '$routeParams', '$http', '$location', 'toastr', 'currentUser', 'Events', 'Destination'];


var logger = (0, _debug2.default)('redash:http');

function DestinationCtrl($scope, $routeParams, $http, $location, toastr, currentUser, Events, Destination) {
  Events.record('view', 'page', 'admin/destination');

  $scope.destinationId = $routeParams.destinationId;

  if ($scope.destinationId === 'new') {
    $scope.destination = new Destination({ options: {} });
  } else {
    $scope.destination = Destination.get({ id: $routeParams.destinationId });
  }

  $scope.$watch('destination.id', function (id) {
    if (id !== $scope.destinationId && id !== undefined) {
      $location.path('/destinations/' + id).replace();
    }
  });

  $scope.delete = function () {
    Events.record('delete', 'destination', $scope.destination.id);

    $scope.destination.$delete(function () {
      toastr.success('Destination deleted successfully.');
      $location.path('/destinations/');
    }, function (httpResponse) {
      logger('Failed to delete destination: ', httpResponse.status, httpResponse.statusText, httpResponse.data);
      toastr.error('Failed to delete destination.');
    });
  };
}

function init(ngModule) {
  ngModule.controller('DestinationCtrl', DestinationCtrl);

  return {
    '/destinations/:destinationId': {
      template: _show2.default,
      controller: 'DestinationCtrl',
      title: 'Destinations'
    }
  };
}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-6\">\n      <dynamic-form target=\"destination\" type=\"destinations\">\n        <button class=\"btn btn-danger\" ng-if=\"destination.id\" ng-click=\"delete()\">Delete</button>\n      </dynamic-form>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _dataSources = __webpack_require__(776);

var _dataSources2 = _interopRequireDefault(_dataSources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GroupDataSourcesCtrl.$inject = ['$scope', '$routeParams', '$http', 'Events', 'Group', 'DataSource'];


function GroupDataSourcesCtrl($scope, $routeParams, $http, Events, Group, DataSource) {
  Events.record('view', 'group_data_sources', $scope.groupId);
  $scope.group = Group.get({ id: $routeParams.groupId });
  $scope.dataSources = Group.dataSources({ id: $routeParams.groupId });
  $scope.newDataSource = {};

  $scope.findDataSource = function () {
    if ($scope.foundDataSources === undefined) {
      DataSource.query(function (dataSources) {
        var existingIds = $scope.dataSources.map(function (m) {
          return m.id;
        });
        $scope.foundDataSources = dataSources.filter(function (ds) {
          return !(0, _underscore.contains)(existingIds, ds.id);
        });
      });
    }
  };

  $scope.addDataSource = function (dataSource) {
    // Clear selection, to clear up the input control.
    $scope.newDataSource.selected = undefined;

    $http.post('api/groups/' + $routeParams.groupId + '/data_sources', { data_source_id: dataSource.id }).success(function () {
      dataSource.view_only = false;
      $scope.dataSources.unshift(dataSource);

      if ($scope.foundDataSources) {
        $scope.foundDataSources = $scope.foundDataSources.filter(function (ds) {
          return ds !== dataSource;
        });
      }
    });
  };

  $scope.changePermission = function (dataSource, viewOnly) {
    $http.post('api/groups/' + $routeParams.groupId + '/data_sources/' + dataSource.id, { view_only: viewOnly }).success(function () {
      dataSource.view_only = viewOnly;
    });
  };

  $scope.removeDataSource = function (dataSource) {
    $http.delete('api/groups/' + $routeParams.groupId + '/data_sources/' + dataSource.id).success(function () {
      $scope.dataSources = $scope.dataSources.filter(function (ds) {
        return dataSource !== ds;
      });
    });
  };
}

function init(ngModule) {
  ngModule.controller('GroupDataSourcesCtrl', GroupDataSourcesCtrl);

  return {
    '/groups/:groupId/data_sources': {
      template: _dataSources2.default,
      controller: 'GroupDataSourcesCtrl'
    }
  };
}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <group-name group=\"group\"></group-name>\n\n  <div class=\"row\">\n    <div class=\"col-lg-4\">\n      <ul class=\"tab-nav\">\n        <li role=\"presentation\"><a href=\"groups/{{group.id}}\">Members</a></li>\n        <li role=\"presentation\" class=\"active\"><a href=\"groups/{{group.id}}/data_sources\">Data Sources</a></li>\n      </ul>\n    </div>\n    <div class=\"col-lg-8\">\n      <ui-select ng-model=\"newDataSource.selected\" on-select=\"addDataSource($item)\">\n        <ui-select-match placeholder=\"Add Data Source\"></ui-select-match>\n        <ui-select-choices repeat=\"dataSource in foundDataSources | filter:$select.search\"\n                           refresh=\"findDataSource($select.search)\"\n                           refresh-delay=\"0\">\n          <div>\n            {{dataSource.name}}\n          </div>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n  <div class=\"row m-t-5\">\n    <div class=\"col-lg-12\">\n      <table class=\"table table-condensed table-hover\">\n        <thead>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"dataSource in dataSources\">\n          <td> {{dataSource.name}}</td>\n          <td width=\"280px\" class=\"text-right\">\n            <div class=\"btn-group\" uib-dropdown>\n              <button type=\"button\" class=\"btn btn-sm btn-default dropdown-toggle\" uib-dropdown-toggle ng-if=\"dataSource.view_only\">\n                View Only <span class=\"caret\"></span>\n              </button>\n\n              <button type=\"button\" class=\"btn btn-sm btn-success dropdown-toggle\" uib-dropdown-toggle ng-if=\"!dataSource.view_only\">\n                Full Access <span class=\"caret\"></span>\n              </button>\n\n              <ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-menu>\n                <li><a ng-click=\"changePermission(dataSource, false)\"><small ng-if=\"!dataSource.view_only\"><span class=\"fa fa-check\"/></small> Full Access<br/></a></li>\n                <li><a ng-click=\"changePermission(dataSource, true)\"><small ng-if=\"dataSource.view_only\"><span class=\"fa fa-check\"/></small> View Only</a></li>\n              </ul>\n            </div>\n\n            <button class=\"pull-right btn btn-sm btn-danger\" ng-click=\"removeDataSource(dataSource)\">Remove</button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _pagination = __webpack_require__(28);

var _list = __webpack_require__(778);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GroupsCtrl.$inject = ['$scope', '$uibModal', 'currentUser', 'Events', 'Group'];


function GroupsCtrl($scope, $uibModal, currentUser, Events, Group) {
  Events.record('view', 'page', 'groups');
  $scope.currentUser = currentUser;
  $scope.groups = new _pagination.Paginator([], { itemsPerPage: 20 });
  Group.query(function (groups) {
    $scope.groups.updateRows(groups);
  });

  $scope.newGroup = function () {
    $uibModal.open({
      component: 'editGroupDialog',
      size: 'sm',
      resolve: {
        group: function group() {
          return new Group({});
        }
      }
    });
  };
}

function init(ngModule) {
  ngModule.controller('GroupsCtrl', GroupsCtrl);

  return {
    '/groups': {
      template: _list2.default,
      controller: 'GroupsCtrl',
      title: 'Groups'
    }
  };
}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-12\">\n      <p ng-if=\"currentUser.hasPermission('admin')\">\n        <a ng-click=\"newGroup()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Group</a>\n      </p>\n      <table class=\"table table-border table-hover\">\n        <thead>\n          <tr>\n            <th>Name</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"row in groups.getPageRows()\">\n            <td>\n              <a href=\"groups/{{row.id}}\">{{row.name}}</a>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <paginator paginator=\"groups\"></paginator>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _show = __webpack_require__(780);

var _show2 = _interopRequireDefault(_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GroupCtrl.$inject = ['$scope', '$routeParams', '$http', 'currentUser', 'Events', 'Group', 'User'];


function GroupCtrl($scope, $routeParams, $http, currentUser, Events, Group, User) {
  Events.record('view', 'group', $scope.groupId);

  $scope.currentUser = currentUser;
  $scope.group = Group.get({ id: $routeParams.groupId });
  $scope.members = Group.members({ id: $routeParams.groupId });
  $scope.newMember = {};

  $scope.findUser = function (search) {
    if (search === '') {
      return;
    }

    if ($scope.foundUsers === undefined) {
      User.query(function (users) {
        var existingIds = $scope.members.map(function (m) {
          return m.id;
        });
        users.forEach(function (user) {
          user.alreadyMember = (0, _underscore.contains)(existingIds, user.id);
        });
        $scope.foundUsers = users;
      });
    }
  };

  $scope.addMember = function (user) {
    // Clear selection, to clear up the input control.
    $scope.newMember.selected = undefined;

    $http.post('api/groups/' + $routeParams.groupId + '/members', { user_id: user.id }).success(function () {
      $scope.members.unshift(user);
      user.alreadyMember = true;
    });
  };

  $scope.removeMember = function (member) {
    $http.delete('api/groups/' + $routeParams.groupId + '/members/' + member.id).success(function () {
      $scope.members = $scope.members.filter(function (m) {
        return m !== member;
      });

      if ($scope.foundUsers) {
        $scope.foundUsers.forEach(function (user) {
          if (user.id === member.id) {
            user.alreadyMember = false;
          }
        });
      }
    });
  };
}

function init(ngModule) {
  ngModule.controller('GroupCtrl', GroupCtrl);
  return {
    '/groups/:groupId': {
      template: _show2.default,
      controller: 'GroupCtrl'
    }
  };
}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <group-name group=\"group\"></group-name>\n\n  <div class=\"row\">\n    <div class=\"col-lg-4\">\n      <ul class=\"tab-nav\">\n        <li role=\"presentation\" class=\"active\"><a href=\"groups/{{group.id}}\">Members</a></li>\n        <li role=\"presentation\" ng-if=\"currentUser.isAdmin\"><a href=\"groups/{{group.id}}/data_sources\">Data Sources</a></li>\n      </ul>\n    </div>\n\n    <div class=\"col-lg-8\" ng-if=\"currentUser.isAdmin\">\n      <ui-select ng-model=\"newMember.selected\" on-select=\"addMember($item)\">\n        <ui-select-match placeholder=\"Add New Member\"></ui-select-match>\n        <ui-select-choices repeat=\"user in foundUsers | filter:$select.search\"\n                           refresh=\"findUser($select.search)\"\n                           refresh-delay=\"0\"\n                           ui-disable-choice=\"user.alreadyMember\">\n          <div>\n            <img ng-src=\"{{user.profile_image_url}}\" height=\"24px\">&nbsp;{{user.name}}\n            <small ng-if=\"user.alreadyMember\">(already member in this group)</small>\n          </div>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n  <div class=\"row m-t-5\">\n    <div class=\"col-lg-12\">\n      <table class=\"table table-condensed table-hover\" ng-show=\"members\">\n        <tbody>\n        <tr ng-repeat=\"member in members\">\n          <td width=\"50px\"><img ng-src=\"{{member.profile_image_url}}\" height=\"40px\"/></td>\n          <td>{{member.name}} <button class=\"pull-right btn btn-sm btn-danger\" ng-click=\"removeMember(member)\" ng-if=\"currentUser.isAdmin && (group.type != 'builtin' || currentUser.id != member.id)\">Remove</button></td>\n        </tr>\n        </tbody>\n      </table>\n\n      <div ng-hide=\"members.length\">\n        No members.\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _home = __webpack_require__(782);

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

HomeCtrl.$inject = ['$scope', '$uibModal', 'currentUser', 'Events', 'Dashboard', 'Query'];


function HomeCtrl($scope, $uibModal, currentUser, Events, Dashboard, Query) {
  Events.record('view', 'page', 'personal_homepage');

  // todo: maybe this should come from some serivce as we have this logic elsewhere.
  this.canCreateQuery = currentUser.hasPermission('create_query');
  this.canCreateDashboard = currentUser.hasPermission('create_dashboard');
  this.canCreateAlert = currentUser.hasPermission('list_alerts');

  this.recentQueries = Query.recent();
  this.recentDashboards = Dashboard.recent();

  this.newDashboard = function () {
    $uibModal.open({
      component: 'editDashboardDialog',
      resolve: {
        dashboard: function dashboard() {
          return { name: null, layout: null };
        }
      }
    });
  };
}

function init(ngModule) {
  ngModule.component('homePage', {
    template: _home2.default,
    controller: HomeCtrl
  });

  return {
    '/': {
      template: '<home-page></home-page>',
      title: 'Redash'
    }
  };
}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n\n  <div class=\"tile\">\n    <div class=\"t-body tb-padding\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <p class=\"f-500 m-b-20 c-black\">Recent Dashboards</p>\n          <div class=\"list-group\">\n            <a ng-href=\"dashboard/{{dashboard.slug}}\" class=\"list-group-item\" ng-repeat=\"dashboard in $ctrl.recentDashboards\">\n                {{dashboard.name}} <span class=\"label label-default\" ng-if=\"dashboard.is_draft\">Unpublished</span>\n              </a>\n          </div>\n        </div>\n\n        <div class=\"col-md-6\">\n          <p class=\"f-500 m-b-20 c-black\">Recent Queries</p>\n          <div class=\"list-group\">\n            <a ng-href=\"queries/{{query.id}}\" class=\"list-group-item\" ng-repeat=\"query in $ctrl.recentQueries\">{{query.name}} <span class=\"label label-default\" ng-if=\"query.is_draft\">Unpublished</span></a>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pagination = __webpack_require__(28);

var _queriesList = __webpack_require__(784);

var _queriesList2 = _interopRequireDefault(_queriesList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QueriesListCtrl = function QueriesListCtrl($location, Title, Query) {
  _classCallCheck(this, QueriesListCtrl);

  var page = parseInt($location.search().page || 1, 10);

  this.defaultOptions = {};

  var self = this;

  switch ($location.path()) {
    case '/queries':
      Title.set('Queries');
      this.resource = Query.query;
      break;
    case '/queries/my':
      Title.set('My Queries');
      this.resource = Query.myQueries;
      break;
    default:
      break;
  }

  function queriesFetcher(requestedPage, itemsPerPage, paginator) {
    $location.search('page', requestedPage);

    var request = _extends({}, self.defaultOptions, { page: requestedPage, page_size: itemsPerPage });

    return self.resource(request).$promise.then(function (data) {
      var rows = data.results.map(function (query) {
        query.created_at = (0, _moment2.default)(query.created_at);
        query.retrieved_at = (0, _moment2.default)(query.retrieved_at);
        return query;
      });

      paginator.updateRows(rows, data.count);
    });
  }

  this.paginator = new _pagination.LivePaginator(queriesFetcher, { page: page });

  this.tabs = [{ path: 'queries', name: 'All Queries', isActive: function isActive(path) {
      return path === '/queries';
    } }, { name: 'My Queries', path: 'queries/my' }];
};

QueriesListCtrl.$inject = ['$location', 'Title', 'Query'];
function init(ngModule) {
  ngModule.component('pageQueriesList', {
    template: _queriesList2.default,
    controller: QueriesListCtrl
  });

  return {
    '/queries': {
      template: '<page-queries-list></page-queries-list>',
      reloadOnSearch: false
    },
    '/queries/my': {
      template: '<page-queries-list></page-queries-list>',
      reloadOnSearch: false
    }
  };
}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <page-header title=\"Queries\"></page-header>\n  <tab-nav tabs=\"$ctrl.tabs\"></tab-nav>\n\n  <div class=\"bg-white tiled\">\n    <table class=\"table table-condensed table-hover\">\n      <thead>\n      <tr>\n        <th>Name</th>\n        <th>Created By</th>\n        <th>Created At</th>\n        <th>Runtime</th>\n        <th>Last Executed At</th>\n        <th>Update Schedule</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"query in $ctrl.paginator.getPageRows()\">\n        <td><a href=\"queries/{{query.id}}\">{{query.name}}</a> <span class=\"label label-default\" ng-if=\"query.is_draft\">Unpublished</span></td>\n        <td>\n          <img ng-src=\"{{query.user.profile_image_url}}\" class=\"profile__image_thumb\"/>\n          {{query.user.name}}\n        </td>\n        <td>{{query.created_at | dateTime}}</td>\n        <td>{{query.runtime | durationHumanize}}</td>\n        <td>{{query.retrieved_at | dateTime}}</td>\n        <td>{{query.schedule | scheduleHumanize}}</td>\n      </tr>\n      </tbody>\n    </table>\n    <paginator paginator=\"$ctrl.paginator\"></paginator>\n  </div>\n</div>\n"

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(3);

var _pagination = __webpack_require__(28);

var _queriesSearchResultsPage = __webpack_require__(786);

var _queriesSearchResultsPage2 = _interopRequireDefault(_queriesSearchResultsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

QuerySearchCtrl.$inject = ['$location', '$filter', 'currentUser', 'Events', 'Query'];


function QuerySearchCtrl($location, $filter, currentUser, Events, Query) {
  var _this = this;

  this.term = $location.search().q;
  this.paginator = new _pagination.Paginator([], { itemsPerPage: 20 });

  Query.search({ q: this.term, include_drafts: true }, function (results) {
    var queries = results.map(function (query) {
      query.created_at = (0, _moment2.default)(query.created_at);
      return query;
    });

    _this.paginator.updateRows(queries);
  });

  this.search = function () {
    if (!(0, _underscore.isString)(_this.term) || _this.term.trim() === '') {
      _this.paginator.updateRows([]);
    } else {
      $location.search({ q: _this.term });
    }
  };

  Events.record('search', 'query', '', { term: this.term });
}

function init(ngModule) {
  ngModule.component('queriesSearchResultsPage', {
    template: _queriesSearchResultsPage2.default,
    controller: QuerySearchCtrl
  });

  return {
    '/queries/search': {
      template: '<queries-search-results-page></queries-search-results-page>',
      reloadOnSearch: true,
      title: 'Queries Search'
    }
  };
}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <div class=\"bg-white tiled p-5 m-t-10 m-b-10\">\n      <form class=\"form-inline\" role=\"form\" ng-submit=\"$ctrl.search()\">\n        <div class=\"input-group\">\n            <input class=\"form-control input-sm\" placeholder=\"Search...\" ng-model=\"$ctrl.term\" autofocus>\n            <span class=\"input-group-btn\">\n              <button class=\"btn btn-primary\" type=\"submit\">\n                <span class=\"zmdi zmdi-search\"></span>\n              </button>\n            </span>\n        </div>\n      </form>\n    </div>\n    <div class=\"bg-white tiled\">\n      <table class=\"table table-condensed table-hover\">\n        <thead>\n          <tr>\n            <th>Name</th>\n            <th>Created By</th>\n            <th>Created At</th>\n            <th>Update Schedule</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"query in $ctrl.paginator.getPageRows()\">\n            <td><a href=\"queries/{{query.id}}\">{{query.name}}</a> <span class=\"label label-default\" ng-if=\"query.is_draft\">Unpublished</span></td>\n            <td>\n              <img ng-src=\"{{query.user.profile_image_url}}\" class=\"profile__image_thumb\"/>\n              {{query.user.name}}</td>\n            <td>{{query.created_at | dateTime}}</td>\n            <td>{{query.schedule | scheduleHumanize}}</td>\n          </tr>\n        </tbody>\n      </table>\n      <paginator paginator=\"$ctrl.paginator\"></paginator>\n    </div>\n</div>\n"

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _query = __webpack_require__(322);

var _query2 = _interopRequireDefault(_query);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

QuerySourceCtrl.$inject = ['Events', 'toastr', '$controller', '$scope', '$location', '$http', '$q', 'AlertDialog', 'currentUser', 'Query', 'Visualization', 'KeyboardShortcuts'];


function QuerySourceCtrl(Events, toastr, $controller, $scope, $location, $http, $q, AlertDialog, currentUser, Query, Visualization, KeyboardShortcuts) {
  // extends QueryViewCtrl
  $controller('QueryViewCtrl', { $scope: $scope });
  // TODO:
  // This doesn't get inherited. Setting it on this didn't work either (which is weird).
  // Obviously it shouldn't be repeated, but we got bigger fish to fry.
  var DEFAULT_TAB = 'table';

  Events.record('view_source', 'query', $scope.query.id);

  var isNewQuery = !$scope.query.id;
  var queryText = $scope.query.query;
  var saveQuery = $scope.saveQuery;

  $scope.sourceMode = true;
  $scope.isDirty = false;
  $scope.base_url = $location.protocol() + '://' + $location.host() + ':' + $location.port();

  $scope.newVisualization = undefined;

  // @override
  Object.defineProperty($scope, 'showDataset', {
    get: function get() {
      return $scope.queryResult && $scope.queryResult.getStatus() === 'done';
    }
  });

  var shortcuts = {
    'mod+s': function save() {
      if ($scope.canEdit) {
        $scope.saveQuery();
      }
    }
  };

  KeyboardShortcuts.bind(shortcuts);

  $scope.$on('$destroy', function () {
    KeyboardShortcuts.unbind(shortcuts);
  });

  $scope.canForkQuery = function () {
    return currentUser.hasPermission('edit_query') && !$scope.dataSource.view_only;
  };

  // @override
  $scope.saveQuery = function (options, data) {
    var savePromise = saveQuery(options, data);

    savePromise.then(function (savedQuery) {
      queryText = savedQuery.query;
      $scope.isDirty = $scope.query.query !== queryText;
      // update to latest version number
      $scope.query.version = savedQuery.version;

      if (isNewQuery) {
        // redirect to new created query (keep hash)
        $location.path(savedQuery.getSourceLink());
      }
    });

    return savePromise;
  };

  $scope.formatQuery = function () {
    Query.format($scope.dataSource.syntax, $scope.query.query).then(function (query) {
      $scope.query.query = query;
    }).catch(function (error) {
      return toastr.error(error);
    });
  };

  $scope.duplicateQuery = function () {
    Events.record('fork', 'query', $scope.query.id);

    Query.fork({ id: $scope.query.id }, function (newQuery) {
      $location.url(newQuery.getSourceLink()).replace();
    });
  };

  $scope.deleteVisualization = function ($e, vis) {
    $e.preventDefault();

    var title = undefined;
    var message = 'Are you sure you want to delete ' + vis.name + ' ?';
    var confirm = { class: 'btn-danger', title: 'Delete' };

    AlertDialog.open(title, message, confirm).then(function () {
      Events.record('delete', 'visualization', vis.id);

      Visualization.delete({ id: vis.id }, function () {
        if ($scope.selectedTab === String(vis.id)) {
          $scope.selectedTab = DEFAULT_TAB;
          $location.hash($scope.selectedTab);
        }
        $scope.query.visualizations = $scope.query.visualizations.filter(function (v) {
          return vis.id !== v.id;
        });
      }, function () {
        toastr.error("Error deleting visualization. Maybe it's used in a dashboard?");
      });
    });
  };

  $scope.$watch('query.query', function (newQueryText) {
    $scope.isDirty = newQueryText !== queryText;
  });
}

function init(ngModule) {
  ngModule.controller('QuerySourceCtrl', QuerySourceCtrl);

  return {
    '/queries/new': {
      template: _query2.default,
      controller: 'QuerySourceCtrl',
      reloadOnSearch: false,
      resolve: {
        query: ['Query', function newQuery(Query) {
          'ngInject';

          return Query.newQuery();
        }],
        dataSources: ['DataSource', function dataSources(DataSource) {
          'ngInject';

          return DataSource.query().$promise;
        }]
      }
    },
    '/queries/:queryId/source': {
      template: _query2.default,
      controller: 'QuerySourceCtrl',
      reloadOnSearch: false,
      resolve: {
        query: ['Query', '$route', function query(Query, $route) {
          'ngInject';

          return Query.get({ id: $route.current.params.queryId }).$promise;
        }]
      }
    }
  };
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = init;

var _underscore = __webpack_require__(3);

var _dataSource = __webpack_require__(245);

var _query = __webpack_require__(322);

var _query2 = _interopRequireDefault(_query);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

QueryViewCtrl.$inject = ['$scope', 'Events', '$route', '$routeParams', '$location', '$window', '$q', 'KeyboardShortcuts', 'Title', 'AlertDialog', 'Notifications', 'clientConfig', 'toastr', '$uibModal', 'currentUser', 'Query', 'DataSource'];


function QueryViewCtrl($scope, Events, $route, $routeParams, $location, $window, $q, KeyboardShortcuts, Title, AlertDialog, Notifications, clientConfig, toastr, $uibModal, currentUser, Query, DataSource) {
  function getQueryResult(maxAge) {
    if (maxAge === undefined) {
      maxAge = $location.search().maxAge;
    }

    if (maxAge === undefined) {
      maxAge = -1;
    }

    $scope.showLog = false;
    $scope.queryResult = $scope.query.getQueryResult(maxAge);
  }

  function getDataSourceId() {
    // Try to get the query's data source id
    var dataSourceId = $scope.query.data_source_id;

    // If there is no source yet, then parse what we have in localStorage
    //   e.g. `null` -> `NaN`, malformed data -> `NaN`, "1" -> 1
    if (dataSourceId === undefined) {
      dataSourceId = parseInt(localStorage.lastSelectedDataSourceId, 10);
    }

    // If we had an invalid value in localStorage (e.g. nothing, deleted source),
    // then use the first data source
    var isValidDataSourceId = !isNaN(dataSourceId) && (0, _underscore.some)($scope.dataSources, function (ds) {
      return ds.id === dataSourceId;
    });

    if (!isValidDataSourceId) {
      dataSourceId = $scope.dataSources[0].id;
    }

    // Return our data source id
    return dataSourceId;
  }

  function getSchema() {
    var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    // TODO: is it possible this will be called before dataSource is set?
    $scope.schema = [];
    $scope.dataSource.getSchema(refresh).then(function (data) {
      if (data.schema) {
        $scope.schema = data.schema;
        $scope.schema.forEach(function (table) {
          table.collapsed = true;
        });
      } else if (data.error.code === _dataSource.SCHEMA_NOT_SUPPORTED) {
        $scope.schema = undefined;
      } else if (data.error.code === _dataSource.SCHEMA_LOAD_ERROR) {
        toastr.error('Schema refresh failed. Please try again later.');
      } else {
        toastr.error('Schema refresh failed. Please try again later.');
      }
    });
  }

  $scope.refreshSchema = function () {
    return getSchema(true);
  };

  function updateDataSources(dataSources) {
    // Filter out data sources the user can't query (or used by current query):
    function canUseDataSource(dataSource) {
      return !dataSource.view_only || dataSource.id === $scope.query.data_source_id;
    }
    $scope.dataSources = dataSources.filter(canUseDataSource);

    if ($scope.dataSources.length === 0) {
      $scope.noDataSources = true;
      return;
    }

    if ($scope.query.isNew()) {
      $scope.query.data_source_id = getDataSourceId();
    }

    $scope.dataSource = (0, _underscore.find)(dataSources, function (ds) {
      return ds.id === $scope.query.data_source_id;
    });

    $scope.canCreateQuery = (0, _underscore.any)(dataSources, function (ds) {
      return !ds.view_only;
    });

    getSchema();
  }

  $scope.executeQuery = function () {
    if (!$scope.canExecuteQuery()) {
      return;
    }

    if (!$scope.query.query) {
      return;
    }

    getQueryResult(0);
    $scope.lockButton(true);
    $scope.cancelling = false;
    Events.record('execute', 'query', $scope.query.id);

    Notifications.getPermissions();
  };

  $scope.selectedTab = 'table';
  $scope.currentUser = currentUser;
  $scope.dataSource = {};
  $scope.query = $route.current.locals.query;
  $scope.showPermissionsControl = clientConfig.showPermissionsControl;

  var shortcuts = {
    'mod+enter': $scope.executeQuery
  };

  KeyboardShortcuts.bind(shortcuts);

  $scope.$on('$destroy', function () {
    KeyboardShortcuts.unbind(shortcuts);
  });

  Events.record('view', 'query', $scope.query.id);
  if ($scope.query.hasResult() || $scope.query.paramsRequired()) {
    getQueryResult();
  }
  $scope.queryExecuting = false;

  $scope.isQueryOwner = currentUser.id === $scope.query.user.id || currentUser.hasPermission('admin');
  $scope.canEdit = currentUser.canEdit($scope.query) || $scope.query.can_edit;
  $scope.canViewSource = currentUser.hasPermission('view_source');

  $scope.canExecuteQuery = function () {
    return currentUser.hasPermission('execute_query') && !$scope.dataSource.view_only;
  };

  $scope.canScheduleQuery = currentUser.hasPermission('schedule_query');

  if ($route.current.locals.dataSources) {
    $scope.dataSources = $route.current.locals.dataSources;
    updateDataSources($route.current.locals.dataSources);
  } else {
    $scope.dataSources = DataSource.query(updateDataSources);
  }

  // in view mode, latest dataset is always visible
  // source mode changes this behavior
  $scope.showDataset = true;
  $scope.showLog = false;

  $scope.lockButton = function (lock) {
    $scope.queryExecuting = lock;
  };

  $scope.showApiKey = function () {
    $uibModal.open({
      component: 'apiKeyDialog',
      resolve: {
        query: $scope.query
      }
    });
  };

  $scope.saveQuery = function (customOptions, data) {
    var request = data;

    if (request) {
      // Don't save new query with partial data
      if ($scope.query.isNew()) {
        return $q.reject();
      }
      request.id = $scope.query.id;
      request.version = $scope.query.version;
    } else {
      request = (0, _underscore.pick)($scope.query, ['schedule', 'query', 'id', 'description', 'name', 'data_source_id', 'options', 'latest_query_data_id', 'version', 'is_draft']);
    }

    var options = _extends({}, {
      successMessage: 'Query saved',
      errorMessage: 'Query could not be saved'
    }, customOptions);

    return Query.save(request, function (updatedQuery) {
      toastr.success(options.successMessage);
      $scope.query.version = updatedQuery.version;
    }, function (error) {
      if (error.status === 409) {
        toastr.error('It seems like the query has been modified by another user. ' + 'Please copy/backup your changes and reload this page.', { autoDismiss: false });
      } else {
        toastr.error(options.errorMessage);
      }
    }).$promise;
  };

  // toastr.success('It seems like the query has been modified by another user. ' +
  //   'Please copy/backup your changes and reload this page.', { timeOut: 0 });

  $scope.togglePublished = function () {
    Events.record('toggle_published', 'query', $scope.query.id);
    $scope.query.is_draft = !$scope.query.is_draft;
    $scope.saveQuery(undefined, { is_draft: $scope.query.is_draft });
  };

  $scope.saveDescription = function () {
    Events.record('edit_description', 'query', $scope.query.id);
    $scope.saveQuery(undefined, { description: $scope.query.description });
  };

  $scope.saveName = function () {
    Events.record('edit_name', 'query', $scope.query.id);

    if ($scope.query.is_draft && clientConfig.autoPublishNamedQueries && $scope.query.name !== 'New Query') {
      $scope.query.is_draft = false;
    }

    $scope.saveQuery(undefined, { name: $scope.query.name, is_draft: $scope.query.is_draft });
  };

  $scope.cancelExecution = function () {
    $scope.cancelling = true;
    $scope.queryResult.cancelExecution();
    Events.record('cancel_execute', 'query', $scope.query.id);
  };

  $scope.archiveQuery = function () {
    function archive() {
      Query.delete({ id: $scope.query.id }, function () {
        $scope.query.is_archived = true;
        $scope.query.schedule = null;
      }, function () {
        toastr.error('Query could not be archived.');
      });
    }

    var title = 'Archive Query';
    var message = 'Are you sure you want to archive this query?<br/> All alerts and dashboard widgets created with its visualizations will be deleted.';
    var confirm = { class: 'btn-warning', title: 'Archive' };

    AlertDialog.open(title, message, confirm).then(archive);
  };

  $scope.updateDataSource = function () {
    Events.record('update_data_source', 'query', $scope.query.id);
    localStorage.lastSelectedDataSourceId = $scope.query.data_source_id;

    $scope.query.latest_query_data = null;
    $scope.query.latest_query_data_id = null;

    if ($scope.query.id) {
      Query.save({
        id: $scope.query.id,
        data_source_id: $scope.query.data_source_id,
        latest_query_data_id: null
      });
    }

    $scope.dataSource = (0, _underscore.find)($scope.dataSources, function (ds) {
      return ds.id === $scope.query.data_source_id;
    });
    getSchema();
    $scope.executeQuery();
  };

  $scope.setVisualizationTab = function (visualization) {
    $scope.selectedTab = visualization.id;
    $location.hash(visualization.id);
  };

  $scope.$watch('query.name', function () {
    Title.set($scope.query.name);
  });

  $scope.$watch('queryResult && queryResult.getData()', function (data) {
    if (!data) {
      return;
    }

    $scope.filters = $scope.queryResult.getFilters();
  });

  $scope.$watch('queryResult && queryResult.getStatus()', function (status) {
    if (!status) {
      return;
    }

    if (status === 'done') {
      $scope.query.latest_query_data_id = $scope.queryResult.getId();
      $scope.query.queryResult = $scope.queryResult;

      Notifications.showNotification('Redash', $scope.query.name + ' updated.');
    } else if (status === 'failed') {
      Notifications.showNotification('Redash', $scope.query.name + ' failed to run: ' + $scope.queryResult.getError());
    }

    if (status === 'done' || status === 'failed') {
      $scope.lockButton(false);
    }

    if ($scope.queryResult.getLog() != null) {
      $scope.showLog = true;
    }
  });

  $scope.openVisualizationEditor = function (visualization) {
    function openModal() {
      $uibModal.open({
        windowClass: 'modal-xl',
        component: 'editVisualizationDialog',
        resolve: {
          query: $scope.query,
          visualization: visualization,
          queryResult: $scope.queryResult,
          onNewSuccess: function onNewSuccess() {
            return $scope.setVisualizationTab;
          }
        }
      });
    }

    if ($scope.query.isNew()) {
      $scope.saveQuery().then(function (query) {
        // Because we have a path change, we need to "signal" the next page to
        // open the visualization editor.
        $location.path(query.getSourceLink()).hash('add');
      });
    } else {
      openModal();
    }
  };

  if ($location.hash() === 'add') {
    $location.hash(null);
    $scope.openVisualizationEditor();
  }

  $scope.openScheduleForm = function () {
    if (!$scope.canEdit || !$scope.canScheduleQuery) {
      return;
    }

    $uibModal.open({
      component: 'scheduleDialog',
      size: 'sm',
      resolve: {
        query: $scope.query,
        saveQuery: function saveQuery() {
          return $scope.saveQuery;
        }
      }
    });
  };

  $scope.showEmbedDialog = function (query, visualization) {
    $uibModal.open({
      component: 'embedCodeDialog',
      resolve: {
        query: query,
        visualization: visualization
      }
    });
  };

  $scope.$watch(function () {
    return $location.hash();
  }, function (hash) {
    // eslint-disable-next-line eqeqeq
    var exists = (0, _underscore.find)($scope.query.visualizations, function (item) {
      return item.id == hash;
    });
    var visualization = (0, _underscore.min)($scope.query.visualizations, function (viz) {
      return viz.id;
    });
    if (!(0, _underscore.isObject)(visualization)) {
      visualization = {};
    }
    $scope.selectedTab = (exists ? hash : visualization.id) || 'table';
  });

  $scope.showManagePermissionsModal = function () {
    $uibModal.open({
      component: 'permissionsEditor',
      resolve: {
        aclUrl: { url: 'api/queries/' + $routeParams.queryId + '/acl' }
      }
    });
  };
}

function init(ngModule) {
  ngModule.controller('QueryViewCtrl', QueryViewCtrl);

  return {
    '/queries/:queryId': {
      template: _query2.default,
      controller: 'QueryViewCtrl',
      reloadOnSearch: false,
      resolve: {
        query: ['Query', '$route', function query(Query, $route) {
          'ngInject';

          return Query.get({ id: $route.current.params.queryId }).$promise;
        }]
      }
    }
  };
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

__webpack_require__(790);

var _edit = __webpack_require__(791);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

SnippetCtrl.$inject = ['$routeParams', '$http', '$location', 'toastr', 'currentUser', 'Events', 'QuerySnippet'];


function SnippetCtrl($routeParams, $http, $location, toastr, currentUser, Events, QuerySnippet) {
  var _this = this;

  this.snippetId = $routeParams.snippetId;
  Events.record('view', 'query_snippet', this.snippetId);

  this.editorOptions = {
    mode: 'snippets',
    advanced: {
      behavioursEnabled: true,
      enableSnippets: false,
      autoScrollEditorIntoView: true
    },
    onLoad: function onLoad(editor) {
      editor.$blockScrolling = Infinity;
      editor.getSession().setUseWrapMode(true);
      editor.setShowPrintMargin(false);
    }
  };

  this.saveChanges = function () {
    _this.snippet.$save(function (snippet) {
      toastr.success('Saved.');
      if (_this.snippetId === 'new') {
        $location.path('/query_snippets/' + snippet.id).replace();
      }
    }, function () {
      toastr.error('Failed saving snippet.');
    });
  };

  this.delete = function () {
    _this.snippet.$delete(function () {
      $location.path('/query_snippets');
      toastr.sucess('Query snippet deleted.');
    }, function () {
      toastr.error('Failed deleting query snippet.');
    });
  };

  if (this.snippetId === 'new') {
    this.snippet = new QuerySnippet({ description: '' });
    this.canEdit = true;
  } else {
    this.snippet = QuerySnippet.get({ id: this.snippetId }, function (snippet) {
      _this.canEdit = currentUser.canEdit(snippet);
    });
  }
}

function init(ngModule) {
  ngModule.component('snippetPage', {
    template: _edit2.default,
    controller: SnippetCtrl
  });

  return {
    '/query_snippets/:snippetId': {
      template: '<snippet-page></snippet-page>',
      title: 'Query Snippets'
    }
  };
}

/***/ }),
/* 790 */,
/* 791 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"\">\n    <form name=\"snippetForm\" class=\"form\">\n      <div class=\"form-group\">\n        <label>Trigger</label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"$ctrl.snippet.trigger\" ng-disabled=\"!$ctrl.canEdit\" required autofocus>\n      </div>\n\n      <div class=\"form-group\">\n        <label>Description</label>\n        <input type=\"string\" class=\"form-control\" ng-model=\"$ctrl.snippet.description\" ng-disabled=\"!$ctrl.canEdit\">\n      </div>\n\n      <div class=\"form-group\">\n        <label>Snippet</label>\n        <pre ng-if=\"!$ctrl.canEdit\">{{$ctrl.snippet.snippet}}</pre>\n        <div ui-ace=\"$ctrl.editorOptions\" ng-model=\"$ctrl.snippet.snippet\" style=\"height:300px\" ng-if=\"$ctrl.canEdit\"></div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"$ctrl.canEdit\">\n        <button class=\"btn btn-primary\" ng-disabled=\"!snippetForm.$valid\" ng-click=\"$ctrl.saveChanges()\">Save</button>\n        <button class=\"btn btn-danger\" ng-if=\"$ctrl.snippet.id\" ng-click=\"$ctrl.delete()\">Delete</button>\n      </div>\n      <small ng-if=\"$ctrl.snippet.user\">\n        Created by: \n        <img ng-src=\"{{$ctrl.snippet.user.profile_image_url}}\" class=\"profile__image_thumb\"/>\n        {{$ctrl.snippet.user.name}}\n      </small>\n    </form>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _pagination = __webpack_require__(28);

var _list = __webpack_require__(793);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

SnippetsCtrl.$inject = ['$location', 'currentUser', 'Events', 'QuerySnippet'];


function SnippetsCtrl($location, currentUser, Events, QuerySnippet) {
  var _this = this;

  Events.record('view', 'page', 'query_snippets');

  this.snippets = new _pagination.Paginator([], { itemsPerPage: 20 });
  QuerySnippet.query(function (snippets) {
    _this.snippets.updateRows(snippets);
  });
}

function init(ngModule) {
  ngModule.component('snippetsListPage', {
    template: _list2.default,
    controller: SnippetsCtrl
  });

  return {
    '/query_snippets': {
      template: '<snippets-list-page></snippets-list-page>',
      title: 'Query Snippets'
    }
  };
}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n    <div class=\"row m-t-5\">\n        <div class=\"col-md-12\">\n          <p>\n            <a href=\"query_snippets/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Snippet</a>\n          </p>\n\n          <table class=\"table table-border table-hover\">\n            <thead>\n              <tr>\n                <th>Trigger</th>\n                <th>Description</th>\n                <th>Snippet</th>\n                <th>Created By</th>\n                <th>Updated At</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"row in $ctrl.snippets.getPageRows()\">\n                <td>\n                  <a href=\"query_snippets/{{row.id}}\">{{row.trigger}}</a>\n                </td>\n                <td>\n                  {{row.description}}\n                </td>\n                <td>\n                  {{row.snippet}}\n                </td>\n                <td>\n                  <img ng-src=\"{{row.user.profile_image_url}}\" class=\"profile__image_thumb\"/>\n                  {{row.user.name}}\n                </td>\n                <td>\n                  <span am-time-ago=\"row.created_at\"></span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n          <paginator paginator=\"$ctrl.snippets\"></paginator>\n        </div>\n    </div>\n</settings-screen>\n"

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _pagination = __webpack_require__(28);

var _list = __webpack_require__(795);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

UsersCtrl.$inject = ['currentUser', 'Events', 'User'];


function UsersCtrl(currentUser, Events, User) {
  var _this = this;

  Events.record('view', 'page', 'users');

  this.currentUser = currentUser;
  this.users = new _pagination.Paginator([], { itemsPerPage: 20 });
  User.query(function (users) {
    _this.users.updateRows(users);
  });
}

function init(ngModule) {
  ngModule.component('usersListPage', {
    controller: UsersCtrl,
    template: _list2.default
  });

  return {
    '/users': {
      template: '<users-list-page></users-list-page>',
      title: 'Users'
    }
  };
}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-12\">\n      <p ng-if=\"$ctrl.currentUser.hasPermission('admin')\">\n        <a href=\"users/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New User</a>\n      </p>\n\n      <table class=\"table table-hover table-border\">\n        <thead>\n          <tr>\n            <th>Name</th>\n            <th>Joined</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"row in $ctrl.users.getPageRows()\">\n            <td>\n              <img ng-src=\"{{row.profile_image_url}}\" height=\"32px\" class=\"profile__image--settings\"/> <a href=\"users/{{row.id}}\">{{row.name}}</a>\n            </td>\n            <td>\n              <span am-time-ago=\"row.created_at\"></span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <paginator paginator=\"$ctrl.users\"></paginator>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _new = __webpack_require__(797);

var _new2 = _interopRequireDefault(_new);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

NewUserCtrl.$inject = ['$scope', '$location', 'toastr', 'currentUser', 'Events', 'User'];


function NewUserCtrl($scope, $location, toastr, currentUser, Events, User) {
  var _this = this;

  Events.record('view', 'page', 'users/new');

  $scope.user = new User({});
  $scope.saveUser = function () {
    if (!_this.userForm.$valid) {
      return;
    }

    $scope.user.$save(function (user) {
      $scope.user = user;
      $scope.user.created = true;
      toastr.success('Saved.');
    }, function (error) {
      var message = error.data.message || 'Failed saving.';
      toastr.error(message);
    });
  };
}

function init(ngModule) {
  ngModule.controller('NewUserCtrl', NewUserCtrl);

  return {
    '/users/new': {
      template: _new2.default,
      controller: 'NewUserCtrl',
      controllerAs: '$ctrl',
      bindToController: 'true'
    }
  };
}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <email-settings-warning function=\"'invite emails'\"></email-settings-warning>\n  <form class=\"form\" name=\"$ctrl.userForm\" ng-submit=\"saveUser()\" novalidate>\n    <div class=\"form-group required\" ng-class=\"{ 'has-error':  ($ctrl.userForm.name | showError )}\">\n      <label class=\"control-label\">Name</label>\n      <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"user.name\" ng-disabled=\"user.created\" required/ autofocus>\n\n      <error-messages input=\"$ctrl.userForm.name\" form=\"$ctrl.userForm\"></error-messages>\n    </div>\n\n    <div class=\"form-group required\" ng-class=\"{ 'has-error': ($ctrl.userForm.email | showError ) }\">\n      <label class=\"control-label\">Email</label>\n      <input name=\"email\" type=\"email\" class=\"form-control\" ng-model=\"user.email\" ng-disabled=\"user.created\" required/>\n\n      <error-messages input=\"$ctrl.userForm.email\" form=\"$ctrl.userForm\"></error-messages>\n    </div>\n\n    <div class=\"form-group\" ng-if=\"!user.created\">\n      <button class=\"btn btn-primary\">Create</button>\n    </div>\n\n\n    <div ng-if=\"user.created\" class=\"alert alert-success\">\n      <p>\n        <strong>The user has been created and should receive an invite email soon.</strong>\n      </p>\n      <p>\n        You can use the following link to invite them yourself:<br/>\n        {{user.invite_link}}\n      </p>\n    </div>\n  </form>\n</settings-screen>\n"

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _underscore = __webpack_require__(3);

var _show = __webpack_require__(799);

var _show2 = _interopRequireDefault(_show);

__webpack_require__(800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

UserCtrl.$inject = ['$scope', '$routeParams', '$http', '$location', 'toastr', 'clientConfig', 'currentUser', 'Events', 'User'];


function UserCtrl($scope, $routeParams, $http, $location, toastr, clientConfig, currentUser, Events, User) {
  $scope.userId = $routeParams.userId;
  $scope.currentUser = currentUser;
  $scope.clientConfig = clientConfig;

  if ($scope.userId === 'me') {
    $scope.userId = currentUser.id;
  }

  Events.record('view', 'user', $scope.userId);
  $scope.canEdit = currentUser.hasPermission('admin') || currentUser.id === parseInt($scope.userId, 10);
  $scope.showSettings = false;
  $scope.showPasswordSettings = false;

  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
    (0, _underscore.each)($scope.tabs, function (v, k) {
      $scope.tabs[k] = k === tab;
    });
  };

  $scope.setTab = function (tab) {
    $scope.selectedTab = tab;
    $location.hash(tab);
  };

  $scope.tabs = {
    profile: false,
    apiKey: false,
    settings: false,
    password: false
  };

  $scope.selectTab($location.hash() || 'profile');

  $scope.user = User.get({ id: $scope.userId }, function (user) {
    if (user.auth_type === 'password') {
      $scope.showSettings = $scope.canEdit;
      $scope.showPasswordSettings = $scope.canEdit;
    }
  });

  $scope.password = {
    current: '',
    new: '',
    newRepeat: ''
  };

  $scope.savePassword = function (form) {
    if (!form.$valid) {
      return;
    }

    var data = {
      id: $scope.user.id,
      password: $scope.password.new,
      old_password: $scope.password.current
    };

    User.save(data, function () {
      toastr.success('Password Saved.');
      $scope.password = {
        current: '',
        new: '',
        newRepeat: ''
      };
    }, function (error) {
      var message = error.data.message || 'Failed saving password.';
      toastr.error(message);
    });
  };

  $scope.updateUser = function (form) {
    if (!form.$valid) {
      return;
    }

    var data = {
      id: $scope.user.id,
      name: $scope.user.name,
      email: $scope.user.email
    };

    User.save(data, function (user) {
      toastr.success('Saved.');
      $scope.user = user;
    }, function (error) {
      var message = error.data.message || 'Failed saving.';
      toastr.error(message);
    });
  };

  $scope.isCollapsed = true;

  $scope.sendPasswordReset = function () {
    $scope.disablePasswordResetButton = true;
    $http.post('api/users/' + $scope.user.id + '/reset_password').success(function (data) {
      $scope.disablePasswordResetButton = false;
      $scope.passwordResetLink = data.reset_link;
    });
  };
}

function init(ngModule) {
  ngModule.controller('UserCtrl', UserCtrl);

  return {
    '/users/:userId': {
      template: _show2.default,
      reloadOnSearch: false,
      controller: 'UserCtrl',
      title: 'Users'
    }
  };
}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "<settings-screen>\n  <email-settings-warning function=\"'invite emails'\"></email-settings-warning>\n\n  <div ng-show=\"selectedTab == 'profile'\" class=\"p-10\">\n    <div class=\"row\">\n      <div class=\"col-md-4 col-md-offset-4 profile__cointainer\">\n\n        <img ng-src=\"{{user.profile_image_url}}\" class=\"profile__image\"/>\n\n        <h3 class=\"profile__h3\">{{user.name}}</h3>\n\n        <hr>\n\n        <form class=\"form\" name=\"userSettingsForm\" ng-submit=\"updateUser(userSettingsForm)\" novalidate>\n          <div class=\"form-group\" ng-class=\"{ 'has-error':  (userSettingsForm.name | showError )}\">\n            <label class=\"control-label\" for=\"name\" >Name</label>\n            <input name=\"name\" id=\"name\" type=\"text\" class=\"form-control\" ng-model=\"user.name\" required/>\n            <error-messages input=\"userSettingsForm.name\" form=\"userSettingsForm\"></error-messages>\n          </div>\n          <div class=\"form-group\" ng-class=\"{ 'has-error':  (userSettingsForm.email | showError )}\">\n            <label class=\"control-label\" for=\"email\" >Email</label>\n            <input name=\"email\" id=\"email\" type=\"email\" class=\"form-control\" ng-model=\"user.email\" required/>\n            <error-messages input=\"userSettingsForm.email\" form=\"userSettingsForm\"></error-messages>\n          </div>\n          <div class=\"form-group\">\n            <button class=\"btn btn-primary\">Save</button>\n          </div>\n        </form>\n\n        <hr>\n\n        <div class=\"form-group\">\n          <label class=\"control-label\">API Key</label>\n          <input type=\"text\" class=\"form-control\" value=\"{{user.api_key}}\" size=\"44\" readonly/>\n        </div>\n\n        <hr>\n\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"isCollapsed = !isCollapsed\">Change password <span class=\"caret\"></span></button>\n\n        <div uib-collapse=\"isCollapsed\">\n          <div class=\"well\">\n            <form class=\"form\" name=\"userPasswordForm\" ng-submit=\"savePassword(userPasswordForm)\" novalidate>\n              <div class=\"form-group required\" ng-class=\"{ 'has-error':  (userPasswordForm.currentPassword | showError:userPasswordForm )}\">\n                <label class=\"control-label\">Current Password</label>\n                <input name=\"currentPassword\" class=\"form-control\" type=\"password\" ng-model=\"password.current\" required/>\n                <error-messages input=\"userPasswordForm.currentPassword\" form=\"userPasswordForm\"></error-messages>\n              </div>\n              <div class=\"form-group required\" ng-class=\"{ 'has-error':  (userPasswordForm.newPassword | showError:userPasswordForm )}\">\n                <label class=\"control-label\">New Password</label>\n                <input name=\"newPassword\" class=\"form-control\" type=\"password\" ng-model=\"password.new\" ng-minlength=\"6\"\n                       required/>\n                <error-messages input=\"userPasswordForm.newPassword\" form=\"userPasswordForm\"></error-messages>\n              </div>\n              <div class=\"form-group required\" ng-class=\"{ 'has-error':  (userPasswordForm.passwordRepeat | showError:userPasswordForm )}\">\n                <label class=\"control-label\">Repeat New Password</label>\n                <input name=\"passwordRepeat\" class=\"form-control\" type=\"password\" ng-model=\"password.newRepeat\"\n                       compare-to=\"password.new\"/>\n                <span class=\"help-block error\"\n                      ng-if=\"userPasswordForm.passwordRepeat.$error.compareTo\">Passwords don't match.</span>\n              </div>\n              <div class=\"form-group\">\n                <button class=\"btn btn-primary\">Set new password</button>\n              </div>\n            </form>\n          </div>\n        </div>\n\n\n        <div ng-if=\"currentUser.isAdmin\">\n          <br>\n          <div class=\"form-group\">\n            <button class=\"btn btn-default\" ng-click=\"sendPasswordReset()\" ng-disabled=\"disablePasswordResetButton\">Send\n              Password Reset Email\n            </button>\n          </div>\n\n          <div ng-if=\"passwordResetLink\" class=\"alert alert-success\">\n            <p ng-if=\"!clientConfig.mailSettingMissing\">\n              <strong>The user should receive a link to reset his password by email soon.</strong>\n            </p>\n            <p ng-if=\"clientConfig.mailSettingsMissing\">\n              You don't have mail server configured, please send the following link\n              to {{user.name}} to reset their password:<br/>\n              <a ng-href=\"passwordResetLink\">{{passwordResetLink}}</a>\n            </p>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[323]);


// WEBPACK FOOTER //
// app.ac60c938f770f6acd657.js